import * as i0 from '@angular/core';
import { NgModule, Directive, Input, EventEmitter, Component, Output, Optional, Self, HostListener, ViewChild, ContentChild, Injectable, TemplateRef, ChangeDetectionStrategy, Pipe, ContentChildren, InjectionToken, Inject, ViewChildren } from '@angular/core';
import * as i6 from '@angular/common';
import { CommonModule, formatNumber, DatePipe, DOCUMENT } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as i1$3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from 'angular-svg-icon';
import { AngularSvgIconModule } from 'angular-svg-icon';
import * as i4$1 from '@syncfusion/ej2-angular-dropdowns';
import { AutoCompleteModule, ComboBoxModule, MultiSelectAllModule, DropDownList, DropDownListModule, DropDownTreeModule } from '@syncfusion/ej2-angular-dropdowns';
import * as i1 from '@asol/core';
import { CORE_CONSTANTS, PipesModule, ERROR_TRANSLATION, stringFormat, RemoveValidationError, markForValidation, GENERAL_TRANSLATION, translateProperty, isValueCurrency, Priority, generateId, MEDIA_QUERY, collectionMapper, getDateDifference, SelectedTreeItem, MAIN_APP, TranslationService } from '@asol/core';
import { Subscription, Subject, debounceTime, catchError, throwError, finalize, of, map, BehaviorSubject, forkJoin, switchMap, lastValueFrom, tap, from } from 'rxjs';
import { debounce, createElement, getComponent, L10n } from '@syncfusion/ej2-base';
import { Predicate, Query, DataManager } from '@syncfusion/ej2-data';
import * as i2$1 from '@syncfusion/ej2-angular-splitbuttons';
import { DropDownButtonModule, SplitButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import * as i1$1 from '@angular/common/http';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import * as i2$2 from '@syncfusion/ej2-angular-popups';
import { DialogModule, DialogUtility, TooltipModule, createSpinner } from '@syncfusion/ej2-angular-popups';
import * as i4$2 from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorAllModule, ToolbarService as ToolbarService$1, LinkService, ImageService, HtmlEditorService, ResizeService, CountService, TableService } from '@syncfusion/ej2-angular-richtexteditor';
import { ToastUtility } from '@syncfusion/ej2-angular-notifications';
import * as i4$4 from '@syncfusion/ej2-angular-calendars';
import { DatePicker, DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import * as i8 from '@syncfusion/ej2-angular-grids';
import { GridModule, PageService, ResizeService as ResizeService$1, SortService, FilterService, GroupService, ColumnChooserService, ReorderService, ExcelExportService, SelectionService, AggregateService as AggregateService$1 } from '@syncfusion/ej2-angular-grids';
import * as i4$3 from '@syncfusion/ej2-angular-inputs';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import * as i5 from '@syncfusion/ej2-angular-buttons';
import { CheckBoxModule, CheckBoxComponent, RadioButtonComponent, RadioButtonModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import * as i1$2 from '@syncfusion/ej2-angular-progressbar';
import { ProgressBarModule } from '@syncfusion/ej2-angular-progressbar';
import * as i2$3 from '@syncfusion/ej2-angular-navigations';
import { BreadcrumbModule, TabModule, SidebarModule, MenuModule, TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import * as i8$1 from '@syncfusion/ej2-angular-querybuilder';
import { QueryBuilderModule, QueryBuilder } from '@syncfusion/ej2-angular-querybuilder';
import { debounceTime as debounceTime$1 } from 'rxjs/operators';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

class AsolControlModule {
}
AsolControlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolControlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolControlModule });
AsolControlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolControlModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolControlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

class SharedModule {
}
SharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SharedModule, imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule, i4.AngularSvgIconModule], exports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AngularSvgIconModule] });
SharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SharedModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            RouterModule,
            AngularSvgIconModule.forRoot(),
        ], CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AngularSvgIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        RouterModule,
                        AngularSvgIconModule.forRoot(),
                    ],
                    exports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        RouterModule,
                        AngularSvgIconModule,
                    ],
                }]
        }] });

class RequiredAsteriskDirective {
    constructor(elementRef, detector) {
        this.elementRef = elementRef;
        this.detector = detector;
        this.control = null;
    }
    ngOnInit() {
        var _a;
        /** checks control for required property */
        this.sub = (_a = this.control) === null || _a === void 0 ? void 0 : _a.statusChanges.subscribe(() => {
            this.setAsterisk();
            this.detector.detectChanges();
        });
    }
    ngOnChanges() {
        this.setAsterisk();
    }
    ngOnDestroy() {
        var _a;
        /** unsubscribes from status changes observable */
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Adds/Removes asterisk from DOM
     */
    setAsterisk() {
        var _a, _b;
        if (!this.control && !this.isRequired) {
            return;
        }
        const controlIsRequired = this.isRequired !== undefined
            ? this.isRequired
            : ((_a = this.control) === null || _a === void 0 ? void 0 : _a.hasValidator(Validators.required)) ||
                ((_b = this.control) === null || _b === void 0 ? void 0 : _b.hasValidator(Validators.requiredTrue));
        if (controlIsRequired) {
            this.elementRef.nativeElement.innerHTML = '*';
            this.elementRef.nativeElement.classList.add('required');
        }
        else {
            this.elementRef.nativeElement.innerHTML = '';
        }
    }
}
RequiredAsteriskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskDirective, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
RequiredAsteriskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: RequiredAsteriskDirective, selector: "[requiredAsterisk]", inputs: { control: "control", isRequired: "isRequired" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[requiredAsterisk]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { control: [{
                type: Input
            }], isRequired: [{
                type: Input
            }] } });

class RequiredAsteriskModule {
}
RequiredAsteriskModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RequiredAsteriskModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskModule, declarations: [RequiredAsteriskDirective], exports: [RequiredAsteriskDirective] });
RequiredAsteriskModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredAsteriskModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RequiredAsteriskDirective],
                    exports: [RequiredAsteriskDirective],
                }]
        }] });

const ASSETS_BASE = {
    BASE: '/assets',
    ICON_POPULAR: '/assets/icons/popular',
    ICON_CHEVRON: '/assets/icons/chevrons',
    ICON_GENERAL: '/assets/icons/general',
    ICONS: '/assets/icons',
    FLAGS: '/assets/icons/flags',
    URL: '/assets/icons/git',
};

const ICONS = {
    CIRCLE_CLOSE: `${ASSETS_BASE.ICON_POPULAR}/circle-close.svg`,
    CIRCLE_INFO: `${ASSETS_BASE.ICON_POPULAR}/circle-info.svg`,
    COG_WHEEL: `${ASSETS_BASE.ICON_POPULAR}/cog-wheel.svg`,
    //PLUS: `${ASSETS_BASE.ICON_POPULAR}/plus.svg`,
    //CHECK: `${ASSETS_BASE.ICON_POPULAR}/check.svg`,
    CLOSE: `${ASSETS_BASE.ICON_POPULAR}/close.svg`,
    CLOSE_SMALL: `${ASSETS_BASE.ICON_POPULAR}/close-small.svg`,
    //CHEVRON_DOWN: `${ASSETS_BASE.ICON_CHEVRON}/chevron-down.svg`,
    //CHEVRON_RIGHT: `${ASSETS_BASE.ICON_CHEVRON}/chevron-right.svg`,
    //CHEVRON_LEFT: `${ASSETS_BASE.ICON_CHEVRON}/chevron-left.svg`,
    //CHEVRON_UP: `${ASSETS_BASE.ICON_CHEVRON}/chevron-up.svg`,
    // ARROW_UP: `${ASSETS_BASE.ICONS}/arrow_up.svg`,
    // ARROW_DOWN: `${ASSETS_BASE.ICONS}/arrow_down.svg`,
    ERROR: `${ASSETS_BASE.ICONS}/error.svg`,
    SEARCH: `${ASSETS_BASE.ICONS}/search.svg`,
    TRASH: `${ASSETS_BASE.ICON_POPULAR}/trash-01.svg`,
    EDIT: `${ASSETS_BASE.ICON_POPULAR}/edit.svg`,
    EDIT2: `${ASSETS_BASE.ICON_POPULAR}/edit2.svg`,
    //DIT_05: `${ASSETS_BASE.ICON_POPULAR}/edit-05.svg`,
    FILTER: `${ASSETS_BASE.ICON_POPULAR}/filter.svg`,
    CARD: `${ASSETS_BASE.ICONS}/card.svg`,
    DUPLICATE: `${ASSETS_BASE.ICONS}/duplicate.svg`,
    //FILE_SEARCH_02: `${ASSETS_BASE.ICON_POPULAR}/file-search-02.svg`,
    //GRID: `${ASSETS_BASE.ICONS}/grid.svg`,
    DANGER: `${ASSETS_BASE.ICONS}/danger.svg`,
    SUCCESS: `${ASSETS_BASE.ICONS}/success.svg`,
    WARNING: `${ASSETS_BASE.ICONS}/warning.svg`,
    INFO: `${ASSETS_BASE.ICONS}/info.svg`,
    //LINK_04: `${ASSETS_BASE.ICON_GENERAL}/link-04.svg`,
    //UPLOAD_01: `${ASSETS_BASE.ICON_GENERAL}/upload-01.svg`,
    //MARKER_PIN_04: `${ASSETS_BASE.ICON_GENERAL}/marker-pin-04.svg`,
    // REPEAT_04: `${ASSETS_BASE.ICON_GENERAL}/repeat-04.svg`,
    //FILE_PLUS_02: `${ASSETS_BASE.ICON_GENERAL}/file-plus-02.svg`,
    // CALENDAR: `${ASSETS_BASE.ICON_GENERAL}/calendar.svg`,
    MORE_VERTICAL: `${ASSETS_BASE.ICONS}/more-vertical.svg`,
    //REFRESH_CW_02: `${ASSETS_BASE.ICON_GENERAL}/refresh-cw-02.svg`,
    //COINS_STACKED_01: `${ASSETS_BASE.ICON_GENERAL}/coins-stacked-01.svg`,
    //EYE: `${ASSETS_BASE.ICON_POPULAR}/eye.svg`,
    DOWNLOAD: `${ASSETS_BASE.ICON_GENERAL}/download.svg`,
    XLS_UPLOAD: `${ASSETS_BASE.ICON_POPULAR}/xls-upload.svg`,
    XLS_UPLOAD_ERROR: `${ASSETS_BASE.ICON_POPULAR}/xls-upload-error.svg`,
    FILE_UPLOAD: `${ASSETS_BASE.ICON_POPULAR}/file-02.svg`,
    REMOVE_FILE: `${ASSETS_BASE.ICON_POPULAR}/remove-file.svg`,
    ACTIVITY_HEART: `${ASSETS_BASE.URL}/activity-heart.svg`,
    ACTIVITY: `${ASSETS_BASE.URL}/activity.svg`,
    AIRPLAY: `${ASSETS_BASE.URL}/airplay.svg`,
    AIRPODS: `${ASSETS_BASE.URL}/airpods.svg`,
    ALARM_CLOCK_CHECK: `${ASSETS_BASE.URL}/alarm-clock-check.svg`,
    ALARM_CLOCK_MINUS: `${ASSETS_BASE.URL}/alarm-clock-minus.svg`,
    ALARM_CLOCK_OFF: `${ASSETS_BASE.URL}/alarm-clock-off.svg`,
    ALARM_CLOCK_PLUS: `${ASSETS_BASE.URL}/alarm-clock-plus.svg`,
    ALARM_CLOCK: `${ASSETS_BASE.URL}/alarm-clock.svg`,
    ALERT_CIRCLE: `${ASSETS_BASE.URL}/alert-circle.svg`,
    ALERT_HEXAGON: `${ASSETS_BASE.URL}/alert-hexagon.svg`,
    ALERT_OCTAGON: `${ASSETS_BASE.URL}/alert-octagon.svg`,
    ALERT_SQUARE: `${ASSETS_BASE.URL}/alert-square.svg`,
    ALERT_TRIANGLE: `${ASSETS_BASE.URL}/alert-triangle.svg`,
    ALIGN_BOTTOM_01: `${ASSETS_BASE.URL}/align-bottom-01.svg`,
    ALIGN_BOTTOM_02: `${ASSETS_BASE.URL}/align-bottom-02.svg`,
    ALIGN_CENTER: `${ASSETS_BASE.URL}/align-center.svg`,
    ALIGN_HORIZONTAL_CENTRE_01: `${ASSETS_BASE.URL}/align-horizontal-centre-01.svg`,
    ALIGN_HORIZONTAL_CENTRE_02: `${ASSETS_BASE.URL}/align-horizontal-centre-02.svg`,
    ALIGN_JUSTIFY: `${ASSETS_BASE.URL}/align-justify.svg`,
    ALIGN_LEFT_01: `${ASSETS_BASE.URL}/align-left-01.svg`,
    ALIGN_LEFT_02: `${ASSETS_BASE.URL}/align-left-02.svg`,
    ALIGN_LEFT: `${ASSETS_BASE.URL}/align-left.svg`,
    ALIGN_RIGHT_01: `${ASSETS_BASE.URL}/align-right-01.svg`,
    ALIGN_RIGHT_02: `${ASSETS_BASE.URL}/align-right-02.svg`,
    ALIGN_RIGHT: `${ASSETS_BASE.URL}/align-right.svg`,
    ALIGN_TOP_ARROW_01: `${ASSETS_BASE.URL}/align-top-arrow-01.svg`,
    ALIGN_TOP_ARROW_02: `${ASSETS_BASE.URL}/align-top-arrow-02.svg`,
    ALIGN_VERTICAL_CENTER_01: `${ASSETS_BASE.URL}/align-vertical-center-01.svg`,
    ALIGN_VERTICAL_CENTER_02: `${ASSETS_BASE.URL}/align-vertical-center-02.svg`,
    ANCHOR: `${ASSETS_BASE.URL}/anchor.svg`,
    ANNOTATION_ALERT: `${ASSETS_BASE.URL}/annotation-alert.svg`,
    ANNOTATION_CHECK: `${ASSETS_BASE.URL}/annotation-check.svg`,
    ANNOTATION_DOTS: `${ASSETS_BASE.URL}/annotation-dots.svg`,
    ANNOTATION_HEART: `${ASSETS_BASE.URL}/annotation-heart.svg`,
    ANNOTATION_INFO: `${ASSETS_BASE.URL}/annotation-info.svg`,
    ANNOTATION_PLUS: `${ASSETS_BASE.URL}/annotation-plus.svg`,
    ANNOTATION_QUESTION: `${ASSETS_BASE.URL}/annotation-question.svg`,
    ANNOTATION_X: `${ASSETS_BASE.URL}/annotation-x.svg`,
    ANNOTATION: `${ASSETS_BASE.URL}/annotation.svg`,
    ANNOUNCEMENT_01: `${ASSETS_BASE.URL}/announcement-01.svg`,
    ANNOUNCEMENT_02: `${ASSETS_BASE.URL}/announcement-02.svg`,
    ANNOUNCEMENT_03: `${ASSETS_BASE.URL}/announcement-03.svg`,
    ARCHIVE: `${ASSETS_BASE.URL}/archive.svg`,
    ARROW_BLOCK_DOWN: `${ASSETS_BASE.URL}/arrow-block-down.svg`,
    ARROW_BLOCK_LEFT: `${ASSETS_BASE.URL}/arrow-block-left.svg`,
    ARROW_BLOCK_RIGHT: `${ASSETS_BASE.URL}/arrow-block-right.svg`,
    ARROW_BLOCK_UP: `${ASSETS_BASE.URL}/arrow-block-up.svg`,
    ARROW_CIRCLE_BROKEN_DOWN_LEFT: `${ASSETS_BASE.URL}/arrow-circle-broken-down-left.svg`,
    ARROW_CIRCLE_BROKEN_DOWN_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-broken-down-right.svg`,
    ARROW_CIRCLE_BROKEN_DOWN: `${ASSETS_BASE.URL}/arrow-circle-broken-down.svg`,
    ARROW_CIRCLE_BROKEN_LEFT: `${ASSETS_BASE.URL}/arrow-circle-broken-left.svg`,
    ARROW_CIRCLE_BROKEN_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-broken-right.svg`,
    ARROW_CIRCLE_BROKEN_UP_LEFT: `${ASSETS_BASE.URL}/arrow-circle-broken-up-left.svg`,
    ARROW_CIRCLE_BROKEN_UP_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-broken-up-right.svg`,
    ARROW_CIRCLE_BROKEN_UP: `${ASSETS_BASE.URL}/arrow-circle-broken-up.svg`,
    ARROW_CIRCLE_DOWN_LEFT: `${ASSETS_BASE.URL}/arrow-circle-down-left.svg`,
    ARROW_CIRCLE_DOWN_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-down-right.svg`,
    ARROW_CIRCLE_DOWN: `${ASSETS_BASE.URL}/arrow-circle-down.svg`,
    ARROW_CIRCLE_LEFT: `${ASSETS_BASE.URL}/arrow-circle-left.svg`,
    ARROW_CIRCLE_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-right.svg`,
    ARROW_CIRCLE_UP_LEFT: `${ASSETS_BASE.URL}/arrow-circle-up-left.svg`,
    ARROW_CIRCLE_UP_RIGHT: `${ASSETS_BASE.URL}/arrow-circle-up-right.svg`,
    ARROW_CIRCLE_UP: `${ASSETS_BASE.URL}/arrow-circle-up.svg`,
    ARROW_DOWN_LEFT: `${ASSETS_BASE.URL}/arrow-down-left.svg`,
    ARROW_DOWN_RIGHT: `${ASSETS_BASE.URL}/arrow-down-right.svg`,
    ARROW_DOWN: `${ASSETS_BASE.URL}/arrow-down.svg`,
    ARROW_LEFT: `${ASSETS_BASE.URL}/arrow-left.svg`,
    ARROW_NARROW_DOWN_LEFT: `${ASSETS_BASE.URL}/arrow-narrow-down-left.svg`,
    ARROW_NARROW_DOWN_RIGHT: `${ASSETS_BASE.URL}/arrow-narrow-down-right.svg`,
    ARROW_NARROW_DOWN: `${ASSETS_BASE.URL}/arrow-narrow-down.svg`,
    ARROW_NARROW_LEFT: `${ASSETS_BASE.URL}/arrow-narrow-left.svg`,
    ARROW_NARROW_RIGHT: `${ASSETS_BASE.URL}/arrow-narrow-right.svg`,
    ARROW_NARROW_UP_LEFT: `${ASSETS_BASE.URL}/arrow-narrow-up-left.svg`,
    ARROW_NARROW_UP_RIGHT: `${ASSETS_BASE.URL}/arrow-narrow-up-right.svg`,
    ARROW_NARROW_UP: `${ASSETS_BASE.URL}/arrow-narrow-up.svg`,
    ARROW_RIGHT: `${ASSETS_BASE.URL}/arrow-right.svg`,
    ARROW_SQUARE_DOWN_LEFT: `${ASSETS_BASE.URL}/arrow-square-down-left.svg`,
    ARROW_SQUARE_DOWN_RIGHT: `${ASSETS_BASE.URL}/arrow-square-down-right.svg`,
    ARROW_SQUARE_DOWN: `${ASSETS_BASE.URL}/arrow-square-down.svg`,
    ARROW_SQUARE_LEFT: `${ASSETS_BASE.URL}/arrow-square-left.svg`,
    ARROW_SQUARE_RIGHT: `${ASSETS_BASE.URL}/arrow-square-right.svg`,
    ARROW_SQUARE_UP_LEFT: `${ASSETS_BASE.URL}/arrow-square-up-left.svg`,
    ARROW_SQUARE_UP_RIGHT: `${ASSETS_BASE.URL}/arrow-square-up-right.svg`,
    ARROW_SQUARE_UP: `${ASSETS_BASE.URL}/arrow-square-up.svg`,
    ARROW_UP_LEFT: `${ASSETS_BASE.URL}/arrow-up-left.svg`,
    ARROW_UP_RIGHT: `${ASSETS_BASE.URL}/arrow-up-right.svg`,
    ARROW_UP: `${ASSETS_BASE.URL}/arrow-up.svg`,
    ARROWS_DOWN: `${ASSETS_BASE.URL}/arrows-down.svg`,
    ARROWS_LEFT: `${ASSETS_BASE.URL}/arrows-left.svg`,
    ARROWS_RIGHT: `${ASSETS_BASE.URL}/arrows-right.svg`,
    ARROWS_TRIANGLE: `${ASSETS_BASE.URL}/arrows-triangle.svg`,
    ARROWS_UP: `${ASSETS_BASE.URL}/arrows-up.svg`,
    ASTERISK_01: `${ASSETS_BASE.URL}/asterisk-01.svg`,
    ASTERISK_02: `${ASSETS_BASE.URL}/asterisk-02.svg`,
    AT_SIGN: `${ASSETS_BASE.URL}/at-sign.svg`,
    ATOM_01: `${ASSETS_BASE.URL}/atom-01.svg`,
    ATOM_02: `${ASSETS_BASE.URL}/atom-02.svg`,
    ATTACHMENT_01: `${ASSETS_BASE.URL}/attachment-01.svg`,
    ATTACHMENT_02: `${ASSETS_BASE.URL}/attachment-02.svg`,
    AWARD_01: `${ASSETS_BASE.URL}/award-01.svg`,
    AWARD_02: `${ASSETS_BASE.URL}/award-02.svg`,
    AWARD_03: `${ASSETS_BASE.URL}/award-03.svg`,
    AWARD_04: `${ASSETS_BASE.URL}/award-04.svg`,
    AWARD_05: `${ASSETS_BASE.URL}/award-05.svg`,
    BACKPACK: `${ASSETS_BASE.URL}/backpack.svg`,
    BANK_NOTE_01: `${ASSETS_BASE.URL}/bank-note-01.svg`,
    BANK_NOTE_02: `${ASSETS_BASE.URL}/bank-note-02.svg`,
    BANK_NOTE_03: `${ASSETS_BASE.URL}/bank-note-03.svg`,
    BANK: `${ASSETS_BASE.URL}/bank.svg`,
    BAR_CHART_01: `${ASSETS_BASE.URL}/bar-chart-01.svg`,
    BAR_CHART_02: `${ASSETS_BASE.URL}/bar-chart-02.svg`,
    BAR_CHART_03: `${ASSETS_BASE.URL}/bar-chart-03.svg`,
    BAR_CHART_04: `${ASSETS_BASE.URL}/bar-chart-04.svg`,
    BAR_CHART_05: `${ASSETS_BASE.URL}/bar-chart-05.svg`,
    BAR_CHART_06: `${ASSETS_BASE.URL}/bar-chart-06.svg`,
    BAR_CHART_07: `${ASSETS_BASE.URL}/bar-chart-07.svg`,
    BAR_CHART_08: `${ASSETS_BASE.URL}/bar-chart-08.svg`,
    BAR_CHART_09: `${ASSETS_BASE.URL}/bar-chart-09.svg`,
    BAR_CHART_10: `${ASSETS_BASE.URL}/bar-chart-10.svg`,
    BAR_CHART_11: `${ASSETS_BASE.URL}/bar-chart-11.svg`,
    BAR_CHART_12: `${ASSETS_BASE.URL}/bar-chart-12.svg`,
    BAR_CHART_CIRCLE_01: `${ASSETS_BASE.URL}/bar-chart-circle-01.svg`,
    BAR_CHART_CIRCLE_02: `${ASSETS_BASE.URL}/bar-chart-circle-02.svg`,
    BAR_CHART_CIRCLE_03: `${ASSETS_BASE.URL}/bar-chart-circle-03.svg`,
    BAR_CHART_SQUARE_01: `${ASSETS_BASE.URL}/bar-chart-square-01.svg`,
    BAR_CHART_SQUARE_02: `${ASSETS_BASE.URL}/bar-chart-square-02.svg`,
    BAR_CHART_SQUARE_03: `${ASSETS_BASE.URL}/bar-chart-square-03.svg`,
    BAR_CHART_SQUARE_DOWN: `${ASSETS_BASE.URL}/bar-chart-square-down.svg`,
    BAR_CHART_SQUARE_MINUS: `${ASSETS_BASE.URL}/bar-chart-square-minus.svg`,
    BAR_CHART_SQUARE_PLUS: `${ASSETS_BASE.URL}/bar-chart-square-plus.svg`,
    BAR_CHART_SQUARE_UP: `${ASSETS_BASE.URL}/bar-chart-square-up.svg`,
    BAR_LINE_CHART: `${ASSETS_BASE.URL}/bar-line-chart.svg`,
    BATTERY_CHARGING_01: `${ASSETS_BASE.URL}/battery-charging-01.svg`,
    BATTERY_CHARGING_02: `${ASSETS_BASE.URL}/battery-charging-02.svg`,
    BATTERY_EMPTY: `${ASSETS_BASE.URL}/battery-empty.svg`,
    BATTERY_FULL: `${ASSETS_BASE.URL}/battery-full.svg`,
    BATTERY_LOW: `${ASSETS_BASE.URL}/battery-low.svg`,
    BATTERY_MID: `${ASSETS_BASE.URL}/battery-mid.svg`,
    BEAKER_01: `${ASSETS_BASE.URL}/beaker-01.svg`,
    BEAKER_02: `${ASSETS_BASE.URL}/beaker-02.svg`,
    BELL_01: `${ASSETS_BASE.URL}/bell-01.svg`,
    BELL_02: `${ASSETS_BASE.URL}/bell-02.svg`,
    BELL_03: `${ASSETS_BASE.URL}/bell-03.svg`,
    BELL_04: `${ASSETS_BASE.URL}/bell-04.svg`,
    BELL_MINUS: `${ASSETS_BASE.URL}/bell-minus.svg`,
    BELL_OFF_01: `${ASSETS_BASE.URL}/bell-off-01.svg`,
    BELL_OFF_02: `${ASSETS_BASE.URL}/bell-off-02.svg`,
    BELL_OFF_03: `${ASSETS_BASE.URL}/bell-off-03.svg`,
    BELL_PLUS: `${ASSETS_BASE.URL}/bell-plus.svg`,
    BELL_RINGING_01: `${ASSETS_BASE.URL}/bell-ringing-01.svg`,
    BELL_RINGING_02: `${ASSETS_BASE.URL}/bell-ringing-02.svg`,
    BELL_RINGING_03: `${ASSETS_BASE.URL}/bell-ringing-03.svg`,
    BELL_RINGING_04: `${ASSETS_BASE.URL}/bell-ringing-04.svg`,
    BEZIER_CURVE_01: `${ASSETS_BASE.URL}/bezier-curve-01.svg`,
    BEZIER_CURVE_02: `${ASSETS_BASE.URL}/bezier-curve-02.svg`,
    BEZIER_CURVE_03: `${ASSETS_BASE.URL}/bezier-curve-03.svg`,
    BLUETOOTH_CONNECT: `${ASSETS_BASE.URL}/bluetooth-connect.svg`,
    BLUETOOTH_ON: `${ASSETS_BASE.URL}/bluetooth-on.svg`,
    BLUETOOTH_SIGNAL: `${ASSETS_BASE.URL}/bluetooth-signal.svg`,
    BLUETOOTH: `${ASSETS_BASE.URL}/bluetooth.svg`,
    BOLD_01: `${ASSETS_BASE.URL}/bold-01.svg`,
    BOLD_02: `${ASSETS_BASE.URL}/bold-02.svg`,
    BOLD_SQUARE: `${ASSETS_BASE.URL}/bold-square.svg`,
    BOOK_CLOSED: `${ASSETS_BASE.URL}/book-closed.svg`,
    BOOK_OPEN_01: `${ASSETS_BASE.URL}/book-open-01.svg`,
    BOOK_OPEN_02: `${ASSETS_BASE.URL}/book-open-02.svg`,
    BOOKMARK_ADD: `${ASSETS_BASE.URL}/bookmark-add.svg`,
    BOOKMARK_CHECK: `${ASSETS_BASE.URL}/bookmark-check.svg`,
    BOOKMARK_MINUS: `${ASSETS_BASE.URL}/bookmark-minus.svg`,
    BOOKMARK_X: `${ASSETS_BASE.URL}/bookmark-x.svg`,
    BOOKMARK: `${ASSETS_BASE.URL}/bookmark.svg`,
    BOX: `${ASSETS_BASE.URL}/box.svg`,
    BRACKETS_CHECK: `${ASSETS_BASE.URL}/brackets-check.svg`,
    BRACKETS_ELLIPSES: `${ASSETS_BASE.URL}/brackets-ellipses.svg`,
    BRACKETS_MINUS: `${ASSETS_BASE.URL}/brackets-minus.svg`,
    BRACKETS_PLUS: `${ASSETS_BASE.URL}/brackets-plus.svg`,
    BRACKETS_SLASH: `${ASSETS_BASE.URL}/brackets-slash.svg`,
    BRACKETS_X: `${ASSETS_BASE.URL}/brackets-x.svg`,
    BRACKETS: `${ASSETS_BASE.URL}/brackets.svg`,
    BRIEFCASE_01: `${ASSETS_BASE.URL}/briefcase-01.svg`,
    BRIEFCASE_02: `${ASSETS_BASE.URL}/briefcase-02.svg`,
    BROWSER: `${ASSETS_BASE.URL}/browser.svg`,
    BRUSH_01: `${ASSETS_BASE.URL}/brush-01.svg`,
    BRUSH_02: `${ASSETS_BASE.URL}/brush-02.svg`,
    BRUSH_03: `${ASSETS_BASE.URL}/brush-03.svg`,
    BUILDING_01: `${ASSETS_BASE.URL}/building-01.svg`,
    BUILDING_02: `${ASSETS_BASE.URL}/building-02.svg`,
    BUILDING_03: `${ASSETS_BASE.URL}/building-03.svg`,
    BUILDING_04: `${ASSETS_BASE.URL}/building-04.svg`,
    BUILDING_05: `${ASSETS_BASE.URL}/building-05.svg`,
    BUILDING_06: `${ASSETS_BASE.URL}/building-06.svg`,
    BUILDING_07: `${ASSETS_BASE.URL}/building-07.svg`,
    BUILDING_08: `${ASSETS_BASE.URL}/building-08.svg`,
    BUS: `${ASSETS_BASE.URL}/bus.svg`,
    CALCULATOR: `${ASSETS_BASE.URL}/calculator.svg`,
    CALENDAR_CHECK_01: `${ASSETS_BASE.URL}/calendar-check-01.svg`,
    CALENDAR_CHECK_02: `${ASSETS_BASE.URL}/calendar-check-02.svg`,
    CALENDAR_DATE: `${ASSETS_BASE.URL}/calendar-date.svg`,
    CALENDAR_HEART_01: `${ASSETS_BASE.URL}/calendar-heart-01.svg`,
    CALENDAR_HEART_02: `${ASSETS_BASE.URL}/calendar-heart-02.svg`,
    CALENDAR_MINUS_01: `${ASSETS_BASE.URL}/calendar-minus-01.svg`,
    CALENDAR_MINUS_02: `${ASSETS_BASE.URL}/calendar-minus-02.svg`,
    CALENDAR_PLUS_01: `${ASSETS_BASE.URL}/calendar-plus-01.svg`,
    CALENDAR_PLUS_02: `${ASSETS_BASE.URL}/calendar-plus-02.svg`,
    CALENDAR: `${ASSETS_BASE.URL}/calendar.svg`,
    CAMERA_01: `${ASSETS_BASE.URL}/camera-01.svg`,
    CAMERA_02: `${ASSETS_BASE.URL}/camera-02.svg`,
    CAMERA_03: `${ASSETS_BASE.URL}/camera-03.svg`,
    CAMERA_LENS: `${ASSETS_BASE.URL}/camera-lens.svg`,
    CAMERA_OFF: `${ASSETS_BASE.URL}/camera-off.svg`,
    CAMERA_PLUS: `${ASSETS_BASE.URL}/camera-plus.svg`,
    CERTIFICATE_01: `${ASSETS_BASE.URL}/certificate-01.svg`,
    CERTIFICATE_02: `${ASSETS_BASE.URL}/certificate-02.svg`,
    CHART_BREAKOUT_CIRCLE: `${ASSETS_BASE.URL}/chart-breakout-circle.svg`,
    CHART_BREAKOUT_SQUARE: `${ASSETS_BASE.URL}/chart-breakout-square.svg`,
    CHECK_CIRCLE_BROKEN: `${ASSETS_BASE.URL}/check-circle-broken.svg`,
    CHECK_CIRCLE: `${ASSETS_BASE.URL}/check-circle.svg`,
    CHECK_DONE_01: `${ASSETS_BASE.URL}/check-done-01.svg`,
    CHECK_DONE_02: `${ASSETS_BASE.URL}/check-done-02.svg`,
    CHECK_HEART: `${ASSETS_BASE.URL}/check-heart.svg`,
    CHECK_SQUARE_BROKEN: `${ASSETS_BASE.URL}/check-square-broken.svg`,
    CHECK_SQUARE: `${ASSETS_BASE.URL}/check-square.svg`,
    CHECK_VERIFIED_01: `${ASSETS_BASE.URL}/check-verified-01.svg`,
    CHECK_VERIFIED_02: `${ASSETS_BASE.URL}/check-verified-02.svg`,
    CHECK_VERIFIED_03: `${ASSETS_BASE.URL}/check-verified-03.svg`,
    CHECK: `${ASSETS_BASE.URL}/check.svg`,
    CHEVRON_DOWN_DOUBLE: `${ASSETS_BASE.URL}/chevron-down-double.svg`,
    CHEVRON_DOWN: `${ASSETS_BASE.URL}/chevron-down.svg`,
    CHEVRON_LEFT_DOUBLE: `${ASSETS_BASE.URL}/chevron-left-double.svg`,
    CHEVRON_LEFT: `${ASSETS_BASE.URL}/chevron-left.svg`,
    CHEVRON_RIGHT_DOUBLE: `${ASSETS_BASE.URL}/chevron-right-double.svg`,
    CHEVRON_RIGHT: `${ASSETS_BASE.URL}/chevron-right.svg`,
    CHEVRON_SELECTOR_HORIZONTAL: `${ASSETS_BASE.URL}/chevron-selector-horizontal.svg`,
    CHEVRON_SELECTOR_VERTICAL: `${ASSETS_BASE.URL}/chevron-selector-vertical.svg`,
    CHEVRON_UP_DOUBLE: `${ASSETS_BASE.URL}/chevron-up-double.svg`,
    CHEVRON_UP: `${ASSETS_BASE.URL}/chevron-up.svg`,
    CHROME_CAST: `${ASSETS_BASE.URL}/chrome-cast.svg`,
    CIRCLE_CUT: `${ASSETS_BASE.URL}/circle-cut.svg`,
    CIRCLE: `${ASSETS_BASE.URL}/circle.svg`,
    CLAPPERBOARD: `${ASSETS_BASE.URL}/clapperboard.svg`,
    CLIPBOARD_ATTACHMENT: `${ASSETS_BASE.URL}/clipboard-attachment.svg`,
    CLIPBOARD_CHECK: `${ASSETS_BASE.URL}/clipboard-check.svg`,
    CLIPBOARD_DOWNLOAD: `${ASSETS_BASE.URL}/clipboard-download.svg`,
    CLIPBOARD_MINUS: `${ASSETS_BASE.URL}/clipboard-minus.svg`,
    CLIPBOARD_PLUS: `${ASSETS_BASE.URL}/clipboard-plus.svg`,
    CLIPBOARD_X: `${ASSETS_BASE.URL}/clipboard-x.svg`,
    CLIPBOARD: `${ASSETS_BASE.URL}/clipboard.svg`,
    CLOCK_CHECK: `${ASSETS_BASE.URL}/clock-check.svg`,
    CLOCK_FAST_FORWARD: `${ASSETS_BASE.URL}/clock-fast-forward.svg`,
    CLOCK_PLUS: `${ASSETS_BASE.URL}/clock-plus.svg`,
    CLOCK_REFRESH: `${ASSETS_BASE.URL}/clock-refresh.svg`,
    CLOCK_REWIND: `${ASSETS_BASE.URL}/clock-rewind.svg`,
    CLOCK_SNOOZE: `${ASSETS_BASE.URL}/clock-snooze.svg`,
    CLOCK_STOPWATCH: `${ASSETS_BASE.URL}/clock-stopwatch.svg`,
    CLOCK: `${ASSETS_BASE.URL}/clock.svg`,
    CLOUD_01: `${ASSETS_BASE.URL}/cloud-01.svg`,
    CLOUD_02: `${ASSETS_BASE.URL}/cloud-02.svg`,
    CLOUD_03: `${ASSETS_BASE.URL}/cloud-03.svg`,
    CLOUD_BLANK_01: `${ASSETS_BASE.URL}/cloud-blank-01.svg`,
    CLOUD_BLANK_02: `${ASSETS_BASE.URL}/cloud-blank-02.svg`,
    CLOUD_LIGHTNING: `${ASSETS_BASE.URL}/cloud-lightning.svg`,
    CLOUD_MOON: `${ASSETS_BASE.URL}/cloud-moon.svg`,
    CLOUD_OFF: `${ASSETS_BASE.URL}/cloud-off.svg`,
    CLOUD_RAINING_01: `${ASSETS_BASE.URL}/cloud-raining-01.svg`,
    CLOUD_RAINING_02: `${ASSETS_BASE.URL}/cloud-raining-02.svg`,
    CLOUD_RAINING_03: `${ASSETS_BASE.URL}/cloud-raining-03.svg`,
    CLOUD_RAINING_04: `${ASSETS_BASE.URL}/cloud-raining-04.svg`,
    CLOUD_RAINING_05: `${ASSETS_BASE.URL}/cloud-raining-05.svg`,
    CLOUD_RAINING_06: `${ASSETS_BASE.URL}/cloud-raining-06.svg`,
    CLOUD_SNOWING_01: `${ASSETS_BASE.URL}/cloud-snowing-01.svg`,
    CLOUD_SNOWING_02: `${ASSETS_BASE.URL}/cloud-snowing-02.svg`,
    CLOUD_SUN_01: `${ASSETS_BASE.URL}/cloud-sun-01.svg`,
    CLOUD_SUN_02: `${ASSETS_BASE.URL}/cloud-sun-02.svg`,
    CLOUD_SUN_03: `${ASSETS_BASE.URL}/cloud-sun-03.svg`,
    CODE_01: `${ASSETS_BASE.URL}/code-01.svg`,
    CODE_02: `${ASSETS_BASE.URL}/code-02.svg`,
    CODE_BROWSER: `${ASSETS_BASE.URL}/code-browser.svg`,
    CODE_CIRCLE_01: `${ASSETS_BASE.URL}/code-circle-01.svg`,
    CODE_CIRCLE_02: `${ASSETS_BASE.URL}/code-circle-02.svg`,
    CODE_CIRCLE_03: `${ASSETS_BASE.URL}/code-circle-03.svg`,
    CODE_SNIPPET_01: `${ASSETS_BASE.URL}/code-snippet-01.svg`,
    CODE_SNIPPET_02: `${ASSETS_BASE.URL}/code-snippet-02.svg`,
    CODE_SQUARE_01: `${ASSETS_BASE.URL}/code-square-01.svg`,
    CODE_SQUARE_02: `${ASSETS_BASE.URL}/code-square-02.svg`,
    CODEPEN: `${ASSETS_BASE.URL}/codepen.svg`,
    COINS_01: `${ASSETS_BASE.URL}/coins-01.svg`,
    COINS_02: `${ASSETS_BASE.URL}/coins-02.svg`,
    COINS_03: `${ASSETS_BASE.URL}/coins-03.svg`,
    COINS_04: `${ASSETS_BASE.URL}/coins-04.svg`,
    COINS_HAND: `${ASSETS_BASE.URL}/coins-hand.svg`,
    COINS_STACKED_01: `${ASSETS_BASE.URL}/coins-stacked-01.svg`,
    COINS_STACKED_02: `${ASSETS_BASE.URL}/coins-stacked-02.svg`,
    COINS_STACKED_03: `${ASSETS_BASE.URL}/coins-stacked-03.svg`,
    COINS_STACKED_04: `${ASSETS_BASE.URL}/coins-stacked-04.svg`,
    COINS_SWAP_01: `${ASSETS_BASE.URL}/coins-swap-01.svg`,
    COINS_SWAP_02: `${ASSETS_BASE.URL}/coins-swap-02.svg`,
    COLORS: `${ASSETS_BASE.URL}/colors.svg`,
    COLUMNS_02: `${ASSETS_BASE.URL}/columns-02.svg`,
    COLUMNS_03: `${ASSETS_BASE.URL}/columns-03.svg`,
    COMMAND: `${ASSETS_BASE.URL}/command.svg`,
    COMPASS_01: `${ASSETS_BASE.URL}/compass-01.svg`,
    COMPASS_02: `${ASSETS_BASE.URL}/compass-02.svg`,
    COMPASS_03: `${ASSETS_BASE.URL}/compass-03.svg`,
    COMPASS: `${ASSETS_BASE.URL}/compass.svg`,
    CONTAINER: `${ASSETS_BASE.URL}/container.svg`,
    CONTRAST_01: `${ASSETS_BASE.URL}/contrast-01.svg`,
    CONTRAST_02: `${ASSETS_BASE.URL}/contrast-02.svg`,
    CONTRAST_03: `${ASSETS_BASE.URL}/contrast-03.svg`,
    COPY_01: `${ASSETS_BASE.URL}/copy-01.svg`,
    COPY_02: `${ASSETS_BASE.URL}/copy-02.svg`,
    COPY_03: `${ASSETS_BASE.URL}/copy-03.svg`,
    COPY_04: `${ASSETS_BASE.URL}/copy-04.svg`,
    COPY_05: `${ASSETS_BASE.URL}/copy-05.svg`,
    COPY_06: `${ASSETS_BASE.URL}/copy-06.svg`,
    COPY_07: `${ASSETS_BASE.URL}/copy-07.svg`,
    CORNER_DOWN_LEFT: `${ASSETS_BASE.URL}/corner-down-left.svg`,
    CORNER_DOWN_RIGHT: `${ASSETS_BASE.URL}/corner-down-right.svg`,
    CORNER_LEFT_DOWN: `${ASSETS_BASE.URL}/corner-left-down.svg`,
    CORNER_LEFT_UP: `${ASSETS_BASE.URL}/corner-left-up.svg`,
    CORNER_RIGHT_DOWN: `${ASSETS_BASE.URL}/corner-right-down.svg`,
    CORNER_RIGHT_UP: `${ASSETS_BASE.URL}/corner-right-up.svg`,
    CORNER_UP_LEFT: `${ASSETS_BASE.URL}/corner-up-left.svg`,
    CORNER_UP_RIGHT: `${ASSETS_BASE.URL}/corner-up-right.svg`,
    CPU_CHIP_01: `${ASSETS_BASE.URL}/cpu-chip-01.svg`,
    CPU_CHIP_02: `${ASSETS_BASE.URL}/cpu-chip-02.svg`,
    CREDIT_CARD_01: `${ASSETS_BASE.URL}/credit-card-01.svg`,
    CREDIT_CARD_02: `${ASSETS_BASE.URL}/credit-card-02.svg`,
    CREDIT_CARD_CHECK: `${ASSETS_BASE.URL}/credit-card-check.svg`,
    CREDIT_CARD_DOWN: `${ASSETS_BASE.URL}/credit-card-down.svg`,
    CREDIT_CARD_DOWNLOAD: `${ASSETS_BASE.URL}/credit-card-download.svg`,
    CREDIT_CARD_EDIT: `${ASSETS_BASE.URL}/credit-card-edit.svg`,
    CREDIT_CARD_LOCK: `${ASSETS_BASE.URL}/credit-card-lock.svg`,
    CREDIT_CARD_MINUS: `${ASSETS_BASE.URL}/credit-card-minus.svg`,
    CREDIT_CARD_PLUS: `${ASSETS_BASE.URL}/credit-card-plus.svg`,
    CREDIT_CARD_REFRESH: `${ASSETS_BASE.URL}/credit-card-refresh.svg`,
    CREDIT_CARD_SEARCH: `${ASSETS_BASE.URL}/credit-card-search.svg`,
    CREDIT_CARD_SHIELD: `${ASSETS_BASE.URL}/credit-card-shield.svg`,
    CREDIT_CARD_UP: `${ASSETS_BASE.URL}/credit-card-up.svg`,
    CREDIT_CARD_UPLOAD: `${ASSETS_BASE.URL}/credit-card-upload.svg`,
    CREDIT_CARD_X: `${ASSETS_BASE.URL}/credit-card-x.svg`,
    CROP_01: `${ASSETS_BASE.URL}/crop-01.svg`,
    CROP_02: `${ASSETS_BASE.URL}/crop-02.svg`,
    CRYPTOCURRENCY_01: `${ASSETS_BASE.URL}/cryptocurrency-01.svg`,
    CRYPTOCURRENCY_02: `${ASSETS_BASE.URL}/cryptocurrency-02.svg`,
    CRYPTOCURRENCY_03: `${ASSETS_BASE.URL}/cryptocurrency-03.svg`,
    CRYPTOCURRENCY_04: `${ASSETS_BASE.URL}/cryptocurrency-04.svg`,
    CUBE_01: `${ASSETS_BASE.URL}/cube-01.svg`,
    CUBE_02: `${ASSETS_BASE.URL}/cube-02.svg`,
    CUBE_03: `${ASSETS_BASE.URL}/cube-03.svg`,
    CUBE_04: `${ASSETS_BASE.URL}/cube-04.svg`,
    CUBE_OUTLINE: `${ASSETS_BASE.URL}/cube-outline.svg`,
    CURRENCY_BITCOIN_CIRCLE: `${ASSETS_BASE.URL}/currency-bitcoin-circle.svg`,
    CURRENCY_BITCOIN: `${ASSETS_BASE.URL}/currency-bitcoin.svg`,
    CURRENCY_DOLLAR_CIRCLE: `${ASSETS_BASE.URL}/currency-dollar-circle.svg`,
    CURRENCY_DOLLAR: `${ASSETS_BASE.URL}/currency-dollar.svg`,
    CURRENCY_ETHEREUM_CIRCLE: `${ASSETS_BASE.URL}/currency-ethereum-circle.svg`,
    CURRENCY_ETHEREUM: `${ASSETS_BASE.URL}/currency-ethereum.svg`,
    CURRENCY_EURO_CIRCLE: `${ASSETS_BASE.URL}/currency-euro-circle.svg`,
    CURRENCY_EURO: `${ASSETS_BASE.URL}/currency-euro.svg`,
    CURRENCY_POUND_CIRCLE: `${ASSETS_BASE.URL}/currency-pound-circle.svg`,
    CURRENCY_POUND: `${ASSETS_BASE.URL}/currency-pound.svg`,
    CURRENCY_RUBLE_CIRCLE: `${ASSETS_BASE.URL}/currency-ruble-circle.svg`,
    CURRENCY_RUBLE: `${ASSETS_BASE.URL}/currency-ruble.svg`,
    CURRENCY_RUPEE_CIRCLE: `${ASSETS_BASE.URL}/currency-rupee-circle.svg`,
    CURRENCY_RUPEE: `${ASSETS_BASE.URL}/currency-rupee.svg`,
    CURRENCY_YEN_CIRCLE: `${ASSETS_BASE.URL}/currency-yen-circle.svg`,
    CURRENCY_YEN: `${ASSETS_BASE.URL}/currency-yen.svg`,
    CURSOR_01: `${ASSETS_BASE.URL}/cursor-01.svg`,
    CURSOR_02: `${ASSETS_BASE.URL}/cursor-02.svg`,
    CURSOR_03: `${ASSETS_BASE.URL}/cursor-03.svg`,
    CURSOR_04: `${ASSETS_BASE.URL}/cursor-04.svg`,
    CURSOR_BOX: `${ASSETS_BASE.URL}/cursor-box.svg`,
    CURSOR_CLICK_01: `${ASSETS_BASE.URL}/cursor-click-01.svg`,
    CURSOR_CLICK_02: `${ASSETS_BASE.URL}/cursor-click-02.svg`,
    DATA: `${ASSETS_BASE.URL}/data.svg`,
    DATABASE_01: `${ASSETS_BASE.URL}/database-01.svg`,
    DATABASE_02: `${ASSETS_BASE.URL}/database-02.svg`,
    DATABASE_03: `${ASSETS_BASE.URL}/database-03.svg`,
    DATAFLOW_01: `${ASSETS_BASE.URL}/dataflow-01.svg`,
    DATAFLOW_02: `${ASSETS_BASE.URL}/dataflow-02.svg`,
    DATAFLOW_03: `${ASSETS_BASE.URL}/dataflow-03.svg`,
    DATAFLOW_04: `${ASSETS_BASE.URL}/dataflow-04.svg`,
    DELETE: `${ASSETS_BASE.URL}/delete.svg`,
    DIAMOND_01: `${ASSETS_BASE.URL}/diamond-01.svg`,
    DIAMOND_02: `${ASSETS_BASE.URL}/diamond-02.svg`,
    DICE_1: `${ASSETS_BASE.URL}/dice-1.svg`,
    DICE_2: `${ASSETS_BASE.URL}/dice-2.svg`,
    DICE_3: `${ASSETS_BASE.URL}/dice-3.svg`,
    DICE_4: `${ASSETS_BASE.URL}/dice-4.svg`,
    DICE_5: `${ASSETS_BASE.URL}/dice-5.svg`,
    DICE_6: `${ASSETS_BASE.URL}/dice-6.svg`,
    DISC_01: `${ASSETS_BASE.URL}/disc-01.svg`,
    DISC_02: `${ASSETS_BASE.URL}/disc-02.svg`,
    DISTRIBUTE_SPACING_HORIZONTAL: `${ASSETS_BASE.URL}/distribute-spacing-horizontal.svg`,
    DISTRIBUTE_SPACING_VERTICAL: `${ASSETS_BASE.URL}/distribute-spacing-vertical.svg`,
    DIVIDE_01: `${ASSETS_BASE.URL}/divide-01.svg`,
    DIVIDE_02: `${ASSETS_BASE.URL}/divide-02.svg`,
    DIVIDE_03: `${ASSETS_BASE.URL}/divide-03.svg`,
    DIVIDER: `${ASSETS_BASE.URL}/divider.svg`,
    DOTPOINTS_01: `${ASSETS_BASE.URL}/dotpoints-01.svg`,
    DOTPOINTS_02: `${ASSETS_BASE.URL}/dotpoints-02.svg`,
    DOTS_GRID: `${ASSETS_BASE.URL}/dots-grid.svg`,
    DOTS_HORIZONTAL: `${ASSETS_BASE.URL}/dots-horizontal.svg`,
    DOTS_VERTICAL: `${ASSETS_BASE.URL}/dots-vertical.svg`,
    DOWNLOAD_01: `${ASSETS_BASE.URL}/download-01.svg`,
    DOWNLOAD_02: `${ASSETS_BASE.URL}/download-02.svg`,
    DOWNLOAD_03: `${ASSETS_BASE.URL}/download-03.svg`,
    DOWNLOAD_04: `${ASSETS_BASE.URL}/download-04.svg`,
    DOWNLOAD_CLOUD_01: `${ASSETS_BASE.URL}/download-cloud-01.svg`,
    DOWNLOAD_CLOUD_02: `${ASSETS_BASE.URL}/download-cloud-02.svg`,
    DROP: `${ASSETS_BASE.URL}/drop.svg`,
    DROPLETS_01: `${ASSETS_BASE.URL}/droplets-01.svg`,
    DROPLETS_02: `${ASSETS_BASE.URL}/droplets-02.svg`,
    DROPLETS_03: `${ASSETS_BASE.URL}/droplets-03.svg`,
    DROPPER: `${ASSETS_BASE.URL}/dropper.svg`,
    EDIT_01: `${ASSETS_BASE.URL}/edit-01.svg`,
    EDIT_02: `${ASSETS_BASE.URL}/edit-02.svg`,
    EDIT_03: `${ASSETS_BASE.URL}/edit-03.svg`,
    EDIT_04: `${ASSETS_BASE.URL}/edit-04.svg`,
    EDIT_05: `${ASSETS_BASE.URL}/edit-05.svg`,
    EQUAL_NOT: `${ASSETS_BASE.URL}/equal-not.svg`,
    EQUAL: `${ASSETS_BASE.URL}/equal.svg`,
    ERASER: `${ASSETS_BASE.URL}/eraser.svg`,
    EXPAND_01: `${ASSETS_BASE.URL}/expand-01.svg`,
    EXPAND_02: `${ASSETS_BASE.URL}/expand-02.svg`,
    EXPAND_03: `${ASSETS_BASE.URL}/expand-03.svg`,
    EXPAND_04: `${ASSETS_BASE.URL}/expand-04.svg`,
    EXPAND_05: `${ASSETS_BASE.URL}/expand-05.svg`,
    EXPAND_06: `${ASSETS_BASE.URL}/expand-06.svg`,
    EYE_OFF: `${ASSETS_BASE.URL}/eye-off.svg`,
    EYE: `${ASSETS_BASE.URL}/eye.svg`,
    FACE_CONTENT: `${ASSETS_BASE.URL}/face-content.svg`,
    FACE_FROWN: `${ASSETS_BASE.URL}/face-frown.svg`,
    FACE_HAPPY: `${ASSETS_BASE.URL}/face-happy.svg`,
    FACE_ID_SQUARE: `${ASSETS_BASE.URL}/face-id-square.svg`,
    FACE_ID: `${ASSETS_BASE.URL}/face-id.svg`,
    FACE_NEUTRAL: `${ASSETS_BASE.URL}/face-neutral.svg`,
    FACE_SAD: `${ASSETS_BASE.URL}/face-sad.svg`,
    FACE_SMILE: `${ASSETS_BASE.URL}/face-smile.svg`,
    FACE_WINK: `${ASSETS_BASE.URL}/face-wink.svg`,
    FAST_BACKWARD: `${ASSETS_BASE.URL}/fast-backward.svg`,
    FAST_FORWARD: `${ASSETS_BASE.URL}/fast-forward.svg`,
    FEATHER: `${ASSETS_BASE.URL}/feather.svg`,
    FIGMA: `${ASSETS_BASE.URL}/figma.svg`,
    FILE_01: `${ASSETS_BASE.URL}/file-01.svg`,
    FILE_02: `${ASSETS_BASE.URL}/file-02.svg`,
    FILE_03: `${ASSETS_BASE.URL}/file-03.svg`,
    FILE_04: `${ASSETS_BASE.URL}/file-04.svg`,
    FILE_05: `${ASSETS_BASE.URL}/file-05.svg`,
    FILE_06: `${ASSETS_BASE.URL}/file-06.svg`,
    FILE_07: `${ASSETS_BASE.URL}/file-07.svg`,
    FILE_ATTACHMENT_01: `${ASSETS_BASE.URL}/file-attachment-01.svg`,
    FILE_ATTACHMENT_02: `${ASSETS_BASE.URL}/file-attachment-02.svg`,
    FILE_ATTACHMENT_03: `${ASSETS_BASE.URL}/file-attachment-03.svg`,
    FILE_ATTACHMENT_04: `${ASSETS_BASE.URL}/file-attachment-04.svg`,
    FILE_ATTACHMENT_05: `${ASSETS_BASE.URL}/file-attachment-05.svg`,
    FILE_CHECK_01: `${ASSETS_BASE.URL}/file-check-01.svg`,
    FILE_CHECK_02: `${ASSETS_BASE.URL}/file-check-02.svg`,
    FILE_CHECK_03: `${ASSETS_BASE.URL}/file-check-03.svg`,
    FILE_CODE_01: `${ASSETS_BASE.URL}/file-code-01.svg`,
    FILE_CODE_02: `${ASSETS_BASE.URL}/file-code-02.svg`,
    FILE_DOWNLOAD_01: `${ASSETS_BASE.URL}/file-download-01.svg`,
    FILE_DOWNLOAD_02: `${ASSETS_BASE.URL}/file-download-02.svg`,
    FILE_DOWNLOAD_03: `${ASSETS_BASE.URL}/file-download-03.svg`,
    FILE_HEART_01: `${ASSETS_BASE.URL}/file-heart-01.svg`,
    FILE_HEART_02: `${ASSETS_BASE.URL}/file-heart-02.svg`,
    FILE_HEART_03: `${ASSETS_BASE.URL}/file-heart-03.svg`,
    FILE_LOCK_01: `${ASSETS_BASE.URL}/file-lock-01.svg`,
    FILE_LOCK_02: `${ASSETS_BASE.URL}/file-lock-02.svg`,
    FILE_LOCK_03: `${ASSETS_BASE.URL}/file-lock-03.svg`,
    FILE_MINUS_01: `${ASSETS_BASE.URL}/file-minus-01.svg`,
    FILE_MINUS_02: `${ASSETS_BASE.URL}/file-minus-02.svg`,
    FILE_MINUS_03: `${ASSETS_BASE.URL}/file-minus-03.svg`,
    FILE_PLUS_01: `${ASSETS_BASE.URL}/file-plus-01.svg`,
    FILE_PLUS_02: `${ASSETS_BASE.URL}/file-plus-02.svg`,
    FILE_PLUS_03: `${ASSETS_BASE.URL}/file-plus-03.svg`,
    FILE_QUESTION_01: `${ASSETS_BASE.URL}/file-question-01.svg`,
    FILE_QUESTION_02: `${ASSETS_BASE.URL}/file-question-02.svg`,
    FILE_QUESTION_03: `${ASSETS_BASE.URL}/file-question-03.svg`,
    FILE_SEARCH_01: `${ASSETS_BASE.URL}/file-search-01.svg`,
    FILE_SEARCH_02: `${ASSETS_BASE.URL}/file-search-02.svg`,
    FILE_SEARCH_03: `${ASSETS_BASE.URL}/file-search-03.svg`,
    FILE_SHIELD_01: `${ASSETS_BASE.URL}/file-shield-01.svg`,
    FILE_SHIELD_02: `${ASSETS_BASE.URL}/file-shield-02.svg`,
    FILE_SHIELD_03: `${ASSETS_BASE.URL}/file-shield-03.svg`,
    FILE_X_01: `${ASSETS_BASE.URL}/file-x-01.svg`,
    FILE_X_02: `${ASSETS_BASE.URL}/file-x-02.svg`,
    FILE_X_03: `${ASSETS_BASE.URL}/file-x-03.svg`,
    FILM_01: `${ASSETS_BASE.URL}/film-01.svg`,
    FILM_02: `${ASSETS_BASE.URL}/film-02.svg`,
    FILM_03: `${ASSETS_BASE.URL}/film-03.svg`,
    FILTER_FUNNEL_01: `${ASSETS_BASE.URL}/filter-funnel-01.svg`,
    FILTER_FUNNEL_02: `${ASSETS_BASE.URL}/filter-funnel-02.svg`,
    FILTER_LINES: `${ASSETS_BASE.URL}/filter-lines.svg`,
    FINGERPRINT_01: `${ASSETS_BASE.URL}/fingerprint-01.svg`,
    FINGERPRINT_02: `${ASSETS_BASE.URL}/fingerprint-02.svg`,
    FINGERPRINT_03: `${ASSETS_BASE.URL}/fingerprint-03.svg`,
    FINGERPRINT_04: `${ASSETS_BASE.URL}/fingerprint-04.svg`,
    FLAG_01: `${ASSETS_BASE.URL}/flag-01.svg`,
    FLAG_02: `${ASSETS_BASE.URL}/flag-02.svg`,
    FLAG_03: `${ASSETS_BASE.URL}/flag-03.svg`,
    FLAG_04: `${ASSETS_BASE.URL}/flag-04.svg`,
    FLAG_05: `${ASSETS_BASE.URL}/flag-05.svg`,
    FLAG_06: `${ASSETS_BASE.URL}/flag-06.svg`,
    FLASH_OFF: `${ASSETS_BASE.URL}/flash-off.svg`,
    FLASH: `${ASSETS_BASE.URL}/flash.svg`,
    FLEX_ALIGN_BOTTOM: `${ASSETS_BASE.URL}/flex-align-bottom.svg`,
    FLEX_ALIGN_LEFT: `${ASSETS_BASE.URL}/flex-align-left.svg`,
    FLEX_ALIGN_RIGHT: `${ASSETS_BASE.URL}/flex-align-right.svg`,
    FLEX_ALIGN_TOP: `${ASSETS_BASE.URL}/flex-align-top.svg`,
    FLIP_BACKWARD: `${ASSETS_BASE.URL}/flip-backward.svg`,
    FLIP_FORWARD: `${ASSETS_BASE.URL}/flip-forward.svg`,
    FOLDER_CHECK: `${ASSETS_BASE.URL}/folder-check.svg`,
    FOLDER_CLOSED: `${ASSETS_BASE.URL}/folder-closed.svg`,
    FOLDER_CODE: `${ASSETS_BASE.URL}/folder-code.svg`,
    FOLDER_DOWNLOAD: `${ASSETS_BASE.URL}/folder-download.svg`,
    FOLDER_LOCK: `${ASSETS_BASE.URL}/folder-lock.svg`,
    FOLDER_MINUS: `${ASSETS_BASE.URL}/folder-minus.svg`,
    FOLDER_PLUS: `${ASSETS_BASE.URL}/folder-plus.svg`,
    FOLDER_QUESTION: `${ASSETS_BASE.URL}/folder-question.svg`,
    FOLDER_SEARCH: `${ASSETS_BASE.URL}/folder-search.svg`,
    FOLDER_SHIELD: `${ASSETS_BASE.URL}/folder-shield.svg`,
    FOLDER_X: `${ASSETS_BASE.URL}/folder-x.svg`,
    FOLDER: `${ASSETS_BASE.URL}/folder.svg`,
    FRAMER: `${ASSETS_BASE.URL}/framer.svg`,
    GAMING_PAD_01: `${ASSETS_BASE.URL}/gaming-pad-01.svg`,
    GAMING_PAD_02: `${ASSETS_BASE.URL}/gaming-pad-02.svg`,
    GIFT_01: `${ASSETS_BASE.URL}/gift-01.svg`,
    GIFT_02: `${ASSETS_BASE.URL}/gift-02.svg`,
    GIT_BRANCH_01: `${ASSETS_BASE.URL}/git-branch-01.svg`,
    GIT_BRANCH_02: `${ASSETS_BASE.URL}/git-branch-02.svg`,
    GIT_COMMIT: `${ASSETS_BASE.URL}/git-commit.svg`,
    GIT_MERGE: `${ASSETS_BASE.URL}/git-merge.svg`,
    GIT_PULL_REQUEST: `${ASSETS_BASE.URL}/git-pull-request.svg`,
    GLASSES_01: `${ASSETS_BASE.URL}/glasses-01.svg`,
    GLASSES_02: `${ASSETS_BASE.URL}/glasses-02.svg`,
    GLOBE_01_EDUCATION: `${ASSETS_BASE.URL}/globe-01-education.svg`,
    GLOBE_01: `${ASSETS_BASE.URL}/globe-01.svg`,
    GLOBE_02_EDUCATION: `${ASSETS_BASE.URL}/globe-02-education.svg`,
    GLOBE_02: `${ASSETS_BASE.URL}/globe-02.svg`,
    GLOBE_03: `${ASSETS_BASE.URL}/globe-03.svg`,
    GLOBE_04: `${ASSETS_BASE.URL}/globe-04.svg`,
    GLOBE_05: `${ASSETS_BASE.URL}/globe-05.svg`,
    GLOBE_06: `${ASSETS_BASE.URL}/globe-06.svg`,
    GOOGLE_CHROME: `${ASSETS_BASE.URL}/google-chrome.svg`,
    GRADUATION_HAT_01: `${ASSETS_BASE.URL}/graduation-hat-01.svg`,
    GRADUATION_HAT_02: `${ASSETS_BASE.URL}/graduation-hat-02.svg`,
    GRID_01: `${ASSETS_BASE.URL}/grid-01.svg`,
    GRID_02: `${ASSETS_BASE.URL}/grid-02.svg`,
    GRID_03: `${ASSETS_BASE.URL}/grid-03.svg`,
    GRID_DOTS_BLANK: `${ASSETS_BASE.URL}/grid-dots-blank.svg`,
    GRID_DOTS_BOTTOM: `${ASSETS_BASE.URL}/grid-dots-bottom.svg`,
    GRID_DOTS_HORIZONTAL_CENTER: `${ASSETS_BASE.URL}/grid-dots-horizontal-center.svg`,
    GRID_DOTS_LEFT: `${ASSETS_BASE.URL}/grid-dots-left.svg`,
    GRID_DOTS_OUTER: `${ASSETS_BASE.URL}/grid-dots-outer.svg`,
    GRID_DOTS_RIGHT: `${ASSETS_BASE.URL}/grid-dots-right.svg`,
    GRID_DOTS_TOP: `${ASSETS_BASE.URL}/grid-dots-top.svg`,
    GRID_DOTS_VERTICAL_CENTER: `${ASSETS_BASE.URL}/grid-dots-vertical-center.svg`,
    GRID: `${ASSETS_BASE.URL}/grid.svg`,
    HAND: `${ASSETS_BASE.URL}/hand.svg`,
    HARD_DRIVE: `${ASSETS_BASE.URL}/hard-drive.svg`,
    HASH_01: `${ASSETS_BASE.URL}/hash-01.svg`,
    HASH_02: `${ASSETS_BASE.URL}/hash-02.svg`,
    HEADING_01: `${ASSETS_BASE.URL}/heading-01.svg`,
    HEADING_02: `${ASSETS_BASE.URL}/heading-02.svg`,
    HEADING_SQUARE: `${ASSETS_BASE.URL}/heading-square.svg`,
    HEADPHONES_01: `${ASSETS_BASE.URL}/headphones-01.svg`,
    HEADPHONES_02: `${ASSETS_BASE.URL}/headphones-02.svg`,
    HEART_CIRCLE: `${ASSETS_BASE.URL}/heart-circle.svg`,
    HEART_HAND: `${ASSETS_BASE.URL}/heart-hand.svg`,
    HEART_OCTAGON: `${ASSETS_BASE.URL}/heart-octagon.svg`,
    HEART_ROUNDED: `${ASSETS_BASE.URL}/heart-rounded.svg`,
    HEART_SQUARE: `${ASSETS_BASE.URL}/heart-square.svg`,
    HEART: `${ASSETS_BASE.URL}/heart.svg`,
    HEARTS: `${ASSETS_BASE.URL}/hearts.svg`,
    HELP_CIRCLE: `${ASSETS_BASE.URL}/help-circle.svg`,
    HELP_HEXAGON: `${ASSETS_BASE.URL}/help-hexagon.svg`,
    HELP_OCTAGON_1: `${ASSETS_BASE.URL}/help-octagon-1.svg`,
    HELP_OCTAGON: `${ASSETS_BASE.URL}/help-octagon.svg`,
    HELP_SQUARE: `${ASSETS_BASE.URL}/help-square.svg`,
    HEXAGON_01: `${ASSETS_BASE.URL}/hexagon-01.svg`,
    HEXAGON_02: `${ASSETS_BASE.URL}/hexagon-02.svg`,
    HOME_01: `${ASSETS_BASE.URL}/home-01.svg`,
    HOME_02: `${ASSETS_BASE.URL}/home-02.svg`,
    HOME_03: `${ASSETS_BASE.URL}/home-03.svg`,
    HOME_04: `${ASSETS_BASE.URL}/home-04.svg`,
    HOME_05: `${ASSETS_BASE.URL}/home-05.svg`,
    HOME_LINE: `${ASSETS_BASE.URL}/home-line.svg`,
    HOME_SMILE: `${ASSETS_BASE.URL}/home-smile.svg`,
    HORIZONTAL_BAR_CHART_01: `${ASSETS_BASE.URL}/horizontal-bar-chart-01.svg`,
    HORIZONTAL_BAR_CHART_02: `${ASSETS_BASE.URL}/horizontal-bar-chart-02.svg`,
    HORIZONTAL_BAR_CHART_03: `${ASSETS_BASE.URL}/horizontal-bar-chart-03.svg`,
    HOURGLASS_01: `${ASSETS_BASE.URL}/hourglass-01.svg`,
    HOURGLASS_02: `${ASSETS_BASE.URL}/hourglass-02.svg`,
    HOURGLASS_03: `${ASSETS_BASE.URL}/hourglass-03.svg`,
    HURRICANE_01: `${ASSETS_BASE.URL}/hurricane-01.svg`,
    HURRICANE_02: `${ASSETS_BASE.URL}/hurricane-02.svg`,
    HURRICANE_03: `${ASSETS_BASE.URL}/hurricane-03.svg`,
    IMAGE_01: `${ASSETS_BASE.URL}/image-01.svg`,
    IMAGE_02: `${ASSETS_BASE.URL}/image-02.svg`,
    IMAGE_03: `${ASSETS_BASE.URL}/image-03.svg`,
    IMAGE_04: `${ASSETS_BASE.URL}/image-04.svg`,
    IMAGE_05: `${ASSETS_BASE.URL}/image-05.svg`,
    IMAGE_CHECK: `${ASSETS_BASE.URL}/image-check.svg`,
    IMAGE_DOWN: `${ASSETS_BASE.URL}/image-down.svg`,
    IMAGE_INDENT_LEFT: `${ASSETS_BASE.URL}/image-indent-left.svg`,
    IMAGE_INDENT_RIGHT: `${ASSETS_BASE.URL}/image-indent-right.svg`,
    IMAGE_LEFT: `${ASSETS_BASE.URL}/image-left.svg`,
    IMAGE_PLUS: `${ASSETS_BASE.URL}/image-plus.svg`,
    IMAGE_RIGHT: `${ASSETS_BASE.URL}/image-right.svg`,
    IMAGE_UP: `${ASSETS_BASE.URL}/image-up.svg`,
    IMAGE_USER_CHECK: `${ASSETS_BASE.URL}/image-user-check.svg`,
    IMAGE_USER_DOWN: `${ASSETS_BASE.URL}/image-user-down.svg`,
    IMAGE_USER_LEFT: `${ASSETS_BASE.URL}/image-user-left.svg`,
    IMAGE_USER_PLUS: `${ASSETS_BASE.URL}/image-user-plus.svg`,
    IMAGE_USER_RIGHT: `${ASSETS_BASE.URL}/image-user-right.svg`,
    IMAGE_USER_UP: `${ASSETS_BASE.URL}/image-user-up.svg`,
    IMAGE_USER_X: `${ASSETS_BASE.URL}/image-user-x.svg`,
    IMAGE_USER: `${ASSETS_BASE.URL}/image-user.svg`,
    IMAGE_X: `${ASSETS_BASE.URL}/image-x.svg`,
    INBOX_01: `${ASSETS_BASE.URL}/inbox-01.svg`,
    INBOX_02: `${ASSETS_BASE.URL}/inbox-02.svg`,
    INFINITY: `${ASSETS_BASE.URL}/infinity.svg`,
    INFO_CIRCLE: `${ASSETS_BASE.URL}/info-circle.svg`,
    INFO_HEXAGON: `${ASSETS_BASE.URL}/info-hexagon.svg`,
    INFO_OCTAGON: `${ASSETS_BASE.URL}/info-octagon.svg`,
    INFO_SQUARE: `${ASSETS_BASE.URL}/info-square.svg`,
    INTERSECT_CIRCLE: `${ASSETS_BASE.URL}/intersect-circle.svg`,
    INTERSECT_SQUARE: `${ASSETS_BASE.URL}/intersect-square.svg`,
    ITALIC_01: `${ASSETS_BASE.URL}/italic-01.svg`,
    ITALIC_02: `${ASSETS_BASE.URL}/italic-02.svg`,
    ITALIC_SQUARE: `${ASSETS_BASE.URL}/italic-square.svg`,
    KEY_01: `${ASSETS_BASE.URL}/key-01.svg`,
    KEY_02: `${ASSETS_BASE.URL}/key-02.svg`,
    KEYBOARD_01: `${ASSETS_BASE.URL}/keyboard-01.svg`,
    KEYBOARD_02: `${ASSETS_BASE.URL}/keyboard-02.svg`,
    LAPTOP_01: `${ASSETS_BASE.URL}/laptop-01.svg`,
    LAPTOP_02: `${ASSETS_BASE.URL}/laptop-02.svg`,
    LAYER_SINGLE: `${ASSETS_BASE.URL}/layer-single.svg`,
    LAYERS_THREE_01: `${ASSETS_BASE.URL}/layers-three-01.svg`,
    LAYERS_THREE_02: `${ASSETS_BASE.URL}/layers-three-02.svg`,
    LAYERS_TWO_01: `${ASSETS_BASE.URL}/layers-two-01.svg`,
    LAYERS_TWO_02: `${ASSETS_BASE.URL}/layers-two-02.svg`,
    LAYOUT_ALT_01: `${ASSETS_BASE.URL}/layout-alt-01.svg`,
    LAYOUT_ALT_02: `${ASSETS_BASE.URL}/layout-alt-02.svg`,
    LAYOUT_ALT_03: `${ASSETS_BASE.URL}/layout-alt-03.svg`,
    LAYOUT_ALT_04: `${ASSETS_BASE.URL}/layout-alt-04.svg`,
    LAYOUT_BOTTOM: `${ASSETS_BASE.URL}/layout-bottom.svg`,
    LAYOUT_GRID_01: `${ASSETS_BASE.URL}/layout-grid-01.svg`,
    LAYOUT_GRID_02: `${ASSETS_BASE.URL}/layout-grid-02.svg`,
    LAYOUT_LEFT: `${ASSETS_BASE.URL}/layout-left.svg`,
    LAYOUT_RIGHT: `${ASSETS_BASE.URL}/layout-right.svg`,
    LAYOUT_TOP: `${ASSETS_BASE.URL}/layout-top.svg`,
    LEFT_INDENT_01: `${ASSETS_BASE.URL}/left-indent-01.svg`,
    LEFT_INDENT_02: `${ASSETS_BASE.URL}/left-indent-02.svg`,
    LETTER_SPACING_01: `${ASSETS_BASE.URL}/letter-spacing-01.svg`,
    LETTER_SPACING_02: `${ASSETS_BASE.URL}/letter-spacing-02.svg`,
    LIFE_BUOY_01: `${ASSETS_BASE.URL}/life-buoy-01.svg`,
    LIFE_BUOY_02: `${ASSETS_BASE.URL}/life-buoy-02.svg`,
    LIGHTBULB_01: `${ASSETS_BASE.URL}/lightbulb-01.svg`,
    LIGHTBULB_02: `${ASSETS_BASE.URL}/lightbulb-02.svg`,
    LIGHTBULB_03: `${ASSETS_BASE.URL}/lightbulb-03.svg`,
    LIGHTBULB_04: `${ASSETS_BASE.URL}/lightbulb-04.svg`,
    LIGHTBULB_05: `${ASSETS_BASE.URL}/lightbulb-05.svg`,
    LIGHTNING_01: `${ASSETS_BASE.URL}/lightning-01.svg`,
    LIGHTNING_02: `${ASSETS_BASE.URL}/lightning-02.svg`,
    LINE_CHART_DOWN_01: `${ASSETS_BASE.URL}/line-chart-down-01.svg`,
    LINE_CHART_DOWN_02: `${ASSETS_BASE.URL}/line-chart-down-02.svg`,
    LINE_CHART_DOWN_03: `${ASSETS_BASE.URL}/line-chart-down-03.svg`,
    LINE_CHART_DOWN_04: `${ASSETS_BASE.URL}/line-chart-down-04.svg`,
    LINE_CHART_DOWN_05: `${ASSETS_BASE.URL}/line-chart-down-05.svg`,
    LINE_CHART_UP_01: `${ASSETS_BASE.URL}/line-chart-up-01.svg`,
    LINE_CHART_UP_02: `${ASSETS_BASE.URL}/line-chart-up-02.svg`,
    LINE_CHART_UP_03: `${ASSETS_BASE.URL}/line-chart-up-03.svg`,
    LINE_CHART_UP_04: `${ASSETS_BASE.URL}/line-chart-up-04.svg`,
    LINE_CHART_UP_05: `${ASSETS_BASE.URL}/line-chart-up-05.svg`,
    LINE_HEIGHT: `${ASSETS_BASE.URL}/line-height.svg`,
    LINK_01: `${ASSETS_BASE.URL}/link-01.svg`,
    LINK_02: `${ASSETS_BASE.URL}/link-02.svg`,
    LINK_03: `${ASSETS_BASE.URL}/link-03.svg`,
    LINK_04: `${ASSETS_BASE.URL}/link-04.svg`,
    LINK_05: `${ASSETS_BASE.URL}/link-05.svg`,
    LINK_BROKEN_01: `${ASSETS_BASE.URL}/link-broken-01.svg`,
    LINK_BROKEN_02: `${ASSETS_BASE.URL}/link-broken-02.svg`,
    LINK_EXTERNAL_01: `${ASSETS_BASE.URL}/link-external-01.svg`,
    LINK_EXTERNAL_02: `${ASSETS_BASE.URL}/link-external-02.svg`,
    LIST: `${ASSETS_BASE.URL}/list.svg`,
    LOADING_01: `${ASSETS_BASE.URL}/loading-01.svg`,
    LOADING_02: `${ASSETS_BASE.URL}/loading-02.svg`,
    LOADING_03: `${ASSETS_BASE.URL}/loading-03.svg`,
    LOCK_01: `${ASSETS_BASE.URL}/lock-01.svg`,
    LOCK_02: `${ASSETS_BASE.URL}/lock-02.svg`,
    LOCK_03: `${ASSETS_BASE.URL}/lock-03.svg`,
    LOCK_04: `${ASSETS_BASE.URL}/lock-04.svg`,
    LOCK_KEYHOLE_CIRCLE: `${ASSETS_BASE.URL}/lock-keyhole-circle.svg`,
    LOCK_KEYHOLE_SQUARE: `${ASSETS_BASE.URL}/lock-keyhole-square.svg`,
    LOCK_UNLOCKED_01: `${ASSETS_BASE.URL}/lock-unlocked-01.svg`,
    LOCK_UNLOCKED_02: `${ASSETS_BASE.URL}/lock-unlocked-02.svg`,
    LOCK_UNLOCKED_03: `${ASSETS_BASE.URL}/lock-unlocked-03.svg`,
    LOCK_UNLOCKED_04: `${ASSETS_BASE.URL}/lock-unlocked-04.svg`,
    LOG_IN_01: `${ASSETS_BASE.URL}/log-in-01.svg`,
    LOG_IN_02: `${ASSETS_BASE.URL}/log-in-02.svg`,
    LOG_IN_03: `${ASSETS_BASE.URL}/log-in-03.svg`,
    LOG_IN_04: `${ASSETS_BASE.URL}/log-in-04.svg`,
    LOG_OUT_01: `${ASSETS_BASE.URL}/log-out-01.svg`,
    LOG_OUT_02: `${ASSETS_BASE.URL}/log-out-02.svg`,
    LOG_OUT_03: `${ASSETS_BASE.URL}/log-out-03.svg`,
    LOG_OUT_04: `${ASSETS_BASE.URL}/log-out-04.svg`,
    LUGGAGE_01: `${ASSETS_BASE.URL}/luggage-01.svg`,
    LUGGAGE_02: `${ASSETS_BASE.URL}/luggage-02.svg`,
    LUGGAGE_03: `${ASSETS_BASE.URL}/luggage-03.svg`,
    MAGIC_WAND_01: `${ASSETS_BASE.URL}/magic-wand-01.svg`,
    MAGIC_WAND_02: `${ASSETS_BASE.URL}/magic-wand-02.svg`,
    MAIL_01: `${ASSETS_BASE.URL}/mail-01.svg`,
    MAIL_02: `${ASSETS_BASE.URL}/mail-02.svg`,
    MAIL_03: `${ASSETS_BASE.URL}/mail-03.svg`,
    MAIL_04: `${ASSETS_BASE.URL}/mail-04.svg`,
    MAIL_05: `${ASSETS_BASE.URL}/mail-05.svg`,
    MAP_01: `${ASSETS_BASE.URL}/map-01.svg`,
    MAP_02: `${ASSETS_BASE.URL}/map-02.svg`,
    MARK: `${ASSETS_BASE.URL}/mark.svg`,
    MARKER_PIN_01: `${ASSETS_BASE.URL}/marker-pin-01.svg`,
    MARKER_PIN_02: `${ASSETS_BASE.URL}/marker-pin-02.svg`,
    MARKER_PIN_03: `${ASSETS_BASE.URL}/marker-pin-03.svg`,
    MARKER_PIN_04: `${ASSETS_BASE.URL}/marker-pin-04.svg`,
    MARKER_PIN_05: `${ASSETS_BASE.URL}/marker-pin-05.svg`,
    MARKER_PIN_06: `${ASSETS_BASE.URL}/marker-pin-06.svg`,
    MAXIMIZE_01: `${ASSETS_BASE.URL}/maximize-01.svg`,
    MAXIMIZE_02: `${ASSETS_BASE.URL}/maximize-02.svg`,
    MEDICAL_CIRCLE: `${ASSETS_BASE.URL}/medical-circle.svg`,
    MEDICAL_CROSS: `${ASSETS_BASE.URL}/medical-cross.svg`,
    MEDICAL_SQUARE: `${ASSETS_BASE.URL}/medical-square.svg`,
    MENU_01: `${ASSETS_BASE.URL}/menu-01.svg`,
    MENU_02: `${ASSETS_BASE.URL}/menu-02.svg`,
    MENU_03: `${ASSETS_BASE.URL}/menu-03.svg`,
    MENU_04: `${ASSETS_BASE.URL}/menu-04.svg`,
    MENU_05: `${ASSETS_BASE.URL}/menu-05.svg`,
    MESSAGE_ALERT_CIRCLE: `${ASSETS_BASE.URL}/message-alert-circle.svg`,
    MESSAGE_ALERT_SQUARE: `${ASSETS_BASE.URL}/message-alert-square.svg`,
    MESSAGE_CHAT_CIRCLE: `${ASSETS_BASE.URL}/message-chat-circle.svg`,
    MESSAGE_CHAT_SQUARE: `${ASSETS_BASE.URL}/message-chat-square.svg`,
    MESSAGE_CHECK_CIRCLE: `${ASSETS_BASE.URL}/message-check-circle.svg`,
    MESSAGE_CHECK_SQUARE: `${ASSETS_BASE.URL}/message-check-square.svg`,
    MESSAGE_CIRCLE_01: `${ASSETS_BASE.URL}/message-circle-01.svg`,
    MESSAGE_CIRCLE_02: `${ASSETS_BASE.URL}/message-circle-02.svg`,
    MESSAGE_DOTS_CIRCLE: `${ASSETS_BASE.URL}/message-dots-circle.svg`,
    MESSAGE_DOTS_SQUARE: `${ASSETS_BASE.URL}/message-dots-square.svg`,
    MESSAGE_HEART_CIRCLE: `${ASSETS_BASE.URL}/message-heart-circle.svg`,
    MESSAGE_HEART_SQUARE: `${ASSETS_BASE.URL}/message-heart-square.svg`,
    MESSAGE_NOTIFICATION_CIRCLE: `${ASSETS_BASE.URL}/message-notification-circle.svg`,
    MESSAGE_NOTIFICATION_SQUARE_ALERTS: `${ASSETS_BASE.URL}/message-notification-square-alerts.svg`,
    MESSAGE_NOTIFICATION_SQUARE: `${ASSETS_BASE.URL}/message-notification-square.svg`,
    MESSAGE_PLUS_CIRCLE: `${ASSETS_BASE.URL}/message-plus-circle.svg`,
    MESSAGE_PLUS_SQUARE: `${ASSETS_BASE.URL}/message-plus-square.svg`,
    MESSAGE_QUESTION_CIRCLE: `${ASSETS_BASE.URL}/message-question-circle.svg`,
    MESSAGE_QUESTION_SQUARE: `${ASSETS_BASE.URL}/message-question-square.svg`,
    MESSAGE_SMILE_CIRCLE: `${ASSETS_BASE.URL}/message-smile-circle.svg`,
    MESSAGE_SMILE_SQUARE: `${ASSETS_BASE.URL}/message-smile-square.svg`,
    MESSAGE_SQUARE_01: `${ASSETS_BASE.URL}/message-square-01.svg`,
    MESSAGE_SQUARE_02: `${ASSETS_BASE.URL}/message-square-02.svg`,
    MESSAGE_TEXT_CIRCLE_01: `${ASSETS_BASE.URL}/message-text-circle-01.svg`,
    MESSAGE_TEXT_CIRCLE_02: `${ASSETS_BASE.URL}/message-text-circle-02.svg`,
    MESSAGE_TEXT_SQUARE_01: `${ASSETS_BASE.URL}/message-text-square-01.svg`,
    MESSAGE_TEXT_SQUARE_02: `${ASSETS_BASE.URL}/message-text-square-02.svg`,
    MESSAGE_X_CIRCLE: `${ASSETS_BASE.URL}/message-x-circle.svg`,
    MESSAGE_X_SQUARE: `${ASSETS_BASE.URL}/message-x-square.svg`,
    MICROPHONE_01: `${ASSETS_BASE.URL}/microphone-01.svg`,
    MICROPHONE_02: `${ASSETS_BASE.URL}/microphone-02.svg`,
    MICROPHONE_OFF_01: `${ASSETS_BASE.URL}/microphone-off-01.svg`,
    MICROPHONE_OFF_02: `${ASSETS_BASE.URL}/microphone-off-02.svg`,
    MICROSCOPE: `${ASSETS_BASE.URL}/microscope.svg`,
    MINIMIZE_01: `${ASSETS_BASE.URL}/minimize-01.svg`,
    MINIMIZE_02: `${ASSETS_BASE.URL}/minimize-02.svg`,
    MINUS_CIRCLE: `${ASSETS_BASE.URL}/minus-circle.svg`,
    MINUS_SQUARE: `${ASSETS_BASE.URL}/minus-square.svg`,
    MINUS: `${ASSETS_BASE.URL}/minus.svg`,
    MODEM_01: `${ASSETS_BASE.URL}/modem-01.svg`,
    MODEM_02: `${ASSETS_BASE.URL}/modem-02.svg`,
    MONITOR_01: `${ASSETS_BASE.URL}/monitor-01.svg`,
    MONITOR_02: `${ASSETS_BASE.URL}/monitor-02.svg`,
    MONITOR_03: `${ASSETS_BASE.URL}/monitor-03.svg`,
    MONITOR_04: `${ASSETS_BASE.URL}/monitor-04.svg`,
    MONITOR_05: `${ASSETS_BASE.URL}/monitor-05.svg`,
    MOON_01: `${ASSETS_BASE.URL}/moon-01.svg`,
    MOON_02: `${ASSETS_BASE.URL}/moon-02.svg`,
    MOON_ECLIPSE: `${ASSETS_BASE.URL}/moon-eclipse.svg`,
    MOON_STAR: `${ASSETS_BASE.URL}/moon-star.svg`,
    MOUSE: `${ASSETS_BASE.URL}/mouse.svg`,
    MOVE: `${ASSETS_BASE.URL}/move.svg`,
    MUSIC_NOTE_01: `${ASSETS_BASE.URL}/music-note-01.svg`,
    MUSIC_NOTE_02: `${ASSETS_BASE.URL}/music-note-02.svg`,
    MUSIC: `${ASSETS_BASE.URL}/music.svg`,
    NAVIGATION_POINTER_01: `${ASSETS_BASE.URL}/navigation-pointer-01.svg`,
    NAVIGATION_POINTER_02: `${ASSETS_BASE.URL}/navigation-pointer-02.svg`,
    NAVIGATION_POINTER_OFF_01: `${ASSETS_BASE.URL}/navigation-pointer-off-01.svg`,
    NAVIGATION_POINTER_OFF_02: `${ASSETS_BASE.URL}/navigation-pointer-off-02.svg`,
    NOTIFICATION_BOX: `${ASSETS_BASE.URL}/notification-box.svg`,
    NOTIFICATION_TEXT: `${ASSETS_BASE.URL}/notification-text.svg`,
    OCTAGON: `${ASSETS_BASE.URL}/octagon.svg`,
    PACKAGE_CHECK: `${ASSETS_BASE.URL}/package-check.svg`,
    PACKAGE_MINUS: `${ASSETS_BASE.URL}/package-minus.svg`,
    PACKAGE_PLUS: `${ASSETS_BASE.URL}/package-plus.svg`,
    PACKAGE_SEARCH: `${ASSETS_BASE.URL}/package-search.svg`,
    PACKAGE_X: `${ASSETS_BASE.URL}/package-x.svg`,
    PACKAGE: `${ASSETS_BASE.URL}/package.svg`,
    PAINT_POUR: `${ASSETS_BASE.URL}/paint-pour.svg`,
    PAINT: `${ASSETS_BASE.URL}/paint.svg`,
    PALETTE: `${ASSETS_BASE.URL}/palette.svg`,
    PAPERCLIP: `${ASSETS_BASE.URL}/paperclip.svg`,
    PARAGRAPH_SPACING: `${ASSETS_BASE.URL}/paragraph-spacing.svg`,
    PARAGRAPH_WRAP: `${ASSETS_BASE.URL}/paragraph-wrap.svg`,
    PASSCODE_LOCK: `${ASSETS_BASE.URL}/passcode-lock.svg`,
    PASSCODE: `${ASSETS_BASE.URL}/passcode.svg`,
    PASSPORT: `${ASSETS_BASE.URL}/passport.svg`,
    PAUSE_CIRCLE: `${ASSETS_BASE.URL}/pause-circle.svg`,
    PAUSE_SQUARE: `${ASSETS_BASE.URL}/pause-square.svg`,
    PEN_TOOL_01: `${ASSETS_BASE.URL}/pen-tool-01.svg`,
    PEN_TOOL_02: `${ASSETS_BASE.URL}/pen-tool-02.svg`,
    PEN_TOOL_MINUS: `${ASSETS_BASE.URL}/pen-tool-minus.svg`,
    PEN_TOOL_PLUS: `${ASSETS_BASE.URL}/pen-tool-plus.svg`,
    PENCIL_01: `${ASSETS_BASE.URL}/pencil-01.svg`,
    PENCIL_02: `${ASSETS_BASE.URL}/pencil-02.svg`,
    PENCIL_LINE: `${ASSETS_BASE.URL}/pencil-line.svg`,
    PENTAGON: `${ASSETS_BASE.URL}/pentagon.svg`,
    PERCENT_01: `${ASSETS_BASE.URL}/percent-01.svg`,
    PERCENT_02: `${ASSETS_BASE.URL}/percent-02.svg`,
    PERCENT_03: `${ASSETS_BASE.URL}/percent-03.svg`,
    PERSPECTIVE_01: `${ASSETS_BASE.URL}/perspective-01.svg`,
    PERSPECTIVE_02: `${ASSETS_BASE.URL}/perspective-02.svg`,
    PHONE_01: `${ASSETS_BASE.URL}/phone-01.svg`,
    PHONE_02: `${ASSETS_BASE.URL}/phone-02.svg`,
    PHONE_CALL_01: `${ASSETS_BASE.URL}/phone-call-01.svg`,
    PHONE_CALL_02: `${ASSETS_BASE.URL}/phone-call-02.svg`,
    PHONE_HANG_UP: `${ASSETS_BASE.URL}/phone-hang-up.svg`,
    PHONE_INCOMING_01: `${ASSETS_BASE.URL}/phone-incoming-01.svg`,
    PHONE_INCOMING_02: `${ASSETS_BASE.URL}/phone-incoming-02.svg`,
    PHONE_OUTGOING_01: `${ASSETS_BASE.URL}/phone-outgoing-01.svg`,
    PHONE_OUTGOING_02: `${ASSETS_BASE.URL}/phone-outgoing-02.svg`,
    PHONE_PAUSE: `${ASSETS_BASE.URL}/phone-pause.svg`,
    PHONE_PLUS: `${ASSETS_BASE.URL}/phone-plus.svg`,
    PHONE_X: `${ASSETS_BASE.URL}/phone-x.svg`,
    PHONE: `${ASSETS_BASE.URL}/phone.svg`,
    PIE_CHART_01: `${ASSETS_BASE.URL}/pie-chart-01.svg`,
    PIE_CHART_02: `${ASSETS_BASE.URL}/pie-chart-02.svg`,
    PIE_CHART_03: `${ASSETS_BASE.URL}/pie-chart-03.svg`,
    PIE_CHART_04: `${ASSETS_BASE.URL}/pie-chart-04.svg`,
    PIGGY_BANK_01: `${ASSETS_BASE.URL}/piggy-bank-01.svg`,
    PIGGY_BANK_02: `${ASSETS_BASE.URL}/piggy-bank-02.svg`,
    PILCROW_01: `${ASSETS_BASE.URL}/pilcrow-01.svg`,
    PILCROW_02: `${ASSETS_BASE.URL}/pilcrow-02.svg`,
    PILCROW_SQUARE: `${ASSETS_BASE.URL}/pilcrow-square.svg`,
    PIN_01: `${ASSETS_BASE.URL}/pin-01.svg`,
    PIN_02: `${ASSETS_BASE.URL}/pin-02.svg`,
    PLACEHOLDER: `${ASSETS_BASE.URL}/placeholder.svg`,
    PLANE: `${ASSETS_BASE.URL}/plane.svg`,
    PLAY_CIRCLE: `${ASSETS_BASE.URL}/play-circle.svg`,
    PLAY_SQUARE: `${ASSETS_BASE.URL}/play-square.svg`,
    PLAY: `${ASSETS_BASE.URL}/play.svg`,
    PLUS_CIRCLE: `${ASSETS_BASE.URL}/plus-circle.svg`,
    PLUS_SQUARE: `${ASSETS_BASE.URL}/plus-square.svg`,
    PLUS: `${ASSETS_BASE.URL}/plus.svg`,
    PODCAST: `${ASSETS_BASE.URL}/podcast.svg`,
    POWER_01: `${ASSETS_BASE.URL}/power-01.svg`,
    POWER_02: `${ASSETS_BASE.URL}/power-02.svg`,
    POWER_03: `${ASSETS_BASE.URL}/power-03.svg`,
    PRESENTATION_CHART_01: `${ASSETS_BASE.URL}/presentation-chart-01.svg`,
    PRESENTATION_CHART_02: `${ASSETS_BASE.URL}/presentation-chart-02.svg`,
    PRESENTATION_CHART_03: `${ASSETS_BASE.URL}/presentation-chart-03.svg`,
    PRINTER: `${ASSETS_BASE.URL}/printer.svg`,
    PUZZLE_PIECE_02: `${ASSETS_BASE.URL}/puzzle-piece-02.svg`,
    PUZZLE_PIECE: `${ASSETS_BASE.URL}/puzzle-piece.svg`,
    QR_CODE_01: `${ASSETS_BASE.URL}/qr-code-01.svg`,
    QR_CODE_02: `${ASSETS_BASE.URL}/qr-code-02.svg`,
    RECEIPT_CHECK: `${ASSETS_BASE.URL}/receipt-check.svg`,
    RECEIPT: `${ASSETS_BASE.URL}/receipt.svg`,
    RECORDING_01: `${ASSETS_BASE.URL}/recording-01.svg`,
    RECORDING_02: `${ASSETS_BASE.URL}/recording-02.svg`,
    RECORDING_03: `${ASSETS_BASE.URL}/recording-03.svg`,
    REFLECT_01: `${ASSETS_BASE.URL}/reflect-01.svg`,
    REFLECT_02: `${ASSETS_BASE.URL}/reflect-02.svg`,
    REFRESH_CCW_01: `${ASSETS_BASE.URL}/refresh-ccw-01.svg`,
    REFRESH_CCW_02: `${ASSETS_BASE.URL}/refresh-ccw-02.svg`,
    REFRESH_CCW_03: `${ASSETS_BASE.URL}/refresh-ccw-03.svg`,
    REFRESH_CCW_04: `${ASSETS_BASE.URL}/refresh-ccw-04.svg`,
    REFRESH_CCW_05: `${ASSETS_BASE.URL}/refresh-ccw-05.svg`,
    REFRESH_CW_01: `${ASSETS_BASE.URL}/refresh-cw-01.svg`,
    REFRESH_CW_02: `${ASSETS_BASE.URL}/refresh-cw-02.svg`,
    REFRESH_CW_03: `${ASSETS_BASE.URL}/refresh-cw-03.svg`,
    REFRESH_CW_04: `${ASSETS_BASE.URL}/refresh-cw-04.svg`,
    REFRESH_CW_05: `${ASSETS_BASE.URL}/refresh-cw-05.svg`,
    REPEAT_01: `${ASSETS_BASE.URL}/repeat-01.svg`,
    REPEAT_02: `${ASSETS_BASE.URL}/repeat-02.svg`,
    REPEAT_03: `${ASSETS_BASE.URL}/repeat-03.svg`,
    REPEAT_04: `${ASSETS_BASE.URL}/repeat-04.svg`,
    REVERSE_LEFT: `${ASSETS_BASE.URL}/reverse-left.svg`,
    REVERSE_RIGHT: `${ASSETS_BASE.URL}/reverse-right.svg`,
    RIGHT_INDENT_01: `${ASSETS_BASE.URL}/right-indent-01.svg`,
    RIGHT_INDENT_02: `${ASSETS_BASE.URL}/right-indent-02.svg`,
    ROCKET_01: `${ASSETS_BASE.URL}/rocket-01.svg`,
    ROCKET_02: `${ASSETS_BASE.URL}/rocket-02.svg`,
    ROLLER_BRUSH: `${ASSETS_BASE.URL}/roller-brush.svg`,
    ROUTE: `${ASSETS_BASE.URL}/route.svg`,
    ROWS_01: `${ASSETS_BASE.URL}/rows-01.svg`,
    ROWS_02: `${ASSETS_BASE.URL}/rows-02.svg`,
    ROWS_03: `${ASSETS_BASE.URL}/rows-03.svg`,
    RSS_01: `${ASSETS_BASE.URL}/rss-01.svg`,
    RSS_02: `${ASSETS_BASE.URL}/rss-02.svg`,
    RULER: `${ASSETS_BASE.URL}/ruler.svg`,
    SAFE: `${ASSETS_BASE.URL}/safe.svg`,
    SALE_01: `${ASSETS_BASE.URL}/sale-01.svg`,
    SALE_02: `${ASSETS_BASE.URL}/sale-02.svg`,
    SALE_03: `${ASSETS_BASE.URL}/sale-03.svg`,
    SALE_04: `${ASSETS_BASE.URL}/sale-04.svg`,
    SAVE_01: `${ASSETS_BASE.URL}/save-01.svg`,
    SAVE_02: `${ASSETS_BASE.URL}/save-02.svg`,
    SAVE_03: `${ASSETS_BASE.URL}/save-03.svg`,
    SCALE_01: `${ASSETS_BASE.URL}/scale-01.svg`,
    SCALE_02: `${ASSETS_BASE.URL}/scale-02.svg`,
    SCALE_03: `${ASSETS_BASE.URL}/scale-03.svg`,
    SCALES_01: `${ASSETS_BASE.URL}/scales-01.svg`,
    SCALES_02: `${ASSETS_BASE.URL}/scales-02.svg`,
    SCAN: `${ASSETS_BASE.URL}/scan.svg`,
    SCISSORS_01: `${ASSETS_BASE.URL}/scissors-01.svg`,
    SCISSORS_02: `${ASSETS_BASE.URL}/scissors-02.svg`,
    SCISSORS_CUT_01: `${ASSETS_BASE.URL}/scissors-cut-01.svg`,
    SCISSORS_CUT_02: `${ASSETS_BASE.URL}/scissors-cut-02.svg`,
    SEARCH_LG: `${ASSETS_BASE.URL}/search-lg.svg`,
    SEARCH_MD: `${ASSETS_BASE.URL}/search-md.svg`,
    SEARCH_REFRACTION: `${ASSETS_BASE.URL}/search-refraction.svg`,
    SEARCH_SM: `${ASSETS_BASE.URL}/search-sm.svg`,
    SEND_01: `${ASSETS_BASE.URL}/send-01.svg`,
    SEND_02: `${ASSETS_BASE.URL}/send-02.svg`,
    SEND_03: `${ASSETS_BASE.URL}/send-03.svg`,
    SERVER_01: `${ASSETS_BASE.URL}/server-01.svg`,
    SERVER_02: `${ASSETS_BASE.URL}/server-02.svg`,
    SERVER_03: `${ASSETS_BASE.URL}/server-03.svg`,
    SERVER_04: `${ASSETS_BASE.URL}/server-04.svg`,
    SERVER_05: `${ASSETS_BASE.URL}/server-05.svg`,
    SERVER_06: `${ASSETS_BASE.URL}/server-06.svg`,
    SETTINGS_01: `${ASSETS_BASE.URL}/settings-01.svg`,
    SETTINGS_02: `${ASSETS_BASE.URL}/settings-02.svg`,
    SETTINGS_03: `${ASSETS_BASE.URL}/settings-03.svg`,
    SETTINGS_04: `${ASSETS_BASE.URL}/settings-04.svg`,
    SHARE_01: `${ASSETS_BASE.URL}/share-01.svg`,
    SHARE_02: `${ASSETS_BASE.URL}/share-02.svg`,
    SHARE_03: `${ASSETS_BASE.URL}/share-03.svg`,
    SHARE_04: `${ASSETS_BASE.URL}/share-04.svg`,
    SHARE_05: `${ASSETS_BASE.URL}/share-05.svg`,
    SHARE_06: `${ASSETS_BASE.URL}/share-06.svg`,
    SHARE_07: `${ASSETS_BASE.URL}/share-07.svg`,
    SHIELD_01: `${ASSETS_BASE.URL}/shield-01.svg`,
    SHIELD_02: `${ASSETS_BASE.URL}/shield-02.svg`,
    SHIELD_03: `${ASSETS_BASE.URL}/shield-03.svg`,
    SHIELD_DOLLAR: `${ASSETS_BASE.URL}/shield-dollar.svg`,
    SHIELD_OFF: `${ASSETS_BASE.URL}/shield-off.svg`,
    SHIELD_PLUS: `${ASSETS_BASE.URL}/shield-plus.svg`,
    SHIELD_TICK: `${ASSETS_BASE.URL}/shield-tick.svg`,
    SHIELD_ZAP: `${ASSETS_BASE.URL}/shield-zap.svg`,
    SHOPPING_BAG_01: `${ASSETS_BASE.URL}/shopping-bag-01.svg`,
    SHOPPING_BAG_02: `${ASSETS_BASE.URL}/shopping-bag-02.svg`,
    SHOPPING_BAG_03: `${ASSETS_BASE.URL}/shopping-bag-03.svg`,
    SHOPPING_CART_01: `${ASSETS_BASE.URL}/shopping-cart-01.svg`,
    SHOPPING_CART_02: `${ASSETS_BASE.URL}/shopping-cart-02.svg`,
    SHOPPING_CART_03: `${ASSETS_BASE.URL}/shopping-cart-03.svg`,
    SHUFFLE_01: `${ASSETS_BASE.URL}/shuffle-01.svg`,
    SHUFFLE_02: `${ASSETS_BASE.URL}/shuffle-02.svg`,
    SIGNAL_01: `${ASSETS_BASE.URL}/signal-01.svg`,
    SIGNAL_02: `${ASSETS_BASE.URL}/signal-02.svg`,
    SIGNAL_03: `${ASSETS_BASE.URL}/signal-03.svg`,
    SIMCARD: `${ASSETS_BASE.URL}/simcard.svg`,
    SKEW: `${ASSETS_BASE.URL}/skew.svg`,
    SKIP_BACK: `${ASSETS_BASE.URL}/skip-back.svg`,
    SKIP_FORWARD: `${ASSETS_BASE.URL}/skip-forward.svg`,
    SLASH_CIRCLE_01: `${ASSETS_BASE.URL}/slash-circle-01.svg`,
    SLASH_CIRCLE_02: `${ASSETS_BASE.URL}/slash-circle-02.svg`,
    SLASH_DIVIDER: `${ASSETS_BASE.URL}/slash-divider.svg`,
    SLASH_OCTAGON: `${ASSETS_BASE.URL}/slash-octagon.svg`,
    SLIDERS_01: `${ASSETS_BASE.URL}/sliders-01.svg`,
    SLIDERS_02: `${ASSETS_BASE.URL}/sliders-02.svg`,
    SLIDERS_03: `${ASSETS_BASE.URL}/sliders-03.svg`,
    SLIDERS_04: `${ASSETS_BASE.URL}/sliders-04.svg`,
    SNOWFLAKE_01: `${ASSETS_BASE.URL}/snowflake-01.svg`,
    SNOWFLAKE_02: `${ASSETS_BASE.URL}/snowflake-02.svg`,
    SPACING_HEIGHT_01: `${ASSETS_BASE.URL}/spacing-height-01.svg`,
    SPACING_HEIGHT_02: `${ASSETS_BASE.URL}/spacing-height-02.svg`,
    SPACING_WIDTH_01: `${ASSETS_BASE.URL}/spacing-width-01.svg`,
    SPACING_WIDTH_02: `${ASSETS_BASE.URL}/spacing-width-02.svg`,
    SPEAKER_01: `${ASSETS_BASE.URL}/speaker-01.svg`,
    SPEAKER_02: `${ASSETS_BASE.URL}/speaker-02.svg`,
    SPEAKER_03: `${ASSETS_BASE.URL}/speaker-03.svg`,
    SPEEDOMETER_01: `${ASSETS_BASE.URL}/speedometer-01.svg`,
    SPEEDOMETER_02: `${ASSETS_BASE.URL}/speedometer-02.svg`,
    SPEEDOMETER_03: `${ASSETS_BASE.URL}/speedometer-03.svg`,
    SPEEDOMETER_04: `${ASSETS_BASE.URL}/speedometer-04.svg`,
    SQUARE: `${ASSETS_BASE.URL}/square.svg`,
    STAND: `${ASSETS_BASE.URL}/stand.svg`,
    STAR_01: `${ASSETS_BASE.URL}/star-01.svg`,
    STAR_02: `${ASSETS_BASE.URL}/star-02.svg`,
    STAR_03: `${ASSETS_BASE.URL}/star-03.svg`,
    STAR_04: `${ASSETS_BASE.URL}/star-04.svg`,
    STAR_05: `${ASSETS_BASE.URL}/star-05.svg`,
    STAR_06: `${ASSETS_BASE.URL}/star-06.svg`,
    STAR_07: `${ASSETS_BASE.URL}/star-07.svg`,
    STARS_01: `${ASSETS_BASE.URL}/stars-01.svg`,
    STARS_02: `${ASSETS_BASE.URL}/stars-02.svg`,
    STARS_03: `${ASSETS_BASE.URL}/stars-03.svg`,
    STICKER_CIRCLE: `${ASSETS_BASE.URL}/sticker-circle.svg`,
    STICKER_SQUARE: `${ASSETS_BASE.URL}/sticker-square.svg`,
    STOP_CIRCLE: `${ASSETS_BASE.URL}/stop-circle.svg`,
    STOP_SQUARE: `${ASSETS_BASE.URL}/stop-square.svg`,
    STOP: `${ASSETS_BASE.URL}/stop.svg`,
    STRIKETHROUGH_01: `${ASSETS_BASE.URL}/strikethrough-01.svg`,
    STRIKETHROUGH_02: `${ASSETS_BASE.URL}/strikethrough-02.svg`,
    STRIKETHROUGH_SQUARE: `${ASSETS_BASE.URL}/strikethrough-square.svg`,
    SUBSCRIPT: `${ASSETS_BASE.URL}/subscript.svg`,
    SUN_SETTING_01: `${ASSETS_BASE.URL}/sun-setting-01.svg`,
    SUN_SETTING_02: `${ASSETS_BASE.URL}/sun-setting-02.svg`,
    SUN_SETTING_03: `${ASSETS_BASE.URL}/sun-setting-03.svg`,
    SUN: `${ASSETS_BASE.URL}/sun.svg`,
    SUNRISE: `${ASSETS_BASE.URL}/sunrise.svg`,
    SUNSET: `${ASSETS_BASE.URL}/sunset.svg`,
    SWITCH_HORIZONTAL_01: `${ASSETS_BASE.URL}/switch-horizontal-01.svg`,
    SWITCH_HORIZONTAL_02: `${ASSETS_BASE.URL}/switch-horizontal-02.svg`,
    SWITCH_VERTICAL_01: `${ASSETS_BASE.URL}/switch-vertical-01.svg`,
    SWITCH_VERTICAL_02: `${ASSETS_BASE.URL}/switch-vertical-02.svg`,
    TABLE: `${ASSETS_BASE.URL}/table.svg`,
    TABLET_01: `${ASSETS_BASE.URL}/tablet-01.svg`,
    TABLET_02: `${ASSETS_BASE.URL}/tablet-02.svg`,
    TAG_01: `${ASSETS_BASE.URL}/tag-01.svg`,
    TAG_02: `${ASSETS_BASE.URL}/tag-02.svg`,
    TAG_03: `${ASSETS_BASE.URL}/tag-03.svg`,
    TARGET_01: `${ASSETS_BASE.URL}/target-01.svg`,
    TARGET_02: `${ASSETS_BASE.URL}/target-02.svg`,
    TARGET_03: `${ASSETS_BASE.URL}/target-03.svg`,
    TARGET_04: `${ASSETS_BASE.URL}/target-04.svg`,
    TARGET_05: `${ASSETS_BASE.URL}/target-05.svg`,
    TELESCOPE: `${ASSETS_BASE.URL}/telescope.svg`,
    TERMINAL_BROWSER: `${ASSETS_BASE.URL}/terminal-browser.svg`,
    TERMINAL_CIRCLE: `${ASSETS_BASE.URL}/terminal-circle.svg`,
    TERMINAL_SQUARE: `${ASSETS_BASE.URL}/terminal-square.svg`,
    TERMINAL: `${ASSETS_BASE.URL}/terminal.svg`,
    TEXT_INPUT: `${ASSETS_BASE.URL}/text-input.svg`,
    THERMOMETER_01: `${ASSETS_BASE.URL}/thermometer-01.svg`,
    THERMOMETER_02: `${ASSETS_BASE.URL}/thermometer-02.svg`,
    THERMOMETER_03: `${ASSETS_BASE.URL}/thermometer-03.svg`,
    THERMOMETER_COLD: `${ASSETS_BASE.URL}/thermometer-cold.svg`,
    THERMOMETER_WARM: `${ASSETS_BASE.URL}/thermometer-warm.svg`,
    THUMBS_DOWN: `${ASSETS_BASE.URL}/thumbs-down.svg`,
    THUMBS_UP: `${ASSETS_BASE.URL}/thumbs-up.svg`,
    TICKET_01: `${ASSETS_BASE.URL}/ticket-01.svg`,
    TICKET_02: `${ASSETS_BASE.URL}/ticket-02.svg`,
    TOGGLE_01_LEFT: `${ASSETS_BASE.URL}/toggle-01-left.svg`,
    TOGGLE_01_RIGHT: `${ASSETS_BASE.URL}/toggle-01-right.svg`,
    TOGGLE_02_LEFT: `${ASSETS_BASE.URL}/toggle-02-left.svg`,
    TOGGLE_02_RIGHT: `${ASSETS_BASE.URL}/toggle-02-right.svg`,
    TOGGLE_03_LEFT: `${ASSETS_BASE.URL}/toggle-03-left.svg`,
    TOGGLE_03_RIGHT: `${ASSETS_BASE.URL}/toggle-03-right.svg`,
    TOOL_01: `${ASSETS_BASE.URL}/tool-01.svg`,
    TOOL_02: `${ASSETS_BASE.URL}/tool-02.svg`,
    TRAIN: `${ASSETS_BASE.URL}/train.svg`,
    TRAM: `${ASSETS_BASE.URL}/tram.svg`,
    TRANSFORM: `${ASSETS_BASE.URL}/transform.svg`,
    TRANSLATE_01: `${ASSETS_BASE.URL}/translate-01.svg`,
    TRANSLATE_02: `${ASSETS_BASE.URL}/translate-02.svg`,
    TRASH_01: `${ASSETS_BASE.URL}/trash-01.svg`,
    TRASH_02: `${ASSETS_BASE.URL}/trash-02.svg`,
    TRASH_03: `${ASSETS_BASE.URL}/trash-03.svg`,
    TRASH_04: `${ASSETS_BASE.URL}/trash-04.svg`,
    TREND_DOWN_01: `${ASSETS_BASE.URL}/trend-down-01.svg`,
    TREND_DOWN_02: `${ASSETS_BASE.URL}/trend-down-02.svg`,
    TREND_UP_01: `${ASSETS_BASE.URL}/trend-up-01.svg`,
    TREND_UP_02: `${ASSETS_BASE.URL}/trend-up-02.svg`,
    TRIANGLE: `${ASSETS_BASE.URL}/triangle.svg`,
    TROPHY_01: `${ASSETS_BASE.URL}/trophy-01.svg`,
    TROPHY_02: `${ASSETS_BASE.URL}/trophy-02.svg`,
    TRUCK_01: `${ASSETS_BASE.URL}/truck-01.svg`,
    TRUCK_02: `${ASSETS_BASE.URL}/truck-02.svg`,
    TV_01: `${ASSETS_BASE.URL}/tv-01.svg`,
    TV_02: `${ASSETS_BASE.URL}/tv-02.svg`,
    TV_03: `${ASSETS_BASE.URL}/tv-03.svg`,
    TYPE_01: `${ASSETS_BASE.URL}/type-01.svg`,
    TYPE_02: `${ASSETS_BASE.URL}/type-02.svg`,
    TYPE_SQUARE: `${ASSETS_BASE.URL}/type-square.svg`,
    TYPE_STRIKETHROUGH_01: `${ASSETS_BASE.URL}/type-strikethrough-01.svg`,
    TYPE_STRIKETHROUGH_02: `${ASSETS_BASE.URL}/type-strikethrough-02.svg`,
    UMBRELLA_01: `${ASSETS_BASE.URL}/umbrella-01.svg`,
    UMBRELLA_02: `${ASSETS_BASE.URL}/umbrella-02.svg`,
    UMBRELLA_03: `${ASSETS_BASE.URL}/umbrella-03.svg`,
    UNDERLINE_01: `${ASSETS_BASE.URL}/underline-01.svg`,
    UNDERLINE_02: `${ASSETS_BASE.URL}/underline-02.svg`,
    UNDERLINE_SQUARE: `${ASSETS_BASE.URL}/underline-square.svg`,
    UPLOAD_01: `${ASSETS_BASE.URL}/upload-01.svg`,
    UPLOAD_02: `${ASSETS_BASE.URL}/upload-02.svg`,
    UPLOAD_03: `${ASSETS_BASE.URL}/upload-03.svg`,
    UPLOAD_04: `${ASSETS_BASE.URL}/upload-04.svg`,
    UPLOAD_CLOUD_01: `${ASSETS_BASE.URL}/upload-cloud-01.svg`,
    UPLOAD_CLOUD_02: `${ASSETS_BASE.URL}/upload-cloud-02.svg`,
    USB_FLASH_DRIVE: `${ASSETS_BASE.URL}/usb-flash-drive.svg`,
    USER_01: `${ASSETS_BASE.URL}/user-01.svg`,
    USER_02: `${ASSETS_BASE.URL}/user-02.svg`,
    USER_03: `${ASSETS_BASE.URL}/user-03.svg`,
    USER_CHECK_01: `${ASSETS_BASE.URL}/user-check-01.svg`,
    USER_CHECK_02: `${ASSETS_BASE.URL}/user-check-02.svg`,
    USER_CIRCLE: `${ASSETS_BASE.URL}/user-circle.svg`,
    USER_DOWN_01: `${ASSETS_BASE.URL}/user-down-01.svg`,
    USER_DOWN_02: `${ASSETS_BASE.URL}/user-down-02.svg`,
    USER_EDIT: `${ASSETS_BASE.URL}/user-edit.svg`,
    USER_LEFT_01: `${ASSETS_BASE.URL}/user-left-01.svg`,
    USER_LEFT_02: `${ASSETS_BASE.URL}/user-left-02.svg`,
    USER_MINUS_01: `${ASSETS_BASE.URL}/user-minus-01.svg`,
    USER_MINUS_02: `${ASSETS_BASE.URL}/user-minus-02.svg`,
    USER_PLUS_01: `${ASSETS_BASE.URL}/user-plus-01.svg`,
    USER_PLUS_02: `${ASSETS_BASE.URL}/user-plus-02.svg`,
    USER_RIGHT_01: `${ASSETS_BASE.URL}/user-right-01.svg`,
    USER_RIGHT_02: `${ASSETS_BASE.URL}/user-right-02.svg`,
    USER_SQUARE: `${ASSETS_BASE.URL}/user-square.svg`,
    USER_UP_01: `${ASSETS_BASE.URL}/user-up-01.svg`,
    USER_UP_02: `${ASSETS_BASE.URL}/user-up-02.svg`,
    USER_X_01: `${ASSETS_BASE.URL}/user-x-01.svg`,
    USER_X_02: `${ASSETS_BASE.URL}/user-x-02.svg`,
    USERS_01: `${ASSETS_BASE.URL}/users-01.svg`,
    USERS_02: `${ASSETS_BASE.URL}/users-02.svg`,
    USERS_03: `${ASSETS_BASE.URL}/users-03.svg`,
    USERS_CHECK: `${ASSETS_BASE.URL}/users-check.svg`,
    USERS_DOWN: `${ASSETS_BASE.URL}/users-down.svg`,
    USERS_EDIT: `${ASSETS_BASE.URL}/users-edit.svg`,
    USERS_LEFT: `${ASSETS_BASE.URL}/users-left.svg`,
    USERS_MINUS: `${ASSETS_BASE.URL}/users-minus.svg`,
    USERS_PLUS: `${ASSETS_BASE.URL}/users-plus.svg`,
    USERS_RIGHT: `${ASSETS_BASE.URL}/users-right.svg`,
    USERS_UP: `${ASSETS_BASE.URL}/users-up.svg`,
    USERS_X: `${ASSETS_BASE.URL}/users-x.svg`,
    VARIABLE: `${ASSETS_BASE.URL}/variable.svg`,
    VIDEO_RECORDER_OFF: `${ASSETS_BASE.URL}/video-recorder-off.svg`,
    VIDEO_RECORDER: `${ASSETS_BASE.URL}/video-recorder.svg`,
    VIRUS: `${ASSETS_BASE.URL}/virus.svg`,
    VOICEMAIL: `${ASSETS_BASE.URL}/voicemail.svg`,
    VOLUME_MAX: `${ASSETS_BASE.URL}/volume-max.svg`,
    VOLUME_MIN: `${ASSETS_BASE.URL}/volume-min.svg`,
    VOLUME_MINUS: `${ASSETS_BASE.URL}/volume-minus.svg`,
    VOLUME_PLUS: `${ASSETS_BASE.URL}/volume-plus.svg`,
    VOLUME_X: `${ASSETS_BASE.URL}/volume-x.svg`,
    WALLET_01: `${ASSETS_BASE.URL}/wallet-01.svg`,
    WALLET_02: `${ASSETS_BASE.URL}/wallet-02.svg`,
    WALLET_03: `${ASSETS_BASE.URL}/wallet-03.svg`,
    WALLET_04: `${ASSETS_BASE.URL}/wallet-04.svg`,
    WALLET_05: `${ASSETS_BASE.URL}/wallet-05.svg`,
    WATCH_CIRCLE: `${ASSETS_BASE.URL}/watch-circle.svg`,
    WATCH_SQUARE: `${ASSETS_BASE.URL}/watch-square.svg`,
    WAVES: `${ASSETS_BASE.URL}/waves.svg`,
    WEBCAM_01: `${ASSETS_BASE.URL}/webcam-01.svg`,
    WEBCAM_02: `${ASSETS_BASE.URL}/webcam-02.svg`,
    WIFI_OFF: `${ASSETS_BASE.URL}/wifi-off.svg`,
    WIFI: `${ASSETS_BASE.URL}/wifi.svg`,
    WIND_01: `${ASSETS_BASE.URL}/wind-01.svg`,
    WIND_02: `${ASSETS_BASE.URL}/wind-02.svg`,
    WIND_03: `${ASSETS_BASE.URL}/wind-03.svg`,
    X_CIRCLE: `${ASSETS_BASE.URL}/x-circle.svg`,
    X_CLOSE: `${ASSETS_BASE.URL}/x-close.svg`,
    X_SQUARE: `${ASSETS_BASE.URL}/x-square.svg`,
    X: `${ASSETS_BASE.URL}/x.svg`,
    YOUTUBE: `${ASSETS_BASE.URL}/youtube.svg`,
    ZAP_CIRCLE: `${ASSETS_BASE.URL}/zap-circle.svg`,
    ZAP_FAST: `${ASSETS_BASE.URL}/zap-fast.svg`,
    ZAP_OFF: `${ASSETS_BASE.URL}/zap-off.svg`,
    ZAP_SQUARE: `${ASSETS_BASE.URL}/zap-square.svg`,
    ZAP: `${ASSETS_BASE.URL}/zap.svg`,
    ZOOM_IN: `${ASSETS_BASE.URL}/zoom-in.svg`,
    ZOOM_OUT: `${ASSETS_BASE.URL}/zoom-out.svg`,
};

class AsolLabelFieldComponent {
    constructor(trans) {
        this.trans = trans;
        /** Header text if label is used as readonly field */
        this.text = null;
        /** Main label class */
        this.textClass = '';
        /** Main label text */
        this.labelText = null;
        /** Main label class */
        this.labelTextClass = '';
        /** Displays translated label text based on key */
        this.labelKey = '';
        /** Translation key */
        this.transKey = '';
        /**
         * Flag if template should be rendered
         * @default false
         */
        this.useTemplate = false;
        /**
         * Flag if empty text should be replaced with core constant
         * @default false
         */
        this.useDefaultText = false;
        this.isDisabled = false;
        this.width = null;
        /**
         * Custom icon
         * @default ICONS.EDIT_05
         */
        this.icon = ICONS.EDIT_05;
        /**
         * Flag to display edit icon
         * @default false
         */
        this.editable = false;
        /**
         * Event emitted when the edit icon is clicked.
         */
        this.edit = new EventEmitter();
        this.CORE_CONSTANTS = CORE_CONSTANTS;
        this.subs = new Subscription();
    }
    ngOnInit() {
        this.localizeTexts();
        this.subs.add(this.trans.languageChanged$.subscribe(() => {
            this.localizeTexts();
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    localizeTexts() {
        if (this.labelKey && this.transKey) {
            this.labelText = this.trans.get(this.transKey, this.labelKey);
        }
    }
}
AsolLabelFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolLabelFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: { text: "text", textStyle: "textStyle", textClass: "textClass", labelText: "labelText", labelTextStyle: "labelTextStyle", labelTextClass: "labelTextClass", labelKey: "labelKey", transKey: "transKey", useTemplate: "useTemplate", useDefaultText: "useDefaultText", control: "control", isDisabled: "isDisabled", isRequired: "isRequired", width: "width", icon: "icon", editable: "editable" }, outputs: { edit: "edit" }, ngImport: i0, template: "<div\n  class=\"asol-label-field\"\n  [ngClass]=\"{ 'mb-3': text || useTemplate || useDefaultText }\"\n  [ngStyle]=\"{ 'width.px': width }\">\n  <label [ngStyle]=\"labelTextStyle | unknownToObject\" [ngClass]=\"labelTextClass\"\n    >{{ labelText }}\n    <span\n      *ngIf=\"!isDisabled\"\n      requiredAsterisk\n      [isRequired]=\"isRequired\"\n      [control]=\"control\"></span>\n  </label>\n\n  <label\n    *ngIf=\"text || useTemplate || useDefaultText\"\n    [ngStyle]=\"textStyle | unknownToObject\"\n    [ngClass]=\"textClass\"\n    class=\"d-block label-text\">\n    {{\n      !text\n        ? useDefaultText\n          ? CORE_CONSTANTS.DEFAULT_RETURN_VALUE\n          : null\n        : text\n    }}\n    <ng-content> </ng-content>\n    <svg-icon\n      *ngIf=\"editable\"\n      class=\"edit-icon ms-0\"\n      [src]=\"icon\"\n      (click)=\"edit.emit()\"></svg-icon>\n  </label>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.label-text{font-weight:700;font-size:.875rem}.edit-icon{visibility:hidden}.edit-icon svg{width:1rem;height:1rem}.asol-label-field:hover .edit-icon{visibility:visible}\n"], components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: RequiredAsteriskDirective, selector: "[requiredAsterisk]", inputs: ["control", "isRequired"] }], pipes: { "unknownToObject": i1.UnknownToObjectPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-label-field', template: "<div\n  class=\"asol-label-field\"\n  [ngClass]=\"{ 'mb-3': text || useTemplate || useDefaultText }\"\n  [ngStyle]=\"{ 'width.px': width }\">\n  <label [ngStyle]=\"labelTextStyle | unknownToObject\" [ngClass]=\"labelTextClass\"\n    >{{ labelText }}\n    <span\n      *ngIf=\"!isDisabled\"\n      requiredAsterisk\n      [isRequired]=\"isRequired\"\n      [control]=\"control\"></span>\n  </label>\n\n  <label\n    *ngIf=\"text || useTemplate || useDefaultText\"\n    [ngStyle]=\"textStyle | unknownToObject\"\n    [ngClass]=\"textClass\"\n    class=\"d-block label-text\">\n    {{\n      !text\n        ? useDefaultText\n          ? CORE_CONSTANTS.DEFAULT_RETURN_VALUE\n          : null\n        : text\n    }}\n    <ng-content> </ng-content>\n    <svg-icon\n      *ngIf=\"editable\"\n      class=\"edit-icon ms-0\"\n      [src]=\"icon\"\n      (click)=\"edit.emit()\"></svg-icon>\n  </label>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.label-text{font-weight:700;font-size:.875rem}.edit-icon{visibility:hidden}.edit-icon svg{width:1rem;height:1rem}.asol-label-field:hover .edit-icon{visibility:visible}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { text: [{
                type: Input
            }], textStyle: [{
                type: Input
            }], textClass: [{
                type: Input
            }], labelText: [{
                type: Input
            }], labelTextStyle: [{
                type: Input
            }], labelTextClass: [{
                type: Input
            }], labelKey: [{
                type: Input
            }], transKey: [{
                type: Input
            }], useTemplate: [{
                type: Input
            }], useDefaultText: [{
                type: Input
            }], control: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], isRequired: [{
                type: Input
            }], width: [{
                type: Input
            }], icon: [{
                type: Input
            }], editable: [{
                type: Input
            }], edit: [{
                type: Output
            }] } });

class AsolLabelFieldModule {
}
AsolLabelFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolLabelFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldModule, declarations: [AsolLabelFieldComponent], imports: [SharedModule, PipesModule, RequiredAsteriskModule], exports: [AsolLabelFieldComponent] });
AsolLabelFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldModule, imports: [[SharedModule, PipesModule, RequiredAsteriskModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLabelFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolLabelFieldComponent],
                    exports: [AsolLabelFieldComponent],
                    imports: [SharedModule, PipesModule, RequiredAsteriskModule],
                }]
        }] });

class ControlBase {
    constructor(trans, ngControl) {
        this.trans = trans;
        this.ngControl = ngControl;
        this.ICONS = ICONS;
        this.disabledFlag = false;
        this.value = null;
        /**
         * Flag if control is focused
         */
        this.hasFocus = false;
        this.subs = new Subscription();
        this.providerSub = new Subscription();
        /** Displays placeholder text */
        this.placeholderText = '';
        /** Displays translated placeholder text based on key */
        this.placeholderKey = '';
        /** Displays label text */
        this.labelText = '';
        /** Translation key */
        this.transKey = '';
        /** Displays hint text */
        this.hintText = '';
        /** Displays translated hint text based on key */
        this.hintKey = '';
        this.formControlName = '';
        this.isReadonly = false;
        this.cssClass = '';
        this.id = null;
        this.width = null;
        /**
         * Debounce time for value changes to emit value
         * @default 1000
         */
        this.debounceTime = 1000;
        /**
         * Flag if error should be shown
         *
         * If errors are shown margin of mb-2 is added otherwise it is no margin
         *
         * @default true
         * */
        this.showError = true;
        this.valueChanged = new EventEmitter();
        this.valueChangedDebouncer = new Subject();
        if (ngControl) {
            ngControl.valueAccessor = this;
        }
    }
    /** Displays translated label text based on key */
    set labelKey(value) {
        this._labelKey = value;
        this.localizeTexts();
    }
    get labelKey() {
        return this._labelKey;
    }
    set isDisabled(value) {
        this.setDisabledState(value);
    }
    get isDisabled() {
        return this.disabledFlag;
    }
    ngOnInit() {
        this.localizeTexts();
        this.subs.add(this.trans.languageChanged$.subscribe(() => {
            this.localizeTexts();
        }));
        this.subs.add(this.valueChangedDebouncer
            .pipe(debounceTime(this.debounceTime))
            .subscribe((value) => this.valueChanged.emit(value)));
        if (this.formControlName) {
            this.id = this.formControlName;
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.setControlDisabled(this.disabledFlag);
            this.updateUI();
        });
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.subs) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.providerSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    getErrorMessages() {
        var _a, _b;
        if (!((_a = this.ngControl.control) === null || _a === void 0 ? void 0 : _a.touched) || !((_b = this.ngControl.control) === null || _b === void 0 ? void 0 : _b.errors)) {
            return [];
        }
        const errorMessages = [];
        for (const err in this.ngControl.control.errors) {
            const errorObject = this.ngControl.control.errors[err];
            // For custom validations
            if (typeof errorObject === 'string') {
                errorMessages.push(errorObject);
                return errorMessages;
            }
            switch (err) {
                case 'required':
                    errorMessages.push(this.trans.get(ERROR_TRANSLATION, 'RequiredErrorMessage'));
                    break;
                case 'minlength':
                    errorMessages.push(stringFormat(this.trans.get(ERROR_TRANSLATION, 'minValueLength'), [
                        errorObject.requiredLength,
                        errorObject.actualLength,
                    ]));
                    break;
                case 'maxlength':
                    errorMessages.push(stringFormat(this.trans.get(ERROR_TRANSLATION, 'maxValueLength'), [
                        errorObject.requiredLength,
                        errorObject.actualLength,
                    ]));
                    break;
                case 'min':
                    errorMessages.push(stringFormat(this.trans.get(ERROR_TRANSLATION, 'minValue'), [
                        errorObject.min,
                        errorObject.actual,
                    ]));
                    break;
                case 'max':
                    errorMessages.push(stringFormat(this.trans.get(ERROR_TRANSLATION, 'maxValue'), [
                        errorObject.max,
                        errorObject.actual,
                    ]));
                    break;
                case 'dateRange':
                    errorMessages.push(this.trans.get(ERROR_TRANSLATION, 'dateRangeErrorMessage'));
                    break;
                case 'maxValues':
                    errorMessages.push(this.trans.get(ERROR_TRANSLATION, 'maxValuesErrorMessage'));
                    break;
                case 'minValues':
                    errorMessages.push(this.trans.get(ERROR_TRANSLATION, 'minValuesErrorMessage'));
                    break;
                case 'duplicate':
                    errorMessages.push(this.checkErrorMessage());
                    break;
                default:
                    errorMessages.push(this.trans.get(ERROR_TRANSLATION, 'GeneralValidationErrorMessage'));
            }
        }
        return errorMessages;
    }
    propagateValue(event) {
        this.storeValue();
        this.onChange(this.value);
    }
    propagateBlur(event) {
        var _a;
        this.onTouched(event);
        this.hasFocus = false;
        (_a = this.providerSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.onFocusOut();
    }
    propagateFocusIn(event) {
        this.hasFocus = true;
    }
    writeValue(obj) {
        this.value = obj;
        this.updateUI();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    localizeTexts() {
        if (this.labelKey && this.transKey) {
            this.labelText = this.trans.get(this.transKey, this.labelKey);
        }
        if (this.placeholderKey && this.transKey) {
            this.placeholderText = this.trans.get(this.transKey, this.placeholderKey);
        }
        if (this.hintKey && this.transKey) {
            this.hintText = this.trans.get(this.transKey, this.hintKey);
        }
    }
    setDisabledState(isDisabled) {
        this.disabledFlag = isDisabled;
        this.setControlDisabled(this.disabledFlag);
    }
    storeValue() {
        this.value = this.getControlValue();
    }
    updateUI() {
        this.setControlValue(this.value);
    }
    /**
     * Error message for duplicate error
     */
    checkErrorMessage() {
        return this.trans.get(ERROR_TRANSLATION, 'duplicate');
    }
    /**
     * Event on focus out
     */
    onFocusOut() {
        //
    }
}
ControlBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ControlBase, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
ControlBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ControlBase, inputs: { placeholderText: "placeholderText", placeholderKey: "placeholderKey", labelKey: "labelKey", labelText: "labelText", labelTextStyle: "labelTextStyle", transKey: "transKey", hintText: "hintText", hintKey: "hintKey", formControlName: "formControlName", isReadonly: "isReadonly", isRequired: "isRequired", cssClass: "cssClass", id: "id", width: "width", debounceTime: "debounceTime", showError: "showError", isDisabled: "isDisabled" }, outputs: { valueChanged: "valueChanged" }, host: { listeners: { "input": "propagateValue($event)", "focusout": "propagateBlur($event)", "focusin": "propagateFocusIn($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ControlBase, decorators: [{
            type: Directive
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { placeholderText: [{
                type: Input
            }], placeholderKey: [{
                type: Input
            }], labelKey: [{
                type: Input,
                args: ['labelKey']
            }], labelText: [{
                type: Input
            }], labelTextStyle: [{
                type: Input
            }], transKey: [{
                type: Input
            }], hintText: [{
                type: Input
            }], hintKey: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isRequired: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], id: [{
                type: Input
            }], width: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], showError: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }], isDisabled: [{
                type: Input,
                args: ['isDisabled']
            }], propagateValue: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], propagateBlur: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }], propagateFocusIn: [{
                type: HostListener,
                args: ['focusin', ['$event']]
            }] } });

class AsolAutoCompleteComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.options = [];
        /** Value property in options */
        this.valueProperty = 'value';
        /** Displayed property in options */
        this.displayProperty = 'text';
        /** Group property in options */
        this.groupProperty = 'groupBy';
        /** Flag for allowing grouping */
        this.allowGrouping = false;
        /** Flag if clear button should be shown */
        this.showClearButton = true;
        /** Flag if searched text should be highlighted in pop up */
        this.highlight = true;
        /** Count of items in pop up */
        this.suggestionCount = 20;
        /** Min length of input text to start search */
        this.minLength = 2;
        /** Specifies whether the component allows user defined value which does not exist in data source */
        this.allowCustom = false;
        /** Triggers on set a custom value to this component */
        this.customValueSpecifier = new EventEmitter();
        /**
         * Triggers when user selects value from options
         * It sends whole option object
         */
        this.select = new EventEmitter();
        /** Current locale */
        this.locale = '';
        /** Flag if event listener was already added */
        this.isFirst = false;
        this.viewInitWaiter$ = new Subject();
        this.input = null;
        /**
         * Sets debounce, syncfusion documentation hack
         */
        this.setDebounce = debounce((e) => {
            this.filterWithProvider(e);
        }, this.debounceTime);
        this.field = {
            text: this.displayProperty,
            value: this.valueProperty,
        };
    }
    ngOnChanges(changes) {
        if (changes.valueProperty ||
            changes.displayProperty ||
            changes.groupProperty) {
            this.field = {
                text: this.displayProperty,
                value: this.valueProperty,
                groupBy: this.allowGrouping ? this.groupProperty : undefined,
            };
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.viewInitWaiter$.complete();
        if (this.itemTemplate) {
            this.input.itemTemplate = this.itemTemplate;
        }
        this.input.element.addEventListener('input', (e) => {
            if (this.isFirst) {
                return;
            }
            this.isFirst = true;
            this.input.element.parentElement
                .querySelector('.e-clear-icon')
                .addEventListener('mousedown', () => {
                this.onChange(null);
                this.valueChangedDebouncer.next(null);
            });
        });
    }
    /** @inheritdoc */
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.value;
    }
    /** @inheritdoc */
    setControlValue(val) {
        if (!this.input) {
            return;
        }
        this.input.value = val;
    }
    /** @inheritdoc */
    setControlDisabled(isDisable) {
        // empty
    }
    /**
     * Overrides autocomplete focuout
     */
    onFocusOut() {
        if (!this.input) {
            return;
        }
        this.input.hidePopup();
        this.input.focusOut();
    }
    /** Calls when user select an item from combobox */
    callOnChange(event, selectEmit = true) {
        if (!event.isInteracted) {
            return;
        }
        const change = !event.itemData
            ? null
            : this.valueProperty
                ? event === null || event === void 0 ? void 0 : event.itemData[this.valueProperty]
                : event === null || event === void 0 ? void 0 : event.itemData.value;
        this.onChange(change);
        this.valueChangedDebouncer.next(change);
        if (this.select.observed && selectEmit) {
            this.select.emit(event.itemData);
        }
    }
    /**
     * Event handler when user types in input field
     * @param e Args @see {@link FilteringEventArgs}
     */
    onFiltering(e) {
        if (e.text.length < this.minLength) {
            e.cancel = true;
            return;
        }
        e.preventDefaultAction = true;
        if (!this.dataProvider) {
            this.filter(e);
            return;
        }
        /** call provider only after some time */
        this.setDebounce(e);
    }
    /**
     * Filters using dataprovider
     * @param e Args @see {@link FilteringEventArgs}
     */
    filterWithProvider(e) {
        var _a;
        // start loading data, show spinner
        this.input.showSpinner();
        // cancel pending previous request if exists
        (_a = this.providerSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        // get new data
        this.providerSub = this.dataProvider
            .getAutoCompleteData({
            text: e.text,
            filter: this.filterParams,
            count: this.suggestionCount,
        })
            .pipe(catchError((error) => {
            // in case of error hide spinner
            this.input.hideSpinner();
            return throwError(() => error);
        }))
            .subscribe((data) => {
            this.options = data;
            this.filter(e);
            if (this.hasFocus) {
                setTimeout(() => this.input.showPopup(), 400);
            }
            // loading complete, hide spinner
            this.input.hideSpinner();
        });
    }
    /**
     * Triggers on set a custom value to this component
     *
     * @private
     * @param {CustomValueSpecifierEventArgs} args
     * @memberof AsolAutoCompleteComponent
     */
    onCustomValueSpecifier(args) {
        this.onChange(args.text);
        this.valueChangedDebouncer.next(args.text);
        this.customValueSpecifier.emit(args);
    }
    /**
     * Filter method to search in display and value property
     * Syncfusion autocomplete is filtering only by value, so this method is to change it
     * @param args Filtering arguments @see {@link FilteringEventArgs}
     */
    filter(args) {
        let predicate = new Predicate(this.valueProperty, 'contains', args.text, true, true);
        predicate = predicate.or(this.displayProperty, 'contains', args.text, true, true);
        let query = new Query();
        //frame the query based on search string with filter type.
        query = args.text != '' ? query.where(predicate) : query;
        //pass the filter data source, filter query to updateData method.
        args.updateData(
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.options, query);
    }
    /**
     * Gets complete selected object
     * @returns Selected entity or null
     */
    getSelectedEntity() {
        if (!this.input.value || !this.options.length) {
            return null;
        }
        return this.options.find((p) => p[this.valueProperty] === this.input.value);
    }
}
AsolAutoCompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolAutoCompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAutoCompleteComponent, selector: "asol-autocomplete", inputs: { options: "options", valueProperty: "valueProperty", displayProperty: "displayProperty", groupProperty: "groupProperty", allowGrouping: "allowGrouping", showClearButton: "showClearButton", dataProvider: "dataProvider", filterParams: "filterParams", highlight: "highlight", suggestionCount: "suggestionCount", minLength: "minLength", allowCustom: "allowCustom" }, outputs: { customValueSpecifier: "customValueSpecifier", select: "select" }, queries: [{ propertyName: "itemTemplate", first: true, predicate: ["itemTemplate"], descendants: true }], viewQueries: [{ propertyName: "input", first: true, predicate: ["autoCompleteField"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError }\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">{{ hintText }}</div>\n\n  <ejs-autocomplete\n    #autoCompleteField\n    [id]=\"id ?? 'autocompleteelement'\"\n    class=\"asol-autocomplete\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [showClearButton]=\"showClearButton\"\n    [showPopupButton]=\"true\"\n    [suggestionCount]=\"suggestionCount\"\n    [highlight]=\"highlight\"\n    [ignoreAccent]=\"true\"\n    [allowCustom]=\"allowCustom\"\n    (filtering)=\"onFiltering($event)\"\n    (select)=\"callOnChange($event)\"\n    (change)=\"callOnChange($event, false)\"\n    (customValueSpecifier)=\"onCustomValueSpecifier($event)\">\n  </ejs-autocomplete>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.e-dropdownbase.e-dd-group .e-list-group-item,.e-dropdownbase.e-dd-group .e-fixed-head{color:#172b4d;font-weight:700}.e-dropdownbase.e-dd-group .e-list-item{padding-left:1.5rem}\n"], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$1.AutoCompleteComponent, selector: "ejs-autocomplete", inputs: ["actionFailureTemplate", "allowCustom", "allowFiltering", "autofill", "cssClass", "dataSource", "enablePersistence", "enableRtl", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "groupTemplate", "headerTemplate", "highlight", "htmlAttributes", "ignoreAccent", "ignoreCase", "index", "itemTemplate", "locale", "minLength", "noRecordsTemplate", "placeholder", "popupHeight", "popupWidth", "query", "readonly", "showClearButton", "showPopupButton", "sortOrder", "suggestionCount", "text", "value", "valueTemplate", "width", "zIndex"], outputs: ["actionBegin", "actionComplete", "actionFailure", "beforeOpen", "blur", "change", "close", "created", "customValueSpecifier", "dataBound", "destroyed", "filtering", "focus", "open", "select", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-autocomplete', template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError }\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">{{ hintText }}</div>\n\n  <ejs-autocomplete\n    #autoCompleteField\n    [id]=\"id ?? 'autocompleteelement'\"\n    class=\"asol-autocomplete\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [showClearButton]=\"showClearButton\"\n    [showPopupButton]=\"true\"\n    [suggestionCount]=\"suggestionCount\"\n    [highlight]=\"highlight\"\n    [ignoreAccent]=\"true\"\n    [allowCustom]=\"allowCustom\"\n    (filtering)=\"onFiltering($event)\"\n    (select)=\"callOnChange($event)\"\n    (change)=\"callOnChange($event, false)\"\n    (customValueSpecifier)=\"onCustomValueSpecifier($event)\">\n  </ejs-autocomplete>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.e-dropdownbase.e-dd-group .e-list-group-item,.e-dropdownbase.e-dd-group .e-fixed-head{color:#172b4d;font-weight:700}.e-dropdownbase.e-dd-group .e-list-item{padding-left:1.5rem}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { options: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], groupProperty: [{
                type: Input
            }], allowGrouping: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], highlight: [{
                type: Input
            }], suggestionCount: [{
                type: Input
            }], minLength: [{
                type: Input
            }], allowCustom: [{
                type: Input
            }], customValueSpecifier: [{
                type: Output
            }], select: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['autoCompleteField']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        itemTemplate: [{
                type: ContentChild,
                args: ['itemTemplate']
            }] } });

class AsolAutoCompleteModule {
}
AsolAutoCompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolAutoCompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteModule, declarations: [AsolAutoCompleteComponent], imports: [SharedModule, AutoCompleteModule, AsolLabelFieldModule], exports: [AsolAutoCompleteComponent] });
AsolAutoCompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteModule, imports: [[SharedModule, AutoCompleteModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolAutoCompleteComponent],
                    exports: [AsolAutoCompleteComponent],
                    imports: [SharedModule, AutoCompleteModule, AsolLabelFieldModule],
                }]
        }] });

class NativeControlBase extends ControlBase {
    constructor(renderer, trans, ngControl) {
        super(trans, ngControl);
        this.renderer = renderer;
        this.trans = trans;
        this.ngControl = ngControl;
        this.input = null;
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.nativeElement.value;
    }
    setControlValue(val) {
        if (!this.input) {
            return;
        }
        if (val) {
            this.input.nativeElement.value = val;
        }
        else {
            this.input.nativeElement.value = '';
        }
    }
    setControlDisabled(isDisabled) {
        if (!this.input) {
            return;
        }
        this.renderer.setProperty(this.input.nativeElement, 'disabled', isDisabled);
    }
}
NativeControlBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NativeControlBase, deps: [{ token: i0.Renderer2 }, { token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
NativeControlBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: NativeControlBase, viewQueries: [{ propertyName: "input", first: true, predicate: ["inputField"], descendants: true }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NativeControlBase, decorators: [{
            type: Directive
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { input: [{
                type: ViewChild,
                args: ['inputField', { static: false }]
            }] } });

class AsolInputFieldComponent extends NativeControlBase {
    constructor(renderer, trans, ngControl) {
        super(renderer, trans, ngControl);
        this.ngControl = ngControl;
        /** Type of the  input field */
        this.inputType = 'text';
        /** Provider to check item for duplication */
        this.provider = null;
        /** Provider URI */
        this.providerUri = null;
        this.ICONS = ICONS;
        /**
         * Flag to show loading spinner
         */
        this.loading = null;
        /** Flag if input is valid */
        this.valid = false;
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.nativeElement.value;
    }
    focusIn(target) {
        target.parentElement.classList.add('e-input-focus');
    }
    focusOut(target) {
        target.parentElement.classList.remove('e-input-focus');
    }
    callOnChange() {
        this.onChange(this.value);
        this.valueChangedDebouncer.next(this.value);
        this.validateInput();
    }
    /**
     * Validates user input for duplicates
     */
    validateInput() {
        if (!this.provider) {
            return;
        }
        this.loading = true;
        this.provider
            .validateInput(this.providerUri, this.value)
            .pipe(finalize(() => (this.loading = false)))
            .subscribe((valid) => {
            this.valid = valid;
            if (!valid) {
                this.ngControl.control.setErrors({ duplicate: true });
            }
            else {
                RemoveValidationError(this.ngControl.control, 'duplicate');
            }
        });
    }
    /**
     * Overrides duplicate error message
     */
    checkErrorMessage() {
        if (!this.checkTransKey || !this.checkErrorKey) {
            return super.checkErrorMessage();
        }
        return this.trans.get(this.checkTransKey, this.checkErrorKey);
    }
}
AsolInputFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldComponent, deps: [{ token: i0.Renderer2 }, { token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolInputFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolInputFieldComponent, selector: "asol-input-field", inputs: { prefixIcon: "prefixIcon", suffixIcon: "suffixIcon", inputType: "inputType", provider: "provider", providerUri: "providerUri", checkTransKey: "checkTransKey", checkErrorKey: "checkErrorKey" }, usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <div\n    class=\"e-input-group asol-input\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched,\n      'e-disabled': ngControl.control?.disabled,\n      'is-valid': valid\n    }\">\n    <svg-icon\n      *ngIf=\"prefixIcon\"\n      [src]=\"prefixIcon\"\n      class=\"e-input-group-icon\"></svg-icon>\n    <input\n      #inputField\n      [id]=\"id ?? 'inputelement'\"\n      class=\"e-input\"\n      [type]=\"inputType\"\n      [ngStyle]=\"{ 'width.px': width }\"\n      [placeholder]=\"placeholderText\"\n      [disabled]=\"ngControl.control?.disabled\"\n      [readonly]=\"isReadonly\"\n      (change)=\"callOnChange()\"\n      (focus)=\"focusIn($event.target)\"\n      (blur)=\"focusOut($event.target)\" />\n\n    <svg-icon\n      *ngIf=\"suffixIcon\"\n      [src]=\"suffixIcon\"\n      class=\"e-input-group-icon\"></svg-icon>\n    <svg-icon\n      *ngIf=\"loading\"\n      [src]=\"ICONS.REFRESH_CW_02\"\n      class=\"e-input-group-icon loading-icon\"></svg-icon>\n    <svg-icon\n      *ngIf=\"!loading && valid\"\n      [src]=\"ICONS.CHECK\"\n      class=\"e-input-group-icon success-icon\"></svg-icon>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.loading-icon{animation:rotation 2s linear infinite}.loading-icon svg{width:16px;height:16px}.asol-input.e-input-group.is-valid{border-color:#36b37e!important}.success-icon svg{width:20px;height:20px}.success-icon svg path{stroke:#36b37e}\n"], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-input-field', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <div\n    class=\"e-input-group asol-input\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched,\n      'e-disabled': ngControl.control?.disabled,\n      'is-valid': valid\n    }\">\n    <svg-icon\n      *ngIf=\"prefixIcon\"\n      [src]=\"prefixIcon\"\n      class=\"e-input-group-icon\"></svg-icon>\n    <input\n      #inputField\n      [id]=\"id ?? 'inputelement'\"\n      class=\"e-input\"\n      [type]=\"inputType\"\n      [ngStyle]=\"{ 'width.px': width }\"\n      [placeholder]=\"placeholderText\"\n      [disabled]=\"ngControl.control?.disabled\"\n      [readonly]=\"isReadonly\"\n      (change)=\"callOnChange()\"\n      (focus)=\"focusIn($event.target)\"\n      (blur)=\"focusOut($event.target)\" />\n\n    <svg-icon\n      *ngIf=\"suffixIcon\"\n      [src]=\"suffixIcon\"\n      class=\"e-input-group-icon\"></svg-icon>\n    <svg-icon\n      *ngIf=\"loading\"\n      [src]=\"ICONS.REFRESH_CW_02\"\n      class=\"e-input-group-icon loading-icon\"></svg-icon>\n    <svg-icon\n      *ngIf=\"!loading && valid\"\n      [src]=\"ICONS.CHECK\"\n      class=\"e-input-group-icon success-icon\"></svg-icon>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.loading-icon{animation:rotation 2s linear infinite}.loading-icon svg{width:16px;height:16px}.asol-input.e-input-group.is-valid{border-color:#36b37e!important}.success-icon svg{width:20px;height:20px}.success-icon svg path{stroke:#36b37e}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { prefixIcon: [{
                type: Input
            }], suffixIcon: [{
                type: Input
            }], inputType: [{
                type: Input
            }], provider: [{
                type: Input
            }], providerUri: [{
                type: Input
            }], checkTransKey: [{
                type: Input
            }], checkErrorKey: [{
                type: Input
            }] } });

class AsolInputFieldModule {
}
AsolInputFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolInputFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldModule, declarations: [AsolInputFieldComponent], imports: [SharedModule, AsolLabelFieldModule], exports: [AsolInputFieldComponent] });
AsolInputFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldModule, imports: [[SharedModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInputFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolInputFieldComponent],
                    exports: [AsolInputFieldComponent],
                    imports: [SharedModule, AsolLabelFieldModule],
                }]
        }] });

class AsolSelectFieldComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        this.options = [];
        this.valueProperty = 'value';
        this.displayProperty = 'text';
        this.autofill = false;
        this.showClearButton = false;
        this.openOnFocus = true;
        /** Allows user defined value which does not exist in data source. */
        this.allowCustom = true;
        /** Defines popup width */
        this.popupWidth = '100%';
        /**
         * Allow filtering of options in dropdown
         * @default false
         */
        this.allowFiltering = false;
        this.locale = '';
        this.ICONS = ICONS;
        this.locale = this.trans.currentLocale;
    }
    ngOnInit() {
        super.ngOnInit();
        this.loadOptions();
    }
    ngOnChanges(changes) {
        if (changes.valueProperty || changes.displayProperty) {
            this.field = {
                text: this.displayProperty,
                value: this.valueProperty,
            };
        }
        if (changes.filterParams && !changes.filterParams.firstChange) {
            this.loadOptions();
        }
        if (changes['options'] && this.value) {
            this.setControlValue(this.value);
        }
    }
    ngAfterViewInit() {
        var _a;
        super.ngAfterViewInit();
        // if options are loaded via async pipe, and not using data provider, set the value
        if (!this.dataProvider && this.value && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.length)) {
            this.setControlValue(this.value);
        }
        if (this.itemTemplate) {
            this.selectInput.itemTemplate = this.itemTemplate;
        }
    }
    loadOptions() {
        if (!this.dataProvider) {
            return;
        }
        if (!this.displayProperty) {
            this.displayProperty = 'text';
        }
        if (!this.valueProperty) {
            this.valueProperty = 'value';
        }
        this.dataProvider.getData(this.filterParams).subscribe((response) => {
            this.options = response;
            this.setControlValue(this.value);
        });
    }
    callOnChange(event) {
        if (!event.isInteracted) {
            return;
        }
        const change = event.itemData
            ? this.valueProperty
                ? event.itemData[this.valueProperty]
                : event.itemData.value
            : null;
        this.onChange(change);
        this.valueChangedDebouncer.next(change);
    }
    getControlValue() {
        if (!this.selectInput) {
            return null;
        }
        return this.selectInput.value;
    }
    setControlValue(val) {
        var _a, _b, _c, _d, _e;
        if (!this.selectInput) {
            return;
        }
        if (val === null || val === void 0 ? void 0 : val.toString()) {
            if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) && this.valueProperty) {
                // Changed to == to allow for number/string comparison
                const value = this.options.find((p) => p[this.valueProperty] == val);
                if (value) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.selectInput.value = value[this.displayProperty];
                }
                else {
                    this.selectInput.value = val;
                }
            }
            else {
                this.selectInput.value = val;
            }
        }
        else {
            this.selectInput.value = '';
        }
        // Prefill require field if there is only one passible option
        if (!this.selectInput.value &&
            ((_b = this.options) === null || _b === void 0 ? void 0 : _b.length) === 1 &&
            ((_c = this.ngControl) === null || _c === void 0 ? void 0 : _c.control) &&
            typeof ((_d = this.ngControl.control) === null || _d === void 0 ? void 0 : _d.validator) === 'function' &&
            ((_e = this.ngControl.control.validator({})) === null || _e === void 0 ? void 0 : _e.required)) {
            const value = this.options[0];
            this.selectInput.value = value[this.displayProperty];
            this.onChange(value[this.valueProperty]);
        }
    }
    setControlDisabled(isDisable) {
        // empty
    }
    /**
     * Opens select popup on input focus
     */
    onFocus() {
        if (this.openOnFocus) {
            this.selectInput.showPopup();
        }
    }
    /**
     * Gets complete selected object
     * @returns Selected entity or null
     */
    getSelectedEntity() {
        var _a, _b;
        if (!this.selectInput.value || !((_a = this.options) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return (_b = this.options) === null || _b === void 0 ? void 0 : _b.find((p) => p[this.valueProperty] === this.selectInput.value);
    }
}
AsolSelectFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolSelectFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: { options: "options", valueProperty: "valueProperty", displayProperty: "displayProperty", dataProvider: "dataProvider", filterParams: "filterParams", autofill: "autofill", showClearButton: "showClearButton", openOnFocus: "openOnFocus", allowCustom: "allowCustom", popupWidth: "popupWidth", allowFiltering: "allowFiltering" }, queries: [{ propertyName: "itemTemplate", first: true, predicate: ["itemTemplate"], descendants: true }], viewQueries: [{ propertyName: "selectInput", first: true, predicate: ["comboBox"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-combobox\n    [id]=\"id ?? 'comboelement'\"\n    class=\"asol-select\"\n    #comboBox\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [popupWidth]=\"popupWidth\"\n    [autofill]=\"autofill\"\n    [showClearButton]=\"showClearButton\"\n    [allowFiltering]=\"allowFiltering\"\n    (focus)=\"onFocus()\"\n    (change)=\"callOnChange($event)\"\n    [allowCustom]=\"allowCustom\">\n  </ejs-combobox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$1.ComboBoxComponent, selector: "ejs-combobox", inputs: ["actionFailureTemplate", "allowCustom", "allowFiltering", "autofill", "cssClass", "dataSource", "enablePersistence", "enableRtl", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "groupTemplate", "headerTemplate", "htmlAttributes", "ignoreAccent", "ignoreCase", "index", "itemTemplate", "locale", "noRecordsTemplate", "placeholder", "popupHeight", "popupWidth", "query", "readonly", "showClearButton", "sortOrder", "text", "value", "valueTemplate", "width", "zIndex"], outputs: ["actionBegin", "actionComplete", "actionFailure", "beforeOpen", "blur", "change", "close", "created", "customValueSpecifier", "dataBound", "destroyed", "filtering", "focus", "open", "select", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-select-field', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-combobox\n    [id]=\"id ?? 'comboelement'\"\n    class=\"asol-select\"\n    #comboBox\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [popupWidth]=\"popupWidth\"\n    [autofill]=\"autofill\"\n    [showClearButton]=\"showClearButton\"\n    [allowFiltering]=\"allowFiltering\"\n    (focus)=\"onFocus()\"\n    (change)=\"callOnChange($event)\"\n    [allowCustom]=\"allowCustom\">\n  </ejs-combobox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { options: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], autofill: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], openOnFocus: [{
                type: Input
            }], allowCustom: [{
                type: Input
            }], popupWidth: [{
                type: Input
            }], allowFiltering: [{
                type: Input
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        itemTemplate: [{
                type: ContentChild,
                args: ['itemTemplate']
            }], selectInput: [{
                type: ViewChild,
                args: ['comboBox']
            }] } });

class AsolSelectFieldModule {
}
AsolSelectFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolSelectFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldModule, declarations: [AsolSelectFieldComponent], imports: [SharedModule, ComboBoxModule, AsolLabelFieldModule], exports: [AsolSelectFieldComponent] });
AsolSelectFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldModule, imports: [[SharedModule, ComboBoxModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolSelectFieldComponent],
                    exports: [AsolSelectFieldComponent],
                    imports: [SharedModule, ComboBoxModule, AsolLabelFieldModule],
                }]
        }] });

class AsolContentFormDirective {
    constructor() {
        /**
         * Debounce time used in formgroup changes delay in ms
         * @default 200
         */
        this.debounceTime = 200;
        /**
         * Flag if save of this form is via parent or it will be saved by its own
         * @default true
         */
        this.includeInParentSave = true;
        /**
         * Flag if listening to form changes should be done in component
         * or the component will listen to changes by itself
         */
        this.autoListenToFormChanges = true;
        /** Class holds unchanged input data for form reset */
        this.unchangedItem = null;
        /**
         * Flag if form is dirty
         */
        this.isDirty = false;
        /**
         * Subject when form becomes dirty
         */
        this.isDirty$ = new Subject();
        this.sub = new Subscription();
    }
    /**
     * Flag if form should be disabled
     * @default false
     */
    set isDisabled(value) {
        if (value) {
            this.formGroup.disable();
        }
        else {
            this.formGroup.enable();
        }
    }
    set data(value) {
        this._data = value;
        this.parseItem();
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
        if (this.data) {
            this.parseItem();
        }
    }
    ngAfterViewInit() {
        if (this.autoListenToFormChanges) {
            this.listenToFormChanges();
        }
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Saves inner form data
     */
    saveData() {
        // virtual method implementation
    }
    /**
     * Resets the form to initial state using item property
     */
    resetForm() {
        this.formGroup.reset(Object.assign({}, this.unchangedItem));
    }
    /**
     * Gets inner form data
     */
    getData() {
        return Object.assign({}, this.formGroup.value);
    }
    /**
     * Validates the form
     * @returns True if validation success
     */
    validate() {
        markForValidation(this.formGroup);
        return this.formGroup.disabled || this.formGroup.valid;
    }
    /**
     * Parses item into form and unchaged item after loaded from API
     * @returns
     */
    parseItem() {
        if (!this.data) {
            this.unchangedItem = null;
            this.resetForm();
            this.afterParseItem(this.data);
            return;
        }
        this.formGroup.patchValue(this.data, {
            emitEvent: false,
            onlySelf: true,
        });
        // parse item to revert changes of form
        this.unchangedItem = Object.assign({}, this.data);
        this.afterParseItem(this.data);
    }
    /**
     * Method that is called when form value changes
     */
    formValueChanged() {
        // to override
    }
    /**
     * Method that is called when item is parsed
     * @param data the data to obtain
     */
    afterParseItem(data) {
        // to override
    }
    /**
     * Starts listen to form value changes and emits state of form
     */
    listenToFormChanges() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.sub = this.formGroup.valueChanges
            .pipe(debounceTime(this.debounceTime))
            .subscribe(() => {
            this.formValueChanged();
            this.isDirty$.next(this.formGroup.dirty);
            this.isDirty = this.formGroup.dirty;
        });
    }
}
AsolContentFormDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentFormDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AsolContentFormDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: AsolContentFormDirective, selector: "[contentForm]", inputs: { isDisabled: "isDisabled", debounceTime: "debounceTime", data: "data", includeInParentSave: "includeInParentSave", autoListenToFormChanges: "autoListenToFormChanges" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentFormDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[contentForm]',
                }]
        }], propDecorators: { isDisabled: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], data: [{
                type: Input
            }], includeInParentSave: [{
                type: Input
            }], autoListenToFormChanges: [{
                type: Input
            }] } });

var translation$i = {
    "sk-SK": {
        street: "Ulica",
        postCode: "PSČ",
        city: "Mesto",
        region: "Kraj",
        county: "Okres",
        state: "Štát",
        orientationNumber: "Orientačné číslo",
        registrationNumber: "Súpisné číslo"
    },
    "cs-CZ": {
        street: "Ulice",
        postCode: "PSČ",
        city: "Město",
        region: "Kraj",
        county: "Okres",
        state: "Stát",
        orientationNumber: "Orientační číslo",
        registrationNumber: "Popisné číslo"
    },
    "en-US": {
        street: "Street",
        postCode: "Postcode",
        city: "City",
        region: "Region",
        county: "County",
        state: "State",
        identNumber: "Identification number",
        orientationNumber: "Orientation number",
        registrationNumber: "Registration number"
    }
};

const ADDRESS_CONSTANT = {
    TRANS: 'asol-address-trans',
};

class FormValidatorService {
    constructor() {
        /** Subject used to trigger the clearing of required fields. */
        this.clearRequiredFields = new Subject();
        /** Observable that emits when required fields should be cleared. */
        this.clearRequiredFields$ = this.clearRequiredFields.asObservable();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Listens to form change if form is not required
     *  @param formGroup form group
     *  @param sub subscription
     */
    listenToFormChange(formGroup) {
        /** switches validity of required field properties */
        this.sub = formGroup.valueChanges.subscribe(() => {
            const hasValues = this.formContainsValues(formGroup);
            this.sub.unsubscribe();
            /** if form is dirty and has some values, make fields required */
            if (formGroup.dirty && hasValues) {
                this.addAllValidators(formGroup);
                this.clearRequiredFields.next();
            }
            else if (!hasValues) {
                /** else don't take fields as required field */
                this.clearAllFields(formGroup);
            }
            this.listenToFormChange(formGroup);
        });
    }
    /**
     * Checks state of form fields if there is any value
     * @param formGroup form group
     */
    formContainsValues(formGroup) {
        return Object.keys(formGroup.controls).some((formKey) => formGroup.controls[formKey].value);
    }
    /**
     * Adds validators to fields in formGroup
     * @param formGroup form group
     */
    addAllValidators(formGroup) {
        for (const key in formGroup.controls) {
            this.addValidator(formGroup, key);
        }
    }
    /**
     * Adds validator to single item
     * @param formGroup form group
     * @param key Key of the item
     */
    addValidator(formGroup, key) {
        formGroup.get(key).addValidators(Validators.required);
        formGroup.get(key).updateValueAndValidity();
    }
    /**
     * Clears all validators from form
     * @param formGroup form group
     */
    clearAllFields(formGroup) {
        for (const key in formGroup.controls) {
            this.removeValidator(formGroup, key);
        }
    }
    /**
     * Removes validator from single item
     * @param formGroup form group
     * @param key Key of the item
     */
    removeValidator(formGroup, key) {
        formGroup.get(key).removeValidators(Validators.required);
        formGroup.get(key).updateValueAndValidity();
    }
}
FormValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FormValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormValidatorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormValidatorService, decorators: [{
            type: Injectable
        }] });

class AsolAddressComponent extends AsolContentFormDirective {
    constructor(trans, builder, formValidatorService) {
        super();
        this.trans = trans;
        this.builder = builder;
        this.formValidatorService = formValidatorService;
        this.ICONS = ICONS;
        /** Multiform implementation */
        this.formId = 'AddressContentForm';
        /** Provider for address select boxes */
        this.provider = null;
        /** Array of properties that should remove required parameter */
        this.clearValidation = [];
        /**
         * Flag if all fields should be optional
         * Shortcut for clearValidation
         */
        this.clearAllValidations = false;
        /** Text for header */
        this.headerText = null;
        /** Flag for form validity, when fields are required only conditionally */
        this.addressRequired = true;
        /** Event indicating if address was changed, true if was changed */
        this.addressChanged = new EventEmitter();
        this.ADDRESS_CONSTANT = ADDRESS_CONSTANT;
        this.trans.initialize(ADDRESS_CONSTANT.TRANS, translation$i);
        this.formGroup = this.builder.group({
            registrationNumber: [null, Validators.required],
            orientationNumber: [null, Validators.required],
            postCode: [null, [Validators.required, Validators.pattern('[0-9 ]+')]],
            street: [null, Validators.required],
            state: [null, Validators.required],
            region: [null, Validators.required],
            city: [null, Validators.required],
            county: [null, Validators.required],
        });
        /** Clears required fields when triggered */
        this.formValidatorService.clearRequiredFields$.subscribe(() => {
            this.clearRequiredFields();
        });
    }
    ngOnChanges(changes) {
        if (changes.clearValidation) {
            this.clearRequiredFields();
        }
        if (changes.clearAllValidations) {
            if (this.clearAllValidations) {
                this.formValidatorService.clearAllFields(this.formGroup);
            }
            else {
                this.formValidatorService.addAllValidators(this.formGroup);
                this.clearRequiredFields();
            }
        }
        /** sets observer to catch address change if address is not required */
        if (changes.addressRequired && !this.addressRequired) {
            this.processNotRequiredAddressData();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * Sets required fields in formgroup
     */
    clearRequiredFields() {
        this.clearValidation.forEach((value) => {
            this.formValidatorService.removeValidator(this.formGroup, value);
        });
    }
    /**
     * Overrides formValueChanged from AsolContentFormDirective
     */
    formValueChanged() {
        this.addressChanged.emit(this.formGroup.dirty);
    }
    /**
     * Compares selected data and formGroup data and sets new values
     * e.g. when user selects street it will set postCode, city, region, state, county
     * @param data Address to set
     */
    onChangedData(data) {
        const person = data;
        const newData = {};
        Object.keys(this.formGroup.value).forEach((key) => {
            const value = this.formGroup.value[key];
            if ((value === null || value === '') &&
                person[key] !== null) {
                newData[key] = person[key];
            }
        });
        this.formGroup.patchValue(Object.assign({}, newData));
    }
    /**
     * Sets validation of fields after parsed item
     * @param data address data
     */
    afterParseItem(data) {
        if (!data ||
            (!this.addressRequired &&
                !this.formValidatorService.formContainsValues(this.formGroup))) {
            this.formValidatorService.clearAllFields(this.formGroup);
            return;
        }
        this.formValidatorService.addAllValidators(this.formGroup);
        this.clearRequiredFields();
    }
    /**
     * Clears address form
     */
    clearAddress() {
        const hasValues = this.formValidatorService.formContainsValues(this.formGroup);
        this.formGroup.reset();
        /** checks if there were any values to trigger dirty parameter */
        if (hasValues && this.data) {
            this.formGroup.markAsDirty();
        }
    }
    /**
     * Checks if validated fields have to be required when address is not required
     */
    processNotRequiredAddressData() {
        /** in case address is required */
        if (this.addressRequired) {
            return;
        }
        /** @inheritdoc */
        this.formValidatorService.listenToFormChange(this.formGroup);
    }
    /**
     * Resets required fields validity if address is not required
     */
    resetForm() {
        super.resetForm();
        if (!this.addressRequired &&
            !this.formValidatorService.formContainsValues(this.formGroup)) {
            this.formValidatorService.clearAllFields(this.formGroup);
        }
    }
}
AsolAddressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }, { token: FormValidatorService }], target: i0.ɵɵFactoryTarget.Component });
AsolAddressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAddressComponent, selector: "asol-address", inputs: { provider: "provider", clearValidation: "clearValidation", clearAllValidations: "clearAllValidations", headerText: "headerText", addressRequired: "addressRequired" }, outputs: { addressChanged: "addressChanged" }, providers: [FormValidatorService], viewQueries: [{ propertyName: "streetAutoComplete", first: true, predicate: ["streetAutoComplete"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"d-flex mt-5 mb-3 gap-3\" *ngIf=\"headerText\">\n  <h2 class=\"mb-0\">{{ headerText }}</h2>\n  <div class=\"c-pointer\" (click)=\"clearAddress()\">\n    <svg-icon [src]=\"ICONS.TRASH_01\"></svg-icon>\n  </div>\n</div>\n<form [formGroup]=\"formGroup\">\n  <div class=\"row\">\n    <asol-autocomplete\n      [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n      #streetAutoComplete\n      labelKey=\"street\"\n      [allowCustom]=\"true\"\n      [dataProvider]=\"provider\"\n      displayProperty=\"street\"\n      valueProperty=\"street\"\n      (select)=\"onChangedData($event)\"\n      [filterParams]=\"{\n        module: 'street',\n        address: formGroup.value\n      }\"\n      formControlName=\"street\">\n      <ng-template #itemTemplate let-data>\n        <div class=\"w-100\">{{ data.street }}</div>\n        <div class=\"street\">\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </div>\n      </ng-template>\n    </asol-autocomplete>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-4\">\n      <asol-input-field\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"registrationNumber\"\n        formControlName=\"registrationNumber\">\n      </asol-input-field>\n    </div>\n    <div class=\"col-12 col-md-4\">\n      <asol-input-field\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"orientationNumber\"\n        formControlName=\"orientationNumber\">\n      </asol-input-field>\n    </div>\n    <div class=\"col-12 col-md-4\">\n      <asol-autocomplete\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"postCode\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'postCode',\n          address: formGroup.value\n        }\"\n        displayProperty=\"postCode\"\n        valueProperty=\"postCode\"\n        (select)=\"onChangedData($event)\"\n        formControlName=\"postCode\">\n        <ng-template #itemTemplate let-data>\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </ng-template>\n      </asol-autocomplete>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"county\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'county',\n          address: formGroup.value\n        }\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        displayProperty=\"county\"\n        valueProperty=\"county\"\n        labelKey=\"county\">\n      </asol-autocomplete>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"region\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'region',\n          address: formGroup.value\n        }\"\n        displayProperty=\"region\"\n        valueProperty=\"region\"\n        labelKey=\"region\">\n      </asol-autocomplete>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"city\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'city',\n          address: formGroup.value\n        }\"\n        displayProperty=\"city\"\n        valueProperty=\"city\"\n        (select)=\"onChangedData($event)\"\n        labelKey=\"city\">\n        <ng-template #itemTemplate let-data>\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </ng-template>\n      </asol-autocomplete>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"state\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'state',\n          address: formGroup.value\n        }\"\n        [allowCustom]=\"true\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        displayProperty=\"state\"\n        valueProperty=\"state\"\n        labelKey=\"state\">\n      </asol-autocomplete>\n    </div>\n  </div>\n</form>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.street{display:flex;justify-content:space-between;font-size:.75rem}\n"], components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolAutoCompleteComponent, selector: "asol-autocomplete", inputs: ["options", "valueProperty", "displayProperty", "groupProperty", "allowGrouping", "showClearButton", "dataProvider", "filterParams", "highlight", "suggestionCount", "minLength", "allowCustom"], outputs: ["customValueSpecifier", "select"] }, { type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-address', providers: [FormValidatorService], template: "<div class=\"d-flex mt-5 mb-3 gap-3\" *ngIf=\"headerText\">\n  <h2 class=\"mb-0\">{{ headerText }}</h2>\n  <div class=\"c-pointer\" (click)=\"clearAddress()\">\n    <svg-icon [src]=\"ICONS.TRASH_01\"></svg-icon>\n  </div>\n</div>\n<form [formGroup]=\"formGroup\">\n  <div class=\"row\">\n    <asol-autocomplete\n      [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n      #streetAutoComplete\n      labelKey=\"street\"\n      [allowCustom]=\"true\"\n      [dataProvider]=\"provider\"\n      displayProperty=\"street\"\n      valueProperty=\"street\"\n      (select)=\"onChangedData($event)\"\n      [filterParams]=\"{\n        module: 'street',\n        address: formGroup.value\n      }\"\n      formControlName=\"street\">\n      <ng-template #itemTemplate let-data>\n        <div class=\"w-100\">{{ data.street }}</div>\n        <div class=\"street\">\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </div>\n      </ng-template>\n    </asol-autocomplete>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-4\">\n      <asol-input-field\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"registrationNumber\"\n        formControlName=\"registrationNumber\">\n      </asol-input-field>\n    </div>\n    <div class=\"col-12 col-md-4\">\n      <asol-input-field\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"orientationNumber\"\n        formControlName=\"orientationNumber\">\n      </asol-input-field>\n    </div>\n    <div class=\"col-12 col-md-4\">\n      <asol-autocomplete\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        labelKey=\"postCode\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'postCode',\n          address: formGroup.value\n        }\"\n        displayProperty=\"postCode\"\n        valueProperty=\"postCode\"\n        (select)=\"onChangedData($event)\"\n        formControlName=\"postCode\">\n        <ng-template #itemTemplate let-data>\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </ng-template>\n      </asol-autocomplete>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"county\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'county',\n          address: formGroup.value\n        }\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        displayProperty=\"county\"\n        valueProperty=\"county\"\n        labelKey=\"county\">\n      </asol-autocomplete>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"region\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'region',\n          address: formGroup.value\n        }\"\n        displayProperty=\"region\"\n        valueProperty=\"region\"\n        labelKey=\"region\">\n      </asol-autocomplete>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"city\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        [allowCustom]=\"true\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'city',\n          address: formGroup.value\n        }\"\n        displayProperty=\"city\"\n        valueProperty=\"city\"\n        (select)=\"onChangedData($event)\"\n        labelKey=\"city\">\n        <ng-template #itemTemplate let-data>\n          <div>{{ data.postCode + ' ' + data.city }}</div>\n        </ng-template>\n      </asol-autocomplete>\n    </div>\n    <div class=\"col-12 col-md-6\">\n      <asol-autocomplete\n        formControlName=\"state\"\n        [dataProvider]=\"provider\"\n        [filterParams]=\"{\n          module: 'state',\n          address: formGroup.value\n        }\"\n        [allowCustom]=\"true\"\n        [transKey]=\"ADDRESS_CONSTANT.TRANS\"\n        displayProperty=\"state\"\n        valueProperty=\"state\"\n        labelKey=\"state\">\n      </asol-autocomplete>\n    </div>\n  </div>\n</form>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.street{display:flex;justify-content:space-between;font-size:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }, { type: FormValidatorService }]; }, propDecorators: { provider: [{
                type: Input
            }], clearValidation: [{
                type: Input
            }], clearAllValidations: [{
                type: Input
            }], headerText: [{
                type: Input
            }], addressRequired: [{
                type: Input
            }], addressChanged: [{
                type: Output
            }], streetAutoComplete: [{
                type: ViewChild,
                args: ['streetAutoComplete']
            }] } });

class AsolAddressModule {
}
AsolAddressModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolAddressModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressModule, declarations: [AsolAddressComponent], imports: [SharedModule,
        AsolInputFieldModule,
        AsolSelectFieldModule,
        AsolAutoCompleteModule], exports: [AsolAddressComponent] });
AsolAddressModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressModule, imports: [[
            SharedModule,
            AsolInputFieldModule,
            AsolSelectFieldModule,
            AsolAutoCompleteModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAddressModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolAddressComponent],
                    exports: [AsolAddressComponent],
                    imports: [
                        SharedModule,
                        AsolInputFieldModule,
                        AsolSelectFieldModule,
                        AsolAutoCompleteModule,
                    ],
                }]
        }] });

class AsolButtonComponent {
    constructor(trans) {
        this.trans = trans;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /**
         * Type of button
         * @default default
         */
        this.type = 'default';
        /** Button text based on type */
        this.textType = null;
        /**
         * Button color @see {@link Color}
         * @default primary
         */
        this.color = 'primary';
        /**
         * Icon position @see {@link IconPosition}
         * @defaults left
         */
        this.iconPosition = 'left';
        /** SVG icon URL, use ICONS constant */
        this.iconSvgUrl = '';
        /**
         * Flag if button is disabled
         * @default false
         */
        this.disabled = false;
        /** Flag if button is active
         * @default false
         */
        this.active = false;
    }
}
AsolButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolButtonComponent, selector: "asol-button", inputs: { type: "type", textType: "textType", color: "color", iconPosition: "iconPosition", iconSvgUrl: "iconSvgUrl", disabled: "disabled", active: "active", cssClass: "cssClass" }, ngImport: i0, template: "<button\n  type=\"button\"\n  class=\"e-btn d-inline-flex\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconPosition === 'left' && iconSvgUrl\"\n    class=\"me-1 btn-icon center-item\"></svg-icon>\n  <ng-content></ng-content>\n  {{ textType ? this.trans.get(GENERAL_TRANSLATION, textType) : '' }}\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    class=\"ms-1 btn-icon center-item\"\n    *ngIf=\"iconPosition === 'right' && iconSvgUrl\"></svg-icon>\n</button>\n", components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-button', template: "<button\n  type=\"button\"\n  class=\"e-btn d-inline-flex\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconPosition === 'left' && iconSvgUrl\"\n    class=\"me-1 btn-icon center-item\"></svg-icon>\n  <ng-content></ng-content>\n  {{ textType ? this.trans.get(GENERAL_TRANSLATION, textType) : '' }}\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    class=\"ms-1 btn-icon center-item\"\n    *ngIf=\"iconPosition === 'right' && iconSvgUrl\"></svg-icon>\n</button>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { type: [{
                type: Input
            }], textType: [{
                type: Input
            }], color: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], iconSvgUrl: [{
                type: Input
            }], disabled: [{
                type: Input
            }], active: [{
                type: Input
            }], cssClass: [{
                type: Input
            }] } });

class AsolDropDownButtonComponent {
    constructor(trans) {
        this.trans = trans;
        this.ICONS = ICONS;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /**
         * Type of button
         * @default default
         */
        this.type = 'default';
        /** Button text based on type */
        this.textType = null;
        /**
         * Button color @see {@link Color}
         * @default primary
         */
        this.color = 'primary';
        /**
         * Flag if button is disabled
         * @default false
         */
        this.disabled = false;
        /** SVG icon URL, use ICONS constant */
        this.iconSvgUrl = '';
        /** SVG icon URL for chevron, use ICONS constant */
        this.iconChevronSvgUrl = ICONS.CHEVRON_DOWN;
        /**
         * Hides chevron icon
         */
        this.hideChevronIcon = false;
        /** Collection of dropdown items */
        this.items = [];
        /** Flag if button is active */
        this.active = false;
        /** Event after user selects item from dropdown */
        this.itemSelect = new EventEmitter();
        this.open = new EventEmitter();
        /**
         * Ref for DOM button
         *
         * @type {DropDownButtonComponent}
         */
        this.asolDropdownButton = null;
    }
    /**
     * Event handler after user selects item from dropdown
     * @param args Arguments of selected item @see {@link MenuEventArgs}
     */
    onItemSelect(args) {
        this.itemSelect.emit(args);
    }
    /**
     * Emits event before popup opens
     * @param args Open close args @see {@link OpenCloseMenuEventArgs}
     */
    onOpen(args) {
        this.open.emit(args);
    }
    /**
     * Method for adding new items on fly for dropdown button
     *
     * @param {ItemModel[]} items
     */
    addItems(items) {
        this.asolDropdownButton.addItems(items);
    }
}
AsolDropDownButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDropDownButtonComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolDropDownButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolDropDownButtonComponent, selector: "asol-dropdown-button", inputs: { type: "type", textType: "textType", color: "color", disabled: "disabled", iconSvgUrl: "iconSvgUrl", iconChevronSvgUrl: "iconChevronSvgUrl", hideChevronIcon: "hideChevronIcon", items: "items", active: "active", cssClass: "cssClass" }, outputs: { itemSelect: "itemSelect", open: "open" }, viewQueries: [{ propertyName: "asolDropdownButton", first: true, predicate: ["asolDropdownButton"], descendants: true }], ngImport: i0, template: "<button\n  #asolDropdownButton\n  type=\"button\"\n  ejs-dropdownbutton\n  cssClass=\"e-caret-hide asol-custom d-inline-flex\"\n  [items]=\"items\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active, 'p-0': hideChevronIcon }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\"\n  (open)=\"onOpen($event)\"\n  (select)=\"onItemSelect($event)\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconSvgUrl\"\n    [ngClass]=\"{ 'me-1': !hideChevronIcon }\"\n    class=\"btn-icon center-item\"></svg-icon>\n  <ng-content></ng-content>\n  {{ textType ? this.trans.get(GENERAL_TRANSLATION, textType) : '' }}\n  <svg-icon\n    *ngIf=\"!hideChevronIcon\"\n    class=\"dropdown-icon ms-1\"\n    [src]=\"iconChevronSvgUrl\"></svg-icon>\n</button>\n", styles: [".e-dropdown-btn.asol-custom .dropdown-icon{width:24px;height:24px}.e-dropdown-btn.asol-custom .dropdown-icon svg{width:24px;height:24px}\n"], components: [{ type: i2$1.DropDownButtonComponent, selector: "[ejs-dropdownbutton]", inputs: ["closeActionEvents", "content", "createPopupOnClick", "cssClass", "disabled", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "iconCss", "iconPosition", "items", "locale", "target"], outputs: ["beforeClose", "beforeItemRender", "beforeOpen", "close", "created", "open", "select"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDropDownButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-dropdown-button', template: "<button\n  #asolDropdownButton\n  type=\"button\"\n  ejs-dropdownbutton\n  cssClass=\"e-caret-hide asol-custom d-inline-flex\"\n  [items]=\"items\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active, 'p-0': hideChevronIcon }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\"\n  (open)=\"onOpen($event)\"\n  (select)=\"onItemSelect($event)\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconSvgUrl\"\n    [ngClass]=\"{ 'me-1': !hideChevronIcon }\"\n    class=\"btn-icon center-item\"></svg-icon>\n  <ng-content></ng-content>\n  {{ textType ? this.trans.get(GENERAL_TRANSLATION, textType) : '' }}\n  <svg-icon\n    *ngIf=\"!hideChevronIcon\"\n    class=\"dropdown-icon ms-1\"\n    [src]=\"iconChevronSvgUrl\"></svg-icon>\n</button>\n", styles: [".e-dropdown-btn.asol-custom .dropdown-icon{width:24px;height:24px}.e-dropdown-btn.asol-custom .dropdown-icon svg{width:24px;height:24px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { type: [{
                type: Input
            }], textType: [{
                type: Input
            }], color: [{
                type: Input
            }], disabled: [{
                type: Input
            }], iconSvgUrl: [{
                type: Input
            }], iconChevronSvgUrl: [{
                type: Input
            }], hideChevronIcon: [{
                type: Input
            }], items: [{
                type: Input
            }], active: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], itemSelect: [{
                type: Output
            }], open: [{
                type: Output
            }], asolDropdownButton: [{
                type: ViewChild,
                args: ['asolDropdownButton']
            }] } });

class AsolIconButtonComponent {
    constructor() {
        /** Button text based on type */
        this.type = 'default';
        /**
         * Button color @see {@link Color}
         * @default primary
         */
        this.color = 'primary';
        /** SVG icon URL, use ICONS constant */
        this.iconSvgUrl = '';
        /**
         * Flag if button is disabled
         * @default false
         */
        this.disabled = false;
        /** Flag if button is active
         * @default false
         */
        this.active = false;
        /** Css class definition to add to button */
        this.cssClass = '';
    }
}
AsolIconButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolIconButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolIconButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: { type: "type", color: "color", iconSvgUrl: "iconSvgUrl", disabled: "disabled", active: "active", cssClass: "cssClass" }, ngImport: i0, template: "<button\n  type=\"button\"\n  class=\"e-btn asol-icon\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconSvgUrl\"\n    class=\"btn-icon center-item\"></svg-icon>\n  <!-- <svg-icon\n    [src]=\"iconSvgUrl\"\n    class=\"ms-1 btn-icon center-item\"\n    *ngIf=\"iconPosition === 'right' && iconSvgUrl\"></svg-icon> -->\n</button>\n", components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolIconButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-icon-button', template: "<button\n  type=\"button\"\n  class=\"e-btn asol-icon\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"{ 'e-active': active }\"\n  [class]=\"'e-' + color + ' e-' + type + ' ' + cssClass\">\n  <svg-icon\n    [src]=\"iconSvgUrl\"\n    *ngIf=\"iconSvgUrl\"\n    class=\"btn-icon center-item\"></svg-icon>\n  <!-- <svg-icon\n    [src]=\"iconSvgUrl\"\n    class=\"ms-1 btn-icon center-item\"\n    *ngIf=\"iconPosition === 'right' && iconSvgUrl\"></svg-icon> -->\n</button>\n" }]
        }], propDecorators: { type: [{
                type: Input
            }], color: [{
                type: Input
            }], iconSvgUrl: [{
                type: Input
            }], disabled: [{
                type: Input
            }], active: [{
                type: Input
            }], cssClass: [{
                type: Input
            }] } });

class AsolSplitButtonComponent {
    constructor(trans) {
        this.trans = trans;
        this.ICONS = ICONS;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        this.type = 'default';
        this.textType = null;
        this.color = 'primary';
        this.disabled = false;
        this.iconSvgUrl = '';
        this.chevronSvgUrl = ICONS.CHEVRON_DOWN;
        this.items = [];
        this.showOutline = false;
        this.cssClass = '';
        this.primaryClick = new EventEmitter();
        this.select = new EventEmitter();
    }
    onSelect(event) {
        this.select.emit(event);
    }
    onPrimaryClick() {
        this.primaryClick.emit();
    }
    /**
     * Calculates new position of popup menu
     * @param args Menu args
     */
    onOpen(args) {
        args.element.parentElement.style.left =
            args.element.parentElement.getBoundingClientRect().left -
                args.element.parentElement.offsetWidth +
                34 +
                'px';
    }
}
AsolSplitButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSplitButtonComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolSplitButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSplitButtonComponent, selector: "asol-split-button", inputs: { type: "type", textType: "textType", color: "color", disabled: "disabled", iconSvgUrl: "iconSvgUrl", chevronSvgUrl: "chevronSvgUrl", items: "items", showOutline: "showOutline", cssClass: "cssClass" }, outputs: { primaryClick: "primaryClick", select: "select" }, viewQueries: [{ propertyName: "primaryButton", first: true, predicate: ["primaryButton"], descendants: true }], ngImport: i0, template: "<div\n  class=\"d-inline-flex asol-split\"\n  [class]=\"cssClass\"\n  [ngClass]=\"{ 'split-outline': showOutline }\">\n  <button\n    #primaryButton\n    [ngClass]=\"'e-' + color + ' e-' + type\"\n    [disabled]=\"disabled\"\n    (click)=\"onPrimaryClick()\"\n    class=\"e-btn d-inline-flex primary-split-button align-items-center\">\n    <svg-icon\n      [src]=\"iconSvgUrl\"\n      *ngIf=\"iconSvgUrl\"\n      class=\"btn-icon center-item me-1\"></svg-icon>\n    <ng-content></ng-content>\n  </button>\n  <button\n    type=\"button\"\n    ejs-dropdownbutton\n    cssClass=\"e-caret-hide asol-custom d-inline-flex align-items-center\"\n    [items]=\"items\"\n    [disabled]=\"disabled\"\n    (select)=\"onSelect($event)\"\n    (open)=\"onOpen($event)\"\n    [ngClass]=\"'e-' + color + ' e-' + type\">\n    <svg-icon class=\"dropdown-icon\" [src]=\"chevronSvgUrl\"></svg-icon>\n  </button>\n</div>\n", components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: i2$1.DropDownButtonComponent, selector: "[ejs-dropdownbutton]", inputs: ["closeActionEvents", "content", "createPopupOnClick", "cssClass", "disabled", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "iconCss", "iconPosition", "items", "locale", "target"], outputs: ["beforeClose", "beforeItemRender", "beforeOpen", "close", "created", "open", "select"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSplitButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-split-button', template: "<div\n  class=\"d-inline-flex asol-split\"\n  [class]=\"cssClass\"\n  [ngClass]=\"{ 'split-outline': showOutline }\">\n  <button\n    #primaryButton\n    [ngClass]=\"'e-' + color + ' e-' + type\"\n    [disabled]=\"disabled\"\n    (click)=\"onPrimaryClick()\"\n    class=\"e-btn d-inline-flex primary-split-button align-items-center\">\n    <svg-icon\n      [src]=\"iconSvgUrl\"\n      *ngIf=\"iconSvgUrl\"\n      class=\"btn-icon center-item me-1\"></svg-icon>\n    <ng-content></ng-content>\n  </button>\n  <button\n    type=\"button\"\n    ejs-dropdownbutton\n    cssClass=\"e-caret-hide asol-custom d-inline-flex align-items-center\"\n    [items]=\"items\"\n    [disabled]=\"disabled\"\n    (select)=\"onSelect($event)\"\n    (open)=\"onOpen($event)\"\n    [ngClass]=\"'e-' + color + ' e-' + type\">\n    <svg-icon class=\"dropdown-icon\" [src]=\"chevronSvgUrl\"></svg-icon>\n  </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { type: [{
                type: Input
            }], textType: [{
                type: Input
            }], color: [{
                type: Input
            }], disabled: [{
                type: Input
            }], iconSvgUrl: [{
                type: Input
            }], chevronSvgUrl: [{
                type: Input
            }], items: [{
                type: Input
            }], showOutline: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], primaryClick: [{
                type: Output
            }], select: [{
                type: Output
            }], primaryButton: [{
                type: ViewChild,
                args: ['primaryButton']
            }] } });

class AsolButtonModule {
}
AsolButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonModule, declarations: [AsolButtonComponent,
        AsolIconButtonComponent,
        AsolDropDownButtonComponent,
        AsolSplitButtonComponent], imports: [SharedModule, DropDownButtonModule], exports: [AsolButtonComponent,
        AsolIconButtonComponent,
        AsolDropDownButtonComponent,
        AsolSplitButtonComponent] });
AsolButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonModule, providers: [], imports: [[SharedModule, DropDownButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolButtonComponent,
                        AsolIconButtonComponent,
                        AsolDropDownButtonComponent,
                        AsolSplitButtonComponent,
                    ],
                    exports: [
                        AsolButtonComponent,
                        AsolIconButtonComponent,
                        AsolDropDownButtonComponent,
                        AsolSplitButtonComponent,
                    ],
                    imports: [SharedModule, DropDownButtonModule],
                    providers: [],
                }]
        }] });

var translation$h = {
    "sk-SK": {
        uploadFile: "Nahrať súbor"
    },
    "cs-CZ": {
        uploadFile: "Nahrát soubor"
    },
    "en-US": {
        uploadFile: "Upload a file"
    }
};

const UPLOAD_CONST = {
    TRANS: 'asol-upload',
};

class AsolUploadComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        this.ICONS = ICONS;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /** Uploaded file reference */
        this.uploadedFiles = null;
        /** Button definition for uploader button */
        this.buttonDefinition = null;
        /** Allowed file extensions for uploader (for example .xls, .pdf) */
        this.allowedExtensions = [];
        /** Uploaded file icon SVG icon URL, use ICONS constant */
        this.uploadedFileIcon = ICONS.FILE_UPLOAD;
        /** Uploaded error file icon SVG icon URL, use ICONS constant */
        this.errorFileIcon = null;
        /** Flag for external uploaded file validation */
        this.uploadedFileError = false;
        /** Flag for uploading multiple files */
        this.multipleFiles = true;
        /** Emitter for emiting currently uploaded file */
        this.fileUploaded = new EventEmitter();
        /** initializes translation service */
        this.trans.initialize(UPLOAD_CONST.TRANS, translation$h);
        /** initializes button */
        this.buttonDefinition = {
            type: 'outline',
            color: 'primary',
            text: this.trans.get(UPLOAD_CONST.TRANS, 'uploadFile'),
        };
    }
    ngOnChanges(changes) {
        /** if button definition is null, use previous settings */
        if (changes.buttonDefinition && !this.buttonDefinition) {
            this.buttonDefinition = changes.buttonDefinition.previousValue;
        }
    }
    /**
     * Obtains uploaded file from list of files
     * @param files list of uploaded files
     */
    obtainUploadedFiles(fileList) {
        /** if file is not uploaded, do nothing */
        if (!fileList.length) {
            return null;
        }
        /** iterate through file list */
        const files = [];
        for (let i = 0; i < fileList.length; i++) {
            files[i] = fileList.item(i);
        }
        /** disable upload button if file is uploaded */
        this.buttonDefinition.disabled = true;
        return files;
    }
    /**
     * Removes previously selected file from browser
     */
    removeFile(index) {
        /** if there is no file uploaded, do nothing */
        if (!this.uploadedFiles.length) {
            return;
        }
        /** enable upload button if file is not uploaded */
        this.buttonDefinition.disabled = false;
        /** remove the uploaded file */
        this.uploadedFiles.splice(index, 1);
        /** clear the input value in case same file would be selected */
        if (this.input) {
            this.input.nativeElement.value = '';
        }
        /** trigger on change after removing file/files */
        this.onChange(this.uploadedFiles);
        this.valueChangedDebouncer.next(this.uploadedFiles);
        /** emit non-existent uploaded file */
        this.fileUploaded.emit(this.uploadedFiles);
    }
    getControlValue() {
        var _a, _b;
        if (!this.input ||
            !this.input.nativeElement ||
            !((_a = this.input.nativeElement.files) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        /** gets file list from input */
        const files = (_b = this.input.nativeElement) === null || _b === void 0 ? void 0 : _b.files;
        /** assigns uploaded files */
        this.uploadedFiles = this.obtainUploadedFiles(files);
        /** emit uploaded file */
        this.fileUploaded.emit(this.uploadedFiles);
        /** trigger on change after adding file/files */
        this.onChange(this.uploadedFiles);
        this.valueChangedDebouncer.next(this.uploadedFiles);
        /** obtains uploaded file */
        return this.uploadedFiles;
    }
    setControlValue(val) {
        if (!val) {
            return null;
        }
        this.uploadedFiles = val;
    }
    setControlDisabled(isDisable) {
        // not needed
    }
    /**
     * Resets uploaded files
     */
    reset() {
        this.uploadedFiles = [];
        this.buttonDefinition.disabled = false;
    }
}
AsolUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolUploadComponent, selector: "asol-upload", inputs: { buttonDefinition: "buttonDefinition", allowedExtensions: "allowedExtensions", uploadedFileIcon: "uploadedFileIcon", errorFileIcon: "errorFileIcon", uploadedFileError: "uploadedFileError", multipleFiles: "multipleFiles" }, outputs: { fileUploaded: "fileUploaded" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["uploader"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <div class=\"d-flex gap-6 text-center justify-content-start uploaded-file\">\n    <div\n      *ngFor=\"let file of uploadedFiles; let i = index\"\n      class=\"d-inline-block\">\n      <div class=\"d-flex flex-column\">\n        <div\n          class=\"d-inline-flex align-items-start w-100 justify-content-center ms-1\">\n          <svg-icon\n            *ngIf=\"uploadedFileIcon\"\n            [src]=\"\n              uploadedFileError\n                ? errorFileIcon ?? uploadedFileIcon\n                : uploadedFileIcon\n            \"></svg-icon>\n          <svg-icon\n            *ngIf=\"!isDisabled\"\n            class=\"remove-icon c-pointer\"\n            [src]=\"ICONS.REMOVE_FILE\"\n            (click)=\"removeFile(i)\"></svg-icon>\n        </div>\n        <div\n          class=\"title\"\n          [ngClass]=\"{\n            'e-error':\n              (ngControl.control.errors && ngControl.control.touched) ||\n              uploadedFileError\n          }\">\n          {{ file.name }}\n        </div>\n      </div>\n    </div>\n    <div *ngIf=\"!uploadedFiles?.length\">\n      <asol-button\n        class=\"mt-1\"\n        [id]=\"buttonDefinition.textType ?? buttonDefinition.text\"\n        [color]=\"getErrorMessages()?.length ? 'danger' : buttonDefinition.color\"\n        [type]=\"buttonDefinition.type\"\n        [iconSvgUrl]=\"buttonDefinition.icon\"\n        [disabled]=\"isDisabled ?? buttonDefinition.disabled\"\n        [iconPosition]=\"buttonDefinition.iconPosition\"\n        [ngClass]=\"{\n          'pe-none': isDisabled || buttonDefinition.disabled\n        }\"\n        (click)=\"uploader.click()\">\n        {{\n          buttonDefinition.text\n            ? buttonDefinition.text\n            : buttonDefinition.textType\n            ? trans.get(GENERAL_TRANSLATION, buttonDefinition.textType)\n            : ''\n        }}\n      </asol-button>\n\n      <input\n        class=\"uploader\"\n        id=\"UPLOAD_FILE\"\n        #uploader\n        type=\"file\"\n        [multiple]=\"multipleFiles\"\n        [accept]=\"allowedExtensions ? allowedExtensions.join() : null\" />\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.uploader{display:none}.uploaded-file{flex-wrap:wrap;color:#091e42}.uploaded-file .remove-icon{line-height:0}.uploaded-file .title{color:#091e42;font-weight:400;font-size:1rem;line-height:1.5rem;max-width:9rem;overflow-wrap:break-word}.uploaded-file .title.e-error{color:#de350b}\n"], components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-upload', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <div class=\"d-flex gap-6 text-center justify-content-start uploaded-file\">\n    <div\n      *ngFor=\"let file of uploadedFiles; let i = index\"\n      class=\"d-inline-block\">\n      <div class=\"d-flex flex-column\">\n        <div\n          class=\"d-inline-flex align-items-start w-100 justify-content-center ms-1\">\n          <svg-icon\n            *ngIf=\"uploadedFileIcon\"\n            [src]=\"\n              uploadedFileError\n                ? errorFileIcon ?? uploadedFileIcon\n                : uploadedFileIcon\n            \"></svg-icon>\n          <svg-icon\n            *ngIf=\"!isDisabled\"\n            class=\"remove-icon c-pointer\"\n            [src]=\"ICONS.REMOVE_FILE\"\n            (click)=\"removeFile(i)\"></svg-icon>\n        </div>\n        <div\n          class=\"title\"\n          [ngClass]=\"{\n            'e-error':\n              (ngControl.control.errors && ngControl.control.touched) ||\n              uploadedFileError\n          }\">\n          {{ file.name }}\n        </div>\n      </div>\n    </div>\n    <div *ngIf=\"!uploadedFiles?.length\">\n      <asol-button\n        class=\"mt-1\"\n        [id]=\"buttonDefinition.textType ?? buttonDefinition.text\"\n        [color]=\"getErrorMessages()?.length ? 'danger' : buttonDefinition.color\"\n        [type]=\"buttonDefinition.type\"\n        [iconSvgUrl]=\"buttonDefinition.icon\"\n        [disabled]=\"isDisabled ?? buttonDefinition.disabled\"\n        [iconPosition]=\"buttonDefinition.iconPosition\"\n        [ngClass]=\"{\n          'pe-none': isDisabled || buttonDefinition.disabled\n        }\"\n        (click)=\"uploader.click()\">\n        {{\n          buttonDefinition.text\n            ? buttonDefinition.text\n            : buttonDefinition.textType\n            ? trans.get(GENERAL_TRANSLATION, buttonDefinition.textType)\n            : ''\n        }}\n      </asol-button>\n\n      <input\n        class=\"uploader\"\n        id=\"UPLOAD_FILE\"\n        #uploader\n        type=\"file\"\n        [multiple]=\"multipleFiles\"\n        [accept]=\"allowedExtensions ? allowedExtensions.join() : null\" />\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.uploader{display:none}.uploaded-file{flex-wrap:wrap;color:#091e42}.uploaded-file .remove-icon{line-height:0}.uploaded-file .title{color:#091e42;font-weight:400;font-size:1rem;line-height:1.5rem;max-width:9rem;overflow-wrap:break-word}.uploaded-file .title.e-error{color:#de350b}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { buttonDefinition: [{
                type: Input
            }], allowedExtensions: [{
                type: Input
            }], uploadedFileIcon: [{
                type: Input
            }], errorFileIcon: [{
                type: Input
            }], uploadedFileError: [{
                type: Input
            }], multipleFiles: [{
                type: Input
            }], fileUploaded: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['uploader']
            }] } });

class AsolUploadModule {
}
AsolUploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolUploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadModule, declarations: [AsolUploadComponent], imports: [SharedModule, AsolButtonModule], exports: [AsolUploadComponent] });
AsolUploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadModule, imports: [[SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolUploadComponent],
                    exports: [AsolUploadComponent],
                    imports: [SharedModule, AsolButtonModule],
                }]
        }] });

class AsolFileUploadProgressComponent {
    constructor(http, trans, fb) {
        this.http = http;
        this.trans = trans;
        this.fb = fb;
        /** Uplaod button translation key */
        this.buttonTransKey = '';
        /** Uplaod button translation label */
        this.buttonTransLabel = '';
        /** Upload URL */
        this.fileUploadUrl = '';
        /** Additional uplaod parameters */
        this.parameters = new Map();
        /** Allowed extensions */
        this.allowedExtensions = [];
        /** Event when upload is finished */
        this.uploadFinished = new EventEmitter();
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /** File upload buttons definition */
        this.uploadButtons = {};
        /**
         * File upload progress in %
         * @default 0
         */
        this.progress = 0;
        /**
         * Error message
         * @default ''
         */
        this.message = '';
        this.fileForm = this.fb.group({
            file: null,
        });
    }
    ngOnInit() {
        this.uploadButtons = {
            text: this.trans.get(this.buttonTransKey, this.buttonTransLabel),
            type: 'default',
            color: 'primary',
        };
    }
    /**
     * Event when file is selected and uploaded
     * @param filesToUpload Files to upload
     */
    onFileUploaded(filesToUpload) {
        if (filesToUpload.length == 0) {
            return;
        }
        const fileToUpload = filesToUpload[0];
        const formData = new FormData();
        formData.append('File', fileToUpload, fileToUpload.name);
        this.parameters.forEach((value, key) => {
            formData.append(key, value);
        });
        this.http
            .post(this.fileUploadUrl, formData, {
            reportProgress: true,
            observe: 'events',
        })
            .subscribe({
            next: (event) => {
                var _a;
                if (event.type === HttpEventType.UploadProgress)
                    this.progress = Math.round((100 * event.loaded) / ((_a = event.total) !== null && _a !== void 0 ? _a : 1));
                else if (event.type === HttpEventType.Response) {
                    this.uploadFinished.emit(event.body);
                }
            },
            error: (err) => {
                this.message =
                    this.trans.get(GENERAL_TRANSLATION, 'error') + err.message;
            },
        });
    }
}
AsolFileUploadProgressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFileUploadProgressComponent, deps: [{ token: i1$1.HttpClient }, { token: i1.TranslationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolFileUploadProgressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolFileUploadProgressComponent, selector: "asol-file-upload-progress", inputs: { buttonTransKey: "buttonTransKey", buttonTransLabel: "buttonTransLabel", fileUploadUrl: "fileUploadUrl", parameters: "parameters", allowedExtensions: "allowedExtensions" }, outputs: { uploadFinished: "uploadFinished" }, ngImport: i0, template: "<div class=\"d-flex align-items-center\">\n  <form [formGroup]=\"fileForm\">\n    <asol-upload\n      formControlName=\"file\"\n      [buttonDefinition]=\"uploadButtons\"\n      [allowedExtensions]=\"allowedExtensions\"\n      (fileUploaded)=\"onFileUploaded($event)\">\n    </asol-upload>\n  </form>\n  <div class=\"fw-bold ms-4\" *ngIf=\"progress > 0\">{{ progress }}%</div>\n</div>\n<div *ngIf=\"message\">\n  {{ message }}\n</div>\n", components: [{ type: AsolUploadComponent, selector: "asol-upload", inputs: ["buttonDefinition", "allowedExtensions", "uploadedFileIcon", "errorFileIcon", "uploadedFileError", "multipleFiles"], outputs: ["fileUploaded"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFileUploadProgressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-file-upload-progress', template: "<div class=\"d-flex align-items-center\">\n  <form [formGroup]=\"fileForm\">\n    <asol-upload\n      formControlName=\"file\"\n      [buttonDefinition]=\"uploadButtons\"\n      [allowedExtensions]=\"allowedExtensions\"\n      (fileUploaded)=\"onFileUploaded($event)\">\n    </asol-upload>\n  </form>\n  <div class=\"fw-bold ms-4\" *ngIf=\"progress > 0\">{{ progress }}%</div>\n</div>\n<div *ngIf=\"message\">\n  {{ message }}\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: i1.TranslationService }, { type: i2.FormBuilder }]; }, propDecorators: { buttonTransKey: [{
                type: Input
            }], buttonTransLabel: [{
                type: Input
            }], fileUploadUrl: [{
                type: Input
            }], parameters: [{
                type: Input
            }], allowedExtensions: [{
                type: Input
            }], uploadFinished: [{
                type: Output
            }] } });

class UploadProgressModule {
}
UploadProgressModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UploadProgressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UploadProgressModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UploadProgressModule, declarations: [AsolFileUploadProgressComponent], imports: [SharedModule, AsolButtonModule, AsolUploadModule], exports: [AsolFileUploadProgressComponent] });
UploadProgressModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UploadProgressModule, imports: [[SharedModule, AsolButtonModule, AsolUploadModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: UploadProgressModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolFileUploadProgressComponent],
                    exports: [AsolFileUploadProgressComponent],
                    imports: [SharedModule, AsolButtonModule, AsolUploadModule],
                }]
        }] });

class DialogContentDirective {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(template) {
        this.template = template;
    }
}
DialogContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DialogContentDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DialogContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: DialogContentDirective, selector: "[dialogContent]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DialogContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dialogContent]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class AsolDialogComponent {
    constructor(trans) {
        this.trans = trans;
        /**
         * Translated dialog header text
         */
        this.headerText = '';
        /**
         * Width of the dialog window
         * @default '750px'
         */
        this.width = '750px';
        /**
         * Minumim height for dialog window
         */
        this.minHeight = '';
        /**
         * Height of the dialog window
         */
        this.height = '';
        /**
         * Flag if dialog should be modal with backdrop
         * @default true
         */
        this.isModal = true;
        /**
         * Definition of buttons for the dialog window
         */
        this.buttonDefinition = null;
        /**
         * Flag if close icon should be shown in header
         * @default true
         */
        this.showCloseIcon = true;
        /**
         * Flag if the dialog window close when clicking on the overlay
         * @default true
         */
        this.closeOnOverlayClick = true;
        /**
         * Position of the buttons in the dialog footer
         * @default 'start'
         */
        this.buttonPosition = 'start';
        /**
         * Flag if paddings under header and above footer should be default or it will be changed in implementation
         * @default true
         */
        this.defaultPaddings = true;
        /**
         * Defines additional class for button section
         */
        this.buttonCssClass = null;
        this.buttonClicked = new EventEmitter();
        this.ICONS = ICONS;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /**
         * Placeholder for child content
         * On dialog show the template will be copied to this template
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.displayedTemplate = null;
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.buttonDefinition && this.buttonDefinition) {
            (_a = this.buttonDefinition) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                var _a, _b;
                (item.color = (_a = item.color) !== null && _a !== void 0 ? _a : 'primary'),
                    (item.type = (_b = item.type) !== null && _b !== void 0 ? _b : 'default');
            });
        }
    }
    /**
     * Shows dialog window
     */
    show() {
        this.lazyRender();
        this.ejDialog.show();
    }
    /**
     * Hides dialog window
     */
    hide() {
        this.ejDialog.hide();
    }
    /**
     * Button click event
     * @param type Type of button clicked, if defined in ButtonDefinition @see{@link ButtonType}
     */
    onClick(type) {
        this.buttonClicked.emit(type);
    }
    /**
     * Close button click handler
     */
    onCloseClick() {
        this.buttonClicked.emit('Close');
        this.hide();
    }
    overlayHide() {
        if (this.closeOnOverlayClick) {
            this.hide();
        }
    }
    onOpen(args) {
        //Preventing the default dialog focus
        args.preventFocus = true;
    }
    lazyRender() {
        // if we can render the template
        if (this.template) {
            // don't re-create the template if already present
            if (this.displayedTemplate == null) {
                this.displayedTemplate = this.template;
            }
        }
        else {
            this.displayedTemplate = null;
        }
    }
}
AsolDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolDialogComponent, selector: "asol-dialog", inputs: { headerText: "headerText", width: "width", minHeight: "minHeight", height: "height", isModal: "isModal", buttonDefinition: "buttonDefinition", showCloseIcon: "showCloseIcon", closeOnOverlayClick: "closeOnOverlayClick", buttonPosition: "buttonPosition", defaultPaddings: "defaultPaddings", buttonCssClass: "buttonCssClass" }, outputs: { buttonClicked: "buttonClicked" }, queries: [{ propertyName: "template", first: true, predicate: DialogContentDirective, descendants: true, read: TemplateRef, static: true }], viewQueries: [{ propertyName: "ejDialog", first: true, predicate: ["ejDialog"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ejs-dialog\n  id=\"dialog\"\n  #ejDialog\n  class=\"asol-dialog\"\n  [isModal]=\"isModal\"\n  [visible]=\"false\"\n  (overlayClick)=\"overlayHide()\"\n  (open)=\"onOpen($event)\"\n  [width]=\"width\"\n  [minHeight]=\"minHeight\"\n  [height]=\"height\">\n  <ng-template #content>\n    <div\n      class=\"center-item-v justify-content-between\"\n      [ngClass]=\"{ 'pb-6': defaultPaddings }\">\n      <h1 *ngIf=\"headerText\">{{ headerText }}</h1>\n      <ng-content select=\"[header]\"> </ng-content>\n      <svg-icon\n        *ngIf=\"showCloseIcon\"\n        class=\"c-pointer\"\n        (click)=\"onCloseClick()\"\n        [src]=\"ICONS.CIRCLE_CLOSE\"></svg-icon>\n    </div>\n    <ng-container *ngTemplateOutlet=\"displayedTemplate\"> </ng-container>\n    <ng-content></ng-content>\n    <div\n      class=\"w-100 d-flex align-items-end\"\n      [class]=\"'justify-content-' + buttonPosition + ' ' + buttonCssClass\"\n      [ngClass]=\"{ 'pt-6': defaultPaddings }\"\n      *ngIf=\"buttonDefinition?.length\">\n      <asol-button\n        [color]=\"item.color\"\n        [id]=\"item.textType ?? item.text\"\n        [type]=\"item.type\"\n        [iconSvgUrl]=\"item.icon\"\n        [disabled]=\"item.disabled\"\n        [ngClass]=\"{\n          'me-5': buttonPosition !== 'end' && !last,\n          'ms-5': buttonPosition === 'end' && i > 0,\n          'pe-none': item.disabled\n        }\"\n        (click)=\"onClick(item.textType)\"\n        *ngFor=\"let item of buttonDefinition; let i = index; let last = last\">\n        {{\n          item.text\n            ? item.text\n            : item.textType\n            ? trans.get(GENERAL_TRANSLATION, item.textType)\n            : ''\n        }}\n      </asol-button>\n    </div>\n  </ng-template>\n</ejs-dialog>\n", styles: [""], components: [{ type: i2$2.DialogComponent, selector: "ejs-dialog", inputs: ["allowDragging", "animationSettings", "buttons", "closeOnEscape", "content", "cssClass", "enableHtmlSanitizer", "enablePersistence", "enableResize", "enableRtl", "footerTemplate", "header", "height", "isModal", "locale", "minHeight", "position", "resizeHandles", "showCloseIcon", "target", "visible", "width", "zIndex"], outputs: ["beforeClose", "beforeOpen", "beforeSanitizeHtml", "close", "created", "destroyed", "drag", "dragStart", "dragStop", "open", "overlayClick", "resizeStart", "resizeStop", "resizing", "visibleChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-dialog', template: "<ejs-dialog\n  id=\"dialog\"\n  #ejDialog\n  class=\"asol-dialog\"\n  [isModal]=\"isModal\"\n  [visible]=\"false\"\n  (overlayClick)=\"overlayHide()\"\n  (open)=\"onOpen($event)\"\n  [width]=\"width\"\n  [minHeight]=\"minHeight\"\n  [height]=\"height\">\n  <ng-template #content>\n    <div\n      class=\"center-item-v justify-content-between\"\n      [ngClass]=\"{ 'pb-6': defaultPaddings }\">\n      <h1 *ngIf=\"headerText\">{{ headerText }}</h1>\n      <ng-content select=\"[header]\"> </ng-content>\n      <svg-icon\n        *ngIf=\"showCloseIcon\"\n        class=\"c-pointer\"\n        (click)=\"onCloseClick()\"\n        [src]=\"ICONS.CIRCLE_CLOSE\"></svg-icon>\n    </div>\n    <ng-container *ngTemplateOutlet=\"displayedTemplate\"> </ng-container>\n    <ng-content></ng-content>\n    <div\n      class=\"w-100 d-flex align-items-end\"\n      [class]=\"'justify-content-' + buttonPosition + ' ' + buttonCssClass\"\n      [ngClass]=\"{ 'pt-6': defaultPaddings }\"\n      *ngIf=\"buttonDefinition?.length\">\n      <asol-button\n        [color]=\"item.color\"\n        [id]=\"item.textType ?? item.text\"\n        [type]=\"item.type\"\n        [iconSvgUrl]=\"item.icon\"\n        [disabled]=\"item.disabled\"\n        [ngClass]=\"{\n          'me-5': buttonPosition !== 'end' && !last,\n          'ms-5': buttonPosition === 'end' && i > 0,\n          'pe-none': item.disabled\n        }\"\n        (click)=\"onClick(item.textType)\"\n        *ngFor=\"let item of buttonDefinition; let i = index; let last = last\">\n        {{\n          item.text\n            ? item.text\n            : item.textType\n            ? trans.get(GENERAL_TRANSLATION, item.textType)\n            : ''\n        }}\n      </asol-button>\n    </div>\n  </ng-template>\n</ejs-dialog>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { headerText: [{
                type: Input
            }], width: [{
                type: Input
            }], minHeight: [{
                type: Input
            }], height: [{
                type: Input
            }], isModal: [{
                type: Input
            }], buttonDefinition: [{
                type: Input
            }], showCloseIcon: [{
                type: Input
            }], closeOnOverlayClick: [{
                type: Input
            }], buttonPosition: [{
                type: Input
            }], defaultPaddings: [{
                type: Input
            }], buttonCssClass: [{
                type: Input
            }], buttonClicked: [{
                type: Output
            }], ejDialog: [{
                type: ViewChild,
                args: ['ejDialog']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        template: [{
                type: ContentChild,
                args: [DialogContentDirective, { read: TemplateRef, static: true }]
            }] } });

class AsolDialogModule {
}
AsolDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogModule, declarations: [AsolDialogComponent, DialogContentDirective], imports: [DialogModule, SharedModule, AsolButtonModule], exports: [AsolDialogComponent, DialogContentDirective] });
AsolDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogModule, imports: [[DialogModule, SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolDialogComponent, DialogContentDirective],
                    imports: [DialogModule, SharedModule, AsolButtonModule],
                    exports: [AsolDialogComponent, DialogContentDirective],
                }]
        }] });

const ENTITY_LINK_CONSTANT = {
    TRANS: 'app-controls-entity-link-trans',
};

class AsolEntityLinkDialogComponent {
    constructor(trans, fb) {
        this.trans = trans;
        this.fb = fb;
        /**
         * Dialog header text.
         */
        this.headerText = null;
        /**
         * Optional filter parameters for data provider
         */
        this.filterParams = null;
        /**
         * Event emitted when user closes dialog.
         */
        this.closed = new EventEmitter();
        /** Objects for dropdown */
        this.selectOptions = null;
        /** Button definition for select dialog */
        this.dialogButtonDefinition = [
            {
                type: 'default',
                color: 'primary',
                textType: 'Confirm',
            },
            {
                type: 'outline',
                color: 'primary',
                textType: 'Cancel',
            },
        ];
        this.formGroup = this.fb.group({
            id: [null, Validators.required],
        });
    }
    ngOnInit() {
        if (!this.headerText) {
            this.headerText = this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'link');
        }
    }
    /**
     * Shows dialog
     */
    showDialog(selectedOption) {
        this.formGroup.patchValue({
            id: selectedOption,
        });
        this.dialog.show();
    }
    /**
     * Event when user selects options from dialog
     * @param button Button which was clicked
     */
    onDialogClose(button) {
        if (button !== 'Confirm') {
            this.dialog.hide();
            return;
        }
        this.formGroup.markAllAsTouched();
        if (this.formGroup.invalid) {
            return;
        }
        this.closed.emit(this.formGroup.value.id);
        this.dialog.hide();
    }
}
AsolEntityLinkDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkDialogComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolEntityLinkDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolEntityLinkDialogComponent, selector: "asol-entity-link-dialog", inputs: { headerText: "headerText", dataProvider: "dataProvider", filterParams: "filterParams" }, outputs: { closed: "closed" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"32.75rem\"\n  [headerText]=\"headerText\"\n  [buttonPosition]=\"'start'\"\n  [buttonDefinition]=\"dialogButtonDefinition\"\n  [closeOnOverlayClick]=\"false\"\n  [defaultPaddings]=\"false\"\n  (buttonClicked)=\"onDialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\" *dialogContent>\n    <asol-select-field\n      class=\"mb-3\"\n      formControlName=\"id\"\n      [dataProvider]=\"dataProvider\"\n      [filterParams]=\"filterParams\"\n      [allowCustom]=\"false\">\n    </asol-select-field>\n  </form>\n</asol-dialog>\n", components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }], directives: [{ type: DialogContentDirective, selector: "[dialogContent]" }, { type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-entity-link-dialog', template: "<asol-dialog\n  #dialog\n  width=\"32.75rem\"\n  [headerText]=\"headerText\"\n  [buttonPosition]=\"'start'\"\n  [buttonDefinition]=\"dialogButtonDefinition\"\n  [closeOnOverlayClick]=\"false\"\n  [defaultPaddings]=\"false\"\n  (buttonClicked)=\"onDialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\" *dialogContent>\n    <asol-select-field\n      class=\"mb-3\"\n      formControlName=\"id\"\n      [dataProvider]=\"dataProvider\"\n      [filterParams]=\"filterParams\"\n      [allowCustom]=\"false\">\n    </asol-select-field>\n  </form>\n</asol-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }]; }, propDecorators: { headerText: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], closed: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

var translation$g = {
    "sk-SK": {
        linkHeader: "Prepojenie s IS",
        link: "Prepojiť",
        linkTooltip: "Pre prepojenie stlačte edit ikonu",
        linkConfirmTitle: "Potvrdenie",
        linkConfirmText: "Skutočne chcete odstrániť prepojenie na IS?",
        linkDefaultText: "Prepojiť..."
    },
    "cs-CZ": {
        linkHeader: "Propojení s IS",
        link: "Propojit",
        linkTooltip: "Pro propojení stiskněte edit ikonu",
        linkConfirmTitle: "Potvrzení",
        linkConfirmText: "Opravdu chcete odstranit propojení na IS?",
        linkDefaultText: "Propojit..."
    },
    "en-US": {
        linkHeader: "Connect to IS",
        link: "Connect",
        linkTooltip: "To connect press edit icon",
        linkConfirmTitle: "Confirmation",
        linkConfirmText: "Do you want to remove the connection to IS?",
        linkDefaultText: "Connect..."
    }
};

class AsolEntityLinkComponent {
    constructor(trans) {
        this.trans = trans;
        /**
         * Entity link dialog header text.
         */
        this.dialogHeaderText = null;
        /**
         * Link text
         */
        this.linkText = null;
        /**
         * Link tooltip
         * @default link text
         */
        this.linkTooltip = null;
        /**
         * Link tooltip position
         * @default TopCenter
         */
        this.tooltipPosition = 'TopCenter';
        /**
         * Filter parameters for data provider @see {@link EntityFilter}
         */
        this.filterParams = null;
        /**
         * Event emitted when user changes item.
         */
        this.linkChanged = new EventEmitter();
        /** Confirmation dialog placeholder */
        this.confirmDialog = null;
        this.ICONS = ICONS;
        this.ENTITY_LINK_CONSTANT = ENTITY_LINK_CONSTANT;
        /**
         * Flag to check if tooltip is set by input or not.
         * @default true
         */
        this.isTooltipSetByInput = true;
        this.trans.initialize(ENTITY_LINK_CONSTANT.TRANS, translation$g);
    }
    ngOnChanges(changes) {
        if (changes['linkText']) {
            this.setTooltip();
        }
    }
    ngOnInit() {
        if (!this.linkTooltip) {
            this.isTooltipSetByInput = false;
            this.setTooltip();
        }
    }
    /**
     * Sets tooltip text based on linked text.
     */
    setTooltip() {
        if (!this.isTooltipSetByInput) {
            this.linkTooltip = this.linkText
                ? this.linkText
                : this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'linkTooltip');
        }
    }
    /**
     * User clicks on edit icon.
     */
    onEditClick() {
        this.dialog.showDialog(this.linkText);
    }
    /**
     * Event handler for dialog closed event.
     * @param id Selected identifier from combo
     */
    onDialogClosed(id) {
        this.linkChanged.emit(id);
    }
    /**
     * Event handler when user clicks in remove icon.
     */
    onCancelClick() {
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'linkConfirmTitle'),
            content: this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'linkConfirmText'),
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.removeLink.bind(this),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    /**
     * Removes link.
     */
    removeLink() {
        var _a;
        (_a = this.confirmDialog) === null || _a === void 0 ? void 0 : _a.hide();
        this.linkChanged.emit(null);
    }
}
AsolEntityLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolEntityLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolEntityLinkComponent, selector: "asol-entity-link", inputs: { dialogHeaderText: "dialogHeaderText", linkText: "linkText", linkTooltip: "linkTooltip", tooltipPosition: "tooltipPosition", dataProvider: "dataProvider", filterParams: "filterParams" }, outputs: { linkChanged: "linkChanged" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ejs-tooltip content=\"{{ linkTooltip }}\" [position]=\"tooltipPosition\">\n  <a class=\"link-button d-inline-flex align-items-center overflow-hidden\">\n    <svg-icon class=\"link-icon\" [src]=\"ICONS.LINK_04\"></svg-icon>\n    <div class=\"text-truncate\">\n      {{\n        linkText ??\n          this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'linkDefaultText')\n      }}\n    </div>\n    <svg-icon [src]=\"ICONS.EDIT_05\" class=\"edit-icon\" (click)=\"onEditClick()\">\n    </svg-icon>\n    <svg-icon\n      *ngIf=\"linkText\"\n      [src]=\"ICONS.X_CLOSE\"\n      class=\"close-icon\"\n      (click)=\"onCancelClick()\">\n    </svg-icon>\n  </a>\n</ejs-tooltip>\n\n<asol-entity-link-dialog\n  #dialog\n  [headerText]=\"dialogHeaderText\"\n  [filterParams]=\"filterParams\"\n  [dataProvider]=\"dataProvider\"\n  (closed)=\"onDialogClosed($event)\">\n</asol-entity-link-dialog>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.link-button{color:var(--primary);text-decoration:none;line-height:2.5rem;font-size:.875rem;font-weight:500;gap:.25rem}.link-button svg path{stroke:var(--primary);fill:none}.link-icon{display:flex;align-items:center}.link-icon-base,.close-icon,.edit-icon{visibility:hidden;cursor:pointer;display:flex;align-items:center}.link-icon-base svg,.close-icon svg,.edit-icon svg{width:1.25rem;height:1.25rem}.edit-icon{margin-left:.5rem;color:var(--primary)!important}.close-icon svg path{stroke:var(--bs-red);fill:none}a:hover .edit-icon,a:hover .close-icon{visibility:visible}\n"], components: [{ type: i2$2.TooltipComponent, selector: "ejs-tooltip", inputs: ["animation", "closeDelay", "container", "content", "cssClass", "enableHtmlParse", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "height", "isSticky", "locale", "mouseTrail", "offsetX", "offsetY", "openDelay", "opensOn", "position", "showTipPointer", "target", "tipPointerPosition", "width", "windowCollision"], outputs: ["afterClose", "afterOpen", "beforeClose", "beforeCollision", "beforeOpen", "beforeRender", "created", "destroyed"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolEntityLinkDialogComponent, selector: "asol-entity-link-dialog", inputs: ["headerText", "dataProvider", "filterParams"], outputs: ["closed"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-entity-link', template: "<ejs-tooltip content=\"{{ linkTooltip }}\" [position]=\"tooltipPosition\">\n  <a class=\"link-button d-inline-flex align-items-center overflow-hidden\">\n    <svg-icon class=\"link-icon\" [src]=\"ICONS.LINK_04\"></svg-icon>\n    <div class=\"text-truncate\">\n      {{\n        linkText ??\n          this.trans.get(ENTITY_LINK_CONSTANT.TRANS, 'linkDefaultText')\n      }}\n    </div>\n    <svg-icon [src]=\"ICONS.EDIT_05\" class=\"edit-icon\" (click)=\"onEditClick()\">\n    </svg-icon>\n    <svg-icon\n      *ngIf=\"linkText\"\n      [src]=\"ICONS.X_CLOSE\"\n      class=\"close-icon\"\n      (click)=\"onCancelClick()\">\n    </svg-icon>\n  </a>\n</ejs-tooltip>\n\n<asol-entity-link-dialog\n  #dialog\n  [headerText]=\"dialogHeaderText\"\n  [filterParams]=\"filterParams\"\n  [dataProvider]=\"dataProvider\"\n  (closed)=\"onDialogClosed($event)\">\n</asol-entity-link-dialog>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.link-button{color:var(--primary);text-decoration:none;line-height:2.5rem;font-size:.875rem;font-weight:500;gap:.25rem}.link-button svg path{stroke:var(--primary);fill:none}.link-icon{display:flex;align-items:center}.link-icon-base,.close-icon,.edit-icon{visibility:hidden;cursor:pointer;display:flex;align-items:center}.link-icon-base svg,.close-icon svg,.edit-icon svg{width:1.25rem;height:1.25rem}.edit-icon{margin-left:.5rem;color:var(--primary)!important}.close-icon svg path{stroke:var(--bs-red);fill:none}a:hover .edit-icon,a:hover .close-icon{visibility:visible}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { dialogHeaderText: [{
                type: Input
            }], linkText: [{
                type: Input
            }], linkTooltip: [{
                type: Input
            }], tooltipPosition: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], linkChanged: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

class AsolEntityLinkModule {
}
AsolEntityLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolEntityLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkModule, declarations: [AsolEntityLinkComponent, AsolEntityLinkDialogComponent], imports: [SharedModule,
        TooltipModule,
        AsolDialogModule,
        AsolSelectFieldModule,
        AsolButtonModule], exports: [AsolEntityLinkComponent] });
AsolEntityLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkModule, imports: [[
            SharedModule,
            TooltipModule,
            AsolDialogModule,
            AsolSelectFieldModule,
            AsolButtonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEntityLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolEntityLinkComponent, AsolEntityLinkDialogComponent],
                    exports: [AsolEntityLinkComponent],
                    imports: [
                        SharedModule,
                        TooltipModule,
                        AsolDialogModule,
                        AsolSelectFieldModule,
                        AsolButtonModule,
                    ],
                }]
        }] });

class EntityFilter {
}

class AsolEditorComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        this.enableResize = false;
        this.showCharCount = false;
        this.height = '100%';
        this.maxLength = -1;
        /**
         * Default toolbar items
         *
         * @type {ToolbarItemsModel}
         */
        this.toolbarItems = {
            items: [
                'Bold',
                'Italic',
                'Underline',
                '|',
                'Formats',
                'Alignments',
                'OrderedList',
                'UnorderedList',
                '|',
                'CreateLink',
                '|',
                'SourceCode',
                'Undo',
                'Redo',
            ],
        };
        /**
         * background color tool settings
         *
         * @type {BackgroundColorModel}
         */
        this.backgroundColor = { modeSwitcher: true };
        /**
         * font color tool settings
         *
         * @type {FontColorModel}
         */
        this.fontColor = { modeSwitcher: true };
        this.editor = null;
        this.locale = this.trans.currentLocale;
    }
    getControlValue() {
        if (!this.editor) {
            return null;
        }
        return this.editor.value;
    }
    setControlValue(val) {
        if (!this.editor) {
            return;
        }
        this.editor.value = val;
    }
    setControlDisabled(isDisable) {
        // not needed
    }
    callOnChange(event) {
        this.onChange(event.value);
        this.valueChangedDebouncer.next(event.value);
    }
    refresh() {
        this.editor.refreshUI();
    }
}
AsolEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolEditorComponent, selector: "asol-editor", inputs: { enableResize: "enableResize", showCharCount: "showCharCount", height: "height", maxLength: "maxLength", toolbarItems: "toolbarItems", backgroundColor: "backgroundColor", fontColor: "fontColor" }, viewQueries: [{ propertyName: "editor", first: true, predicate: ["editor"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-richtexteditor\n    #editor\n    [id]=\"id ?? 'rtxelement'\"\n    [enableResize]=\"enableResize\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [enabled]=\"!isDisabled\"\n    [locale]=\"locale\"\n    [maxLength]=\"maxLength\"\n    [width]=\"width\"\n    [showCharCount]=\"showCharCount\"\n    (change)=\"callOnChange($event)\"\n    [height]=\"height\"\n    [toolbarSettings]=\"toolbarItems\"\n    [readonly]=\"isReadonly\"\n    [backgroundColor]=\"backgroundColor\"\n    [fontColor]=\"fontColor\">\n  </ejs-richtexteditor>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [".e-rte-content{height:100%!important}.e-rte-link-dialog{height:auto!important}.e-toolbar-wrapper{height:38px!important}\n"], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$2.RichTextEditorComponent, selector: "ejs-richtexteditor", inputs: ["autoSaveOnIdle", "backgroundColor", "bulletFormatList", "cssClass", "editorMode", "enableAutoUrl", "enableHtmlEncode", "enableHtmlSanitizer", "enablePersistence", "enableResize", "enableRtl", "enableTabKey", "enableXhtml", "enabled", "enterKey", "fileManagerSettings", "floatingToolbarOffset", "fontColor", "fontFamily", "fontSize", "format", "formatter", "height", "htmlAttributes", "iframeSettings", "inlineMode", "insertImageSettings", "keyConfig", "locale", "maxLength", "numberFormatList", "pasteCleanupSettings", "placeholder", "quickToolbarSettings", "readonly", "saveInterval", "shiftEnterKey", "showCharCount", "tableSettings", "toolbarSettings", "undoRedoSteps", "undoRedoTimer", "value", "valueTemplate", "width"], outputs: ["actionBegin", "actionComplete", "afterImageDelete", "afterPasteCleanup", "beforeDialogClose", "beforeDialogOpen", "beforeImageDrop", "beforeImageUpload", "beforePasteCleanup", "beforeQuickToolbarOpen", "beforeSanitizeHtml", "blur", "change", "created", "destroyed", "dialogClose", "dialogOpen", "focus", "imageRemoving", "imageSelected", "imageUploadFailed", "imageUploadSuccess", "imageUploading", "quickToolbarClose", "quickToolbarOpen", "resizeStart", "resizeStop", "resizing", "toolbarClick", "toolbarStatusUpdate", "updatedToolbarStatus", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-editor', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-richtexteditor\n    #editor\n    [id]=\"id ?? 'rtxelement'\"\n    [enableResize]=\"enableResize\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [enabled]=\"!isDisabled\"\n    [locale]=\"locale\"\n    [maxLength]=\"maxLength\"\n    [width]=\"width\"\n    [showCharCount]=\"showCharCount\"\n    (change)=\"callOnChange($event)\"\n    [height]=\"height\"\n    [toolbarSettings]=\"toolbarItems\"\n    [readonly]=\"isReadonly\"\n    [backgroundColor]=\"backgroundColor\"\n    [fontColor]=\"fontColor\">\n  </ejs-richtexteditor>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [".e-rte-content{height:100%!important}.e-rte-link-dialog{height:auto!important}.e-toolbar-wrapper{height:38px!important}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { enableResize: [{
                type: Input
            }], showCharCount: [{
                type: Input
            }], height: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], toolbarItems: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], fontColor: [{
                type: Input
            }], editor: [{
                type: ViewChild,
                args: ['editor']
            }] } });

class AsolEditorModule {
}
AsolEditorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolEditorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorModule, declarations: [AsolEditorComponent], imports: [SharedModule, AsolLabelFieldModule, RichTextEditorAllModule], exports: [AsolEditorComponent] });
AsolEditorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorModule, providers: [
        ToolbarService$1,
        LinkService,
        ImageService,
        HtmlEditorService,
        ResizeService,
        CountService,
        TableService,
    ], imports: [[SharedModule, AsolLabelFieldModule, RichTextEditorAllModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolEditorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolEditorComponent],
                    exports: [AsolEditorComponent],
                    imports: [SharedModule, AsolLabelFieldModule, RichTextEditorAllModule],
                    providers: [
                        ToolbarService$1,
                        LinkService,
                        ImageService,
                        HtmlEditorService,
                        ResizeService,
                        CountService,
                        TableService,
                    ],
                }]
        }] });

const COMMENTS_CONSTANT = {
    TRANS: 'asol-comments-trans',
};

class CommentBase {
    constructor() {
        /** Comment provider for CRUD operations */
        this.provider = null;
        this.COMMENTS_CONSTANT = COMMENTS_CONSTANT;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
    }
    ngOnInit() {
        if (!this.entityId) {
            throw new Error('Entity identifier is required');
        }
        if (!this.provider) {
            throw new Error('Comment provider is required');
        }
    }
}
CommentBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommentBase, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CommentBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: CommentBase, inputs: { entityId: "entityId", moduleId: "moduleId", provider: "provider" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommentBase, decorators: [{
            type: Directive
        }], propDecorators: { entityId: [{
                type: Input
            }], moduleId: [{
                type: Input
            }], provider: [{
                type: Input
            }] } });

class NotificationService {
    constructor() {
        this.timeout = 7000;
    }
    openToast(message, className, showCloseButton = true, timeout) {
        return ToastUtility.show({
            content: message,
            cssClass: className,
            icon: `${className}-icon`,
            showCloseButton: showCloseButton,
            position: { X: 'Right', Y: 'Top' },
            timeOut: timeout !== null && timeout !== void 0 ? timeout : this.timeout,
        });
    }
    /**
     * Shows success message
     * @param message Message to show
     * @param showCloseButton if close button should be shown
     * @param timeout Optional timeout, if undefined default would be used, it message should be always visible insert 0
     */
    success(message, showCloseButton = true, timeout) {
        return this.openToast(message, 'e-toast-success', showCloseButton, timeout);
    }
    /**
     * Shows info message
     * @param message Message to show
     * @param showCloseButton if close button should be shown
     * @param timeout Optional timeout, if undefined default would be used, it message should be always visible insert 0
     */
    info(message, showCloseButton = true, timeout) {
        return this.openToast(message, 'e-toast-info', showCloseButton, timeout);
    }
    /**
     * Shows warning message
     * @param message Message to show
     * @param showCloseButton if close button should be shown
     * @param timeout Optional timeout, if undefined default would be used, it message should be always visible insert 0
     */
    warning(message, showCloseButton = true, timeout) {
        return this.openToast(message, 'e-toast-warning', showCloseButton, timeout);
    }
    /**
     * Shows danger message
     * @param message Message to show
     * @param showCloseButton if close button should be shown
     * @param timeout Optional timeout, if undefined default would be used, it message should be always visible insert 0
     */
    danger(message, showCloseButton = true, timeout) {
        return this.openToast(message, 'e-toast-danger', showCloseButton, timeout);
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NotificationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AsolCommentAddComponent extends CommentBase {
    constructor(trans, builder, notificationService) {
        super();
        this.trans = trans;
        this.builder = builder;
        this.notificationService = notificationService;
        /** Evetn when comment was stored */
        this.commentStored = new EventEmitter();
        this.formGroup = this.builder.group({
            text: [null, [Validators.maxLength(500)]],
        });
    }
    /**
     * Sends text to comments provider
     */
    onSend() {
        markForValidation(this.formGroup);
        if (this.formGroup.invalid || !this.formGroup.controls.text.value) {
            return;
        }
        this.provider
            .addComment(this.formGroup.value.text, this.entityId, this.moduleId)
            .subscribe((result) => {
            if (!result) {
                this.notificationService.danger(this.trans.get(COMMENTS_CONSTANT.TRANS, 'commentSendErrorMessage'));
                return;
            }
            this.notificationService.success(this.trans.get(COMMENTS_CONSTANT.TRANS, 'commentSendMessage'));
            this.formGroup.reset();
            this.commentStored.emit();
        });
    }
}
AsolCommentAddComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentAddComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }, { token: NotificationService }], target: i0.ɵɵFactoryTarget.Component });
AsolCommentAddComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolCommentAddComponent, selector: "asol-comment-add", outputs: { commentStored: "commentStored" }, usesInheritance: true, ngImport: i0, template: "<div class=\"w-100\">\n  <form [formGroup]=\"formGroup\">\n    <asol-editor\n      formControlName=\"text\"\n      class=\"mb-2\"\n      [transKey]=\"COMMENTS_CONSTANT.TRANS\"\n      placeholderKey=\"commentPlaceholder\">\n    </asol-editor>\n\n    <div class=\"d-flex justify-content-end mb-5\">\n      <asol-button color=\"primary\" type=\"outline\" (click)=\"onSend()\">\n        {{ trans.get(GENERAL_TRANSLATION, 'send') }}\n      </asol-button>\n    </div>\n  </form>\n</div>\n", components: [{ type: AsolEditorComponent, selector: "asol-editor", inputs: ["enableResize", "showCharCount", "height", "maxLength", "toolbarItems", "backgroundColor", "fontColor"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentAddComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-comment-add', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"w-100\">\n  <form [formGroup]=\"formGroup\">\n    <asol-editor\n      formControlName=\"text\"\n      class=\"mb-2\"\n      [transKey]=\"COMMENTS_CONSTANT.TRANS\"\n      placeholderKey=\"commentPlaceholder\">\n    </asol-editor>\n\n    <div class=\"d-flex justify-content-end mb-5\">\n      <asol-button color=\"primary\" type=\"outline\" (click)=\"onSend()\">\n        {{ trans.get(GENERAL_TRANSLATION, 'send') }}\n      </asol-button>\n    </div>\n  </form>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }, { type: NotificationService }]; }, propDecorators: { commentStored: [{
                type: Output
            }] } });

class AsolCommentItemComponent extends CommentBase {
    constructor(trans, builder, notificationService, cdr) {
        super();
        this.trans = trans;
        this.builder = builder;
        this.notificationService = notificationService;
        this.cdr = cdr;
        /** Comment item */
        this.item = null;
        /**
         * Flag if component is last
         * @default false
         */
        this.lastItem = false;
        /**
         * Flag if user edits the comment
         * @default false
         */
        this.editMode = false;
        /**
         * Flag if adding, editting, removing is enabled or disabled
         * @default false
         */
        this.isDisabled = false;
        /**
         * Flag if comment can be deleted
         * @default true
         */
        this.canDelete = true;
        /** Event handler when user deletes the comment (or response) */
        this.commentDelete = new EventEmitter();
        /** Event when user cancel creation of new response */
        this.responseCancel = new EventEmitter();
        /** Event after new response was saved */
        this.responseAdded = new EventEmitter();
        /** Event when user clicks on Respond button */
        this.response = new EventEmitter();
        this.ICONS = ICONS;
        /** Confirmation dialog */
        this.confirmDialog = null;
        this.formGroup = this.builder.group({
            text: [null, Validators.required],
        });
    }
    ngOnChanges(changes) {
        if (changes['item']) {
            this.formGroup.patchValue({
                text: this.item.text,
            });
            if (this.item.id === 0) {
                this.editMode = true;
            }
        }
    }
    /**
     * Event handler after user clicks on respond button
     * @param id Comment identifier
     */
    onRespond(id) {
        this.response.emit(id);
    }
    /**
     * Event handler when user clicks delete comment
     */
    onDelete() {
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(COMMENTS_CONSTANT.TRANS, 'deleteCommentConfirmTitle'),
            content: this.trans.get(COMMENTS_CONSTANT.TRANS, 'deleteCommentConfirm'),
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.confirmDeleteClick.bind(this, this.item.id),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    /**
     * Deletes item after confirmation dialog close
     * @param id Comment identifier
     */
    confirmDeleteClick(id) {
        this.provider.removeComment(id).subscribe((result) => {
            if (!result) {
                return;
            }
            this.notificationService.success(this.trans.get(COMMENTS_CONSTANT.TRANS, 'commentRemovedMessage'));
            this.commentDelete.emit(id);
            this.confirmDialog.close();
        });
    }
    /**
     * Event handler when user clicks store comment text
     * If user is adding new response it is saved and closed
     * If user is editing it updates current comment
     */
    onSave() {
        markForValidation(this.formGroup);
        if (this.formGroup.invalid) {
            return;
        }
        if (this.item.id === 0) {
            this.provider
                .addResponse(this.item.parentId, this.formGroup.value.text)
                .subscribe(() => {
                this.editMode = false;
                this.notificationService.success(this.trans.get(COMMENTS_CONSTANT.TRANS, 'commentSendMessage'));
                this.responseAdded.emit();
                this.cdr.detectChanges();
            });
        }
        else {
            this.provider
                .updateComment(this.item.id, this.formGroup.value.text)
                .subscribe((comment) => {
                this.editMode = false;
                this.notificationService.success(this.trans.get(COMMENTS_CONSTANT.TRANS, 'commentSendMessage'));
                this.item = comment;
                this.cdr.detectChanges();
            });
        }
    }
    /**
     * Event handler when user clicks on Cancel
     * It shows confirmation dialog if user is adding new response or id disables edit mode if not
     */
    onCancel() {
        if (this.item.id === 0) {
            this.confirmDialog = DialogUtility.confirm({
                title: this.trans.get(COMMENTS_CONSTANT.TRANS, 'cancelResponseConfirmTitle'),
                content: this.trans.get(COMMENTS_CONSTANT.TRANS, 'cancelResponseConfirm'),
                okButton: {
                    text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                    click: this.confirmCancelClick.bind(this),
                },
                cancelButton: {
                    text: this.trans.get(GENERAL_TRANSLATION, 'No'),
                },
            });
        }
        else {
            this.editMode = false;
        }
    }
    /**
     * Cancels adding new response
     */
    confirmCancelClick() {
        this.responseCancel.emit();
        this.confirmDialog.close();
    }
}
AsolCommentItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentItemComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }, { token: NotificationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolCommentItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolCommentItemComponent, selector: "asol-comment-item", inputs: { item: "item", lastItem: "lastItem", editMode: "editMode", isDisabled: "isDisabled", canDelete: "canDelete" }, outputs: { commentDelete: "commentDelete", responseCancel: "responseCancel", responseAdded: "responseAdded", response: "response" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"w-100\" *ngIf=\"item\" [ngClass]=\"{ 'd-flex': item.parentId }\">\n  <div\n    *ngIf=\"item.parentId\"\n    class=\"comment-response-line mx-5\"\n    [ngClass]=\"{ 'mb-8': lastItem }\"></div>\n\n  <!-- Main comment -->\n  <div class=\"comment-wrapper mb-5\">\n    <div class=\"d-flex justify-content-between comment-header\">\n      <div class=\"d-inline-flex\" *ngIf=\"item.user || item.created\">\n        <h4>{{ item?.user }}</h4>\n        <div class=\"created ms-3\">\n          {{ item?.created | datetime: 'short':'' }}\n        </div>\n      </div>\n      <div *ngIf=\"!editMode && !isDisabled\">\n        <a\n          class=\"respond\"\n          *ngIf=\"!item.parentId\"\n          (click)=\"onRespond(item.id)\"\n          >{{ trans.get(GENERAL_TRANSLATION, 'respond') }}</a\n        >\n        <ng-container *ngIf=\"item.canEdit\">\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.TRASH\"\n            *ngIf=\"canDelete\"\n            color=\"danger\"\n            type=\"flat\"\n            (click)=\"onDelete()\">\n          </asol-icon-button>\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.EDIT\"\n            color=\"dark\"\n            type=\"flat\"\n            (click)=\"editMode = true\">\n          </asol-icon-button>\n        </ng-container>\n      </div>\n    </div>\n    <div\n      class=\"mt-5 text\"\n      *ngIf=\"!editMode; else edit\"\n      [innerHTML]=\"item.text\"></div>\n  </div>\n  <ng-content></ng-content>\n</div>\n\n<ng-template #edit>\n  <form [formGroup]=\"formGroup\" class=\"mt-5\">\n    <asol-editor\n      formControlName=\"text\"\n      [isDisabled]=\"isDisabled\"\n      class=\"mb-2\"\n      [transKey]=\"COMMENTS_CONSTANT.TRANS\"\n      placeholderKey=\"commentPlaceholder\">\n    </asol-editor>\n\n    <div class=\"d-flex justify-content-end\">\n      <asol-button\n        color=\"primary\"\n        type=\"flat\"\n        (click)=\"onCancel()\"\n        [disabled]=\"isDisabled\">\n        {{ trans.get(GENERAL_TRANSLATION, 'cancel') }}\n      </asol-button>\n      <asol-button color=\"primary\" (click)=\"onSave()\" [disabled]=\"isDisabled\">\n        {{ trans.get(GENERAL_TRANSLATION, 'save') }}\n      </asol-button>\n    </div>\n  </form>\n</ng-template>\n", components: [{ type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolEditorComponent, selector: "asol-editor", inputs: ["enableResize", "showCharCount", "height", "maxLength", "toolbarItems", "backgroundColor", "fontColor"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], pipes: { "datetime": i1.DateTimePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-comment-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"w-100\" *ngIf=\"item\" [ngClass]=\"{ 'd-flex': item.parentId }\">\n  <div\n    *ngIf=\"item.parentId\"\n    class=\"comment-response-line mx-5\"\n    [ngClass]=\"{ 'mb-8': lastItem }\"></div>\n\n  <!-- Main comment -->\n  <div class=\"comment-wrapper mb-5\">\n    <div class=\"d-flex justify-content-between comment-header\">\n      <div class=\"d-inline-flex\" *ngIf=\"item.user || item.created\">\n        <h4>{{ item?.user }}</h4>\n        <div class=\"created ms-3\">\n          {{ item?.created | datetime: 'short':'' }}\n        </div>\n      </div>\n      <div *ngIf=\"!editMode && !isDisabled\">\n        <a\n          class=\"respond\"\n          *ngIf=\"!item.parentId\"\n          (click)=\"onRespond(item.id)\"\n          >{{ trans.get(GENERAL_TRANSLATION, 'respond') }}</a\n        >\n        <ng-container *ngIf=\"item.canEdit\">\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.TRASH\"\n            *ngIf=\"canDelete\"\n            color=\"danger\"\n            type=\"flat\"\n            (click)=\"onDelete()\">\n          </asol-icon-button>\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.EDIT\"\n            color=\"dark\"\n            type=\"flat\"\n            (click)=\"editMode = true\">\n          </asol-icon-button>\n        </ng-container>\n      </div>\n    </div>\n    <div\n      class=\"mt-5 text\"\n      *ngIf=\"!editMode; else edit\"\n      [innerHTML]=\"item.text\"></div>\n  </div>\n  <ng-content></ng-content>\n</div>\n\n<ng-template #edit>\n  <form [formGroup]=\"formGroup\" class=\"mt-5\">\n    <asol-editor\n      formControlName=\"text\"\n      [isDisabled]=\"isDisabled\"\n      class=\"mb-2\"\n      [transKey]=\"COMMENTS_CONSTANT.TRANS\"\n      placeholderKey=\"commentPlaceholder\">\n    </asol-editor>\n\n    <div class=\"d-flex justify-content-end\">\n      <asol-button\n        color=\"primary\"\n        type=\"flat\"\n        (click)=\"onCancel()\"\n        [disabled]=\"isDisabled\">\n        {{ trans.get(GENERAL_TRANSLATION, 'cancel') }}\n      </asol-button>\n      <asol-button color=\"primary\" (click)=\"onSave()\" [disabled]=\"isDisabled\">\n        {{ trans.get(GENERAL_TRANSLATION, 'save') }}\n      </asol-button>\n    </div>\n  </form>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }, { type: NotificationService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { item: [{
                type: Input
            }], lastItem: [{
                type: Input
            }], editMode: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], canDelete: [{
                type: Input
            }], commentDelete: [{
                type: Output
            }], responseCancel: [{
                type: Output
            }], responseAdded: [{
                type: Output
            }], response: [{
                type: Output
            }] } });

var translation$f = {
    "sk-SK": {
        commentPlaceholder: "Pridať komentár...",
        commentSendErrorMessage: "Pri ukladaní vznikla chyba",
        commentSendMessage: "Komentár uložený",
        deleteCommentConfirmTitle: "Zmazanie komentára",
        deleteCommentConfirm: "Skutočne chcete zmazať komentár?",
        cancelResponseConfirmTitle: "Zrušenie odpovede",
        cancelResponseConfirm: "Skutočne chcete zrušiť pridanie odpovede?",
        commentRemovedMessage: "Komentár zmazaný",
        "": ""
    },
    "cs-CZ": {
        commentPlaceholder: "Přidat komentář...",
        commentSendErrorMessage: "Při uložení vznikla chyba",
        commentSendMessage: "Komentář uložen",
        deleteCommentConfirmTitle: "Smazání komentáře",
        deleteCommentConfirm: "Skutečně chcete smazat komentář?",
        cancelResponseConfirmTitle: "Zrušení odpovědi",
        cancelResponseConfirm: "Skutečně chcete zrušit přidávání odpovědi?",
        commentRemovedMessage: "Komentář smazaný",
        "": ""
    },
    "en-US": {
        commentPlaceholder: "Add comment...",
        commentSendErrorMessage: "Error occured",
        commentSendMessage: "Comment saved",
        deleteCommentConfirmTitle: "Delete comment",
        deleteCommentConfirm: "Are you sure you want to delete the comment?",
        cancelResponseConfirmTitle: "Response canceling",
        cancelResponseConfirm: "Are you sure you want to cancel adding new response?",
        commentRemovedMessage: "Comment removed",
        "": ""
    }
};

/**
 * Pipe used to display a list of responses based on parent comment.
 */
class HasResponsesPipe {
    transform(value, parentId) {
        if (!value.length) {
            return false;
        }
        return value.some((p) => p.parentId === parentId);
    }
}
HasResponsesPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HasResponsesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HasResponsesPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HasResponsesPipe, name: "hasResponses" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HasResponsesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'hasResponses',
                    pure: true,
                }]
        }] });

/**
 * Used to display a list of comments without responses.
 */
class CommentsFilterPipe {
    transform(value) {
        return value
            .filter((p) => p.parentId === undefined || p.parentId === null)
            .sort((a, b) => {
            return new Date(b.created).getTime() - new Date(a.created).getTime();
        });
    }
}
CommentsFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommentsFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CommentsFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommentsFilterPipe, name: "commentsFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CommentsFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'commentsFilter',
                    pure: true,
                }]
        }] });

/**
 * Pipe used to display a list of responses based on parent comment.
 */
class ResponsesFilterPipe {
    transform(value, parentId) {
        if (!value.length) {
            return [];
        }
        const data = value.filter((p) => p.parentId === parentId);
        return data.sort((a, b) => {
            return new Date(b.created).getTime() - new Date(a.created).getTime();
        });
    }
}
ResponsesFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ResponsesFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ResponsesFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ResponsesFilterPipe, name: "responsesFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ResponsesFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'responsesFilter',
                    pure: true,
                }]
        }] });

class AsolCommentComponent extends CommentBase {
    constructor(trans, cdr) {
        super();
        this.trans = trans;
        this.cdr = cdr;
        /**
         * Flag if add comments should be shown
         * @default true
         */
        this.canAddComment = true;
        /**
         * Flag if loading of comments should be instant or not
         * @default false
         */
        this.deferLoading = false;
        /**
         * Flag if adding, editting, removing is enabled or disabled
         * @default false
         */
        this.isDisabled = false;
        /** Observable for all comments and responses */
        this.comments$ = of([]);
        /** New response object */
        this.newResponse = null;
        /** user id from profile service */
        this.userId = null;
        this.subs = new Subscription();
        trans.initialize(COMMENTS_CONSTANT.TRANS, translation$f);
    }
    ngOnInit() {
        super.ngOnInit();
        if (!this.deferLoading && this.provider) {
            this.loadComments();
        }
        this.subs = this.trans.languageChanged$.subscribe(() => {
            this.loadComments();
            this.cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /**
     * Load comments
     */
    loadComments() {
        this.comments$ = this.provider.getComments(this.entityId, this.moduleId, this.filter);
    }
    /**
     * Comments track by function
     * @param index index
     * @param item Item with identifier
     */
    commentId(index, item) {
        return item.id;
    }
    /**
     * Event handler when user hits respond button
     * @param id Comment identifier to pass as parentId
     */
    onResponse(id) {
        this.newResponse = {
            id: 0,
            parentId: id,
            canEdit: true,
        };
        this.cdr.detectChanges();
    }
    /**
     * Event handler when response creation was canceled
     */
    onResponseCancel() {
        this.newResponse = null;
        this.cdr.detectChanges();
    }
    /**
     * Event handler when new response was added
     */
    onResponseAdded() {
        this.onResponseCancel();
        this.loadComments();
        this.cdr.detectChanges();
    }
}
AsolCommentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentComponent, deps: [{ token: i1.TranslationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolCommentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolCommentComponent, selector: "asol-comment", inputs: { filter: "filter", canAddComment: "canAddComment", deferLoading: "deferLoading", isDisabled: "isDisabled" }, usesInheritance: true, ngImport: i0, template: "<div class=\"comment-container\">\n  <asol-comment-add\n    *ngIf=\"!isDisabled && canAddComment\"\n    [provider]=\"provider\"\n    [entityId]=\"entityId\"\n    [moduleId]=\"moduleId\"\n    (commentStored)=\"loadComments()\">\n  </asol-comment-add>\n\n  <div *ngIf=\"comments$ | async as comments\">\n    <asol-comment-item\n      *ngFor=\"let comment of comments | commentsFilter; trackBy: commentId\"\n      [item]=\"comment\"\n      [isDisabled]=\"isDisabled\"\n      [entityId]=\"entityId\"\n      [moduleId]=\"moduleId\"\n      [canDelete]=\"!(comments | hasResponses: comment.id)\"\n      [provider]=\"provider\"\n      (commentDelete)=\"loadComments()\"\n      (response)=\"onResponse($event)\">\n      <ng-container *ngIf=\"comments | responsesFilter: comment.id as responses\">\n        <!-- Add response -->\n        <asol-comment-item\n          [lastItem]=\"!responses.length\"\n          *ngIf=\"newResponse && newResponse.parentId === comment.id\"\n          [item]=\"newResponse\"\n          [entityId]=\"entityId\"\n          [moduleId]=\"moduleId\"\n          [provider]=\"provider\"\n          (responseAdded)=\"onResponseAdded()\"\n          (responseCancel)=\"onResponseCancel()\">\n        </asol-comment-item>\n\n        <!-- Repsonses -->\n        <asol-comment-item\n          *ngFor=\"\n            let response of responses;\n            trackBy: commentId;\n            let last = last\n          \"\n          [lastItem]=\"last\"\n          [entityId]=\"entityId\"\n          [moduleId]=\"moduleId\"\n          [isDisabled]=\"isDisabled\"\n          [item]=\"response\"\n          [provider]=\"provider\"\n          (commentDelete)=\"loadComments()\">\n        </asol-comment-item>\n      </ng-container>\n    </asol-comment-item>\n  </div>\n</div>\n", styles: [".comment-container{width:100%;max-width:680px}\n"], components: [{ type: AsolCommentAddComponent, selector: "asol-comment-add", outputs: ["commentStored"] }, { type: AsolCommentItemComponent, selector: "asol-comment-item", inputs: ["item", "lastItem", "editMode", "isDisabled", "canDelete"], outputs: ["commentDelete", "responseCancel", "responseAdded", "response"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe, "hasResponses": HasResponsesPipe, "commentsFilter": CommentsFilterPipe, "responsesFilter": ResponsesFilterPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-comment', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"comment-container\">\n  <asol-comment-add\n    *ngIf=\"!isDisabled && canAddComment\"\n    [provider]=\"provider\"\n    [entityId]=\"entityId\"\n    [moduleId]=\"moduleId\"\n    (commentStored)=\"loadComments()\">\n  </asol-comment-add>\n\n  <div *ngIf=\"comments$ | async as comments\">\n    <asol-comment-item\n      *ngFor=\"let comment of comments | commentsFilter; trackBy: commentId\"\n      [item]=\"comment\"\n      [isDisabled]=\"isDisabled\"\n      [entityId]=\"entityId\"\n      [moduleId]=\"moduleId\"\n      [canDelete]=\"!(comments | hasResponses: comment.id)\"\n      [provider]=\"provider\"\n      (commentDelete)=\"loadComments()\"\n      (response)=\"onResponse($event)\">\n      <ng-container *ngIf=\"comments | responsesFilter: comment.id as responses\">\n        <!-- Add response -->\n        <asol-comment-item\n          [lastItem]=\"!responses.length\"\n          *ngIf=\"newResponse && newResponse.parentId === comment.id\"\n          [item]=\"newResponse\"\n          [entityId]=\"entityId\"\n          [moduleId]=\"moduleId\"\n          [provider]=\"provider\"\n          (responseAdded)=\"onResponseAdded()\"\n          (responseCancel)=\"onResponseCancel()\">\n        </asol-comment-item>\n\n        <!-- Repsonses -->\n        <asol-comment-item\n          *ngFor=\"\n            let response of responses;\n            trackBy: commentId;\n            let last = last\n          \"\n          [lastItem]=\"last\"\n          [entityId]=\"entityId\"\n          [moduleId]=\"moduleId\"\n          [isDisabled]=\"isDisabled\"\n          [item]=\"response\"\n          [provider]=\"provider\"\n          (commentDelete)=\"loadComments()\">\n        </asol-comment-item>\n      </ng-container>\n    </asol-comment-item>\n  </div>\n</div>\n", styles: [".comment-container{width:100%;max-width:680px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { filter: [{
                type: Input
            }], canAddComment: [{
                type: Input
            }], deferLoading: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });

class AsolCommentsModule {
}
AsolCommentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolCommentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentsModule, declarations: [AsolCommentAddComponent,
        AsolCommentItemComponent,
        AsolCommentComponent,
        ResponsesFilterPipe,
        CommentsFilterPipe,
        HasResponsesPipe], imports: [SharedModule, AsolEditorModule, AsolButtonModule, PipesModule], exports: [AsolCommentComponent] });
AsolCommentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentsModule, imports: [[SharedModule, AsolEditorModule, AsolButtonModule, PipesModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCommentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolCommentAddComponent,
                        AsolCommentItemComponent,
                        AsolCommentComponent,
                        ResponsesFilterPipe,
                        CommentsFilterPipe,
                        HasResponsesPipe,
                    ],
                    exports: [AsolCommentComponent],
                    imports: [SharedModule, AsolEditorModule, AsolButtonModule, PipesModule],
                }]
        }] });

/* eslint-disable @typescript-eslint/no-explicit-any */
class AsolDataColumnDirective {
    constructor() {
        // Grid fields
        /**
         * If `allowResizing` set to false, it disables resize option of a particular column.
         *
         * @default true
         */
        this.allowResizing = true;
        /**
         * If `allowSorting` set to false, then it disables sorting option of a particular column.
         * By default all columns are sortable.
         *
         * @default true
         */
        this.allowSorting = true;
        /**
         * If `allowFiltering` set to false, then it disables filtering option and filter bar element of a particular column.
         * By default all columns are filterable.
         *
         * @default true
         */
        this.allowFiltering = true;
        /**
         * If `allowReordering` set to false, then it disables reorder of a particular column.
         * By default all columns can be reorder.
         *
         * @default true
         */
        this.allowReordering = true;
        /**
         * If `allowGrouping` set to false, then it disables grouping of a particular column.
         * By default all columns are groupable.
         *
         * @default true
         */
        this.allowGrouping = true;
        /**
         * If `allowSearching` set to false, then it disables Searching of a particular column.
         * By default all columns allow Searching.
         *
         * @default false
         */
        this.allowSearching = false;
        /**
         * If `isPrimaryKey` is set to true, considers this column as the primary key constraint.
         *
         * @default false
         */
        this.isPrimaryKey = false;
        /**
         * If `autoFit` set to true, then the particular column content width will be
         * adjusted based on its content in the initial rendering itself.
         * Setting this property as true is equivalent to calling `autoFitColumns` method in the `dataBound` event.
         *
         * @default false
         */
        this.autoFit = false;
        /**
         * Defines the cell content's overflow mode. The available modes are
         * * `Clip` -  Truncates the cell content when it overflows its area.
         * * `Ellipsis` -  Displays ellipsis when the cell content overflows its area.
         * * `EllipsisWithTooltip` - Displays ellipsis when the cell content overflows its area
         * also it will display tooltip while hover on ellipsis applied cell.
         *
         * @default Ellipsis
         */
        this.clipMode = 'Ellipsis';
        /** Defines the field name of column which is mapped with mapping name of DataSource. */
        this.field = '';
        /** Defines DB entity mapping */
        this.member = '';
        /**
         * It is used to change display value with the given format and does not affect the original data.
         */
        this.format = null;
        /** Defines the header text of column which is used to display in column header. */
        this.headerText = '';
        /** Key for header translation */
        this.headerKey = '';
        /** Key translation */
        this.transKey = '';
        /**
         * Define the alignment of column header which is used to align the text of column header.
         */
        this.headerTextAlign = 'Center';
        /** Template type */
        this.templateType = null;
        /** Template value field if different that field */
        this.templateValueField = null;
        /** Color definition for styles */
        this.color = null;
        /** Field that contains color definition */
        this.colorField = null;
        /**
         * Defines the minimum width of the column in pixels or percentage.
         *
         * @default 0
         */
        this.minWidth = 0;
        /**
         * Defines the maximum width of the column in pixel or percentage, which will restrict resizing beyond this pixel or percentage.
         *
         * @default 0
         */
        this.maxWidth = 0;
        /**
         * If `showInColumnChooser` set to false, then hides the particular column in column chooser.
         * By default all columns are displayed in column Chooser.
         *
         * @default true
         */
        this.showInColumnChooser = true;
        /**
         * Defines the alignment of the column in both header and content cells.
         *
         * @default Left
         */
        this.textAlign = 'Left';
        /**
         * If `visible` is set to false, hides the particular column. By default, all columns are displayed.
         *
         * @default true
         */
        this.visible = true;
        /**
         * Defines the width of the column in pixels or percentage.
         *
         * @default 0
         */
        this.width = 0;
        /**
         * Defines the data type of the column.
         *
         * @default null
         */
        this.type = null;
        /**
         * Column visibility can change based on Media Queries. hideAtMedia accepts only valid Media Queries.
         *
         * @default ''
         */
        this.hideAtMedia = '';
        /**
         * Defines column chooser group name
         * Will be used to group columns under header
         */
        this.columnChooserGroup = '';
        // Other fields
        /**
         * If `showInMassEdit` set to false, then hides the particular column in mass edit dialog.
         * By default all columns are displayed in mass edit dialog.
         *
         * @default true
         */
        this.showInMassEdit = true;
        /**
         * Defines the data type of the column in edit.
         *
         * @default null
         */
        this.editType = null;
        /**
         * Flag that defines if column definition should be used in filter
         *
         * @default false
         */
        this.useInFilter = false;
        /**
         * Flag if column should be used in aggregate dialog
         *
         * @default false
         */
        this.useInAggregate = false;
    }
}
AsolDataColumnDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AsolDataColumnDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: AsolDataColumnDirective, selector: "asol-column", inputs: { allowResizing: "allowResizing", allowSorting: "allowSorting", allowFiltering: "allowFiltering", allowReordering: "allowReordering", allowGrouping: "allowGrouping", allowSearching: "allowSearching", isPrimaryKey: "isPrimaryKey", autoFit: "autoFit", clipMode: "clipMode", field: "field", member: "member", format: "format", headerText: "headerText", headerKey: "headerKey", transKey: "transKey", headerTextAlign: "headerTextAlign", templateType: "templateType", templateValueField: "templateValueField", color: "color", colorField: "colorField", minWidth: "minWidth", maxWidth: "maxWidth", showInColumnChooser: "showInColumnChooser", textAlign: "textAlign", visible: "visible", width: "width", type: "type", hideAtMedia: "hideAtMedia", columnChooserGroup: "columnChooserGroup", category: "category", operators: "operators", step: "step", validation: "validation", value: "value", values: "values", showInMassEdit: "showInMassEdit", editType: "editType", useInFilter: "useInFilter", useInAggregate: "useInAggregate", dropDownService: "dropDownService", dropDownServiceName: "dropDownServiceName", dropDownServiceFilter: "dropDownServiceFilter", id: "id", columnChooserType: "columnChooserType", columnChooserMultiselectService: "columnChooserMultiselectService", columnChooserMultiselectValue: "columnChooserMultiselectValue", valueAccessor: "valueAccessor" }, queries: [{ propertyName: "gridTemplate", first: true, predicate: ["gridTemplate"], descendants: true }, { propertyName: "filterTemplate", first: true, predicate: ["filterTemplate"], descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'asol-column',
                }]
        }], propDecorators: { allowResizing: [{
                type: Input
            }], allowSorting: [{
                type: Input
            }], allowFiltering: [{
                type: Input
            }], allowReordering: [{
                type: Input
            }], allowGrouping: [{
                type: Input
            }], allowSearching: [{
                type: Input
            }], isPrimaryKey: [{
                type: Input
            }], autoFit: [{
                type: Input
            }], clipMode: [{
                type: Input
            }], field: [{
                type: Input
            }], member: [{
                type: Input
            }], format: [{
                type: Input
            }], headerText: [{
                type: Input
            }], headerKey: [{
                type: Input
            }], transKey: [{
                type: Input
            }], headerTextAlign: [{
                type: Input
            }], templateType: [{
                type: Input
            }], templateValueField: [{
                type: Input
            }], color: [{
                type: Input
            }], colorField: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], showInColumnChooser: [{
                type: Input
            }], textAlign: [{
                type: Input
            }], visible: [{
                type: Input
            }], width: [{
                type: Input
            }], type: [{
                type: Input
            }], hideAtMedia: [{
                type: Input
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        gridTemplate: [{
                type: ContentChild,
                args: ['gridTemplate']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        filterTemplate: [{
                type: ContentChild,
                args: ['filterTemplate']
            }], columnChooserGroup: [{
                type: Input
            }], category: [{
                type: Input
            }], operators: [{
                type: Input
            }], step: [{
                type: Input
            }], validation: [{
                type: Input
            }], value: [{
                type: Input
            }], values: [{
                type: Input
            }], showInMassEdit: [{
                type: Input
            }], editType: [{
                type: Input
            }], useInFilter: [{
                type: Input
            }], useInAggregate: [{
                type: Input
            }], dropDownService: [{
                type: Input
            }], dropDownServiceName: [{
                type: Input
            }], dropDownServiceFilter: [{
                type: Input
            }], id: [{
                type: Input
            }], columnChooserType: [{
                type: Input
            }], columnChooserMultiselectService: [{
                type: Input
            }], columnChooserMultiselectValue: [{
                type: Input
            }], valueAccessor: [{
                type: Input
            }] } });

class AsolDataColumnModule {
}
AsolDataColumnModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolDataColumnModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnModule, declarations: [AsolDataColumnDirective], exports: [AsolDataColumnDirective] });
AsolDataColumnModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDataColumnModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolDataColumnDirective],
                    exports: [AsolDataColumnDirective],
                }]
        }] });

class ToolbarService {
    constructor() {
        this.toolbarClicked = new Subject();
        /** Subject when toolbar item is clicked */
        this.toolbarClicked$ = this.toolbarClicked.asObservable();
        this.toolbarChanged = new Subject();
        /** Subject when toolbar item should be changed */
        this.toolbarChanged$ = this.toolbarChanged.asObservable();
    }
    /**
     * Sends clicked toolbar item type
     * @param type Toolbar item type or string @see {@link ToolbarItemType}
     */
    clicked(syncId, type) {
        this.toolbarClicked.next({
            syncId: syncId,
            type: type,
        });
    }
    /**
     * Sends change request of toolbar item
     * @param syncId Synchronization identifier
     * @param change Changed toolbar item @see {@link ToolbarChange}
     */
    changed(syncId, change) {
        this.toolbarChanged.next({
            syncId: syncId,
            change,
        });
    }
}
ToolbarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ToolbarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarService, decorators: [{
            type: Injectable
        }] });

class AsolNumberFieldComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        this.currency = null;
        this.decimals = null;
        this.max = null;
        this.min = null;
        this.step = 1;
        this.showClearButton = false;
        this.showSpinButton = true;
        this.input = null;
        this.locale = this.trans.currentLocale;
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.value;
    }
    setControlValue(val) {
        if (!this.input) {
            return;
        }
        this.input.value = val;
    }
    setControlDisabled(isDisable) {
        // empty
    }
    callOnChange(event) {
        if (event.value !== event.previousValue && event.isInteracted) {
            this.onChange(event.value);
            this.valueChangedDebouncer.next(event.value);
        }
    }
}
AsolNumberFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolNumberFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolNumberFieldComponent, selector: "asol-number-field", inputs: { currency: "currency", decimals: "decimals", format: "format", max: "max", min: "min", step: "step", showClearButton: "showClearButton", showSpinButton: "showSpinButton" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["numberField"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError }\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-numerictextbox\n    #numberField\n    [id]=\"id ?? 'numericelement'\"\n    class=\"asol-numeric\"\n    [enabled]=\"!isDisabled\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [currency]=\"currency\"\n    [decimals]=\"decimals\"\n    [format]=\"format\"\n    [locale]=\"locale\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [step]=\"step\"\n    [placeholder]=\"placeholderText\"\n    [showSpinButton]=\"showSpinButton\"\n    [readonly]=\"isReadonly\"\n    [width]=\"width\"\n    (change)=\"callOnChange($event)\"\n    [showClearButton]=\"showClearButton\">\n  </ejs-numerictextbox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [""], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$3.NumericTextBoxComponent, selector: "ejs-numerictextbox", inputs: ["cssClass", "currency", "currencyCode", "decimals", "enablePersistence", "enableRtl", "enabled", "floatLabelType", "format", "htmlAttributes", "locale", "max", "min", "placeholder", "readonly", "showClearButton", "showSpinButton", "step", "strictMode", "validateDecimalOnType", "value", "width"], outputs: ["blur", "change", "created", "destroyed", "focus", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-number-field', template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError }\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-numerictextbox\n    #numberField\n    [id]=\"id ?? 'numericelement'\"\n    class=\"asol-numeric\"\n    [enabled]=\"!isDisabled\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [currency]=\"currency\"\n    [decimals]=\"decimals\"\n    [format]=\"format\"\n    [locale]=\"locale\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [step]=\"step\"\n    [placeholder]=\"placeholderText\"\n    [showSpinButton]=\"showSpinButton\"\n    [readonly]=\"isReadonly\"\n    [width]=\"width\"\n    (change)=\"callOnChange($event)\"\n    [showClearButton]=\"showClearButton\">\n  </ejs-numerictextbox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { currency: [{
                type: Input
            }], decimals: [{
                type: Input
            }], format: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], step: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], showSpinButton: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['numberField']
            }] } });

class AsolNumberFieldModule {
}
AsolNumberFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolNumberFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldModule, declarations: [AsolNumberFieldComponent], imports: [SharedModule, AsolLabelFieldModule, NumericTextBoxModule], exports: [AsolNumberFieldComponent] });
AsolNumberFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldModule, imports: [[SharedModule, AsolLabelFieldModule, NumericTextBoxModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolNumberFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolNumberFieldComponent],
                    exports: [AsolNumberFieldComponent],
                    imports: [SharedModule, AsolLabelFieldModule, NumericTextBoxModule],
                }]
        }] });

var aggregateTranslation = {
    "sk-SK": {
        headerTitle: "Aggregácia",
        amount: "Sumár",
        average: "Priemer",
        median: "Stredná hodnota",
        min: "Min",
        max: "Max",
        count: "Počet",
        trueCount: "True count",
        falseCount: "False count",
        aggregationSaved: "Aggregácia bola uložená.",
        aggregationError: "Aggregáciu sa nepodarilo uložiť.",
        field: "Stĺpec",
        fieldPlaceholder: "Vyberte stĺpec",
        suffix: "Sufix",
        suffixPlaceholder: "Zadajte suffix",
        color: "Farba",
        options: "Operácia",
        optionsPlaceholder: "Vyberte operáciu"
    },
    "cs-CZ": {
        headerTitle: "Aggregace",
        amount: "Sumář",
        average: "Průměr",
        median: "Střední hodnota",
        min: "Min",
        max: "Max",
        count: "Počet",
        trueCount: "True count",
        falseCount: "False count",
        aggregationSaved: "Aggregace byla uložena",
        aggregationError: "Aggregaci se nepodařilo uložit",
        field: "Sloupec",
        fieldPlaceholder: "Vyberte sloupec",
        suffix: "Sufix",
        suffixPlaceholder: "Zadejte suffix",
        color: "Barva",
        options: "Operace",
        optionsPlaceholder: "Vyberte operaci"
    },
    "en-US": {
        headerTitle: "Aggregation",
        amount: "Sum",
        average: "Average",
        median: "Median",
        min: "Min",
        max: "Max",
        count: "Count",
        trueCount: "True count",
        falseCount: "False count",
        aggregationSaved: "Aggregation saved.",
        aggregationError: "Aggregation failed to save.",
        field: "Field",
        fieldPlaceholder: "Choose field",
        suffix: "Suffix",
        suffixPlaceholder: "Enter suffix",
        color: "Color",
        options: "Operation",
        optionsPlaceholder: "Choose operation"
    }
};

const AGGREGATE_CONSTANT = {
    TRANS: 'asol-aggregate-trans',
    COLOR: '#212529',
};

const MODULE_CONST = {
    FILTER: 'filter',
    AGGREGATE: 'aggregate',
    GRID: 'grid',
};

/**
 * Base class for service to store and get settings
 */
class SettingsServiceBase {
}
SettingsServiceBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SettingsServiceBase, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SettingsServiceBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: SettingsServiceBase, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SettingsServiceBase, decorators: [{
            type: Directive
        }] });

class AggregateService {
    constructor(service, settingsService) {
        this.service = service;
        this.settingsService = settingsService;
        /**
         * Indicates whether aggregates have been changed
         * @param string Sync identifier
         */
        this.refreshSubject = new Subject();
        this.refresh$ = this.refreshSubject.asObservable();
        /** Holds all loaded aggregate definitions */
        this.aggregateMap = new Map();
    }
    /**
     * Gets aggregates for sync identifier
     * @param uri Uri to get aggregates
     * @param syncId Synchronization identifier
     * @param aggregates Aggregate definitions @see {@link AggregateDefinition}
     * @param filters Filter data @see {@link FilterData}
     * @returns Collection of aggregates @see {@link AggregateResult}
     */
    get(uri, syncId, aggregates, filters) {
        return this.service.postData(uri, {
            aggregates,
            filters,
        });
    }
    /**
     * Gets stored aggregate definition based on synchronization identifier
     * @param syncId Synchronization identifier
     * @returns Collection of aggregate definitions @see {@link AggregateDefinition}
     */
    getDefinition(syncId) {
        if (this.aggregateMap.has(syncId)) {
            return of(this.aggregateMap.get(syncId));
        }
        return this.settingsService.get(syncId, MODULE_CONST.AGGREGATE).pipe(map((settings) => {
            return settings ? settings : null;
        }));
    }
    /**
     * Stores aggregate definition based on synchronization identifier
     * @param syncId Synchronization identifier
     * @param aggregates Aggregate definitions @see {@link AggregateDefinition}
     * @returns True if store was successful
     */
    storeDefinition(syncId, aggregates) {
        this.aggregateMap.set(syncId, aggregates);
        if (!aggregates.length) {
            return this.settingsService.delete(syncId, MODULE_CONST.AGGREGATE);
        }
        return this.settingsService.store(syncId, MODULE_CONST.AGGREGATE, JSON.stringify(aggregates));
    }
    /**
     * Refreshes aggregates
     * @param syncId Sync identifier
     */
    refresh(syncId) {
        this.refreshSubject.next(syncId);
    }
}
AggregateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregateService, deps: [{ token: i1.ApiDataService }, { token: SettingsServiceBase }], target: i0.ɵɵFactoryTarget.Injectable });
AggregateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.ApiDataService }, { type: SettingsServiceBase }]; } });

var AggregationType;
(function (AggregationType) {
    AggregationType["Amount"] = "AMOUNT";
    AggregationType["Average"] = "AVERAGE";
    AggregationType["Median"] = "MEDIAN";
    AggregationType["Count"] = "COUNT";
})(AggregationType || (AggregationType = {}));

class AggregationTypesService {
    constructor(trans) {
        this.trans = trans;
        this.trans.initialize(AGGREGATE_CONSTANT.TRANS, aggregateTranslation);
    }
    getAggregationTypes() {
        return [
            {
                text: this.trans.get(AGGREGATE_CONSTANT.TRANS, AggregationType.Amount),
                value: AggregationType.Amount,
            },
            {
                text: this.trans.get(AGGREGATE_CONSTANT.TRANS, AggregationType.Average),
                value: AggregationType.Average,
            },
            // {
            //   text: this.trans.get(AGGREGATE_CONSTANT.TRANS, AggregationType.Median),
            //   value: AggregationType.Median,
            // },
            {
                text: this.trans.get(AGGREGATE_CONSTANT.TRANS, AggregationType.Count),
                value: AggregationType.Count,
            },
        ];
    }
}
AggregationTypesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregationTypesService, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
AggregationTypesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregationTypesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AggregationTypesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; } });

class PageColumnsService {
    constructor() {
        /** Holds all columns for grid */
        this.columnMap = new Map();
        this.columnsChangedObservable = new Subject();
        /** Emits when new columns are available for grid */
        this.columnsChanged$ = this.columnsChangedObservable.asObservable();
    }
    /**
     * Gets columns for grid
     * @param syncId Synchronization identifier
     * @returns Collection of columns in data page @see {@link AsolDataColumnDirective}
     */
    getColumns(syncId) {
        return this.columnMap.get(syncId) || null;
    }
    /**
     * Checks if columns are available for grid
     * @param syncId Synchronization identifier
     * @returns True if columns are available, otherwise false
     */
    hasColumns(syncId) {
        return this.columnMap.has(syncId);
    }
    /**
     * Sets columns for grid
     * @param syncId Synchronization identifier
     * @param columns Collection of columns in data page @see AsolDataColumnDirective
     * @param emit If true, emits columns changed event
     */
    setColumns(syncId, columns, emit = true) {
        this.columnMap.set(syncId, columns);
        if (emit) {
            this.columnsChangedObservable.next(syncId);
        }
    }
    /**
     * Removes columns for grid
     * @param syncId Synchronization identifier
     */
    removeColumns(syncId) {
        this.columnMap.delete(syncId);
    }
}
PageColumnsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PageColumnsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PageColumnsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PageColumnsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: PageColumnsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SpinnerService {
    constructor() {
        this.spinObservable = new BehaviorSubject(false);
        this.spin$ = this.spinObservable.asObservable();
        /**
         * Counter of total active spinners
         *
         * @private
         * @type {number}
         */
        this.totalSpinners = 0;
    }
    /**
     * Invoke spinner to show
     *
     * @public
     */
    show() {
        if (this.totalSpinners === 0) {
            this.spinObservable.next(true);
        }
        this.totalSpinners++;
    }
    /**
     * Invoke spinner to hide
     *
     * @public
     */
    hide() {
        // if method resetAndHide() was called this will prevend to decrement totalSpinners into negative numbers
        if (this.totalSpinners > 0) {
            this.totalSpinners--;
        }
        if (this.totalSpinners === 0) {
            this.spinObservable.next(false);
        }
    }
    /**
     * Reset total number of active spinners to zero and invoke to hide spinner
     *
     * @public
     */
    resetAndHide() {
        this.totalSpinners = 0;
        this.spinObservable.next(false);
    }
    /**
     * Get total number of active spinners
     *
     * @public
     * @returns {number}
     */
    getTotalActiveSpinners() {
        return this.totalSpinners;
    }
}
SpinnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SpinnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SpinnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SpinnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SpinnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Aggregate dialog component
 *
 * Component shows fields, operation and optinal suffix to configure aggregates on grid
 */
class AsolAggregateDialogComponent {
    constructor(trans, aggregateService, notificationService, aggregationTypesService, dataPageService, fb, spinner, cdr) {
        this.trans = trans;
        this.aggregateService = aggregateService;
        this.notificationService = notificationService;
        this.aggregationTypesService = aggregationTypesService;
        this.dataPageService = dataPageService;
        this.fb = fb;
        this.spinner = spinner;
        this.cdr = cdr;
        this.syncId = null;
        /** Defines columns that will be shown dialog @see {@link SelectedItem} */
        this.columns = [];
        /** Aggregation types */
        this.aggregationTypes = this.aggregationTypesService.getAggregationTypes();
        /** Emits new column aggregate definition when dialog closes @see {@link AggregateDefinition} */
        this.hide = new EventEmitter();
        this.AGGREGATE_CONST = AGGREGATE_CONSTANT;
        this.ICONS = ICONS;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Confirm',
            },
        ];
        this.sub = new Subscription();
        this.trans.initialize(AGGREGATE_CONSTANT.TRANS, aggregateTranslation);
        this.form = this.fb.group({
            aggregates: this.fb.array([]),
        });
        this.sub.add(this.dataPageService.columnsChanged$.subscribe((syncId) => {
            if (syncId !== this.syncId) {
                return;
            }
            const columns = this.dataPageService.getColumns(this.syncId);
            this.parseColumns(columns);
        }));
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /** Shortcut for aggregate FormArray */
    get aggregates() {
        return this.form.controls.aggregates;
    }
    /**
     * Parses columns from grid
     * @param columns Columns from grid
     */
    parseColumns(columns) {
        this.columns.splice(0, this.columns.length);
        columns
            .filter((p) => p.useInAggregate)
            .forEach((column) => {
            const text = column.headerKey
                ? column.transKey
                    ? this.trans.get(column.transKey, column.headerKey)
                    : translateProperty(this.columnTranslation, column.headerKey, this.trans.getFullLocale)
                : column.headerText;
            this.columns.push({
                text: text,
                value: column.field,
            });
        });
        this.cdr.markForCheck();
    }
    /**
     * Shows dialog
     */
    showDialog() {
        this.spinner.show();
        if (!this.columns.length) {
            // someone could change the columns in the grid, reload
            const cols = this.dataPageService.getColumns(this.syncId);
            if (!cols) {
                return;
            }
            this.parseColumns(cols);
        }
        this.aggregateService
            .getDefinition(this.syncId)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe((definition) => {
            if (definition) {
                this.parseAggregates(definition);
            }
            this.dialog.show();
        });
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        if (type !== 'Confirm') {
            return;
        }
        this.form.markAllAsTouched();
        if (this.form.invalid || !this.syncId) {
            return;
        }
        this.spinner.show();
        this.aggregateService
            .storeDefinition(this.syncId, this.getAggregatesFromForm())
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe((result) => {
            if (!result) {
                this.notificationService.danger(this.trans.get(AGGREGATE_CONSTANT.TRANS, 'aggregationError'));
                return;
            }
            this.notificationService.success(this.trans.get(AGGREGATE_CONSTANT.TRANS, 'aggregationSaved'));
            this.aggregateService.refresh(this.syncId);
            this.dialog.hide();
        });
    }
    /**
     * Adds new aggregate form to aggregates
     */
    onAdd(aggregationColumn, aggregationType, suffix, color) {
        const aggregate = this.fb.group({
            aggregationColumn: [aggregationColumn !== null && aggregationColumn !== void 0 ? aggregationColumn : null, Validators.required],
            aggregationType: [aggregationType !== null && aggregationType !== void 0 ? aggregationType : null, Validators.required],
            suffix: [suffix !== null && suffix !== void 0 ? suffix : null],
            color: [color !== null && color !== void 0 ? color : null],
        });
        this.aggregates.push(aggregate);
        this.cdr.markForCheck();
    }
    /**
     * Removes aggregate form from aggregates
     * @param index Index of form to remove
     */
    onDelete(index) {
        this.aggregates.removeAt(index, { emitEvent: false });
        this.cdr.markForCheck();
    }
    /**
     * Transforms form data to aggregate
     * @returns Collection of aggreate settings @see {@link AggregateDefinition}
     */
    getAggregatesFromForm() {
        const result = [];
        this.aggregates.controls.forEach((control) => {
            const form = control.controls;
            result.push({
                aggregationColumn: form.aggregationColumn.value,
                aggregationType: form.aggregationType.value.toString(),
                suffix: form.suffix.value,
                color: form.color.value,
            });
        });
        return result;
    }
    /**
     * Parses stored aggregate settings and patches the form
     * @param aggregatesSettings Settings to parse @see {@link GridAggregateRow}
     */
    parseAggregates(aggregateDefinition) {
        if (!aggregateDefinition.length) {
            return;
        }
        this.aggregates.clear();
        aggregateDefinition.forEach((col) => {
            this.onAdd(col.aggregationColumn, col.aggregationType, col.suffix, col.color);
        });
        this.cdr.markForCheck();
    }
}
AsolAggregateDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateDialogComponent, deps: [{ token: i1.TranslationService }, { token: AggregateService }, { token: NotificationService }, { token: AggregationTypesService }, { token: PageColumnsService }, { token: i2.FormBuilder }, { token: SpinnerService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolAggregateDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAggregateDialogComponent, selector: "asol-aggregate-dialog", inputs: { syncId: "syncId", transKey: "transKey", columnTranslation: "columnTranslation" }, outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"800px\"\n  headerText=\"{{trans.get(AGGREGATE_CONST.TRANS,'headerTitle')}}\"\n  buttonPosition=\"start\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <asol-icon-button class=\"me-1\" [iconSvgUrl]=\"ICONS.PLUS\" (click)=\"onAdd()\">\n  </asol-icon-button>\n\n  <form [formGroup]=\"form\" class=\"mt-3\">\n    <ng-container formArrayName=\"aggregates\">\n      <ng-container\n        *ngFor=\"let aggregate of aggregates.controls; let i = index\">\n        <div class=\"d-inline-flex\" [formGroupName]=\"i\">\n          <asol-select-field\n            id=\"aggregate-field-select-field\"\n            formControlName=\"aggregationColumn\"\n            class=\"me-3\"\n            [options]=\"columns\"\n            popupWidth=\"auto\"\n            displayProperty=\"text\"\n            valueProperty=\"value\"\n            labelKey=\"field\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"fieldPlaceholder\">\n          </asol-select-field>\n\n          <asol-select-field\n            id=\"aggregate-operation-select-field\"\n            formControlName=\"aggregationType\"\n            class=\"me-3\"\n            [options]=\"aggregationTypes\"\n            displayProperty=\"text\"\n            valueProperty=\"value\"\n            labelKey=\"options\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"optionsPlaceholder\">\n          </asol-select-field>\n\n          <asol-input-field\n            id=\"aggregate-suffix-input-field\"\n            formControlName=\"suffix\"\n            class=\"me-3\"\n            labelKey=\"suffix\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"suffixPlaceholder\">\n          </asol-input-field>\n\n          <div>\n            {{ trans.get(AGGREGATE_CONST.TRANS, 'color') }}\n            <input ejs-colorpicker type=\"color\" formControlName=\"color\" />\n          </div>\n\n          <div class=\"center-item-v\">\n            <asol-icon-button\n              [iconSvgUrl]=\"ICONS.TRASH\"\n              color=\"dark\"\n              type=\"flat\"\n              (click)=\"onDelete(i)\">\n            </asol-icon-button>\n          </div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </form>\n</asol-dialog>\n", components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-aggregate-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<asol-dialog\n  #dialog\n  width=\"800px\"\n  headerText=\"{{trans.get(AGGREGATE_CONST.TRANS,'headerTitle')}}\"\n  buttonPosition=\"start\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <asol-icon-button class=\"me-1\" [iconSvgUrl]=\"ICONS.PLUS\" (click)=\"onAdd()\">\n  </asol-icon-button>\n\n  <form [formGroup]=\"form\" class=\"mt-3\">\n    <ng-container formArrayName=\"aggregates\">\n      <ng-container\n        *ngFor=\"let aggregate of aggregates.controls; let i = index\">\n        <div class=\"d-inline-flex\" [formGroupName]=\"i\">\n          <asol-select-field\n            id=\"aggregate-field-select-field\"\n            formControlName=\"aggregationColumn\"\n            class=\"me-3\"\n            [options]=\"columns\"\n            popupWidth=\"auto\"\n            displayProperty=\"text\"\n            valueProperty=\"value\"\n            labelKey=\"field\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"fieldPlaceholder\">\n          </asol-select-field>\n\n          <asol-select-field\n            id=\"aggregate-operation-select-field\"\n            formControlName=\"aggregationType\"\n            class=\"me-3\"\n            [options]=\"aggregationTypes\"\n            displayProperty=\"text\"\n            valueProperty=\"value\"\n            labelKey=\"options\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"optionsPlaceholder\">\n          </asol-select-field>\n\n          <asol-input-field\n            id=\"aggregate-suffix-input-field\"\n            formControlName=\"suffix\"\n            class=\"me-3\"\n            labelKey=\"suffix\"\n            [transKey]=\"AGGREGATE_CONST.TRANS\"\n            placeholderKey=\"suffixPlaceholder\">\n          </asol-input-field>\n\n          <div>\n            {{ trans.get(AGGREGATE_CONST.TRANS, 'color') }}\n            <input ejs-colorpicker type=\"color\" formControlName=\"color\" />\n          </div>\n\n          <div class=\"center-item-v\">\n            <asol-icon-button\n              [iconSvgUrl]=\"ICONS.TRASH\"\n              color=\"dark\"\n              type=\"flat\"\n              (click)=\"onDelete(i)\">\n            </asol-icon-button>\n          </div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </form>\n</asol-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: AggregateService }, { type: NotificationService }, { type: AggregationTypesService }, { type: PageColumnsService }, { type: i2.FormBuilder }, { type: SpinnerService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { syncId: [{
                type: Input
            }], transKey: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }], hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

class AsolAggregateItemComponent {
    constructor(trans) {
        this.trans = trans;
        /** Text to display */
        this.text = '';
        this.AGGREGATE_CONSTANT = AGGREGATE_CONSTANT;
        this.isNaN = isNaN;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = this.parseValue(value);
    }
    ngOnChanges(changes) {
        if (changes.column && this.column) {
            this.text = this.getText();
        }
    }
    /**
     * Gets text for the column
     * @returns Text for the column
     */
    getText() {
        if (!this.column) {
            return '';
        }
        if (this.column.transKey && this.column.headerKey) {
            return this.trans.get(this.column.transKey, this.column.headerKey);
        }
        else if (this.column.headerText) {
            return this.column.headerText;
        }
        else if (this.column.headerKey && this.columnTranslation) {
            return translateProperty(this.columnTranslation, this.column.headerKey, this.trans.getFullLocale);
        }
        else {
            return '';
        }
    }
    /**
     * Parses unknown value to string
     * @param value Value to parse
     * @returns String representation of the value
     */
    parseValue(value) {
        if (value === null || value === undefined) {
            return '0';
        }
        if (typeof value === 'number') {
            return formatNumber(+value, this.trans.currentLocale, '1.0-0');
        }
        if (isValueCurrency(value) && this.definition) {
            const currencyValue = value;
            this.definition.suffix = currencyValue.currency;
            return formatNumber(currencyValue.value, this.trans.currentLocale, '1.2-2');
        }
        return value.toString();
    }
}
AsolAggregateItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateItemComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolAggregateItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAggregateItemComponent, selector: "asol-aggregate-item", inputs: { value: "value", definition: "definition", column: "column", columnTranslation: "columnTranslation" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"d-inline-flex me-2 text-nowrap flex-grow-1\">\n  <ng-container *ngIf=\"column && definition\">\n    {{ text }}\n    <div\n      class=\"ms-1\"\n      [ngStyle]=\"{ color: definition.color ?? AGGREGATE_CONSTANT.COLOR }\">\n      {{ value + ' ' + (definition.suffix ?? '') }}\n    </div>\n  </ng-container>\n</div>\n", directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-aggregate-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-inline-flex me-2 text-nowrap flex-grow-1\">\n  <ng-container *ngIf=\"column && definition\">\n    {{ text }}\n    <div\n      class=\"ms-1\"\n      [ngStyle]=\"{ color: definition.color ?? AGGREGATE_CONSTANT.COLOR }\">\n      {{ value + ' ' + (definition.suffix ?? '') }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { value: [{
                type: Input
            }], definition: [{
                type: Input
            }], column: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }] } });

class FilterSyncService {
    constructor(settingService) {
        this.settingService = settingService;
        this.filterChanged = new Subject();
        /** Subject for filter changes */
        this.filterChanged$ = this.filterChanged.asObservable();
        /** Holds loaded filter definitions */
        this.filterMap = new Map();
    }
    /**
     * Send filter change to all subscribers
     * @param id Entity identifier
     * @param type Filter type @see {@link FilterType}
     * @param predicate Filter predicate @see {@link Predicate}
     * @param store Indicates whether filter should be stored
     */
    changeFilter(id, type, predicate, store = true) {
        this.processFilter(id, type, predicate).subscribe((filter) => {
            if (!filter) {
                return;
            }
            if (!store) {
                this.filterMap.set(id, filter);
                this.filterChanged.next({
                    id,
                    filter,
                    type,
                });
                return;
            }
            if (Object.keys(filter).length === 0) {
                this.deleteFilter(id).subscribe();
            }
            else {
                this.saveFilter(id, filter);
            }
        });
    }
    /**
     * Resets all filter data by identifier
     * @param id Synchronization identifier
     * @param type Filter type @see {@link FilterType}
     */
    resetFilter(id, type) {
        return this.deleteFilter(id, type);
    }
    /**
     * Deletes filter from DB
     * @param id Synchronization identifier
     * @param type Filter type @see {@link FilterType}
     */
    deleteFilter(id, type) {
        return this.settingService.delete(id, MODULE_CONST.FILTER).pipe(map((result) => {
            if (!result) {
                return result;
            }
            this.filterMap.delete(id);
            this.filterChanged.next({
                id,
                filter: null,
                type,
            });
            return true;
        }));
    }
    /**
     * Saves filter to DB
     * @param id Synchronization identifier
     * @param filter Filter to store
     */
    saveFilter(id, filter, type) {
        this.settingService
            .store(id, MODULE_CONST.FILTER, JSON.stringify(filter))
            .subscribe((result) => {
            if (!result) {
                return;
            }
            this.filterMap.set(id, filter);
            this.filterChanged.next({
                id,
                filter,
                type,
            });
        });
    }
    /**
     * Processes filter changes
     * @param id Filter identifier
     * @param type Filter type @see {@link FilterType}
     * @param predicate Filter predicate @see {@link Predicate}
     * @returns New filter data
     */
    processFilter(id, type, predicate) {
        return this.get(id).pipe(map((filter) => {
            // if there is no filter and no predicate, do nothing
            if (!filter && !predicate) {
                return null;
            }
            // if there is no filter and there is predicate, create filter
            if (!filter && predicate) {
                filter = this.createFilter(type, predicate);
            }
            else if (filter && !predicate) {
                delete filter[type];
            }
            else {
                filter[type] = predicate;
            }
            return filter;
        }));
    }
    /**
     * Creates new filter to store in DB
     * @param type Filter type @see {@link FilterType}
     * @param predicate Predicate @see {@link Predicate}
     * @returns New filter data
     */
    createFilter(type, predicate) {
        const filter = {};
        filter[type] = predicate;
        return filter;
    }
    /**
     * Gets stored filter by identifier
     * @param id Filter identifier (usualy synchronization identifier)
     * @returns Filter data or null
     */
    get(id) {
        if (!id) {
            return of(null);
        }
        if (this.filterMap.has(id)) {
            return of(this.filterMap.get(id));
        }
        return this.settingService.get(id, MODULE_CONST.FILTER).pipe(catchError(() => {
            // TODO log error
            return of(null);
        }), map((filter) => {
            if (!filter) {
                return null;
            }
            const filterData = filter;
            if (filterData) {
                this.filterMap.set(id, filterData);
            }
            return filterData;
        }));
    }
}
FilterSyncService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FilterSyncService, deps: [{ token: SettingsServiceBase }], target: i0.ɵɵFactoryTarget.Injectable });
FilterSyncService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FilterSyncService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FilterSyncService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: SettingsServiceBase }]; } });

class AsolAggregateItemsComponent {
    constructor(aggregateService, filterService, dataPageService, cdr) {
        this.aggregateService = aggregateService;
        this.filterService = filterService;
        this.dataPageService = dataPageService;
        this.cdr = cdr;
        /** Aggregate URI for the seervice */
        this.uri = null;
        /** Sync identifier for filter */
        this.syncId = null;
        /** Aggregate data from service */
        this.data$ = of([]);
        this.sub = new Subscription();
        /** Collection of columns to get translations and other settings */
        this.columns = [];
    }
    ngOnInit() {
        if (!this.uri) {
            throw new Error('Uri is required');
        }
        this.sub.add(
        // changes in aggregate definition
        this.aggregateService.refresh$.subscribe((data) => {
            if (data !== this.syncId || !this.columns.length) {
                return;
            }
            this.getData();
            this.cdr.markForCheck();
        }));
        this.sub.add(
        // changes in aggregate definition
        this.dataPageService.columnsChanged$.subscribe((syncId) => {
            if (syncId !== this.syncId) {
                return;
            }
            this.getData();
            this.cdr.markForCheck();
        }));
        this.sub.add(
        // changes in filter
        this.filterService.filterChanged$.subscribe((data) => {
            if (data.id !== this.syncId) {
                return;
            }
            this.getData();
            this.cdr.markForCheck();
        }));
        this.getData();
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Gets column item from columns from grid, data pager etc.
     * @param column Column to find
     * @returns Aggregate column @see {@link AggregateColumn}
     */
    getColumnItem(column) {
        return this.columns.find((x) => x.field === column);
    }
    /**
     * Gets aggregate definition for column
     * @param column Column to find
     * @param type Aggregation type @see {@link AggregationType}
     * @returns Column definition @see {@link AggregateDefinition}
     */
    getColumnDefinition(column, type) {
        return this.aggregateDefinitions.find((x) => x.aggregationColumn === column && x.aggregationType === type);
    }
    /**
     * Gets aggregate data from service based on aggregate definitions and filter
     */
    getData() {
        this.data$ = forkJoin([
            this.aggregateService.getDefinition(this.syncId),
            of(this.dataPageService.getColumns(this.syncId)),
            this.filterService.get(this.syncId),
        ]).pipe(switchMap(([aggregates, columns, filters]) => {
            this.columns = columns;
            this.aggregateDefinitions = aggregates;
            return aggregates && columns
                ? this.aggregateService.get(this.uri, this.syncId, aggregates, filters)
                : of([]);
        }));
    }
}
AsolAggregateItemsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateItemsComponent, deps: [{ token: AggregateService }, { token: FilterSyncService }, { token: PageColumnsService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolAggregateItemsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAggregateItemsComponent, selector: "asol-aggregate-items", inputs: { uri: "uri", syncId: "syncId", columnTranslation: "columnTranslation" }, ngImport: i0, template: "<ng-container *ngIf=\"data$ | async as items\">\n  <div class=\"d-flex\">\n    <ng-container *ngFor=\"let item of items\">\n      <asol-aggregate-item\n        [columnTranslation]=\"columnTranslation\"\n        [definition]=\"\n          getColumnDefinition(item.aggregationColumn, item.aggregationType)\n        \"\n        [column]=\"getColumnItem(item.aggregationColumn)\"\n        [value]=\"item.value\">\n      </asol-aggregate-item>\n    </ng-container>\n  </div>\n</ng-container>\n", components: [{ type: AsolAggregateItemComponent, selector: "asol-aggregate-item", inputs: ["value", "definition", "column", "columnTranslation"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i6.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateItemsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-aggregate-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"data$ | async as items\">\n  <div class=\"d-flex\">\n    <ng-container *ngFor=\"let item of items\">\n      <asol-aggregate-item\n        [columnTranslation]=\"columnTranslation\"\n        [definition]=\"\n          getColumnDefinition(item.aggregationColumn, item.aggregationType)\n        \"\n        [column]=\"getColumnItem(item.aggregationColumn)\"\n        [value]=\"item.value\">\n      </asol-aggregate-item>\n    </ng-container>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: AggregateService }, { type: FilterSyncService }, { type: PageColumnsService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { uri: [{
                type: Input
            }], syncId: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }] } });

class AsolAggregateModule {
}
AsolAggregateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolAggregateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateModule, declarations: [AsolAggregateDialogComponent,
        AsolAggregateItemComponent,
        AsolAggregateItemsComponent], imports: [SharedModule,
        AsolDialogModule,
        AsolSelectFieldModule,
        AsolButtonModule,
        AsolInputFieldModule], exports: [AsolAggregateDialogComponent,
        AsolAggregateItemComponent,
        AsolAggregateItemsComponent] });
AsolAggregateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateModule, imports: [[
            SharedModule,
            AsolDialogModule,
            AsolSelectFieldModule,
            AsolButtonModule,
            AsolInputFieldModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAggregateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolAggregateDialogComponent,
                        AsolAggregateItemComponent,
                        AsolAggregateItemsComponent,
                    ],
                    exports: [
                        AsolAggregateDialogComponent,
                        AsolAggregateItemComponent,
                        AsolAggregateItemsComponent,
                    ],
                    imports: [
                        SharedModule,
                        AsolDialogModule,
                        AsolSelectFieldModule,
                        AsolButtonModule,
                        AsolInputFieldModule,
                    ],
                }]
        }] });

class AsolCheckboxComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        this.indeterminate = false;
        this.labelPosition = 'After';
        this.input = null;
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.checked;
    }
    setControlValue(val) {
        if (!this.input || val === null) {
            return;
        }
        if (this.input) {
            this.input.checked = val;
        }
    }
    setControlDisabled(isDisable) {
        // throw new Error('Method not implemented.');
    }
    callOnChange(event) {
        this.onChange(event.checked);
        this.valueChangedDebouncer.next(event.checked);
    }
}
AsolCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolCheckboxComponent, selector: "asol-checkbox", inputs: { indeterminate: "indeterminate", labelPosition: "labelPosition" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["checkboxField"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError, readonly: isReadonly }\">\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-checkbox\n    #checkboxField\n    [id]=\"id ?? 'checkboxelement'\"\n    cssClass=\"d-block w-100\"\n    [disabled]=\"isDisabled\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [indeterminate]=\"indeterminate\"\n    [labelPosition]=\"labelPosition\"\n    (change)=\"callOnChange($event)\"\n    [label]=\"labelText\">\n  </ejs-checkbox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [".readonly{pointer-events:none}\n"], components: [{ type: i5.CheckBoxComponent, selector: "ejs-checkbox", inputs: ["checked", "cssClass", "disabled", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "htmlAttributes", "indeterminate", "label", "labelPosition", "locale", "name", "value"], outputs: ["focus", "blur", "change", "created", "checkedChange", "indeterminateChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-checkbox', template: "<div [class]=\"cssClass\" [ngClass]=\"{ 'mb-2': showError, readonly: isReadonly }\">\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-checkbox\n    #checkboxField\n    [id]=\"id ?? 'checkboxelement'\"\n    cssClass=\"d-block w-100\"\n    [disabled]=\"isDisabled\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [indeterminate]=\"indeterminate\"\n    [labelPosition]=\"labelPosition\"\n    (change)=\"callOnChange($event)\"\n    [label]=\"labelText\">\n  </ejs-checkbox>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [".readonly{pointer-events:none}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { indeterminate: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['checkboxField', { static: false }]
            }] } });

class AsolCheckboxModule {
}
AsolCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxModule, declarations: [AsolCheckboxComponent], imports: [SharedModule, CheckBoxModule], exports: [AsolCheckboxComponent] });
AsolCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxModule, imports: [[SharedModule, CheckBoxModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolCheckboxComponent],
                    exports: [AsolCheckboxComponent],
                    imports: [SharedModule, CheckBoxModule],
                }]
        }] });

/**
 * Operator enum to properly define filter operation in Predicate @see {@link Predicate}
 */
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["EQUAL"] = "equal";
    FilterOperator["NOT_EQUAL"] = "notequal";
    FilterOperator["GREATER_THAN"] = "greaterthan";
    FilterOperator["GREATER_THAN_OR_EQUAL"] = "greaterthanorequal";
    FilterOperator["LESS_THAN"] = "lessthan";
    FilterOperator["LESS_THAN_OR_EQUAL"] = "lessthanorequal";
    FilterOperator["IS_NULL"] = "isnull";
    FilterOperator["NOT_NULL"] = "notnull";
    FilterOperator["CONTAINS"] = "contains";
    FilterOperator["STARTS_WITH"] = "startswith";
    FilterOperator["ENDS_WITH"] = "endswith";
    FilterOperator["IN"] = "in";
    FilterOperator["NOT_IN"] = "notin";
})(FilterOperator || (FilterOperator = {}));

class AsolMultiselectComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        /**
         * Allows filtering on multiselect field
         * @default true
         */
        this.allowFiltering = true;
        /**
         * Multiselect component fires the change event while focus out the component. If you want to fires the change event on every value selection and remove, then disable the changeOnBlur property.
         * @default true
         */
        this.changeOnBlur = true;
        /**
         * Select options array
         */
        this.options = [];
        /**
         * Value property of the options
         */
        this.valueProperty = 'value';
        /**
         * Display property of the options
         */
        this.displayProperty = 'text';
        /** Filter operator if filtering is allowed */
        this.filterOperator = FilterOperator.CONTAINS;
        /**
         * Specifies whether to show or hide the clear button
         * @default true
         */
        this.showClearButton = true;
        /**
         * Allows to enter custom value
         * @default false
         */
        this.allowCustomValue = false;
        /**
         * Configures visibility mode for component interaction.
         * @default Box
         */
        this.mode = 'Box';
        this.locale = '';
        this.field = {
            text: this.displayProperty,
            value: this.valueProperty,
        };
        this.locale = this.trans.currentLocale;
    }
    ngOnInit() {
        super.ngOnInit();
        this.loadOptions();
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d;
        if (changes.valueProperty || changes.displayProperty) {
            this.field = {
                text: this.displayProperty,
                value: this.valueProperty,
            };
        }
        if (changes.filterParams && !changes.filterParams.firstChange) {
            this.loadOptions();
        }
        if (!((_a = changes.options) === null || _a === void 0 ? void 0 : _a.previousValue) &&
            ((_b = changes.options) === null || _b === void 0 ? void 0 : _b.currentValue) &&
            ((_c = this.value) === null || _c === void 0 ? void 0 : _c.length) &&
            !((_d = changes === null || changes === void 0 ? void 0 : changes.filterParams) === null || _d === void 0 ? void 0 : _d.firstChange)) {
            this.setControlValue(this.value);
        }
    }
    ngAfterViewInit() {
        var _a, _b;
        super.ngAfterViewInit();
        // if options are loaded via async pipe, and not using data provider, set the value
        if (!this.dataProvider && ((_a = this.value) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.options) === null || _b === void 0 ? void 0 : _b.length)) {
            this.setControlValue(this.value);
        }
    }
    /**
     * Loads data using data provider
     */
    loadOptions() {
        if (!this.dataProvider) {
            return;
        }
        if (!this.displayProperty) {
            this.displayProperty = 'text';
        }
        if (!this.valueProperty) {
            this.valueProperty = 'value';
        }
        this.dataProvider.getMultiData(this.filterParams).subscribe((response) => {
            if (!response || !response.length) {
                return;
            }
            this.options = response;
            this.setControlValue(this.value);
        });
    }
    /**
     * Event handler after selecting values
     * @param event Change event args
     */
    callOnChange(event) {
        if (!event.isInteracted) {
            return;
        }
        this.onChange(event.value);
        this.valueChangedDebouncer.next(event.value);
    }
    /**
     * @inheritdoc
     */
    getControlValue() {
        if (!this.selectInput) {
            return null;
        }
        return this.selectInput.value;
    }
    /**
     * @inheritdoc
     */
    setControlValue(val) {
        var _a;
        if (!this.selectInput) {
            return;
        }
        // because of race condition, set values after options are filled
        if (val && (val === null || val === void 0 ? void 0 : val.length) && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.length)) {
            this.selectInput.value = val;
        }
        else {
            this.selectInput.value = [];
        }
    }
    /**
     * @inheritdoc
     */
    setControlDisabled(isDisable) {
        // empty
    }
    /**
     * Defines filtering options if filtering is allowed
     * @param e filter event arguments @see FilteringEventArgs
     */
    onFiltering(e) {
        let query = new Query();
        //frame the query based on search string with filter type.
        query =
            e.text != ''
                ? query.where(this.displayProperty, this.filterOperator, e.text, true)
                : query;
        //pass the filter data source, filter query to updateData method.
        e.updateData(this.options, query);
    }
    /**
     * Rebinds options
     * @param options Options to rebind
     */
    rebind(options) {
        if (options) {
            this.options = options;
        }
        else {
            this.loadOptions();
        }
        this.selectInput.refresh();
    }
}
AsolMultiselectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolMultiselectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolMultiselectComponent, selector: "asol-multiselect", inputs: { allowFiltering: "allowFiltering", changeOnBlur: "changeOnBlur", options: "options", valueProperty: "valueProperty", displayProperty: "displayProperty", dataProvider: "dataProvider", filterParams: "filterParams", filterOperator: "filterOperator", showClearButton: "showClearButton", allowCustomValue: "allowCustomValue", mode: "mode" }, viewQueries: [{ propertyName: "selectInput", first: true, predicate: ["multiselect"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-multiselect\n    [id]=\"id ?? 'multiselectelement'\"\n    #multiselect\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    class=\"asol-multiselect\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [changeOnBlur]=\"changeOnBlur\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [mode]=\"mode\"\n    [showClearButton]=\"showClearButton\"\n    [cssClass]=\"cssClass\"\n    [allowCustomValue]=\"allowCustomValue\"\n    (change)=\"callOnChange($event)\"\n    [allowFiltering]=\"allowFiltering\"\n    (filtering)=\"onFiltering($event)\">\n  </ejs-multiselect>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$1.MultiSelectComponent, selector: "ejs-multiselect", inputs: ["actionFailureTemplate", "addTagOnBlur", "allowCustomValue", "allowFiltering", "changeOnBlur", "closePopupOnSelect", "cssClass", "dataSource", "delimiterChar", "enableGroupCheckBox", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "enableSelectionOrder", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "groupTemplate", "headerTemplate", "hideSelectedItem", "htmlAttributes", "ignoreAccent", "ignoreCase", "itemTemplate", "locale", "maximumSelectionLength", "mode", "noRecordsTemplate", "openOnClick", "placeholder", "popupHeight", "popupWidth", "query", "readonly", "selectAllText", "showClearButton", "showDropDownIcon", "showSelectAll", "sortOrder", "text", "unSelectAllText", "value", "valueTemplate", "width", "zIndex"], outputs: ["actionBegin", "actionComplete", "actionFailure", "beforeOpen", "beforeSelectAll", "blur", "change", "chipSelection", "close", "created", "customValueSelection", "dataBound", "destroyed", "filtering", "focus", "open", "removed", "removing", "select", "selectedAll", "tagging", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-multiselect', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <ejs-multiselect\n    [id]=\"id ?? 'multiselectelement'\"\n    #multiselect\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [dataSource]=\"options\"\n    class=\"asol-multiselect\"\n    [fields]=\"field\"\n    [placeholder]=\"placeholderText\"\n    [changeOnBlur]=\"changeOnBlur\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [width]=\"width\"\n    [locale]=\"locale\"\n    [mode]=\"mode\"\n    [showClearButton]=\"showClearButton\"\n    [cssClass]=\"cssClass\"\n    [allowCustomValue]=\"allowCustomValue\"\n    (change)=\"callOnChange($event)\"\n    [allowFiltering]=\"allowFiltering\"\n    (filtering)=\"onFiltering($event)\">\n  </ejs-multiselect>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { allowFiltering: [{
                type: Input
            }], changeOnBlur: [{
                type: Input
            }], options: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], filterOperator: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], allowCustomValue: [{
                type: Input
            }], mode: [{
                type: Input
            }], selectInput: [{
                type: ViewChild,
                args: ['multiselect']
            }] } });

class AsolMultiselectModule {
}
AsolMultiselectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolMultiselectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectModule, declarations: [AsolMultiselectComponent], imports: [SharedModule, MultiSelectAllModule, AsolLabelFieldModule], exports: [AsolMultiselectComponent] });
AsolMultiselectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectModule, imports: [[SharedModule, MultiSelectAllModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMultiselectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolMultiselectComponent],
                    exports: [AsolMultiselectComponent],
                    imports: [SharedModule, MultiSelectAllModule, AsolLabelFieldModule],
                }]
        }] });

class AsolColumnChooserCheckboxComponent {
    constructor() {
        /**
         * Name of the group of columns in column chooser
         *
         * @type {string}
         */
        this.groupName = '';
        /**
         * Items to be displayed as checkboxes
         *
         * @type {ColumnItem[]}
         */
        this.items = [];
    }
}
AsolColumnChooserCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolColumnChooserCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolColumnChooserCheckboxComponent, selector: "asol-column-chooser-checkbox", inputs: { groupName: "groupName", items: "items" }, ngImport: i0, template: "<h4>{{ groupName }}</h4>\n<div class=\"d-flex flex-column me-1 mb-3\" *ngFor=\"let item of items\">\n  <asol-checkbox\n    [id]=\"item.field\"\n    [labelText]=\"item.headerText\"\n    [(ngModel)]=\"item.visible\">\n  </asol-checkbox>\n</div>\n", components: [{ type: AsolCheckboxComponent, selector: "asol-checkbox", inputs: ["indeterminate", "labelPosition"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-column-chooser-checkbox', template: "<h4>{{ groupName }}</h4>\n<div class=\"d-flex flex-column me-1 mb-3\" *ngFor=\"let item of items\">\n  <asol-checkbox\n    [id]=\"item.field\"\n    [labelText]=\"item.headerText\"\n    [(ngModel)]=\"item.visible\">\n  </asol-checkbox>\n</div>\n" }]
        }], propDecorators: { groupName: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

/**
 * Transforms grid columns to column choose
 * @param data Data to transform @see {@link  AsolDataColumnDirective}
 * @returns Collection of column choose items @see {@link ColumnChoose}
 */
function transformToColumnChoose(data) {
    if (!data) {
        return [];
    }
    const columns = [];
    const groupNames = [
        ...new Set(data
            .filter((p) => p.showInColumnChooser && !!p.headerText)
            .map((p) => p.columnChooserGroup)),
    ];
    groupNames.forEach((name) => {
        const columnItems = data
            .filter((p) => p.showInColumnChooser && p.headerText && p.columnChooserGroup === name)
            .map((item) => {
            return {
                field: item.field,
                headerText: item.headerText,
                visible: item.visible,
                columnChooserType: item.columnChooserType,
                columnChooserMultiselectService: item.columnChooserMultiselectService,
                columnChooserMultiselectValue: item.columnChooserMultiselectValue,
            };
        });
        columns.push({
            groupName: name,
            items: columnItems,
        });
    });
    return columns;
}

var translation$e = {
    "sk-SK": {
        headerTitle: "Zoznam stĺpcov"
    },
    "cs-CZ": {
        headerTitle: "Seznam sloupců"
    },
    "en-US": {
        headerTitle: "Column chooser"
    }
};

const CHOOSER_CONST = {
    TRANS: 'asol-column-chooser-trans',
};

class AsolColumnChooserMultiselectComponent {
    constructor() {
        /**
         * Name of the group of columns in column chooser
         *
         * @type {string}
         */
        this.groupName = '';
        /**
         * Items to be displayed in multiselect
         *
         * @type {ColumnItem[]}
         */
        this.items = [];
        /**
         * Preselected values in multiselect
         *
         * @public
         * @type {number[]}
         */
        this.multiselectData = [];
        /**
         * Service for options in multiselect
         *
         * @public
         * @type {(Observable<SelectedItem[]> | null)}
         */
        this.multiselectService = null;
    }
    ngOnChanges(changes) {
        var _a;
        if ((_a = changes.items) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.multiselectData = changes.items.currentValue
                .filter((item) => item.visible && !isNaN(Number(item.columnChooserMultiselectValue)))
                .map((item) => +item.columnChooserMultiselectValue);
            this.multiselectService = changes.items.currentValue.find((item) => item.columnChooserType === 'multiselect').columnChooserMultiselectService;
        }
    }
    /**
     * Method called when multiselect value changes
     *
     * @param {number[]} inputs
     */
    onChange(inputs) {
        this.items.forEach((item) => {
            item.visible = inputs.includes(+item.columnChooserMultiselectValue);
        });
    }
}
AsolColumnChooserMultiselectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserMultiselectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolColumnChooserMultiselectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolColumnChooserMultiselectComponent, selector: "asol-column-chooser-multiselect", inputs: { groupName: "groupName", items: "items" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"col-12\">\n  <h4>{{ groupName }}</h4>\n  <div class=\"d-flex flex-column me-1 mb-3\">\n    <ng-container>\n      <asol-multiselect\n        [ngModel]=\"multiselectData\"\n        (ngModelChange)=\"onChange($event)\"\n        [options]=\"multiselectService | async\"\n        mode=\"CheckBox\">\n      </asol-multiselect>\n    </ng-container>\n  </div>\n</div>\n", components: [{ type: AsolMultiselectComponent, selector: "asol-multiselect", inputs: ["allowFiltering", "changeOnBlur", "options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "filterOperator", "showClearButton", "allowCustomValue", "mode"] }], directives: [{ type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserMultiselectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-column-chooser-multiselect', template: "<div class=\"col-12\">\n  <h4>{{ groupName }}</h4>\n  <div class=\"d-flex flex-column me-1 mb-3\">\n    <ng-container>\n      <asol-multiselect\n        [ngModel]=\"multiselectData\"\n        (ngModelChange)=\"onChange($event)\"\n        [options]=\"multiselectService | async\"\n        mode=\"CheckBox\">\n      </asol-multiselect>\n    </ng-container>\n  </div>\n</div>\n" }]
        }], propDecorators: { groupName: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

/**
 * Filtering pipe used to filter column chooser items based on type
 */
class AsolColumnChooserFilterPipe {
    transform(items, type) {
        var _a;
        if (!items || !items.length) {
            return items;
        }
        return ((_a = items.filter((columnChoose) => {
            return columnChoose.items.find((item) => item.columnChooserType === type)
                ? true
                : false;
        })) !== null && _a !== void 0 ? _a : []);
    }
}
AsolColumnChooserFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AsolColumnChooserFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserFilterPipe, name: "columnChooserFilter", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'columnChooserFilter',
                    pure: false,
                }]
        }] });

/**
 * Column chooser dialog component
 */
class AsolColumnChooserDialogComponent {
    constructor(trans, dataPageService) {
        this.trans = trans;
        this.dataPageService = dataPageService;
        /** Defines columns that will be shown in column chooser dialog @see {@link ColumnChoose} */
        this.columns = [];
        /** Emits new column definition when dialog closes @see {@link ColumnChoose} */
        this.hide = new EventEmitter();
        this.CHOOSER_CONST = CHOOSER_CONST;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Save',
            },
            {
                textType: 'Cancel',
            },
        ];
        this.trans.initialize(CHOOSER_CONST.TRANS, translation$e);
    }
    /**
     * Shows dialog with columns, it parses the column
     * @param syncId Sync identifier
     */
    showDialog(syncId) {
        this.columns.splice(0, this.columns.length);
        this.columns = this.getColumns(syncId);
        this.dialog.show();
    }
    /**
     * Get columns from data page service
     * @param syncId Sync identifier
     * @returns Transformed columns @see {@link ColumnChoose}
     */
    getColumns(syncId) {
        const data = this.dataPageService.getColumns(syncId);
        return transformToColumnChoose(data);
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        if (type === 'Save') {
            this.hide.emit(this.columns);
        }
        this.dialog.hide();
    }
}
AsolColumnChooserDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogComponent, deps: [{ token: i1.TranslationService }, { token: PageColumnsService }], target: i0.ɵɵFactoryTarget.Component });
AsolColumnChooserDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolColumnChooserDialogComponent, selector: "asol-column-chooser-dialog", outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"700px\"\n  headerText=\"{{trans.get(CHOOSER_CONST.TRANS,'headerTitle')}}\"\n  buttonPosition=\"center\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <div class=\"row mb-2\">\n    <ng-container *ngFor=\"let group of columns | columnChooserFilter\">\n      <div class=\"col-4\">\n        <asol-column-chooser-checkbox\n          #checkBoxChooser\n          [groupName]=\"group.groupName\"\n          [items]=\"group.items\">\n        </asol-column-chooser-checkbox>\n      </div>\n    </ng-container>\n  </div>\n  <div class=\"row mb-2\">\n    <ng-container\n      *ngFor=\"let group of columns | columnChooserFilter : 'multiselect'\">\n      <asol-column-chooser-multiselect\n        #multiselectChooser\n        [groupName]=\"group.groupName\"\n        [items]=\"group.items\">\n      </asol-column-chooser-multiselect>\n    </ng-container>\n  </div>\n</asol-dialog>\n", components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolColumnChooserCheckboxComponent, selector: "asol-column-chooser-checkbox", inputs: ["groupName", "items"] }, { type: AsolColumnChooserMultiselectComponent, selector: "asol-column-chooser-multiselect", inputs: ["groupName", "items"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "columnChooserFilter": AsolColumnChooserFilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-column-chooser-dialog', template: "<asol-dialog\n  #dialog\n  width=\"700px\"\n  headerText=\"{{trans.get(CHOOSER_CONST.TRANS,'headerTitle')}}\"\n  buttonPosition=\"center\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <div class=\"row mb-2\">\n    <ng-container *ngFor=\"let group of columns | columnChooserFilter\">\n      <div class=\"col-4\">\n        <asol-column-chooser-checkbox\n          #checkBoxChooser\n          [groupName]=\"group.groupName\"\n          [items]=\"group.items\">\n        </asol-column-chooser-checkbox>\n      </div>\n    </ng-container>\n  </div>\n  <div class=\"row mb-2\">\n    <ng-container\n      *ngFor=\"let group of columns | columnChooserFilter : 'multiselect'\">\n      <asol-column-chooser-multiselect\n        #multiselectChooser\n        [groupName]=\"group.groupName\"\n        [items]=\"group.items\">\n      </asol-column-chooser-multiselect>\n    </ng-container>\n  </div>\n</asol-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: PageColumnsService }]; }, propDecorators: { hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

class AsolColumnChooserDialogModule {
}
AsolColumnChooserDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolColumnChooserDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogModule, declarations: [AsolColumnChooserDialogComponent,
        AsolColumnChooserFilterPipe,
        AsolColumnChooserCheckboxComponent,
        AsolColumnChooserMultiselectComponent], imports: [SharedModule,
        AsolDialogModule,
        AsolCheckboxModule,
        AsolMultiselectModule], exports: [AsolColumnChooserDialogComponent] });
AsolColumnChooserDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogModule, imports: [[
            SharedModule,
            AsolDialogModule,
            AsolCheckboxModule,
            AsolMultiselectModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolColumnChooserDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolColumnChooserDialogComponent,
                        AsolColumnChooserFilterPipe,
                        AsolColumnChooserCheckboxComponent,
                        AsolColumnChooserMultiselectComponent,
                    ],
                    exports: [AsolColumnChooserDialogComponent],
                    imports: [
                        SharedModule,
                        AsolDialogModule,
                        AsolCheckboxModule,
                        AsolMultiselectModule,
                    ],
                }]
        }] });

var translations = {
    "sk-SK": {
        selected: "Označené",
        count: "Počet",
        onPage: "Na stránke",
        of: "z",
        page: "Stránka"
    },
    "cs-CZ": {
        selected: "Označené",
        count: "Počet",
        onPage: "Na stránce",
        of: "z",
        page: "Stránka"
    },
    "en-US": {
        selected: "Selected",
        count: "Count",
        onPage: "On page",
        of: "of",
        page: "Page"
    }
};

const PAGER_CONSTANT = {
    DEFAULT_PAGE_SIZE: 15,
    DEFAULT_PAGE_SIZES: [5, 15, 50, 100],
    DEFAULT_PAGE_COUNT: 1,
    DEFAULT_PAGE_CURRENT: 1,
    TRANS: 'asol-pager-trans',
};

class AsolPagerComponent {
    constructor(trans, mediaService) {
        this.trans = trans;
        this.mediaService = mediaService;
        /** Synchronization identifier */
        this.syncId = null;
        /** Aggregation service URI to load aggregate data into pager */
        this.aggregateUri = null;
        /**
         * Flag if pager is fixed to bottom
         * @default true
         */
        this.fixBottom = true;
        /** Page settings setup */
        this.pageSettings = {
            pageSize: PAGER_CONSTANT.DEFAULT_PAGE_SIZE,
            pageSizes: PAGER_CONSTANT.DEFAULT_PAGE_SIZES,
            currentPage: PAGER_CONSTANT.DEFAULT_PAGE_CURRENT,
            pageCount: PAGER_CONSTANT.DEFAULT_PAGE_COUNT,
            totalRecordsCount: 0,
        };
        /**
         * Flag if aggregates and aggregate dialog are allowed
         * @default false
         */
        this.allowAggregates = false;
        /**
         * Emits when page is changed
         */
        this.pageChanged = new EventEmitter();
        /**
         * Emits when user changes settings (page size, page count, etc.)
         */
        this.pageSettignsChanged = new EventEmitter();
        /**
         * Flag if window resolution is mobile
         * @default false
         */
        this.isMobileResolution = false;
        this.sub = new Subscription();
        this.PAGER_CONSTANT = PAGER_CONSTANT;
        this.ICONS = ICONS;
        this.aggregateDialog = null;
        this.trans.initialize(PAGER_CONSTANT.TRANS, translations);
        this.sub.add(this.mediaService.mobileViewportChanged$.subscribe((state) => {
            this.isMobileResolution = state.matches;
        }));
        this.reset();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Event when page is changed
     * @param increment Flag if page is incremented
     */
    onPageChange(increment) {
        if ((!increment && this.pageSettings.currentPage - 1 === 0) ||
            (increment &&
                this.pageSettings.currentPage + 1 > this.pageSettings.pageCount)) {
            return;
        }
        this.pageSettings.currentPage = increment
            ? this.pageSettings.currentPage + 1
            : this.pageSettings.currentPage - 1;
        this.pageChanged.emit(this.pageSettings);
    }
    /**
     * Resets the current page to 1
     */
    resetCurrentPage() {
        this.pageSettings.currentPage = 1;
    }
    /**
     * Resets page settings to default
     */
    reset() {
        this.pageSettings = {
            pageSize: PAGER_CONSTANT.DEFAULT_PAGE_SIZE,
            pageSizes: PAGER_CONSTANT.DEFAULT_PAGE_SIZES,
            currentPage: PAGER_CONSTANT.DEFAULT_PAGE_CURRENT,
            pageCount: PAGER_CONSTANT.DEFAULT_PAGE_COUNT,
            totalRecordsCount: 0,
        };
    }
    /**
     * Gets data for skip from page settings
     * @returns Number of data to skip
     */
    getSkipData() {
        return this.pageSettings.currentPage === 0
            ? 0
            : (this.pageSettings.currentPage - 1) * this.pageSettings.pageSize;
    }
    /**
     * Parses settings from grid
     * @param settings Settings to parse @see {@link PageSettingsModel}
     */
    parseSettingsFromGrid(settings) {
        const pageSizes = !settings.pageSizes || settings.pageSizes instanceof Boolean
            ? PAGER_CONSTANT.DEFAULT_PAGE_SIZES
            : settings.pageSizes;
        this.pageSettings = {
            pageCount: settings.pageCount,
            pageSize: settings.pageSize,
            pageSizes: pageSizes,
            currentPage: settings.currentPage,
        };
    }
    /**
     * Sets pager total count to calculate other settings
     * @param totalRecords Total records count
     */
    setPager(totalRecords) {
        if (totalRecords === undefined || totalRecords === null) {
            return;
        }
        this.pageSettings.totalRecordsCount = totalRecords;
        this.pageSettings.pageCount = Math.ceil(totalRecords / this.pageSettings.pageSize);
        if (this.pageSettings.pageCount === 0) {
            this.pageSettings.pageCount = 1;
        }
        if (this.pageSettings.currentPage > this.pageSettings.pageCount) {
            this.resetCurrentPage();
        }
    }
    /**
     * Emits event when page settings are changed by user (page size, page count, etc.)
     */
    onPageSettingsChanged() {
        let pageCount = Math.ceil(this.pageSettings.totalRecordsCount / this.pageSettings.pageSize);
        if (pageCount === 0) {
            pageCount = 1;
        }
        if (this.pageSettings.currentPage > pageCount) {
            this.resetCurrentPage();
        }
        this.pageSettignsChanged.emit();
    }
    /**
     * Event when user clicks on aggregate button in pager
     */
    onShowAggregates() {
        var _a;
        (_a = this.aggregateDialog) === null || _a === void 0 ? void 0 : _a.showDialog();
    }
}
AsolPagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerComponent, deps: [{ token: i1.TranslationService }, { token: i1.AsolMediaQueryService }], target: i0.ɵɵFactoryTarget.Component });
AsolPagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolPagerComponent, selector: "asol-pager", inputs: { syncId: "syncId", aggregateUri: "aggregateUri", fixBottom: "fixBottom", pageSettings: "pageSettings", allowAggregates: "allowAggregates", pagerData: "pagerData", columnTranslation: "columnTranslation" }, outputs: { pageChanged: "pageChanged", pageSettignsChanged: "pageSettignsChanged" }, queries: [{ propertyName: "pagerTemplate", first: true, predicate: ["pagerTemplate"], descendants: true }], viewQueries: [{ propertyName: "aggregateDialog", first: true, predicate: ["aggregateDialog"], descendants: true }], ngImport: i0, template: "<div\n  class=\"asol-pager d-flex align-items-center mw-100 overflow-hidden\"\n  [ngClass]=\"{\n    'justify-content-center': isMobileResolution,\n    'justify-content-between': !isMobileResolution,\n    'fixed-bottom': fixBottom\n  }\">\n  <div class=\"d-inline-flex align-items-center text-nowrap\">\n    <asol-icon-button\n      *ngIf=\"allowAggregates\"\n      color=\"dark\"\n      type=\"flat\"\n      [iconSvgUrl]=\"ICONS.COG_WHEEL\"\n      (click)=\"onShowAggregates()\">\n    </asol-icon-button>\n    <div class=\"ms-2 text-nowrap\" gIf=\"!isMobileResolution\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'count') }}\n      <strong>{{ pageSettings.totalRecordsCount }}</strong>\n    </div>\n  </div>\n  <asol-aggregate-items\n    *ngIf=\"aggregateUri && syncId && !isMobileResolution\"\n    class=\"ms-4 overflow-hidden\"\n    [columnTranslation]=\"columnTranslation\"\n    [syncId]=\"syncId\"\n    [uri]=\"aggregateUri\">\n  </asol-aggregate-items>\n  <ng-container *ngIf=\"!isMobileResolution\">\n    <ng-container\n      *ngTemplateOutlet=\"pagerTemplate; context: { $implicit: pagerData }\">\n    </ng-container>\n  </ng-container>\n  <div class=\"me-2 d-inline-flex align-items-center text-nowrap\">\n    <div class=\"mx-1\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'onPage') }}\n    </div>\n    <asol-select-field\n      [options]=\"pageSettings.pageSizes\"\n      [width]=\"80\"\n      cssClass=\"asol-select-grid\"\n      [showError]=\"false\"\n      [allowCustom]=\"false\"\n      *ngIf=\"!isMobileResolution\"\n      [(ngModel)]=\"pageSettings.pageSize\"\n      (ngModelChange)=\"onPageSettingsChanged()\">\n    </asol-select-field>\n    <div class=\"ms-5 me-2\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'page') }}\n    </div>\n    <asol-number-field\n      format=\"##\"\n      [step]=\"1\"\n      [min]=\"1\"\n      [max]=\"pageSettings.pageCount\"\n      [showError]=\"false\"\n      [showSpinButton]=\"false\"\n      [width]=\"40\"\n      cssClass=\"asol-number-grid\"\n      [(ngModel)]=\"pageSettings.currentPage\"\n      (valueChanged)=\"onPageSettingsChanged()\">\n    </asol-number-field>\n    <div class=\"mx-2\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'of') }}\n    </div>\n    <div class=\"me-4\">\n      {{ pageSettings.pageCount }}\n    </div>\n    <asol-icon-button\n      class=\"me-1 pager-button\"\n      type=\"flat\"\n      color=\"dark\"\n      [disabled]=\"pageSettings.currentPage <= 1\"\n      (click)=\"onPageChange(false)\"\n      [iconSvgUrl]=\"ICONS.CHEVRON_LEFT\">\n    </asol-icon-button>\n    <asol-icon-button\n      class=\"me-1 pager-button\"\n      type=\"flat\"\n      color=\"dark\"\n      [disabled]=\"!(pageSettings.currentPage < pageSettings.pageCount)\"\n      (click)=\"onPageChange(true)\"\n      [iconSvgUrl]=\"ICONS.CHEVRON_RIGHT\">\n    </asol-icon-button>\n  </div>\n</div>\n\n<ng-container *ngIf=\"allowAggregates\">\n  <asol-aggregate-dialog\n    [syncId]=\"syncId\"\n    [columnTranslation]=\"columnTranslation\"\n    #aggregateDialog>\n  </asol-aggregate-dialog>\n</ng-container>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.asol-pager{background-color:#fff;border-radius:0 0 .25rem .25rem;height:40px;box-shadow:0 1px 1px #00000024,0 2px 1px #0000001f,0 1px 3px #0003;display:flex;align-items:center;font-size:.75rem}\n"], components: [{ type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolAggregateItemsComponent, selector: "asol-aggregate-items", inputs: ["uri", "syncId", "columnTranslation"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolNumberFieldComponent, selector: "asol-number-field", inputs: ["currency", "decimals", "format", "max", "min", "step", "showClearButton", "showSpinButton"] }, { type: AsolAggregateDialogComponent, selector: "asol-aggregate-dialog", inputs: ["syncId", "transKey", "columnTranslation"], outputs: ["hide"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-pager', template: "<div\n  class=\"asol-pager d-flex align-items-center mw-100 overflow-hidden\"\n  [ngClass]=\"{\n    'justify-content-center': isMobileResolution,\n    'justify-content-between': !isMobileResolution,\n    'fixed-bottom': fixBottom\n  }\">\n  <div class=\"d-inline-flex align-items-center text-nowrap\">\n    <asol-icon-button\n      *ngIf=\"allowAggregates\"\n      color=\"dark\"\n      type=\"flat\"\n      [iconSvgUrl]=\"ICONS.COG_WHEEL\"\n      (click)=\"onShowAggregates()\">\n    </asol-icon-button>\n    <div class=\"ms-2 text-nowrap\" gIf=\"!isMobileResolution\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'count') }}\n      <strong>{{ pageSettings.totalRecordsCount }}</strong>\n    </div>\n  </div>\n  <asol-aggregate-items\n    *ngIf=\"aggregateUri && syncId && !isMobileResolution\"\n    class=\"ms-4 overflow-hidden\"\n    [columnTranslation]=\"columnTranslation\"\n    [syncId]=\"syncId\"\n    [uri]=\"aggregateUri\">\n  </asol-aggregate-items>\n  <ng-container *ngIf=\"!isMobileResolution\">\n    <ng-container\n      *ngTemplateOutlet=\"pagerTemplate; context: { $implicit: pagerData }\">\n    </ng-container>\n  </ng-container>\n  <div class=\"me-2 d-inline-flex align-items-center text-nowrap\">\n    <div class=\"mx-1\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'onPage') }}\n    </div>\n    <asol-select-field\n      [options]=\"pageSettings.pageSizes\"\n      [width]=\"80\"\n      cssClass=\"asol-select-grid\"\n      [showError]=\"false\"\n      [allowCustom]=\"false\"\n      *ngIf=\"!isMobileResolution\"\n      [(ngModel)]=\"pageSettings.pageSize\"\n      (ngModelChange)=\"onPageSettingsChanged()\">\n    </asol-select-field>\n    <div class=\"ms-5 me-2\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'page') }}\n    </div>\n    <asol-number-field\n      format=\"##\"\n      [step]=\"1\"\n      [min]=\"1\"\n      [max]=\"pageSettings.pageCount\"\n      [showError]=\"false\"\n      [showSpinButton]=\"false\"\n      [width]=\"40\"\n      cssClass=\"asol-number-grid\"\n      [(ngModel)]=\"pageSettings.currentPage\"\n      (valueChanged)=\"onPageSettingsChanged()\">\n    </asol-number-field>\n    <div class=\"mx-2\">\n      {{ trans.get(PAGER_CONSTANT.TRANS, 'of') }}\n    </div>\n    <div class=\"me-4\">\n      {{ pageSettings.pageCount }}\n    </div>\n    <asol-icon-button\n      class=\"me-1 pager-button\"\n      type=\"flat\"\n      color=\"dark\"\n      [disabled]=\"pageSettings.currentPage <= 1\"\n      (click)=\"onPageChange(false)\"\n      [iconSvgUrl]=\"ICONS.CHEVRON_LEFT\">\n    </asol-icon-button>\n    <asol-icon-button\n      class=\"me-1 pager-button\"\n      type=\"flat\"\n      color=\"dark\"\n      [disabled]=\"!(pageSettings.currentPage < pageSettings.pageCount)\"\n      (click)=\"onPageChange(true)\"\n      [iconSvgUrl]=\"ICONS.CHEVRON_RIGHT\">\n    </asol-icon-button>\n  </div>\n</div>\n\n<ng-container *ngIf=\"allowAggregates\">\n  <asol-aggregate-dialog\n    [syncId]=\"syncId\"\n    [columnTranslation]=\"columnTranslation\"\n    #aggregateDialog>\n  </asol-aggregate-dialog>\n</ng-container>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.asol-pager{background-color:#fff;border-radius:0 0 .25rem .25rem;height:40px;box-shadow:0 1px 1px #00000024,0 2px 1px #0000001f,0 1px 3px #0003;display:flex;align-items:center;font-size:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i1.AsolMediaQueryService }]; }, propDecorators: { syncId: [{
                type: Input
            }], aggregateUri: [{
                type: Input
            }], fixBottom: [{
                type: Input
            }], pageSettings: [{
                type: Input
            }], allowAggregates: [{
                type: Input
            }], pageChanged: [{
                type: Output
            }], pageSettignsChanged: [{
                type: Output
            }], pagerTemplate: [{
                type: ContentChild,
                args: ['pagerTemplate']
            }], pagerData: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }], aggregateDialog: [{
                type: ViewChild,
                args: ['aggregateDialog']
            }] } });

class AsolPagerModule {
}
AsolPagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolPagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerModule, declarations: [AsolPagerComponent], imports: [SharedModule,
        AsolNumberFieldModule,
        AsolButtonModule,
        AsolSelectFieldModule,
        AsolAggregateModule], exports: [AsolPagerComponent] });
AsolPagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerModule, imports: [[
            SharedModule,
            AsolNumberFieldModule,
            AsolButtonModule,
            AsolSelectFieldModule,
            AsolAggregateModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolPagerComponent],
                    exports: [AsolPagerComponent],
                    imports: [
                        SharedModule,
                        AsolNumberFieldModule,
                        AsolButtonModule,
                        AsolSelectFieldModule,
                        AsolAggregateModule,
                    ],
                }]
        }] });

class AsolPriorityComponent {
    constructor() {
        /** Defined priority */
        this.priority = Priority.low;
        this.Priority = Priority;
        /** Number of section based on priority level */
        this.pillArray = [];
    }
    ngOnChanges(changes) {
        if (changes.priority && changes.priority.currentValue) {
            const priorityLevel = +this.priority;
            if (isNaN(priorityLevel)) {
                return;
            }
            this.pillArray = new Array(priorityLevel);
        }
    }
}
AsolPriorityComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolPriorityComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolPriorityComponent, selector: "asol-priority", inputs: { priority: "priority" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"d-inline-flex\" *ngIf=\"pillArray.length > 0\">\n  <div\n    *ngFor=\"let item of pillArray\"\n    class=\"pil\"\n    [ngClass]=\"Priority[priority]\">\n    &nbsp;\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.pil{width:1.225rem;height:.8125rem;margin-left:.05rem;margin-right:.05rem}.pil:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}.pil:last-child{border-top-right-radius:3px;border-bottom-right-radius:3px}.pil.low{background-color:#36b37e}.pil.medium{background-color:#ffab00}.pil.high{background-color:#de350b}\n"], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-priority', template: "<div class=\"d-inline-flex\" *ngIf=\"pillArray.length > 0\">\n  <div\n    *ngFor=\"let item of pillArray\"\n    class=\"pil\"\n    [ngClass]=\"Priority[priority]\">\n    &nbsp;\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.pil{width:1.225rem;height:.8125rem;margin-left:.05rem;margin-right:.05rem}.pil:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}.pil:last-child{border-top-right-radius:3px;border-bottom-right-radius:3px}.pil.low{background-color:#36b37e}.pil.medium{background-color:#ffab00}.pil.high{background-color:#de350b}\n"] }]
        }], propDecorators: { priority: [{
                type: Input
            }] } });

class AsolPriorityModule {
}
AsolPriorityModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolPriorityModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityModule, declarations: [AsolPriorityComponent], imports: [SharedModule], exports: [AsolPriorityComponent] });
AsolPriorityModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityModule, imports: [[SharedModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriorityModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolPriorityComponent],
                    exports: [AsolPriorityComponent],
                    imports: [SharedModule],
                }]
        }] });

/* eslint-disable @typescript-eslint/no-empty-function */
class AsolProgressBarComponent {
    constructor() {
        /**
         * progress bar types: default, simple, percentage, steps
         * @default type: default
         */
        this.type = 'default';
        /**
         * set the current value of the progress bar
         * @default 0
         */
        this.value = 0;
        /**
         * set the maximum value of the progress bar
         * @default 100
         */
        this.maxValue = 100;
        /**
         * set the backround color of the progress bar
         * @default trackColor: neutral-30
         */
        this.trackColor = 'var(--neutral-30)';
        /**
         * customize label text
         * @default color: white
         * size: 16px
         * fontWeight: Normal
         * fontStyle: Normal
         */
        this.labelStyle = {
            color: 'var(--white)',
            textAlignment: 'Center',
        };
        /**
         * customize the width of the progress bar
         * @default 100%
         */
        this.width = '100%';
        /**
         * Height of the progress bar
         * @default null
         */
        this.height = null;
        /**
         * Margin size
         * @default 10
         */
        this.margin = {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
        };
        /** Custom css class */
        this.cssClass = '';
        /**
         * set animation for the progress bar by using animation property.
         * @default enable: false,
         * duration: 2000,
         * delay: 0,
         */
        this.animation = {
            enable: false,
            duration: 2000,
            delay: 0,
        };
        /** Znak pred hodnotou */
        this.prefix = null;
        /** Znak za hodnotou */
        this.suffix = null;
        /** Color of the label
         * @default trackColor value
         */
        this.labelColor = this.trackColor;
        /**
         * Generates random id
         */
        if (!this.id) {
            this.id = generateId();
        }
    }
    ngOnInit() {
        this.setDefaultColors();
        /**
         * thickness sets the height of the progress bar, if the type is set: percentage or steps, the height is set to 20px. Default is 8px.
         */
        this.thickness =
            this.thickness || this.type == 'percentage' || this.type == 'steps'
                ? 20
                : 8;
        this.showProgressValue =
            this.type == 'percentage' || this.type == 'steps' || this.label
                ? true
                : false;
    }
    ngOnChanges(changes) {
        if (changes.maxValue) {
            /**
             * if maxValue set to 0, maxValue will be set to 100
             */
            if (this.maxValue === 0) {
                this.maxValue = 100;
            }
        }
        /**
         * if value is higher than maxValue, value will be set to maxValue
         */
        if (this.value > this.maxValue) {
            this.value = this.maxValue;
        }
    }
    /**
     * set default colors
     * @default type: default basically have this colors:
     * below  100% set neutral-500 color  //dark gray color,
     * 100% set success color   //green color,
     *
     * type: simple, percentage, steps basically have this colors:
     * below 33,33..% set danger color  //red color,
     * below 66,66..% set warning color //orange color,
     * above 66,66..% set success color //green color,
     * last color is used as complete color
     */
    setDefaultColors() {
        if (this.type !== 'default') {
            this.colors = this.colors || [
                { value: (1 / 3) * 100, color: 'var(--danger)' },
                { value: (2 / 3) * 100, color: 'var(--warning)' },
                { value: 100, color: 'var(--success)' },
            ];
        }
        else {
            this.colors = this.colors || [
                { value: (1 / 3) * 100 + (2 / 3) * 100, color: 'var(--neutral-500)' },
                { value: 100, color: 'var(--success)' },
            ];
        }
    }
    /**
     * takes value and maximum value, transforms them into percentages and in the colors detected what color it should change to according to the value
     * @param args Event for progress bar. IProgressValueEventArgs changes trackColor and progressColor
     * @returns returns the current color according to the value specified in colorPalette
     */
    valueChanged(args) {
        this.sortingValueColors();
        for (const color of this.colors) {
            if ((this.value / this.maxValue) * 100 <= color.value) {
                args.progressColor = color.color;
                this.labelColor = color.color;
                return;
            }
        }
    }
    /**
     * progressCompleted take the last color from array and set to complete color
     * @param args Event for progress bar. IProgressValueEventArgs changes trackColor and progressColor when value is 100%.
     */
    progressCompleted(args) {
        this.sortingValueColors();
        args.progressColor = this.colors[this.colors.length - 1].color;
        this.labelColor = this.colors[this.colors.length - 1].color;
    }
    /**
     * if the progress bar type is set, it detects if the label is set, if not, it only displays their values.
     * @param args loadedEvent for progress bar and defines the text
     */
    textRender(args) {
        switch (this.type) {
            case 'steps':
                args.text = this.label
                    ? `${this.label}: ${this.value}/${this.maxValue}`
                    : `${this.value}/${this.maxValue}`;
                break;
            case 'percentage':
                {
                    /**
                     * transforms value to a percentage without decimal part
                     */
                    const percentageValue = Math.trunc((this.value / this.maxValue) * 100);
                    args.text = this.label
                        ? `${this.label}: ${percentageValue}%`
                        : `${percentageValue}%`;
                }
                break;
            default:
                /**
                 * if a label set in the progress bar, then set it, if it is not there, nothing will happen
                 */
                args.text = this.label ? `${this.label}` : '';
        }
    }
    /**
     * sorting the color array by values
     */
    sortingValueColors() {
        this.colors.sort((a, b) => a.value - b.value);
    }
}
AsolProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolProgressBarComponent, selector: "asol-progress-bar", inputs: { id: "id", type: "type", value: "value", maxValue: "maxValue", label: "label", colors: "colors", thickness: "thickness", trackColor: "trackColor", labelStyle: "labelStyle", width: "width", height: "height", margin: "margin", cssClass: "cssClass", animation: "animation", prefix: "prefix", suffix: "suffix" }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"d-inline-flex align-items-center\"\n  [ngStyle]=\"{ width: width, height: height }\">\n  <div\n    class=\"progress-label\"\n    [ngStyle]=\"{ color: labelColor }\"\n    *ngIf=\"type === 'frontLabel'\">\n    {{ prefix + value + suffix }}\n  </div>\n\n  <ejs-progressbar\n    [id]=\"id\"\n    [value]=\"value\"\n    [maximum]=\"maxValue\"\n    cornerRadius=\"Round\"\n    [trackThickness]=\"thickness\"\n    [progressThickness]=\"thickness\"\n    [trackColor]=\"trackColor\"\n    [showProgressValue]=\"showProgressValue\"\n    [labelStyle]=\"labelStyle\"\n    (textRender)=\"textRender($event)\"\n    (valueChanged)=\"valueChanged($event)\"\n    (progressCompleted)=\"progressCompleted($event)\"\n    [animation]=\"animation\"\n    [height]=\"height\"\n    [margin]=\"margin\"\n    [class]=\"cssClass\"\n    [width]=\"width\">\n  </ejs-progressbar>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}ejs-progressbar,.progress-label{--danger: #de350b;--warning: #ffab00;--success: #36b37e;--white: #fff;--neutral-500: #42526e;--neutral-30: #ebecf0}\n"], components: [{ type: i1$2.ProgressBarComponent, selector: "ejs-progressbar", inputs: ["animation", "annotations", "cornerRadius", "enablePersistence", "enablePieProgress", "enableProgressSegments", "enableRtl", "endAngle", "gapWidth", "height", "innerRadius", "isActive", "isGradient", "isIndeterminate", "isStriped", "labelOnTrack", "labelStyle", "locale", "margin", "maximum", "minimum", "progressColor", "progressThickness", "radius", "rangeColors", "role", "secondaryProgress", "segmentColor", "segmentCount", "showProgressValue", "startAngle", "theme", "trackColor", "trackThickness", "type", "value", "width"], outputs: ["animationComplete", "load", "loaded", "mouseClick", "mouseDown", "mouseLeave", "mouseMove", "mouseUp", "progressCompleted", "textRender", "valueChanged"] }], directives: [{ type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-progress-bar', template: "<div\n  class=\"d-inline-flex align-items-center\"\n  [ngStyle]=\"{ width: width, height: height }\">\n  <div\n    class=\"progress-label\"\n    [ngStyle]=\"{ color: labelColor }\"\n    *ngIf=\"type === 'frontLabel'\">\n    {{ prefix + value + suffix }}\n  </div>\n\n  <ejs-progressbar\n    [id]=\"id\"\n    [value]=\"value\"\n    [maximum]=\"maxValue\"\n    cornerRadius=\"Round\"\n    [trackThickness]=\"thickness\"\n    [progressThickness]=\"thickness\"\n    [trackColor]=\"trackColor\"\n    [showProgressValue]=\"showProgressValue\"\n    [labelStyle]=\"labelStyle\"\n    (textRender)=\"textRender($event)\"\n    (valueChanged)=\"valueChanged($event)\"\n    (progressCompleted)=\"progressCompleted($event)\"\n    [animation]=\"animation\"\n    [height]=\"height\"\n    [margin]=\"margin\"\n    [class]=\"cssClass\"\n    [width]=\"width\">\n  </ejs-progressbar>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}ejs-progressbar,.progress-label{--danger: #de350b;--warning: #ffab00;--success: #36b37e;--white: #fff;--neutral-500: #42526e;--neutral-30: #ebecf0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { id: [{
                type: Input
            }], type: [{
                type: Input
            }], value: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], label: [{
                type: Input
            }], colors: [{
                type: Input
            }], thickness: [{
                type: Input
            }], trackColor: [{
                type: Input
            }], labelStyle: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], margin: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], animation: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }] } });

class AsolProgressBarModule {
}
AsolProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarModule, declarations: [AsolProgressBarComponent], imports: [ProgressBarModule, SharedModule], exports: [AsolProgressBarComponent] });
AsolProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarModule, imports: [[ProgressBarModule, SharedModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolProgressBarComponent],
                    exports: [AsolProgressBarComponent],
                    imports: [ProgressBarModule, SharedModule],
                }]
        }] });

/**
 * Value currency component is a component used to correctly format currency values with conditional formatting for negative numbers.
 * This component is using valueCurrency pipe.
 *
 * @export
 * @class AsolValueCurrencyComponent
 * @typedef {AsolValueCurrencyComponent}
 */
class AsolValueCurrencyComponent {
    constructor() {
        /**
         *  Data of type ValueCurrency
         *
         * @type {(ValueCurrency | null)}
         */
        this.data = null;
        /**
         * Precision of number
         *
         * @type {string}
         * @default 1.2
         */
        this.precision = '1.2';
        /**
         * Flag if value should have success color if positive
         *
         * @default false
         */
        this.showSuccessColor = false;
    }
    /**
     * Evaluate if number is negative
     *
     * @param {number} val number
     * @returns {boolean}
     */
    isNegative(val) {
        return val ? (val < 0 ? true : false) : false;
    }
}
AsolValueCurrencyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolValueCurrencyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolValueCurrencyComponent, selector: "asol-value-currency", inputs: { data: "data", precision: "precision", showSuccessColor: "showSuccessColor" }, ngImport: i0, template: "<div\n  [ngClass]=\"{\n    'negative-number-currency': isNegative(data?.value),\n    'positive-number-currency': showSuccessColor && !isNegative(data?.value)\n  }\">\n  {{ data | valueCurrency: precision }}\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.negative-number-currency{color:#bf2600}.positive-number-currency{color:#36b37e}\n"], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "valueCurrency": i1.ValueCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-value-currency', template: "<div\n  [ngClass]=\"{\n    'negative-number-currency': isNegative(data?.value),\n    'positive-number-currency': showSuccessColor && !isNegative(data?.value)\n  }\">\n  {{ data | valueCurrency: precision }}\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.negative-number-currency{color:#bf2600}.positive-number-currency{color:#36b37e}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], precision: [{
                type: Input
            }], showSuccessColor: [{
                type: Input
            }] } });

class AsolValueCurrencyModule {
}
AsolValueCurrencyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolValueCurrencyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyModule, declarations: [AsolValueCurrencyComponent], imports: [CommonModule, PipesModule], exports: [AsolValueCurrencyComponent] });
AsolValueCurrencyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyModule, imports: [[CommonModule, PipesModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolValueCurrencyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolValueCurrencyComponent],
                    exports: [AsolValueCurrencyComponent],
                    imports: [CommonModule, PipesModule],
                }]
        }] });

var translation$d = {
    "sk-SK": {
        selected: "Označené",
        onPage: "Na stránke",
        of: "z",
        page: "Stránka",
        confirmDeleteTitle: "Potvrdenie zmazania",
        confirmDeleteContent: "Ste si istý, že chcete zmazať {0} položiek?",
        deletedToast: "Položky boli zmazané"
    },
    "cs-CZ": {
        selected: "Označené",
        onPage: "Na stránce",
        of: "z",
        page: "Stránka",
        confirmDeleteTitle: "Potvrzení smazání",
        confirmDeleteContent: "Jste si jist, že chcete smazat {0} položek?",
        deletedToast: "Položky byli smazané"
    },
    "en-US": {
        selected: "Selected",
        onPage: "On page",
        of: "of",
        page: "Page",
        confirmDeleteTitle: "Delete confirmation",
        confirmDeleteContent: "Are you sure you want to remove {0} records?",
        deletedToast: "Records where deleted"
    }
};

const GRID_CONSTANT = {
    DEFAULT_PAGE_SIZE: 15,
    DEFAULT_PAGE_SIZES: [5, 15, 50, 100],
    DEFAULT_PAGE_COUNT: 1,
    DEFAULT_PAGE_CURRENT: 1,
    MAX_RECORDS_FOR_EXPORT: 1000,
    EXCEL_EXPORT: 'ExcelExport',
    PDF_EXPORT: 'PdfExport',
    TRANS: 'asol-grid-trans',
};

/* eslint-disable @typescript-eslint/ban-types */
/**
 * Creates date picker component for filter bar
 * @param changeCallback Callback function when user selects date
 * @returns Filter bar component
 */
function createFilterBarDate(changeCallback, value) {
    const callback = changeCallback;
    const dateValue = typeof value === 'boolean' ? undefined : value;
    let htmlElement = null;
    return {
        create: () => {
            htmlElement = document.createElement('input');
            return htmlElement;
        },
        write: (args) => {
            var _a;
            const datePicker = new DatePicker({
                allowEdit: false,
                format: (_a = args.column.format) !== null && _a !== void 0 ? _a : 'dd.MM.yyyy',
                value: dateValue ? new Date(dateValue) : undefined,
                floatLabelType: 'Never',
                change: (data) => {
                    callback(data, args.column.field);
                },
            });
            datePicker.appendTo(htmlElement);
        },
    };
}

/**
 * Creates dropdown component for filter bar
 * @param changeCallback Callback function when user selects item from dropdown
 * @param values Optional values for the dropdown
 * @param service Optional service to load values for the dropdown
 * @returns Filter bar component
 */
function createFilterBarDropdown(changeCallback, values, service, value) {
    const callback = changeCallback;
    const dropValue = value instanceof Date ? undefined : value;
    let htmlElement = null;
    let dropDown = null;
    return {
        create: () => {
            htmlElement = document.createElement('input');
            return htmlElement;
        },
        write: (args) => {
            dropDown = new DropDownList({
                fields: { value: 'value', text: 'text' },
                enabled: true,
                showClearButton: true,
                allowFiltering: true,
                change: (data) => {
                    callback(data, args.column.field);
                },
                floatLabelType: 'Never',
                value: dropValue,
            });
            dropDown.appendTo(htmlElement);
            if (service && args.column.visible) {
                // call the service and setup the component
                lastValueFrom(service).then((items) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    dropDown.dataSource = items;
                });
            }
            else {
                dropDown.dataSource = values;
            }
        },
    };
}

/**
 * Fills filter data to state
 * @param state Current state @see {@link DataState}
 * @param filterData Current filter data @see {@link FilterData}
 * @returns State containing filter and where predicates
 */
function fillFilterToState(state, filterData) {
    if (!state) {
        state = {};
    }
    state.filter = filterData;
    state.where = (filterData === null || filterData === void 0 ? void 0 : filterData.where) ? [filterData.where] : null;
    return state;
}

/**
 * Fills search data from global search filter bar to state
 * @param state Current state @see {@link DataState}
 * @param columns Column definitions @see {@link GridColumnModel}
 * @param filterData Current filter date
 * @returns New state with search parameters
 */
function fillSearchToState(state, columns, filterData) {
    var _a;
    let searchParams = undefined;
    if (!(columns === null || columns === void 0 ? void 0 : columns.length)) {
        return state;
    }
    if (!state) {
        state = {};
    }
    if ((filterData === null || filterData === void 0 ? void 0 : filterData.search) && ((_a = filterData === null || filterData === void 0 ? void 0 : filterData.search) === null || _a === void 0 ? void 0 : _a.value) !== '') {
        const fields = columns
            .filter((column) => column.visible &&
            column.field !== '' &&
            (column.type == 'string' || !column.type))
            .map((p) => {
            return { field: p.field, member: p.member };
        });
        searchParams = {
            fields: fields.map((p) => p.field),
            members: fields.map((p) => p.member),
            searchText: filterData.search.value,
        };
    }
    state.searchParams = searchParams;
    return state;
}

/**
 * Fixes date grid filter greater than predicate
 * @param predicates to search desired predicate
 */
function fixDateFilterOperator(predicates) {
    if (!predicates || !predicates.length) {
        return;
    }
    predicates.forEach((predicate) => {
        if (predicate.isComplex) {
            fixDateFilterOperator(predicate.predicates);
        }
        else {
            if (!isNaN(new Date(predicate.value).getDate()) &&
                predicate.operator === FilterOperator.GREATER_THAN) {
                predicate.operator = FilterOperator.GREATER_THAN_OR_EQUAL;
            }
        }
    });
}

/**
 * Gets value from filter model, mostly used in custom filter bar components
 * @param filter Filter containing value to find @see {@link FilterSettingsModel}
 * @param field Field to search
 * @returns Value if found
 */
function getValueFromProp(filter, field) {
    var _a;
    if (!filter || !((_a = filter.columns) === null || _a === void 0 ? void 0 : _a.length)) {
        return undefined;
    }
    const data = filter.columns.find((p) => p.field === field);
    if (!data || !data.value) {
        return undefined;
    }
    return data.value;
}

/**
 * Transforms grid filter settings into filter to store
 * @param filter Filter to transform @see {@link FilterSettingsModel}
 * @returns Filter model to store
 */
function transformFilterToStore(filter) {
    const cols = [];
    filter.columns.forEach((item) => {
        cols.push({
            field: item.field,
            ignoreAccent: true,
            isForeignKey: item.isForeignKey,
            matchCase: item.matchCase,
            operator: item.operator,
            predicate: item.predicate,
            type: item.type,
            value: item.value,
        });
    });
    return {
        type: 'FilterBar',
        showFilterBarOperator: true,
        ignoreAccent: true,
        columns: cols,
    };
}

/**
 * Transforms query list column directive to array.
 * This transform is needed as query list contains a lots of properties and methods that causes stringify to fail
 * @param list Query list to transform @see {@link AsolDataColumnDirective}
 * @returns Collection of asol directives
 */
function transformQueryListToArray(list, gridCols) {
    const result = [];
    gridCols.forEach((data) => {
        const item = list.find((p) => p.field === data.field);
        if (!item) {
            return;
        }
        result.push({
            allowResizing: item.allowResizing,
            allowSorting: item.allowSorting,
            allowFiltering: item.allowFiltering,
            allowReordering: item.allowReordering,
            allowGrouping: item.allowGrouping,
            allowSearching: item.allowSearching,
            isPrimaryKey: item.isPrimaryKey,
            autoFit: item.autoFit,
            clipMode: item.clipMode,
            field: item.field,
            format: item.format,
            headerText: item.headerText,
            headerTextAlign: item.headerTextAlign,
            minWidth: item.minWidth,
            maxWidth: item.maxWidth,
            showInColumnChooser: item.showInColumnChooser,
            textAlign: item.textAlign,
            visible: item.visible,
            width: data.width,
            type: item.type,
            hideAtMedia: item.hideAtMedia,
            gridTemplate: null,
            filterTemplate: null,
            columnChooserGroup: item.columnChooserGroup,
            category: item.category,
            operators: item.operators,
            step: item.step,
            validation: item.validation,
            value: item.value,
            values: item.values,
            showInMassEdit: item.showInMassEdit,
            editType: item.editType,
            useInFilter: item.useInFilter,
            headerKey: item.headerKey,
            transKey: item.transKey,
            dropDownServiceName: item.dropDownServiceName,
            dropDownServiceFilter: item.dropDownServiceFilter,
            useInAggregate: item.useInAggregate,
            id: item.id,
            member: item.member,
            templateType: item.templateType,
            templateValueField: item.templateValueField,
            color: item.color,
            colorField: item.colorField,
            valueAccessor: item.valueAccessor,
        });
    });
    return result;
}

/**
 * Transforms SortsDescriptorModel to Sorts
 * Mostly used when storing grid data and loading into state
 * @param columns Sorts to transform @see {@link SortDescriptorModel}
 * @returns Collection of Sorts or undefined if input is empty @see {@link Sorts}
 */
function transformSortModelToSorts(columns) {
    if (!columns || !columns.length) {
        return undefined;
    }
    return columns.map((p) => {
        return {
            name: p.field,
            direction: p.direction,
        };
    });
}

class GridStorageService {
    constructor(settingsService) {
        this.settingsService = settingsService;
    }
    /**
     * Stores grid properties into DB
     * @param syncId Sync identifier
     * @param storageKey Storage key
     * @param settings Settings to store @see {@link GridProperties}
     * @returns True is stored
     */
    store(syncId, storageKey, settings) {
        if (!syncId && !storageKey) {
            return of(false);
        }
        if (!syncId) {
            return this.storeLocal(storageKey, JSON.stringify(settings));
        }
        return this.storeDb(syncId, JSON.stringify(settings));
    }
    /**
     * Gets stored grid properties
     * @param syncId Sync identifier
     * @param storageKey Storage key
     * @returns Stored grid properties @see {@link GridProperties}
     */
    get(syncId, storageKey) {
        if (!syncId && !storageKey) {
            return of(null);
        }
        if (!syncId) {
            return this.getFromLocal(storageKey);
        }
        return this.getFromDb(syncId);
    }
    /**
     * Stores grid properties into local storage
     * @param key Storage key
     * @param settings Settings to store @see {@link GridProperties}
     * @returns
     */
    storeLocal(key, settings) {
        if (!key) {
            return of(false);
        }
        localStorage.setItem(key, settings);
        return of(true);
    }
    /**
     * Gets stored grid properties from local storage
     * @param key Storage key
     * @returns Grid properties @see {@link GridProperties}
     */
    getFromLocal(key) {
        const data = localStorage.getItem(key);
        if (!data) {
            return of(null);
        }
        const parsedData = JSON.parse(data);
        return of(parsedData);
    }
    /**
     * Stores grid properties into DB
     * @param syncId Sync identifier
     * @param settings Grid properties @see {@link GridProperties}
     * @returns True is stored
     */
    storeDb(syncId, settings) {
        return this.settingsService.store(syncId, MODULE_CONST.GRID, settings);
    }
    /**
     * Gets stored grid properties from DB
     * @param syncId Sync identifier
     * @returns Grid properties @see {@link GridProperties}
     */
    getFromDb(syncId) {
        return this.settingsService.get(syncId, MODULE_CONST.GRID).pipe(map((data) => {
            if (!data) {
                return null;
            }
            return data;
        }));
    }
}
GridStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GridStorageService, deps: [{ token: SettingsServiceBase }], target: i0.ɵɵFactoryTarget.Injectable });
GridStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GridStorageService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GridStorageService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: SettingsServiceBase }]; } });

class AsolGridComponent {
    constructor(trans, notificationService, changeDetector, mediaService, pageColumnsService, filterService, storageService, spinner, toolbarService) {
        this.trans = trans;
        this.notificationService = notificationService;
        this.changeDetector = changeDetector;
        this.mediaService = mediaService;
        this.pageColumnsService = pageColumnsService;
        this.filterService = filterService;
        this.storageService = storageService;
        this.spinner = spinner;
        this.toolbarService = toolbarService;
        this.selectedItemsCount = 0;
        /** Synchronization identifier */
        this.syncId = null;
        /** Aggregate URI to load data for aggregates in pager */
        this.aggregateUri = null;
        /** Css class for parent div, used for responsivity */
        this.cssClass = '';
        /** Unique id definition */
        this.id = null;
        /** Flag if row should have checkbox or not */
        this.checkboxDisableField = '';
        /** Datasource for grid CRUD operations */
        this.datasource = null;
        /** Flag to allow aggregates on pager  */
        this.allowAggregates = false;
        /** Flag to allow filtering on grid  */
        this.allowFiltering = true;
        /** Flag to allow column resize on grid  */
        this.allowResizing = true;
        /** Flag to allow grouping of columns on grid  */
        this.allowGrouping = true;
        /** Flag to allow column reordering on grid  */
        this.allowReordering = true;
        /** Flag to allow sorting on grid  */
        this.allowSorting = false;
        /** Flag to allow excel export on grid  */
        this.allowExcelExport = false;
        /** Flag to allow pdf export on grid  */
        this.allowPdfExport = false;
        /** Flag to show paging with grid  */
        this.showPaging = true;
        /** Flag if grid cells should wrap text */
        this.allowTextWrap = true;
        /**
         * Flag if pager should be fixed at bottom of the page
         * @default true
         */
        this.fixPagerAtBottom = true;
        /** Flag if data should be stored */
        this.enablePersistance = true;
        /** Flag if data should be loaded on component initialization  */
        this.initialDataLoad = true;
        /**
         * Defines the scrollable height of the grid content.
         * @default 'auto'
         */
        this.height = 'auto';
        /**
         * Defines the Grid width.
         * @default 'auto'
         */
        this.width = '100%';
        /**
         * Filter settings
         * @default FilterBar
         */
        this.filterOption = {
            type: 'FilterBar',
            showFilterBarOperator: true,
        };
        /** Group settings for grid */
        this.groupSettings = null;
        /** Selection settings */
        this.selectionSettings = {
            checkboxOnly: true,
            persistSelection: true,
            checkboxMode: 'ResetOnRowClick',
        };
        /** Properties of grid, used to store and load grid settings */
        this.gridProperties = null;
        /**
         * Flag if Asol spinner should be shown over grid
         * (It is not using the grids spinner, but the global spinner)
         * @default false
         */
        this.useGlobalSpinner = false;
        /**
         * Defines the grid row elements rendering direction
         * @default 'Horizontal'
         */
        this.rowRenderingMode = 'Horizontal';
        /**
         * Flag if adaptive layout should be disabled
         *  If true, grid will not be responsive
         * @default false
         */
        this.disableAdaptiveLayout = false;
        /**
         * Flag if window resolution is mobile
         * @default false
         */
        this.isMobileResolution = false;
        /**
         * Additional export parameters
         * @default null
         */
        this.exportParams = null;
        /**
         * Index of the selected row
         * @default null
         */
        this.selectedRowIndex = null;
        /**
         * Flag for allowing single selection using checkboxes
         * @default false
         */
        this.singleSelection = false;
        /** Emits when row is selected @see {@link RowSelectionArgs} */
        this.rowSelected = new EventEmitter();
        /** Emits when row is double clicked @see {@link RecordDoubleClickEventArgs} */
        this.rowDoubleClick = new EventEmitter();
        /** Emits when data state changes */
        this.dataStateChanged = new EventEmitter();
        /** Emits when user removes items and datasource is not present */
        this.removeItems = new EventEmitter();
        /** Emits when settings where parsed */
        this.settingsParsed = new EventEmitter();
        /** Emits when data are bound to grid */
        this.databound = new EventEmitter();
        /** Emits when row is bound to grid */
        this.rowDatabound = new EventEmitter();
        this.grid = null;
        this.chooserDialog = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.progressTemplate = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.currencyTemplate = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.colorTemplate = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.priorityTemplate = null;
        this.pager = null;
        /** Column definition used directly on grid component (when not used with page columns component)  */
        this.childColumns = null;
        /** Column definition used to fill grid */
        this.columnModel = [];
        this.sub = new Subscription();
        /** Holds subscription when data are loaded into grid */
        this.reloadSub = new Subscription();
        /** Holds subscription when data are loaded into grid */
        this.initializeSub = new Subscription();
        this.confirmDialog = null;
        this.storageKey = null;
        this.firstColumnRounded = false;
        this.sortSettings = {
            allowUnsort: true,
            columns: [],
        };
        this.GRID_CONSTANT = GRID_CONSTANT;
        this.ICONS = ICONS;
        /** Stores current grid data state */
        this.state = {
            skip: 0,
            take: GRID_CONSTANT.DEFAULT_PAGE_SIZE,
            where: [],
            sorted: [],
            group: [],
            search: [],
        };
        /** Flag if grid is already initialized */
        this.gridInitialized = false;
        this.trans.initialize(GRID_CONSTANT.TRANS, translation$d);
        this.trans.initialize(AGGREGATE_CONSTANT.TRANS, aggregateTranslation);
    }
    ngOnInit() {
        var _a, _b;
        if (!this.syncId) {
            this.syncId = this.id;
        }
        this.sub.add((_a = this.filterService) === null || _a === void 0 ? void 0 : _a.filterChanged$.subscribe((item) => {
            var _a;
            // skip if filter is not for this grid and filter change originated from this grid
            if (item.id !== this.syncId || item.type === 'where') {
                return;
            }
            (_a = this.pager) === null || _a === void 0 ? void 0 : _a.resetCurrentPage();
            this.parseFilterSettings(item === null || item === void 0 ? void 0 : item.filter);
            this.state.membersMapping = this.getMemberMapping();
            // load only when grid is initialized
            if (this.grid) {
                this.reload();
            }
        }));
        this.sub.add((_b = this.toolbarService) === null || _b === void 0 ? void 0 : _b.toolbarClicked$.subscribe((item) => {
            if (item.syncId !== this.syncId) {
                return;
            }
            switch (item.type) {
                case 'delete':
                    this.onToolbarDelete();
                    return;
                case 'chooser':
                    this.showColumnChooser();
                    return;
                case 'reset':
                    this.resetSettings();
                    return;
                case 'export':
                    this.exportHandler();
                    return;
            }
        }));
        this.sub.add(this.mediaService.viewportChanged$.subscribe((resolution) => {
            if (resolution.breakpoints[MEDIA_QUERY.XS] != true) {
                this.rowRenderingMode = 'Horizontal';
                this.isMobileResolution = false;
                return;
            }
            // Is mobile under 576px
            this.isMobileResolution = true;
            this.rowRenderingMode = 'Vertical';
        }));
        this.sub.add(this.pageColumnsService.columnsChanged$.subscribe((syncId) => {
            var _a;
            if (syncId !== this.syncId) {
                return;
            }
            if (!this.gridInitialized) {
                (_a = this.initializeSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                this.initializeSub = this.initializeGrid().subscribe(() => {
                    if (this.initialDataLoad) {
                        this.reload();
                    }
                });
            }
            else {
                this.parseColumns(undefined, true);
            }
        }));
    }
    ngOnDestroy() {
        var _a, _b, _c;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.reloadSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.initializeSub) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        // destroy grid
        this.destroy();
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.entityId) {
            this.state.entityId = this.entityId;
        }
        // TODO remove in next major version of controls
        if (((_a = changes.id) === null || _a === void 0 ? void 0 : _a.firstChange) && this.id) {
            this.storageKey = `grid-container${this.id}`;
        }
    }
    ngAfterViewInit() {
        var _a;
        // It has to be in after view init,
        // because we need childColumns if available
        if (this.childColumns) {
            (_a = this.initializeSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this.initializeSub = this.initializeGrid().subscribe(() => {
                if (this.initialDataLoad) {
                    this.reload();
                }
            });
        }
    }
    /**
     * Initialize grid, load settings from storage or from input
     */
    initializeGrid() {
        // Get columns from local grid or page columns service, will be used
        // add missing services, that where stripped from grid properties when storing
        this.setGridColumnsDefinition();
        // properties for grid added as Input (dashboard, etc.), no need to load from storage
        if (this.gridProperties) {
            this.setProperties(this.gridProperties);
            this.settingsParsed.emit();
            this.gridInitialized = true;
            this.pageColumnsService.setColumns(this.syncId, this.gridProperties.columns);
            this.parseColumns(this.gridProperties.columns);
            this.parseVisibility(this.gridProperties.columns);
            return of();
        }
        if (this.enablePersistance && this.syncId) {
            return this.loadStateFromStorage().pipe(map((gridProperties) => {
                // No properties in storage, do nothing
                if (!gridProperties) {
                    this.parseColumns();
                    return;
                }
                this.setProperties(gridProperties);
                this.parseColumns(gridProperties.columns);
                this.parseVisibility(gridProperties.columns);
                this.gridInitialized = true;
            }));
        }
        this.parseColumns();
        this.gridInitialized = true;
        return of();
    }
    /**
     * Sets local grid columns definition from local definition if page columns does not exists
     */
    setGridColumnsDefinition() {
        var _a;
        if (!this.pageColumnsService.hasColumns(this.syncId) &&
            ((_a = this.childColumns) === null || _a === void 0 ? void 0 : _a.length)) {
            this.pageColumnsService.setColumns(this.syncId, this.childColumns.toArray(), false);
        }
    }
    /**
     * Parses column visibility
     * @param columns Columns to parse
     */
    parseVisibility(columns) {
        const cols = columns.map((p) => {
            return {
                field: p.field,
                visible: p.visible,
                headerText: p.headerText,
            };
        });
        const colChoose = [
            {
                items: cols,
            },
        ];
        this.changeColumnVisibility(colChoose, false, false);
    }
    /** Shows column chooser dialog */
    showColumnChooser() {
        var _a;
        (_a = this.chooserDialog) === null || _a === void 0 ? void 0 : _a.showDialog(this.syncId);
    }
    /** Event handler after column chooser dialog closes */
    onColumnChooserHide(columns) {
        this.changeColumnVisibility(columns);
    }
    /**
     * Handler for exporting data from grid after toolbar click
     */
    exportHandler() {
        const state = Object.assign(Object.assign({}, this.state), { entityId: this.entityId, skip: 0, take: GRID_CONSTANT.MAX_RECORDS_FOR_EXPORT });
        this.datasource.getGridData(state, this.exportParams).subscribe((data) => {
            const dataMap = collectionMapper(data.result, this.trans);
            const eep = {
                dataSource: dataMap,
                includeHiddenColumn: false,
            };
            this.grid.excelExport(eep);
        });
    }
    /**
     * Parses column definition from input or Data page
     * @param columns Columns to parse (from dashboard or stored)
     * @param refreshColumns Flag if grid columns should be refreshed, only usable when grid is initialized and columns are changed
     */
    parseColumns(columns, refreshColumns = false) {
        var _a;
        let pageColumns = this.pageColumnsService.getColumns(this.syncId);
        if (columns === null || columns === void 0 ? void 0 : columns.length) {
            columns.forEach((col) => {
                const pageCol = pageColumns === null || pageColumns === void 0 ? void 0 : pageColumns.find((p) => p.field === col.field);
                if (!pageCol) {
                    return;
                }
                col.dropDownService = pageCol.dropDownService;
                col.columnChooserMultiselectService =
                    pageCol.columnChooserMultiselectService;
                col.gridTemplate = pageCol.gridTemplate;
                col.filterTemplate = pageCol.filterTemplate;
            });
            pageColumns = columns;
        }
        const cols = this.getUniqueCols(pageColumns);
        if (!cols.length) {
            return;
        }
        cols.forEach((column) => {
            var _a;
            const header = column.headerKey
                ? column.transKey
                    ? this.trans.get(column.transKey, column.headerKey)
                    : translateProperty(this.columnTranslation, column.headerKey, this.trans.getFullLocale)
                : column.headerText;
            if (!column.gridTemplate) {
                switch (column.templateType) {
                    case 'progress':
                        column.gridTemplate = this.progressTemplate;
                        break;
                    case 'valueCurrency':
                        column.gridTemplate = this.currencyTemplate;
                        break;
                    case 'color':
                        column.gridTemplate = this.colorTemplate;
                        break;
                    case 'priority':
                        column.gridTemplate = this.priorityTemplate;
                        break;
                }
            }
            this.columnModel.push(Object.assign(Object.assign({}, column), { headerText: header, member: column.member, columnChooserGroup: (_a = column.columnChooserGroup) !== null && _a !== void 0 ? _a : '', format: column.type === 'date'
                    ? { type: 'date', format: this.trans.getDateFormatForLocale() }
                    : column.format, template: column.gridTemplate, filterBarTemplate: this.createCustomFilterBarComponent(column.type, column.values, column.dropDownService, getValueFromProp(this.filterOption, column.field)) }));
        });
        if (refreshColumns) {
            (_a = this.grid) === null || _a === void 0 ? void 0 : _a.refreshColumns();
        }
    }
    /**
     * Gets columns which are not in column model
     * @param columns Columns to filter
     * @returns Return Columns that are not in column model (in grid)
     */
    getUniqueCols(columns) {
        var _a;
        if (!((_a = this.columnModel) === null || _a === void 0 ? void 0 : _a.length)) {
            return columns;
        }
        const diff = columns.filter((p) => !this.columnModel.some((c) => p.field === c.field));
        return diff;
    }
    /**
     * Creates custom components for grids filter bar
     * @param type Type of component to create
     * @param values Values to add to combobox
     * @param service Service to load data to combobox
     * @returns Returns component or undefined if component is not needed
     */
    createCustomFilterBarComponent(type, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    values, service, value) {
        if (!type) {
            return undefined;
        }
        switch (type) {
            case 'select':
                return createFilterBarDropdown((data, id) => {
                    this.parseFilterChange(data, id);
                }, values, service, value);
            case 'date':
                return createFilterBarDate((data, id) => {
                    this.parseFilterChange(data, id);
                }, value);
        }
        return undefined;
    }
    /**
     * Event handler after select component in filter bar is changed
     * @param data Selected item data @see {@link ChangeEventArgs}
     * @param id Select components unique identifier
     */
    parseFilterChange(data, id) {
        if (data === null || data.value === null || data.value === undefined) {
            this.grid.removeFilteredColsByField(id);
        }
        else {
            this.grid.filterByColumn(id, 'equal', data.value);
        }
        this.store();
    }
    /**
     * Handling action erros in grid
     * @param event Failure error handler @see {@link FailureEventArgs}
     */
    onActionfailure(event) {
        var _a;
        (_a = this.grid) === null || _a === void 0 ? void 0 : _a.hideSpinner();
    }
    /**
     * Gets selected rows from grid
     * @returns
     */
    getSelectedRecords() {
        return this.grid.getSelectedRecords();
    }
    /**
     * Event when row is selected/deselected
     */
    rowSelection(event, selected) {
        this.rowSelected.next({
            data: event.data,
            rowIndex: event.rowIndex,
            selected: selected,
            count: this.grid.getSelectedRecords().length,
        });
        this.selectedItemsCount = this.grid.getSelectedRecords().length;
    }
    /**
     * Reloads data from dataservice based on paging, sorting, filtering etc.
     * @param state Data state arguments
     * @param params Additional parameters
     */
    reload(state, params) {
        var _a, _b, _c, _d, _e, _f, _g;
        const members = this.getMemberMapping();
        if (state) {
            if (state.action.requestType === 'filtering' &&
                this.syncId &&
                this.enablePersistance) {
                const dataWhere = ((_a = state.where) === null || _a === void 0 ? void 0 : _a.length) ? state.where[0] : null;
                this.filterService.changeFilter(this.syncId, 'where', dataWhere);
                this.store();
                return; // data will be loaded through filter service
            }
            const search = this.state.searchParams;
            this.state = {
                skip: state.skip,
                take: state.take,
                sorted: state.sorted,
                membersMapping: members,
                group: state.group,
                searchParams: search,
                entityId: this.entityId,
            };
            fixDateFilterOperator(this.state.where);
            this.store();
        }
        if (params) {
            this.searchParams = params;
        }
        this.state.additionalSearchParams = this.additionalSearchParams;
        this.state.membersMapping = members;
        this.state.skip = (_c = (_b = this.pager) === null || _b === void 0 ? void 0 : _b.getSkipData()) !== null && _c !== void 0 ? _c : 0;
        this.state.take =
            (_e = (_d = this.pager) === null || _d === void 0 ? void 0 : _d.pageSettings.pageSize) !== null && _e !== void 0 ? _e : GRID_CONSTANT.DEFAULT_PAGE_SIZE;
        if (this.datasource) {
            if (this.useGlobalSpinner) {
                (_f = this.spinner) === null || _f === void 0 ? void 0 : _f.show();
            }
            // hide if new reuqest is made
            if (!this.reloadSub.closed) {
                this.reloadSub.unsubscribe();
                (_g = this.spinner) === null || _g === void 0 ? void 0 : _g.hide();
            }
            this.reloadSub = this.filterService
                .get(this.syncId)
                .pipe(finalize(() => {
                var _a;
                if (this.useGlobalSpinner) {
                    (_a = this.spinner) === null || _a === void 0 ? void 0 : _a.hide();
                }
            }), switchMap((item) => {
                if (this.syncId) {
                    this.parseFilterSettings(item);
                    fixDateFilterOperator(this.state.where);
                }
                return this.datasource.getGridData(this.state, this.searchParams);
            }))
                .subscribe((data) => {
                if (data &&
                    ((data.count && !data.result.length) ||
                        (data.count === 0 && data.result.length > 0))) {
                    this.data = { count: 0, result: [] };
                }
                else {
                    this.data = data;
                }
                /** set timeout until pager is rendered */
                setTimeout(() => {
                    this.setPager(data === null || data === void 0 ? void 0 : data.count);
                });
                this.changeDetector.detectChanges();
            });
        }
        this.dataStateChanged.emit(this.state);
    }
    /**
     * Sets pager according to count
     * @param count Total records count
     */
    setPager(count) {
        var _a;
        (_a = this.pager) === null || _a === void 0 ? void 0 : _a.setPager(count);
    }
    /**
     * Refreshes the grid after data change outside of datasource
     */
    refresh() {
        this.grid.refresh();
    }
    /**
     * Destroys the grid
     */
    destroy() {
        var _a;
        try {
            (_a = this.grid) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        catch (_b) {
            // not needed as it is destroy operation
        }
    }
    /**
     * Sets stored properties to grid
     * @param prop - Defines properties that will be loaded into grdi @see {@link GridProperties}
     */
    setProperties(prop) {
        var _a, _b, _c, _d, _e, _f;
        if (prop.gridSettings) {
            this.parseGridSettings(prop.gridSettings);
        }
        if (prop.filterSettings) {
            this.filterOption = prop.filterSettings;
        }
        if (prop.sortSettings) {
            this.sortSettings = prop.sortSettings;
        }
        if (prop.pageSettings) {
            (_a = this.pager) === null || _a === void 0 ? void 0 : _a.parseSettingsFromGrid(prop.pageSettings);
            this.state.skip = (_c = (_b = this.pager) === null || _b === void 0 ? void 0 : _b.getSkipData()) !== null && _c !== void 0 ? _c : 0;
            this.state.take =
                (_e = (_d = this.pager) === null || _d === void 0 ? void 0 : _d.pageSettings.pageSize) !== null && _e !== void 0 ? _e : GRID_CONSTANT.DEFAULT_PAGE_SIZE;
        }
        if (prop.aggregateUri) {
            this.aggregateUri = prop.aggregateUri;
        }
        this.state.sorted = transformSortModelToSorts((_f = prop === null || prop === void 0 ? void 0 : prop.sortSettings) === null || _f === void 0 ? void 0 : _f.columns);
    }
    /**
     * Parses filter changes into grid state
     * @param item Filter data to parse @see {@link FilterData}
     */
    parseFilterSettings(item) {
        var _a, _b, _c;
        if (!(item === null || item === void 0 ? void 0 : item.where) && ((_c = (_b = (_a = this.grid) === null || _a === void 0 ? void 0 : _a.filterSettings) === null || _b === void 0 ? void 0 : _b.columns) === null || _c === void 0 ? void 0 : _c.length)) {
            this.resetSettings();
        }
        this.state = fillFilterToState(this.state, item);
        this.state = fillSearchToState(this.state, this.columnModel, item);
    }
    /**
     * Returns Current grid state
     * @returns Data state object @see {@link DataState}
     */
    getCurrentState() {
        return this.state;
    }
    /**
     * Parses stored grid settings
     * @param gridSettings Settings to parse
     */
    parseGridSettings(gridSettings) {
        if (!gridSettings) {
            return;
        }
        this.allowFiltering = gridSettings.allowFiltering;
        this.allowResizing = gridSettings.allowResizing;
        this.allowGrouping = gridSettings.allowGrouping;
        this.allowReordering = gridSettings.allowReordering;
        this.allowAggregates = gridSettings.allowAggregates;
        this.allowSorting = gridSettings.allowSorting;
        this.allowExcelExport = gridSettings.allowExcelExport;
        this.allowPdfExport = gridSettings.allowPdfExport;
        this.initialDataLoad = gridSettings.initialDataLoad;
        if (gridSettings === null || gridSettings === void 0 ? void 0 : gridSettings.height) {
            this.height = gridSettings.height;
        }
        if (gridSettings === null || gridSettings === void 0 ? void 0 : gridSettings.width) {
            this.width = gridSettings.width;
        }
    }
    /**
     * Gets current grid setup to grd settings
     * @returns Grid settings @see {@link GridSettings}
     */
    getGridSettings() {
        const settings = {
            allowFiltering: this.allowFiltering,
            allowResizing: this.allowResizing,
            allowGrouping: this.allowGrouping,
            allowReordering: this.allowReordering,
            allowAggregates: this.allowAggregates,
            allowSorting: this.allowSorting,
            allowExcelExport: this.allowExcelExport,
            allowPdfExport: this.allowPdfExport,
            initialDataLoad: this.initialDataLoad,
            height: this.height,
            width: this.width,
        };
        return settings;
    }
    /**
     * Gets persist data for grid
     * @returns string data
     */
    getPersistData() {
        var _a, _b, _c, _d, _e, _f;
        const columns = this.pageColumnsService.getColumns(this.syncId);
        const cols = transformQueryListToArray(columns, this.grid.columns);
        const persistData = {
            gridSettings: this.getGridSettings(),
            columns: cols,
            filterSettings: transformFilterToStore(this.grid.filterSettings),
            groupSettings: {
                columns: (_a = this.grid.groupSettings) === null || _a === void 0 ? void 0 : _a.columns,
                allowReordering: (_b = this.grid.groupSettings) === null || _b === void 0 ? void 0 : _b.allowReordering,
            },
            pageSettings: {
                pageCount: this.grid.pageSettings.pageCount,
                pageSize: (_c = this.pager) === null || _c === void 0 ? void 0 : _c.pageSettings.pageSize,
                currentPage: (_d = this.pager) === null || _d === void 0 ? void 0 : _d.pageSettings.currentPage,
                totalRecordsCount: this.grid.pageSettings.totalRecordsCount,
            },
            searchSettings: { key: '', fields: [] },
            selectedRowIndex: -1,
            aggregateUri: this.aggregateUri,
            sortSettings: {
                allowUnsort: (_e = this.grid.sortSettings) === null || _e === void 0 ? void 0 : _e.allowUnsort,
                columns: (_f = this.grid.sortSettings) === null || _f === void 0 ? void 0 : _f.columns.map((item) => {
                    return {
                        direction: item.direction,
                        field: item.field,
                        isFromGroup: item.isFromGroup,
                    };
                }),
            },
        };
        return persistData;
    }
    /**
     * Gets member mapping for grid (field => member)
     * @returns Colection of map @see {@link MemberMap}
     */
    getMemberMapping() {
        return this.columnModel
            .filter((p) => p.member && p.field)
            .map((p) => {
            return {
                member: p.member,
                field: p.field,
            };
        });
    }
    /**
     * Handler when user double clicks record
     * @param event Event argumets
     */
    onRowDoubleClick(event) {
        this.rowDoubleClick.emit(event);
    }
    /**
     * Changes visibility of columns
     * @param columns Columns to change
     * @param store Flag if column change should be stored
     * @param refresh Flag if grid should be refreshed
     */
    changeColumnVisibility(columns, store = true, refresh = true) {
        const pageColumns = this.pageColumnsService.getColumns(this.syncId);
        columns.forEach((columnGroup) => {
            columnGroup === null || columnGroup === void 0 ? void 0 : columnGroup.items.forEach((column) => {
                const item = this.columnModel.find((p) => p.field === column.field);
                if (item) {
                    item.visible = column.visible;
                }
                const item2 = pageColumns === null || pageColumns === void 0 ? void 0 : pageColumns.find((p) => p.field === column.field);
                if (item2) {
                    item2.visible = column.visible;
                }
            });
        });
        this.pageColumnsService.setColumns(this.syncId, pageColumns, false);
        if (store) {
            this.store();
        }
        if (refresh) {
            this.refresh();
        }
    }
    /**
     * Stores grid properties into local storage
     */
    store() {
        if (!this.enablePersistance) {
            return;
        }
        const dataToStore = this.getPersistData();
        this.storageService
            .store(this.syncId, this.storageKey, dataToStore)
            // swallow subscribe as user does not need to know if data were stored
            .subscribe();
    }
    /**
     * Loads properties
     */
    loadStateFromStorage() {
        if (!this.enablePersistance) {
            return of(null);
        }
        return this.storageService.get(this.syncId, this.storageKey).pipe(map((data) => {
            return data;
        }));
    }
    /**
     * Check if grid has stored data in local storage
     * @returns True if he does
     */
    hasStoredData() {
        if (!this.enablePersistance) {
            return of(false);
        }
        return this.storageService.get(this.syncId, this.storageKey).pipe(map((data) => {
            return !!data;
        }));
    }
    /**
     * Toolbar confirmation dialog after delete button in toolbar was clicked
     */
    onToolbarDelete() {
        var _a;
        const selectedCount = (_a = this.getSelectedRecords().length) !== null && _a !== void 0 ? _a : 0;
        const content = stringFormat(this.trans.get(GRID_CONSTANT.TRANS, 'confirmDeleteContent'), [selectedCount.toString()]);
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(GRID_CONSTANT.TRANS, 'confirmDeleteTitle'),
            content: content,
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.confirmClick.bind(this),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    /**
     * Reset grid settings
     */
    resetSettings() {
        var _a;
        (_a = this.pager) === null || _a === void 0 ? void 0 : _a.reset();
        if (this.syncId) {
            this.filterService.resetFilter(this.syncId, 'where').subscribe(() => {
                this.resetGrid();
            });
        }
        else {
            this.resetGrid();
        }
    }
    /**
     * Resets grid filter and sort settings
     */
    resetGrid() {
        this.filterOption.columns = [];
        this.sortSettings.columns = [];
        this.refreshFilterBarTemplates();
        this.storageService.get(this.syncId, this.storageKey).subscribe((data) => {
            if (!data) {
                data = this.getPersistData();
            }
            data.filterSettings.columns = [];
            data.sortSettings.columns = [];
            this.setProperties(data);
            this.store();
            this.reload();
        });
    }
    /**
     * Refreshes filter bar templates
     */
    refreshFilterBarTemplates() {
        const cols = this.columnModel.filter((p) => p.filterBarTemplate);
        const pageColumns = this.pageColumnsService.getColumns(this.syncId);
        for (const col of cols) {
            const column = pageColumns.find((p) => p.field === col.field);
            if (!column) {
                continue;
            }
            col.filterBarTemplate = this.createCustomFilterBarComponent(column.type, column.values, column.dropDownService, getValueFromProp(this.filterOption, col.field));
        }
        this.grid.refreshColumns();
    }
    /**
     * Calls deleteItems on grid datasource
     */
    confirmClick() {
        if (!this.datasource) {
            this.removeItems.emit(this.getSelectedRecords());
            return;
        }
        this.spinner.show();
        this.datasource
            .deleteItems(this.getSelectedRecords(), this.entityId)
            .pipe(finalize(() => this.spinner.hide()))
            .subscribe((result) => {
            if (!result) {
                return;
            }
            this.confirmDialog.hide();
            this.notificationService.success(this.trans.get(GRID_CONSTANT.TRANS, 'deletedToast'));
            // clear selection after deletion
            this.clearSelection();
            this.reload();
        });
    }
    /**
     * Sets cell value without reloading entire grid
     * @param key Primary key in grid
     * @param field Field that will be changed
     * @param value Value that will be changed
     * @deprecated
     */
    setCellValue(key, field, value) {
        this.grid.setCellValue(key, field, value);
    }
    /**
     * Clears global search params from search panel
     */
    clearGlobalSearch() {
        this.searchParams = undefined;
    }
    /**
     * Clears selection of grid
     */
    clearSelection() {
        this.grid.clearSelection();
    }
    /**
     * Reloades the grid and stores values
     */
    reloadAndStore(state, params) {
        this.reload(state, params);
        this.store();
    }
    /**
     * Stores data when user reorders column
     * SetTimout needs to be here that reorder is propagated to grid settings
     */
    onDrop() {
        setTimeout(() => {
            this.store();
        }, 400);
    }
    /**
     * Event when data are bound to grid
     */
    onDataBound() {
        /** if single selection is turned on, remove key down handlers to turn off CTRL + A command */
        if (this.singleSelection) {
            this.grid.addEventListener('keyPressed', this.keyDownHandler.bind(this));
        }
        this.databound.emit();
    }
    /**
     * Removes key down handler for grid
     * @param args the keyboard event args
     */
    keyDownHandler(args) {
        args.cancel = true;
    }
    /**
     * Fix for rounded header corners
     * @param args Header cell info @see {@link HeaderCellInfoEventArgs}
     */
    onHeaderCellInfo(args) {
        if (!args.node.classList.contains('e-hide') && !this.firstColumnRounded) {
            this.firstColumnRounded = true;
            args.node.classList.add('left-round-header');
        }
        const lastCellIndex = this.grid.getVisibleColumns()[this.grid.getVisibleColumns().length - 1]
            .index;
        if (this.firstColumnRounded && args.cell.column.index == lastCellIndex) {
            this.firstColumnRounded = false;
            args.node.classList.add('right-round-header');
        }
    }
    /**
     * External global search
     * @deprecated Use filter service instead
     * @param text Text to find in search
     */
    search(text) {
        var _a;
        let searchParams = undefined;
        if (text && text !== '') {
            const fields = this.columnModel
                .filter((column) => column.visible &&
                column.field !== '' &&
                (column.type == 'string' || !column.type))
                .map((p) => {
                return { field: p.field, member: p.member };
            });
            searchParams = {
                fields: fields.map((p) => p.field),
                members: fields.map((p) => p.member),
                searchText: text,
            };
        }
        (_a = this.pager) === null || _a === void 0 ? void 0 : _a.resetCurrentPage();
        this.state.searchParams = searchParams;
        this.reload();
    }
    /**
     * Fires when row is bounded to grid
     * It hides checkbox if checkboxDisableField is true
     * @param args Argument
     */
    onRowDataBound(args) {
        if (this.checkboxDisableField) {
            if (args.data[this.checkboxDisableField] === true) {
                args.row
                    .getElementsByClassName('e-checkbox-wrapper')[0]
                    .classList.add('d-none');
            }
        }
        this.rowDatabound.emit(args);
    }
    /**
     * Handles the single selection in grid
     */
    rowSelecting() {
        if (this.grid.getSelectedRecords().length && this.singleSelection) {
            this.grid.clearSelection();
        }
    }
}
AsolGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridComponent, deps: [{ token: i1.TranslationService }, { token: NotificationService }, { token: i0.ChangeDetectorRef }, { token: i1.AsolMediaQueryService }, { token: PageColumnsService }, { token: FilterSyncService }, { token: GridStorageService }, { token: SpinnerService }, { token: ToolbarService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AsolGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolGridComponent, selector: "asol-grid", inputs: { syncId: "syncId", aggregateUri: "aggregateUri", entityId: "entityId", additionalSearchParams: "additionalSearchParams", cssClass: "cssClass", data: "data", id: "id", checkboxDisableField: "checkboxDisableField", datasource: "datasource", allowAggregates: "allowAggregates", allowFiltering: "allowFiltering", allowResizing: "allowResizing", allowGrouping: "allowGrouping", allowReordering: "allowReordering", allowSorting: "allowSorting", allowExcelExport: "allowExcelExport", allowPdfExport: "allowPdfExport", showPaging: "showPaging", allowTextWrap: "allowTextWrap", fixPagerAtBottom: "fixPagerAtBottom", enablePersistance: "enablePersistance", initialDataLoad: "initialDataLoad", height: "height", width: "width", filterOption: "filterOption", groupSettings: "groupSettings", selectionSettings: "selectionSettings", gridProperties: "gridProperties", columnTranslation: "columnTranslation", useGlobalSpinner: "useGlobalSpinner", rowRenderingMode: "rowRenderingMode", disableAdaptiveLayout: "disableAdaptiveLayout", exportParams: "exportParams", selectedRowIndex: "selectedRowIndex", singleSelection: "singleSelection", pagerData: "pagerData" }, outputs: { rowSelected: "rowSelected", rowDoubleClick: "rowDoubleClick", dataStateChanged: "dataStateChanged", removeItems: "removeItems", settingsParsed: "settingsParsed", databound: "databound", rowDatabound: "rowDatabound" }, providers: [GridStorageService], queries: [{ propertyName: "pagerGridTemplate", first: true, predicate: ["pagerTemplate"], descendants: true }, { propertyName: "childColumns", predicate: AsolDataColumnDirective }], viewQueries: [{ propertyName: "grid", first: true, predicate: ["grid"], descendants: true }, { propertyName: "chooserDialog", first: true, predicate: ["chooser"], descendants: true }, { propertyName: "progressTemplate", first: true, predicate: ["progressTemplate"], descendants: true }, { propertyName: "currencyTemplate", first: true, predicate: ["currencyTemplate"], descendants: true }, { propertyName: "colorTemplate", first: true, predicate: ["colorTemplate"], descendants: true }, { propertyName: "priorityTemplate", first: true, predicate: ["priorityTemplate"], descendants: true }, { propertyName: "pager", first: true, predicate: ["pager"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"columnModel.length\">\n  <div\n    class=\"row\"\n    [ngClass]=\"{ 'e-bigger': isMobileResolution && !disableAdaptiveLayout }\">\n    <div [ngClass]=\"cssClass\" class=\"mb-7\">\n      <ejs-grid\n        #grid\n        [id]=\"id\"\n        [ngClass]=\"{ 'single-selection': singleSelection }\"\n        [dataSource]=\"data\"\n        [enableStickyHeader]=\"false\"\n        [enablePersistence]=\"false\"\n        [allowSorting]=\"allowSorting\"\n        [allowFiltering]=\"allowFiltering\"\n        [allowExcelExport]=\"allowExcelExport\"\n        [allowPdfExport]=\"allowPdfExport\"\n        [allowResizing]=\"allowResizing\"\n        [allowReordering]=\"allowReordering\"\n        [allowGrouping]=\"allowGrouping\"\n        [allowTextWrap]=\"allowTextWrap\"\n        [filterSettings]=\"filterOption\"\n        [groupSettings]=\"groupSettings\"\n        [sortSettings]=\"sortSettings\"\n        [columns]=\"columnModel\"\n        [showColumnChooser]=\"false\"\n        [width]=\"width\"\n        [height]=\"height\"\n        [enableAdaptiveUI]=\"!disableAdaptiveLayout\"\n        [rowRenderingMode]=\"rowRenderingMode\"\n        [allowPaging]=\"false\"\n        rowHeight=\"32\"\n        [selectionSettings]=\"selectionSettings\"\n        [selectedRowIndex]=\"selectedRowIndex\"\n        (dataStateChange)=\"reload($event)\"\n        (actionFailure)=\"onActionfailure($event)\"\n        (rowSelected)=\"rowSelection($event, true)\"\n        (rowSelecting)=\"rowSelecting()\"\n        (rowDeselected)=\"rowSelection($event, false)\"\n        (recordDoubleClick)=\"onRowDoubleClick($event)\"\n        (headerCellInfo)=\"onHeaderCellInfo($event)\"\n        (dataBound)=\"onDataBound()\"\n        (rowDataBound)=\"onRowDataBound($event)\"\n        (resizeStop)=\"store()\"\n        (columnDrop)=\"onDrop()\">\n      </ejs-grid>\n      <asol-pager\n        *ngIf=\"showPaging\"\n        #pager\n        [id]=\"id\"\n        [syncId]=\"syncId\"\n        [aggregateUri]=\"aggregateUri\"\n        [fixBottom]=\"fixPagerAtBottom\"\n        [columnTranslation]=\"columnTranslation\"\n        [pagerData]=\"pagerData\"\n        [allowAggregates]=\"allowAggregates\"\n        (pageChanged)=\"reloadAndStore()\"\n        (pageSettignsChanged)=\"reloadAndStore()\">\n        <ng-template #pagerTemplate>\n          <ng-container\n            *ngTemplateOutlet=\"\n              pagerGridTemplate;\n              context: { $implicit: pagerData }\n            \">\n          </ng-container>\n        </ng-template>\n      </asol-pager>\n    </div>\n  </div>\n</ng-container>\n\n<asol-column-chooser-dialog #chooser (hide)=\"onColumnChooserHide($event)\">\n</asol-column-chooser-dialog>\n\n<ng-template #progressTemplate let-data>\n  <div class=\"d-flex center-item-v row\">\n    <asol-progress-bar\n      width=\"{{ (data.column.width - 50).toString() + 'px' }} \"\n      suffix=\"%\"\n      type=\"frontLabel\"\n      [value]=\"\n        data.column.templateValueField\n          ? data[data.column.templateValueField]\n          : data[data.column.field]\n      \">\n    </asol-progress-bar>\n  </div>\n</ng-template>\n\n<ng-template #currencyTemplate let-data>\n  <asol-value-currency\n    [data]=\"\n      data.column.templateValueField\n        ? data[data.column.templateValueField]\n        : data[data.column.field]\n    \"></asol-value-currency>\n</ng-template>\n\n<ng-template #colorTemplate let-data>\n  <div class=\"d-flex center-item-v\">\n    <div\n      [ngStyle]=\"{\n        color: data.column.color ?? data[data.column.colorField] ?? '#212529'\n      }\">\n      {{\n        data.column.templateValueField\n          ? data[data.column.templateValueField]\n          : data[data.column.field]\n      }}\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #priorityTemplate let-data>\n  <asol-priority\n    [priority]=\"\n      data.column.templateValueField\n        ? data[data.column.templateValueField]\n        : data[data.column.field]\n    \">\n  </asol-priority>\n</ng-template>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.e-grid .e-groupdroparea{border-top-left-radius:4px;border-top-right-radius:4px}.e-grid .e-toolbar{display:none}.e-grid .e-headercell,.e-grid .e-row{height:32px}.e-grid .e-headertext{padding-top:.5rem;padding-bottom:.5rem;font-size:16px}.e-grid.e-default tr th.e-headercell:first-child:not(.e-firstcell):not(.e-headercell.e-frozen-left-border){border-top-left-radius:4px}.e-grid .e-gridheader tr th:first-child{border-top-left-radius:4px}.e-grid .e-gridheader tr th:last-child{border-top-right-radius:4px}.e-grid .e-gridpager{border-bottom-left-radius:4px;border-bottom-right-radius:4px;box-shadow:0 2px 2px #3232470f,0 2px 4px #3232470f}.single-selection.e-grid .e-gridheader .e-headercontent .e-columnheader .e-checkbox-wrapper{display:none}.e-bigger .e-grid.e-row-responsive .e-gridcontent .e-row,.e-bigger .e-grid.e-row-responsive .e-bigger.e-grid.e-row-responsive .e-gridcontent .e-row{height:100%!important}.e-bigger .e-grid.e-row-responsive .e-toolbar,.e-bigger .e-grid.e-row-responsive .e-gridpopup{display:none}.e-bigger .e-grid.e-row-responsive .e-table td:not(.e-hide){line-height:inherit;text-align:start!important}.e-bigger .e-grid.e-row-responsive .e-gridcontent td:before,.e-bigger .e-grid.e-row-responsive .e-gridcontent td:before{text-align:start}::-webkit-scrollbar{height:6px}::-webkit-scrollbar-thumb:horizontal{margin:.5rem 0;background:#7a869a;border-radius:4px;height:6px}.e-pager{height:40px;font-size:.75rem;padding:0}.asol-pager{height:40px}\n"], components: [{ type: i8.GridComponent, selector: "ejs-grid", inputs: ["aggregates", "allowExcelExport", "allowFiltering", "allowGrouping", "allowKeyboard", "allowMultiSorting", "allowPaging", "allowPdfExport", "allowReordering", "allowResizing", "allowRowDragAndDrop", "allowSelection", "allowSorting", "allowTextWrap", "childGrid", "clipMode", "columnChooserSettings", "columnMenuItems", "columnQueryMode", "columns", "contextMenuItems", "cssClass", "currencyCode", "currentAction", "dataSource", "detailTemplate", "editSettings", "ej2StatePersistenceVersion", "enableAdaptiveUI", "enableAltRow", "enableAutoFill", "enableColumnVirtualization", "enableHeaderFocus", "enableHover", "enableImmutableMode", "enableInfiniteScrolling", "enablePersistence", "enableRtl", "enableStickyHeader", "enableVirtualization", "filterSettings", "frozenColumns", "frozenRows", "gridLines", "groupSettings", "height", "hierarchyPrintMode", "infiniteScrollSettings", "locale", "pageSettings", "pagerTemplate", "parentDetails", "printMode", "query", "queryString", "resizeSettings", "rowDropSettings", "rowHeight", "rowRenderingMode", "rowTemplate", "searchSettings", "selectedRowIndex", "selectionSettings", "showColumnChooser", "showColumnMenu", "sortSettings", "textWrapSettings", "toolbar", "toolbarTemplate", "width"], outputs: ["actionBegin", "actionComplete", "actionFailure", "batchAdd", "batchCancel", "batchDelete", "beforeAutoFill", "beforeBatchAdd", "beforeBatchDelete", "beforeBatchSave", "beforeCopy", "beforeDataBound", "beforeExcelExport", "beforeOpenAdaptiveDialog", "beforeOpenColumnChooser", "beforePaste", "beforePdfExport", "beforePrint", "beginEdit", "cellDeselected", "cellDeselecting", "cellEdit", "cellSave", "cellSaved", "cellSelected", "cellSelecting", "checkBoxChange", "columnDataStateChange", "columnDeselected", "columnDeselecting", "columnDrag", "columnDragStart", "columnDrop", "columnMenuClick", "columnMenuOpen", "columnSelected", "columnSelecting", "commandClick", "contextMenuClick", "contextMenuOpen", "created", "dataBound", "dataSourceChanged", "dataStateChange", "destroyed", "detailDataBound", "excelAggregateQueryCellInfo", "excelExportComplete", "excelHeaderQueryCellInfo", "excelQueryCellInfo", "exportDetailDataBound", "exportGroupCaption", "headerCellInfo", "keyPressed", "lazyLoadGroupCollapse", "lazyLoadGroupExpand", "load", "pdfAggregateQueryCellInfo", "pdfExportComplete", "pdfHeaderQueryCellInfo", "pdfQueryCellInfo", "printComplete", "queryCellInfo", "recordClick", "recordDoubleClick", "resizeStart", "resizeStop", "resizing", "rowDataBound", "rowDeselected", "rowDeselecting", "rowDrag", "rowDragStart", "rowDragStartHelper", "rowDrop", "rowSelected", "rowSelecting", "toolbarClick", "dataSourceChange"] }, { type: AsolPagerComponent, selector: "asol-pager", inputs: ["syncId", "aggregateUri", "fixBottom", "pageSettings", "allowAggregates", "pagerData", "columnTranslation"], outputs: ["pageChanged", "pageSettignsChanged"] }, { type: AsolColumnChooserDialogComponent, selector: "asol-column-chooser-dialog", outputs: ["hide"] }, { type: AsolProgressBarComponent, selector: "asol-progress-bar", inputs: ["id", "type", "value", "maxValue", "label", "colors", "thickness", "trackColor", "labelStyle", "width", "height", "margin", "cssClass", "animation", "prefix", "suffix"] }, { type: AsolValueCurrencyComponent, selector: "asol-value-currency", inputs: ["data", "precision", "showSuccessColor"] }, { type: AsolPriorityComponent, selector: "asol-priority", inputs: ["priority"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-grid', providers: [GridStorageService], template: "<ng-container *ngIf=\"columnModel.length\">\n  <div\n    class=\"row\"\n    [ngClass]=\"{ 'e-bigger': isMobileResolution && !disableAdaptiveLayout }\">\n    <div [ngClass]=\"cssClass\" class=\"mb-7\">\n      <ejs-grid\n        #grid\n        [id]=\"id\"\n        [ngClass]=\"{ 'single-selection': singleSelection }\"\n        [dataSource]=\"data\"\n        [enableStickyHeader]=\"false\"\n        [enablePersistence]=\"false\"\n        [allowSorting]=\"allowSorting\"\n        [allowFiltering]=\"allowFiltering\"\n        [allowExcelExport]=\"allowExcelExport\"\n        [allowPdfExport]=\"allowPdfExport\"\n        [allowResizing]=\"allowResizing\"\n        [allowReordering]=\"allowReordering\"\n        [allowGrouping]=\"allowGrouping\"\n        [allowTextWrap]=\"allowTextWrap\"\n        [filterSettings]=\"filterOption\"\n        [groupSettings]=\"groupSettings\"\n        [sortSettings]=\"sortSettings\"\n        [columns]=\"columnModel\"\n        [showColumnChooser]=\"false\"\n        [width]=\"width\"\n        [height]=\"height\"\n        [enableAdaptiveUI]=\"!disableAdaptiveLayout\"\n        [rowRenderingMode]=\"rowRenderingMode\"\n        [allowPaging]=\"false\"\n        rowHeight=\"32\"\n        [selectionSettings]=\"selectionSettings\"\n        [selectedRowIndex]=\"selectedRowIndex\"\n        (dataStateChange)=\"reload($event)\"\n        (actionFailure)=\"onActionfailure($event)\"\n        (rowSelected)=\"rowSelection($event, true)\"\n        (rowSelecting)=\"rowSelecting()\"\n        (rowDeselected)=\"rowSelection($event, false)\"\n        (recordDoubleClick)=\"onRowDoubleClick($event)\"\n        (headerCellInfo)=\"onHeaderCellInfo($event)\"\n        (dataBound)=\"onDataBound()\"\n        (rowDataBound)=\"onRowDataBound($event)\"\n        (resizeStop)=\"store()\"\n        (columnDrop)=\"onDrop()\">\n      </ejs-grid>\n      <asol-pager\n        *ngIf=\"showPaging\"\n        #pager\n        [id]=\"id\"\n        [syncId]=\"syncId\"\n        [aggregateUri]=\"aggregateUri\"\n        [fixBottom]=\"fixPagerAtBottom\"\n        [columnTranslation]=\"columnTranslation\"\n        [pagerData]=\"pagerData\"\n        [allowAggregates]=\"allowAggregates\"\n        (pageChanged)=\"reloadAndStore()\"\n        (pageSettignsChanged)=\"reloadAndStore()\">\n        <ng-template #pagerTemplate>\n          <ng-container\n            *ngTemplateOutlet=\"\n              pagerGridTemplate;\n              context: { $implicit: pagerData }\n            \">\n          </ng-container>\n        </ng-template>\n      </asol-pager>\n    </div>\n  </div>\n</ng-container>\n\n<asol-column-chooser-dialog #chooser (hide)=\"onColumnChooserHide($event)\">\n</asol-column-chooser-dialog>\n\n<ng-template #progressTemplate let-data>\n  <div class=\"d-flex center-item-v row\">\n    <asol-progress-bar\n      width=\"{{ (data.column.width - 50).toString() + 'px' }} \"\n      suffix=\"%\"\n      type=\"frontLabel\"\n      [value]=\"\n        data.column.templateValueField\n          ? data[data.column.templateValueField]\n          : data[data.column.field]\n      \">\n    </asol-progress-bar>\n  </div>\n</ng-template>\n\n<ng-template #currencyTemplate let-data>\n  <asol-value-currency\n    [data]=\"\n      data.column.templateValueField\n        ? data[data.column.templateValueField]\n        : data[data.column.field]\n    \"></asol-value-currency>\n</ng-template>\n\n<ng-template #colorTemplate let-data>\n  <div class=\"d-flex center-item-v\">\n    <div\n      [ngStyle]=\"{\n        color: data.column.color ?? data[data.column.colorField] ?? '#212529'\n      }\">\n      {{\n        data.column.templateValueField\n          ? data[data.column.templateValueField]\n          : data[data.column.field]\n      }}\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #priorityTemplate let-data>\n  <asol-priority\n    [priority]=\"\n      data.column.templateValueField\n        ? data[data.column.templateValueField]\n        : data[data.column.field]\n    \">\n  </asol-priority>\n</ng-template>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.e-grid .e-groupdroparea{border-top-left-radius:4px;border-top-right-radius:4px}.e-grid .e-toolbar{display:none}.e-grid .e-headercell,.e-grid .e-row{height:32px}.e-grid .e-headertext{padding-top:.5rem;padding-bottom:.5rem;font-size:16px}.e-grid.e-default tr th.e-headercell:first-child:not(.e-firstcell):not(.e-headercell.e-frozen-left-border){border-top-left-radius:4px}.e-grid .e-gridheader tr th:first-child{border-top-left-radius:4px}.e-grid .e-gridheader tr th:last-child{border-top-right-radius:4px}.e-grid .e-gridpager{border-bottom-left-radius:4px;border-bottom-right-radius:4px;box-shadow:0 2px 2px #3232470f,0 2px 4px #3232470f}.single-selection.e-grid .e-gridheader .e-headercontent .e-columnheader .e-checkbox-wrapper{display:none}.e-bigger .e-grid.e-row-responsive .e-gridcontent .e-row,.e-bigger .e-grid.e-row-responsive .e-bigger.e-grid.e-row-responsive .e-gridcontent .e-row{height:100%!important}.e-bigger .e-grid.e-row-responsive .e-toolbar,.e-bigger .e-grid.e-row-responsive .e-gridpopup{display:none}.e-bigger .e-grid.e-row-responsive .e-table td:not(.e-hide){line-height:inherit;text-align:start!important}.e-bigger .e-grid.e-row-responsive .e-gridcontent td:before,.e-bigger .e-grid.e-row-responsive .e-gridcontent td:before{text-align:start}::-webkit-scrollbar{height:6px}::-webkit-scrollbar-thumb:horizontal{margin:.5rem 0;background:#7a869a;border-radius:4px;height:6px}.e-pager{height:40px;font-size:.75rem;padding:0}.asol-pager{height:40px}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: NotificationService }, { type: i0.ChangeDetectorRef }, { type: i1.AsolMediaQueryService }, { type: PageColumnsService }, { type: FilterSyncService }, { type: GridStorageService }, { type: SpinnerService }, { type: ToolbarService, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { syncId: [{
                type: Input
            }], aggregateUri: [{
                type: Input
            }], entityId: [{
                type: Input
            }], additionalSearchParams: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], data: [{
                type: Input
            }], id: [{
                type: Input
            }], checkboxDisableField: [{
                type: Input
            }], datasource: [{
                type: Input
            }], allowAggregates: [{
                type: Input
            }], allowFiltering: [{
                type: Input
            }], allowResizing: [{
                type: Input
            }], allowGrouping: [{
                type: Input
            }], allowReordering: [{
                type: Input
            }], allowSorting: [{
                type: Input
            }], allowExcelExport: [{
                type: Input
            }], allowPdfExport: [{
                type: Input
            }], showPaging: [{
                type: Input
            }], allowTextWrap: [{
                type: Input
            }], fixPagerAtBottom: [{
                type: Input
            }], enablePersistance: [{
                type: Input
            }], initialDataLoad: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], filterOption: [{
                type: Input
            }], groupSettings: [{
                type: Input
            }], selectionSettings: [{
                type: Input
            }], gridProperties: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }], useGlobalSpinner: [{
                type: Input
            }], rowRenderingMode: [{
                type: Input
            }], disableAdaptiveLayout: [{
                type: Input
            }], exportParams: [{
                type: Input
            }], selectedRowIndex: [{
                type: Input
            }], singleSelection: [{
                type: Input
            }], rowSelected: [{
                type: Output
            }], rowDoubleClick: [{
                type: Output
            }], dataStateChanged: [{
                type: Output
            }], removeItems: [{
                type: Output
            }], settingsParsed: [{
                type: Output
            }], databound: [{
                type: Output
            }], rowDatabound: [{
                type: Output
            }], grid: [{
                type: ViewChild,
                args: ['grid']
            }], chooserDialog: [{
                type: ViewChild,
                args: ['chooser']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        progressTemplate: [{
                type: ViewChild,
                args: ['progressTemplate']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        currencyTemplate: [{
                type: ViewChild,
                args: ['currencyTemplate']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        colorTemplate: [{
                type: ViewChild,
                args: ['colorTemplate']
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        priorityTemplate: [{
                type: ViewChild,
                args: ['priorityTemplate']
            }], pager: [{
                type: ViewChild,
                args: ['pager']
            }], pagerGridTemplate: [{
                type: ContentChild,
                args: ['pagerTemplate']
            }], pagerData: [{
                type: Input
            }], childColumns: [{
                type: ContentChildren,
                args: [AsolDataColumnDirective]
            }] } });

class AsolGridModule {
}
AsolGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridModule, declarations: [AsolGridComponent], imports: [SharedModule,
        GridModule,
        AsolNumberFieldModule,
        AsolSelectFieldModule,
        AsolButtonModule,
        AsolDataColumnModule,
        AsolColumnChooserDialogModule,
        AsolProgressBarModule,
        AsolValueCurrencyModule,
        DatePickerModule,
        PipesModule,
        AsolPriorityModule,
        AsolAggregateModule,
        AsolPagerModule], exports: [AsolGridComponent] });
AsolGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridModule, providers: [
        PageService,
        ResizeService$1,
        SortService,
        FilterService,
        GroupService,
        ColumnChooserService,
        ReorderService,
        ExcelExportService,
        SelectionService,
        AggregateService$1,
    ], imports: [[
            SharedModule,
            GridModule,
            AsolNumberFieldModule,
            AsolSelectFieldModule,
            AsolButtonModule,
            AsolDataColumnModule,
            AsolColumnChooserDialogModule,
            AsolProgressBarModule,
            AsolValueCurrencyModule,
            DatePickerModule,
            PipesModule,
            AsolPriorityModule,
            AsolAggregateModule,
            AsolPagerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolGridModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolGridComponent],
                    exports: [AsolGridComponent],
                    imports: [
                        SharedModule,
                        GridModule,
                        AsolNumberFieldModule,
                        AsolSelectFieldModule,
                        AsolButtonModule,
                        AsolDataColumnModule,
                        AsolColumnChooserDialogModule,
                        AsolProgressBarModule,
                        AsolValueCurrencyModule,
                        DatePickerModule,
                        PipesModule,
                        AsolPriorityModule,
                        AsolAggregateModule,
                        AsolPagerModule,
                    ],
                    providers: [
                        PageService,
                        ResizeService$1,
                        SortService,
                        FilterService,
                        GroupService,
                        ColumnChooserService,
                        ReorderService,
                        ExcelExportService,
                        SelectionService,
                        AggregateService$1,
                    ],
                }]
        }] });

const INFO_PANEL_CONSTANT = {
    TRANS: 'ASOL-INFO-PANEL-TRANS',
};

var translation$c = {
    "sk-SK": {
        ShowMore: "Zobraziť viac",
        DisableShow: "Už nezobrazovať"
    },
    "cs-CZ": {
        ShowMore: "Zobrazit více",
        DisableShow: "Již nezobrazovat"
    },
    "en-US": {
        ShowMore: "Show more",
        DisableShow: "Don't show anymore"
    }
};

class AsolInfoPanelComponent {
    constructor(router, trans) {
        this.router = router;
        this.trans = trans;
        /**
         * sets info panel types
         * @default info
         */
        this.type = 'info';
        /**
         * display button: show more
         * @default false
         */
        this.showMoreButton = false;
        /**
         * display button: don't show anymore
         * @default false
         */
        this.showAnymoreButton = false;
        /**
         * display close button
         * @default false
         */
        this.showCloseButton = false;
        /** Additional css class style */
        this.cssClass = '';
        /**
         * displays the info panel
         * @default true
         */
        this.showInfoPanel = true;
        this.ICONS = ICONS;
        this.INFO_PANEL_CONSTANT = INFO_PANEL_CONSTANT;
        /**
         * map types and assign icons to them
         */
        this.map = new Map([
            ['danger', ICONS.DANGER],
            ['success', ICONS.SUCCESS],
            ['warning', ICONS.WARNING],
            ['info', ICONS.INFO],
        ]);
        this.trans.initialize(INFO_PANEL_CONSTANT.TRANS, translation$c);
    }
    /**
     * redirects the user to the custom url
     */
    showMore() {
        this.router.navigate([this.url]);
    }
    /**
     * info panel will never be displayed again
     */
    disableShow() {
        // console.log('disable show');
    }
    /**
     * after clicking on the close button, the info panel will be close
     */
    hideInfoPanel() {
        this.showInfoPanel = false;
    }
}
AsolInfoPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelComponent, deps: [{ token: i1$3.Router }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolInfoPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolInfoPanelComponent, selector: "asol-info-panel", inputs: { type: "type", text: "text", showMoreButton: "showMoreButton", url: "url", showAnymoreButton: "showAnymoreButton", showCloseButton: "showCloseButton", cssClass: "cssClass", showInfoPanel: "showInfoPanel" }, ngImport: i0, template: "<div\n  *ngIf=\"showInfoPanel\"\n  class=\"info-panel w-100 position-relative px-3 d-flex align-items-center justify-content-between\"\n  ngClass=\"info-panel-{{ type }}\"\n  [class]=\"cssClass\">\n  <div class=\"d-flex align-items-center\">\n    <svg-icon\n      class=\"d-flex align-items-start me-2\"\n      [src]=\"map.get(type)\"></svg-icon>\n    <span>{{ text }}</span>\n  </div>\n  <div class=\"d-flex align-items-center\">\n    <asol-button\n      *ngIf=\"showMoreButton\"\n      type=\"flat\"\n      color=\"dark\"\n      (click)=\"showMore()\">\n      {{ trans.get(INFO_PANEL_CONSTANT.TRANS, 'ShowMore') }}\n    </asol-button>\n    <asol-button\n      *ngIf=\"showAnymoreButton\"\n      type=\"flat\"\n      color=\"dark\"\n      (click)=\"disableShow()\">\n      {{ trans.get(INFO_PANEL_CONSTANT.TRANS, 'DisableShow') }}\n    </asol-button>\n    <svg-icon\n      *ngIf=\"showCloseButton\"\n      (click)=\"hideInfoPanel()\"\n      class=\"close d-flex align-items-center\"\n      [src]=\"ICONS.CLOSE\"></svg-icon>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.info-panel{color:#091e42;height:2.5rem}.info-panel .close svg{height:1.3rem;width:1.3rem}.info-panel .close svg path{fill:#091e42!important;stroke-width:0!important}.info-panel.info-panel-success{background:#e3fcef}.info-panel.info-panel-danger{background:#ffebe6}.info-panel.info-panel-warning{background:#fffae6}.info-panel.info-panel-info{background:#deebff}\n"], components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-info-panel', template: "<div\n  *ngIf=\"showInfoPanel\"\n  class=\"info-panel w-100 position-relative px-3 d-flex align-items-center justify-content-between\"\n  ngClass=\"info-panel-{{ type }}\"\n  [class]=\"cssClass\">\n  <div class=\"d-flex align-items-center\">\n    <svg-icon\n      class=\"d-flex align-items-start me-2\"\n      [src]=\"map.get(type)\"></svg-icon>\n    <span>{{ text }}</span>\n  </div>\n  <div class=\"d-flex align-items-center\">\n    <asol-button\n      *ngIf=\"showMoreButton\"\n      type=\"flat\"\n      color=\"dark\"\n      (click)=\"showMore()\">\n      {{ trans.get(INFO_PANEL_CONSTANT.TRANS, 'ShowMore') }}\n    </asol-button>\n    <asol-button\n      *ngIf=\"showAnymoreButton\"\n      type=\"flat\"\n      color=\"dark\"\n      (click)=\"disableShow()\">\n      {{ trans.get(INFO_PANEL_CONSTANT.TRANS, 'DisableShow') }}\n    </asol-button>\n    <svg-icon\n      *ngIf=\"showCloseButton\"\n      (click)=\"hideInfoPanel()\"\n      class=\"close d-flex align-items-center\"\n      [src]=\"ICONS.CLOSE\"></svg-icon>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.info-panel{color:#091e42;height:2.5rem}.info-panel .close svg{height:1.3rem;width:1.3rem}.info-panel .close svg path{fill:#091e42!important;stroke-width:0!important}.info-panel.info-panel-success{background:#e3fcef}.info-panel.info-panel-danger{background:#ffebe6}.info-panel.info-panel-warning{background:#fffae6}.info-panel.info-panel-info{background:#deebff}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.Router }, { type: i1.TranslationService }]; }, propDecorators: { type: [{
                type: Input
            }], text: [{
                type: Input
            }], showMoreButton: [{
                type: Input
            }], url: [{
                type: Input
            }], showAnymoreButton: [{
                type: Input
            }], showCloseButton: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], showInfoPanel: [{
                type: Input
            }] } });

class AsolInfoPanelModule {
}
AsolInfoPanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolInfoPanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelModule, declarations: [AsolInfoPanelComponent], imports: [SharedModule, AsolButtonModule], exports: [AsolInfoPanelComponent] });
AsolInfoPanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelModule, imports: [[SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInfoPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolInfoPanelComponent],
                    exports: [AsolInfoPanelComponent],
                    imports: [SharedModule, AsolButtonModule],
                }]
        }] });

var translation$b = {
    "sk-SK": {
        duplicate: "Duplikovať",
        edit: "Zmeniť",
        "delete": "Vymazať",
        "export": "Exportovať",
        grid: "Zobrazenie do gridu",
        card: "Zobrazenie do card",
        chooser: "Výber stlpcov",
        "single-edit": "Editácia",
        refresh: "Refresh",
        aggregate: "Aggregovať",
        reset: "Reset"
    },
    "cs-CZ": {
        duplicate: "Duplikovat",
        edit: "Změnit",
        "delete": "Smazat",
        "export": "Export",
        grid: "Zobrazení do gridu",
        card: "Zobrazení do card",
        chooser: "Výběr sloupců",
        "single-edit": "Editace",
        refresh: "Refresh",
        aggregate: "Aggregovat",
        reset: "Reset"
    },
    "en-US": {
        duplicate: "Duplicate",
        edit: "Edit",
        "delete": "Delete",
        "export": "Export",
        grid: "Show as grid",
        card: "Show as card",
        chooser: "Column chooser",
        "single-edit": "Editácia",
        refresh: "Refresh",
        aggregate: "Aggregate",
        reset: "Reset"
    }
};

const TOOLBAR_CONST = {
    TRANS: 'asol-toolbar',
};

/**
 * Configuration for default toolbar items
 */
const DEFAULT_CONFIG = [
    {
        icon: ICONS.DUPLICATE,
        tooltip: 'duplicate',
        type: 'duplicate',
    },
    {
        icon: ICONS.EDIT,
        tooltip: 'edit',
        type: 'edit',
    },
    {
        icon: ICONS.TRASH,
        tooltip: 'delete',
        type: 'delete',
    },
    {
        icon: ICONS.UPLOAD_01,
        tooltip: 'export',
        type: 'export',
    },
    {
        icon: ICONS.GRID,
        tooltip: 'grid',
        type: 'grid',
    },
    {
        icon: ICONS.CARD,
        tooltip: 'card',
        type: 'card',
    },
    {
        icon: ICONS.EDIT2,
        tooltip: 'chooser',
        type: 'chooser',
    },
    {
        icon: ICONS.EDIT_05,
        tooltip: 'single-edit',
        type: 'single-edit',
    },
    {
        icon: ICONS.REFRESH_CW_02,
        tooltip: 'refresh',
        type: 'refresh',
    },
    {
        icon: ICONS.FILE_PLUS_02,
        tooltip: 'aggregate',
        iconPosition: 'left',
        type: 'aggregate',
    },
    {
        icon: ICONS.X_SQUARE,
        tooltip: 'reset',
        iconPosition: 'right',
        type: 'reset',
    },
];

class ToolbarItemDirective {
    constructor(trans) {
        this.trans = trans;
        /**
         * Defines position of toolbar item
         * @dfault left
         */
        this.position = 'left';
        /**
         * Defines disabled state
         * @default false
         */
        this.disabled = false;
        /** Defines button type */
        this.buttonType = 'flat';
        /** Defines tooltip for button */
        this.tooltip = '';
        /** Defines if toolbar item is visible */
        this.visible = true;
        /** Defines if toolbar items is active (has background color) */
        this.active = false;
        /** Defines if toolbar item can be active */
        this.canBeActive = false;
        /**
         * Defines if default tooltip item style should be removed,
         * e.g. by using asol button to not override asol buttons styles
         * */
        this.removeDefaultStyle = false;
        /** Defines group of toolbar items, active state is available in group */
        this.group = null;
        /** Defines data provider for item type select */
        this.dataProvider = null;
        /** Defines default data for item type select */
        this.data = undefined;
        this.trans.initialize(TOOLBAR_CONST.TRANS, translation$b);
    }
    /** Gets item type based on filled data */
    get getType() {
        if (this.type === 'select') {
            return 'select';
        }
        if (this.text) {
            return 'text';
        }
        if (this.template) {
            return 'template';
        }
        return 'icon';
    }
    ngOnChanges(changes) {
        if (changes.type) {
            this.parseItemOnType();
        }
    }
    /**
     * Parses type and adds default icon and tooltip
     */
    parseItemOnType() {
        const toolbar = DEFAULT_CONFIG.find((p) => p.type === this.type);
        if (!toolbar) {
            return;
        }
        if (this.type === 'chooser') {
            this.text = this.trans.get(TOOLBAR_CONST.TRANS, 'chooser');
        }
        if (this.type === 'aggregate') {
            this.text = this.trans.get(TOOLBAR_CONST.TRANS, 'aggregate');
        }
        if (this.type === 'reset') {
            this.text = this.trans.get(TOOLBAR_CONST.TRANS, 'reset');
        }
        if (!this.icon && toolbar.icon) {
            this.icon = toolbar.icon;
        }
        this.iconPosition = toolbar.iconPosition;
        if (!this.tooltip && toolbar.tooltip) {
            this.tooltip = this.trans.get(TOOLBAR_CONST.TRANS, toolbar.tooltip);
        }
    }
}
ToolbarItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarItemDirective, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Directive });
ToolbarItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ToolbarItemDirective, selector: "asol-toolbar>asol-item", inputs: { id: "id", type: "type", position: "position", icon: "icon", iconPosition: "iconPosition", color: "color", disabled: "disabled", text: "text", buttonType: "buttonType", tooltip: "tooltip", visible: "visible", active: "active", canBeActive: "canBeActive", removeDefaultStyle: "removeDefaultStyle", group: "group", dataProvider: "dataProvider", data: "data" }, queries: [{ propertyName: "template", first: true, predicate: ["template"], descendants: true }], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'asol-toolbar>asol-item',
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { id: [{
                type: Input
            }], type: [{
                type: Input
            }], position: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], color: [{
                type: Input
            }], disabled: [{
                type: Input
            }], text: [{
                type: Input
            }], buttonType: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], visible: [{
                type: Input
            }], active: [{
                type: Input
            }], canBeActive: [{
                type: Input
            }], removeDefaultStyle: [{
                type: Input
            }], group: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], data: [{
                type: Input
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        template: [{
                type: ContentChild,
                args: ['template']
            }] } });

/**
 * Filtering pipe used to filter toolbar items based on position
 */
class ToolbarFilterPipe {
    transform(items, position) {
        var _a;
        if (!items || !items.length || !position) {
            return items;
        }
        return (_a = items.filter((p) => p.position === position && p.visible)) !== null && _a !== void 0 ? _a : [];
    }
}
ToolbarFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ToolbarFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarFilterPipe, name: "toolbarFilter", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToolbarFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toolbarFilter',
                    pure: false,
                }]
        }] });

class AsolToolbarComponent {
    constructor(toolbarService, trans) {
        this.toolbarService = toolbarService;
        this.trans = trans;
        /** Synchronization identifier */
        this.syncId = null;
        /** CSS class */
        this.cssClass = '';
        /** Emits type or text when user clicks on toolbar icon */
        this.itemClick = new EventEmitter();
        /** Defines toolbar items in HTML */
        this.toolbarItems = [];
        this.ICONS = ICONS;
    }
    ngOnInit() {
        this.toolbarService.toolbarChanged$.subscribe((item) => {
            if (item.syncId !== this.syncId) {
                return;
            }
            this.parseChange(item.change);
        });
    }
    /**
     * Event handler after user clicks on toolbar
     * @param item Clicked toolbar item
     */
    onToolbarClick(item) {
        if (item.disabled || !this.syncId) {
            return;
        }
        const message = item.type ? item.type : item.text;
        this.itemClick.emit(message);
        this.toolbarService.clicked(this.syncId, message);
    }
    /**
     * Event handler after user changes value on toolbar
     * @param item Changed toolbar item
     */
    onToolbarChanged(data, item) {
        if (item.disabled || !this.syncId) {
            return;
        }
        this.toolbarService.changed(this.syncId, {
            type: ['select'],
            active: true,
            data: data,
        });
    }
    /**
     * Disable tooltip if not content provided
     * @param args Tooltip arguments
     * @param tooltip Tooltip text to show
     */
    onBeforeOpen(args, tooltip) {
        if (!tooltip) {
            args.cancel = true;
        }
    }
    /**
     * Parses request for toolbar change
     * @param changed Requested change
     */
    parseChange(changed) {
        changed.type.forEach((type) => {
            const toolbar = this.toolbarItems.find((p) => p.type === type || p.text === type);
            if (!toolbar) {
                return;
            }
            if (changed.disabled !== undefined) {
                toolbar.disabled = changed.disabled;
            }
            if (changed.visible !== undefined) {
                toolbar.visible = changed.visible;
            }
            if (changed.active !== undefined) {
                let group = null;
                if (toolbar.group) {
                    group = toolbar.group;
                }
                this.toolbarItems
                    .filter((p) => p.group === group)
                    .forEach((item) => {
                    item.active = false;
                });
                toolbar.active = changed.active;
            }
        });
    }
}
AsolToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarComponent, deps: [{ token: ToolbarService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolToolbarComponent, selector: "asol-toolbar", inputs: { syncId: "syncId", cssClass: "cssClass" }, outputs: { itemClick: "itemClick" }, queries: [{ propertyName: "toolbarItems", predicate: ToolbarItemDirective }], ngImport: i0, template: "<div class=\"my-2 d-flex justify-content-between\" [ngClass]=\"cssClass\">\n  <div class=\"center-item-v\">\n    <ng-container\n      *ngFor=\"let item of toolbarItems | toolbarFilter: 'left'\"\n      [ngTemplateOutlet]=\"toolbarItemTemplate\"\n      [ngTemplateOutletContext]=\"{ $implicit: item }\">\n    </ng-container>\n  </div>\n  <div class=\"center-item-v\">\n    <ng-container\n      *ngFor=\"let item of toolbarItems | toolbarFilter: 'right'\"\n      [ngTemplateOutlet]=\"toolbarItemTemplate\"\n      [ngTemplateOutletContext]=\"{ $implicit: item }\">\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #toolbarItemTemplate let-item>\n  <span [ngSwitch]=\"item.getType\" class=\"me-2\">\n    <ejs-tooltip\n      target=\".toolbar-item\"\n      [windowCollision]=\"false\"\n      (beforeOpen)=\"onBeforeOpen($event, item.tooltip)\">\n      <asol-icon-button\n        *ngSwitchCase=\"'icon'\"\n        class=\"toolbar-item tooltip-target\"\n        color=\"dark\"\n        [id]=\"item.id\"\n        [title]=\"item.tooltip\"\n        [iconSvgUrl]=\"item.icon\"\n        [disabled]=\"item.disabled\"\n        [active]=\"item.canBeActive && item.active\"\n        (click)=\"onToolbarClick(item)\"\n        [type]=\"item.buttonType\">\n      </asol-icon-button>\n      <asol-button\n        *ngSwitchCase=\"'text'\"\n        [iconSvgUrl]=\"item.icon\"\n        (click)=\"onToolbarClick(item)\"\n        [iconPosition]=\"item.iconPosition ?? 'right'\"\n        [id]=\"item.id\"\n        [type]=\"item.buttonType\"\n        [color]=\"item.color ?? 'dark'\"\n        [title]=\"item.tooltip\"\n        [disabled]=\"item.disabled\"\n        [active]=\"item.canBeActive && item.active\"\n        class=\"toolbar-item tooltip-target\">\n        {{ item.text }}\n      </asol-button>\n      <asol-select-field\n        *ngSwitchCase=\"'select'\"\n        [dataProvider]=\"item.dataProvider\"\n        [showClearButton]=\"true\"\n        [showError]=\"false\"\n        [allowCustom]=\"false\"\n        [(ngModel)]=\"item.data\"\n        (ngModelChange)=\"onToolbarChanged($event, item)\"\n        [placeholderText]=\"item.text\">\n      </asol-select-field>\n      <span\n        [title]=\"item.tooltip\"\n        [ngClass]=\"{ 'toolbar-item': !item.removeDefaultStyle }\"\n        class=\"tooltip-target\">\n        <ng-container\n          *ngSwitchCase=\"'template'\"\n          [ngTemplateOutlet]=\"item.template\">\n        </ng-container>\n      </span>\n    </ejs-tooltip>\n  </span>\n</ng-template>\n", styles: [".toolbar-item ::ng-deep .e-btn.asol-icon{height:32px!important;width:32px!important;min-width:auto;min-height:auto;padding:0!important}.toolbar-item ::ng-deep .e-btn.e-flat{padding-left:0!important;padding-right:0!important}\n"], components: [{ type: i2$2.TooltipComponent, selector: "ejs-tooltip", inputs: ["animation", "closeDelay", "container", "content", "cssClass", "enableHtmlParse", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "height", "isSticky", "locale", "mouseTrail", "offsetX", "offsetY", "openDelay", "opensOn", "position", "showTipPointer", "target", "tipPointerPosition", "width", "windowCollision"], outputs: ["afterClose", "afterOpen", "beforeClose", "beforeCollision", "beforeOpen", "beforeRender", "created", "destroyed"] }, { type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i6.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "toolbarFilter": ToolbarFilterPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-toolbar', template: "<div class=\"my-2 d-flex justify-content-between\" [ngClass]=\"cssClass\">\n  <div class=\"center-item-v\">\n    <ng-container\n      *ngFor=\"let item of toolbarItems | toolbarFilter: 'left'\"\n      [ngTemplateOutlet]=\"toolbarItemTemplate\"\n      [ngTemplateOutletContext]=\"{ $implicit: item }\">\n    </ng-container>\n  </div>\n  <div class=\"center-item-v\">\n    <ng-container\n      *ngFor=\"let item of toolbarItems | toolbarFilter: 'right'\"\n      [ngTemplateOutlet]=\"toolbarItemTemplate\"\n      [ngTemplateOutletContext]=\"{ $implicit: item }\">\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #toolbarItemTemplate let-item>\n  <span [ngSwitch]=\"item.getType\" class=\"me-2\">\n    <ejs-tooltip\n      target=\".toolbar-item\"\n      [windowCollision]=\"false\"\n      (beforeOpen)=\"onBeforeOpen($event, item.tooltip)\">\n      <asol-icon-button\n        *ngSwitchCase=\"'icon'\"\n        class=\"toolbar-item tooltip-target\"\n        color=\"dark\"\n        [id]=\"item.id\"\n        [title]=\"item.tooltip\"\n        [iconSvgUrl]=\"item.icon\"\n        [disabled]=\"item.disabled\"\n        [active]=\"item.canBeActive && item.active\"\n        (click)=\"onToolbarClick(item)\"\n        [type]=\"item.buttonType\">\n      </asol-icon-button>\n      <asol-button\n        *ngSwitchCase=\"'text'\"\n        [iconSvgUrl]=\"item.icon\"\n        (click)=\"onToolbarClick(item)\"\n        [iconPosition]=\"item.iconPosition ?? 'right'\"\n        [id]=\"item.id\"\n        [type]=\"item.buttonType\"\n        [color]=\"item.color ?? 'dark'\"\n        [title]=\"item.tooltip\"\n        [disabled]=\"item.disabled\"\n        [active]=\"item.canBeActive && item.active\"\n        class=\"toolbar-item tooltip-target\">\n        {{ item.text }}\n      </asol-button>\n      <asol-select-field\n        *ngSwitchCase=\"'select'\"\n        [dataProvider]=\"item.dataProvider\"\n        [showClearButton]=\"true\"\n        [showError]=\"false\"\n        [allowCustom]=\"false\"\n        [(ngModel)]=\"item.data\"\n        (ngModelChange)=\"onToolbarChanged($event, item)\"\n        [placeholderText]=\"item.text\">\n      </asol-select-field>\n      <span\n        [title]=\"item.tooltip\"\n        [ngClass]=\"{ 'toolbar-item': !item.removeDefaultStyle }\"\n        class=\"tooltip-target\">\n        <ng-container\n          *ngSwitchCase=\"'template'\"\n          [ngTemplateOutlet]=\"item.template\">\n        </ng-container>\n      </span>\n    </ejs-tooltip>\n  </span>\n</ng-template>\n", styles: [".toolbar-item ::ng-deep .e-btn.asol-icon{height:32px!important;width:32px!important;min-width:auto;min-height:auto;padding:0!important}.toolbar-item ::ng-deep .e-btn.e-flat{padding-left:0!important;padding-right:0!important}\n"] }]
        }], ctorParameters: function () { return [{ type: ToolbarService }, { type: i1.TranslationService }]; }, propDecorators: { syncId: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], itemClick: [{
                type: Output
            }], toolbarItems: [{
                type: ContentChildren,
                args: [ToolbarItemDirective]
            }] } });

class AsolToolbarModule {
}
AsolToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarModule, declarations: [AsolToolbarComponent, ToolbarItemDirective, ToolbarFilterPipe], imports: [SharedModule,
        AsolButtonModule,
        TooltipModule,
        AsolSelectFieldModule], exports: [AsolToolbarComponent, ToolbarItemDirective] });
AsolToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarModule, imports: [[
            SharedModule,
            AsolButtonModule,
            TooltipModule,
            AsolSelectFieldModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolToolbarComponent, ToolbarItemDirective, ToolbarFilterPipe],
                    exports: [AsolToolbarComponent, ToolbarItemDirective],
                    imports: [
                        SharedModule,
                        AsolButtonModule,
                        TooltipModule,
                        AsolSelectFieldModule,
                    ],
                }]
        }] });

class AsolDatePickerComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        this.max = new Date(2099, 11, 31);
        this.min = new Date(1900, 0, 1);
        this.openOnFocus = false;
        this.showClearButton = true;
        this.showTodayButton = true;
        this.start = 'Month';
        this.weekNumber = false;
        this.firstDay = 1;
        this.input = null;
        this.format = this.trans.getDateFormatForLocale();
    }
    /**
     * Override for base lcoalize after language change
     */
    localizeTexts() {
        super.localizeTexts();
        this.format = this.trans.getDateFormatForLocale();
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.value;
    }
    setControlValue(val) {
        if (!this.input) {
            return;
        }
        if (typeof val === 'string') {
            val = new Date(val);
        }
        this.input.value = val;
    }
    setControlDisabled(isDisable) {
        // not needed
    }
    callOnChange(event) {
        if (event.isInteracted) {
            this.onChange(event.value);
            this.valueChangedDebouncer.next(event.value);
        }
    }
}
AsolDatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolDatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolDatePickerComponent, selector: "asol-date-picker", inputs: { max: "max", min: "min", openOnFocus: "openOnFocus", showClearButton: "showClearButton", showTodayButton: "showTodayButton", start: "start", weekNumber: "weekNumber", format: "format" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["datePicker"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-datepicker\n    #datePicker\n    [id]=\"id ?? 'datepickerelement'\"\n    [enabled]=\"!isDisabled\"\n    class=\"asol-datepicker\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [openOnFocus]=\"openOnFocus\"\n    [placeholder]=\"placeholderText\"\n    [firstDayOfWeek]=\"firstDay\"\n    [readonly]=\"isReadonly\"\n    [format]=\"format\"\n    [showClearButton]=\"showClearButton\"\n    [showTodayButton]=\"showTodayButton\"\n    [start]=\"start\"\n    [width]=\"width\"\n    [weekNumber]=\"weekNumber\"\n    (change)=\"callOnChange($event)\">\n  </ejs-datepicker>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$4.DatePickerComponent, selector: "ejs-datepicker", inputs: ["allowEdit", "calendarMode", "cssClass", "dayHeaderFormat", "depth", "enableMask", "enablePersistence", "enableRtl", "enabled", "firstDayOfWeek", "floatLabelType", "format", "htmlAttributes", "isMultiSelection", "keyConfigs", "locale", "maskPlaceholder", "max", "min", "openOnFocus", "placeholder", "readonly", "serverTimezoneOffset", "showClearButton", "showTodayButton", "start", "strictMode", "value", "values", "weekNumber", "weekRule", "width", "zIndex"], outputs: ["blur", "change", "cleared", "close", "created", "destroyed", "focus", "navigated", "open", "renderDayCell", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-date-picker', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-datepicker\n    #datePicker\n    [id]=\"id ?? 'datepickerelement'\"\n    [enabled]=\"!isDisabled\"\n    class=\"asol-datepicker\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [openOnFocus]=\"openOnFocus\"\n    [placeholder]=\"placeholderText\"\n    [firstDayOfWeek]=\"firstDay\"\n    [readonly]=\"isReadonly\"\n    [format]=\"format\"\n    [showClearButton]=\"showClearButton\"\n    [showTodayButton]=\"showTodayButton\"\n    [start]=\"start\"\n    [width]=\"width\"\n    [weekNumber]=\"weekNumber\"\n    (change)=\"callOnChange($event)\">\n  </ejs-datepicker>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { max: [{
                type: Input
            }], min: [{
                type: Input
            }], openOnFocus: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], showTodayButton: [{
                type: Input
            }], start: [{
                type: Input
            }], weekNumber: [{
                type: Input
            }], format: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['datePicker']
            }] } });

class AsolDatePickerModule {
}
AsolDatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolDatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerModule, declarations: [AsolDatePickerComponent], imports: [SharedModule, AsolLabelFieldModule, DatePickerModule], exports: [AsolDatePickerComponent] });
AsolDatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerModule, imports: [[SharedModule, AsolLabelFieldModule, DatePickerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolDatePickerComponent],
                    exports: [AsolDatePickerComponent],
                    imports: [SharedModule, AsolLabelFieldModule, DatePickerModule],
                }]
        }] });

const ITEMS_LIST_CONSTANT = {
    TRANS: 'asol-items-list-trans',
    SPLIT: 'split',
    DUPLICATE: 'duplicate',
    DELETE: 'delete',
};

class AsolInvoicingDateDialogComponent {
    constructor(trans, fb) {
        this.trans = trans;
        this.fb = fb;
        this.ITEMS_LIST_CONSTANT = ITEMS_LIST_CONSTANT;
        this.ICONS = ICONS;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Confirm',
            },
        ];
        /** Emits new invoicing date when dialog closes */
        this.hide = new EventEmitter();
        this.formGroup = this.fb.group({
            invoiceDate: [new Date()],
            allItems: [false],
        });
    }
    /**
     * Shows dialog
     */
    showDialog() {
        this.dialog.show();
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        if (type === 'Confirm') {
            this.hide.emit(Object.assign({}, this.formGroup.value));
            this.formGroup.reset();
        }
        this.dialog.hide();
    }
}
AsolInvoicingDateDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInvoicingDateDialogComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolInvoicingDateDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolInvoicingDateDialogComponent, selector: "asol-invoicing-date-dialog", outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"600px\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate') }}\"\n  buttonPosition=\"start\"\n  [defaultPaddings]=\"false\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\">\n    <div class=\"w-100\">\n      <asol-date-picker\n        formControlName=\"invoiceDate\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        labelKey=\"invoiceDate\">\n      </asol-date-picker>\n    </div>\n    <asol-checkbox\n      formControlName=\"allItems\"\n      labelKey=\"allItemsDateChange\"\n      [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\">\n    </asol-checkbox>\n  </form>\n</asol-dialog>\n", components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolDatePickerComponent, selector: "asol-date-picker", inputs: ["max", "min", "openOnFocus", "showClearButton", "showTodayButton", "start", "weekNumber", "format"] }, { type: AsolCheckboxComponent, selector: "asol-checkbox", inputs: ["indeterminate", "labelPosition"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolInvoicingDateDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-invoicing-date-dialog', template: "<asol-dialog\n  #dialog\n  width=\"600px\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate') }}\"\n  buttonPosition=\"start\"\n  [defaultPaddings]=\"false\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\">\n    <div class=\"w-100\">\n      <asol-date-picker\n        formControlName=\"invoiceDate\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        labelKey=\"invoiceDate\">\n      </asol-date-picker>\n    </div>\n    <asol-checkbox\n      formControlName=\"allItems\"\n      labelKey=\"allItemsDateChange\"\n      [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\">\n    </asol-checkbox>\n  </form>\n</asol-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }]; }, propDecorators: { hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

var translation$a = {
    "sk-SK": {
        itemName: "Meno položky",
        count: "Počet",
        addItem: "Pridať položku",
        priceNoVat: "Jednotková cena bez DPH",
        itemType: "Typ položky",
        price: "Jednotková cena",
        totalPrice: "Celková cena s DPH",
        totalPriceNoVat: "Celková cena bez DPH",
        discount: "Percentuálna zľava",
        absDiscount: "Absolutná zľava",
        costPrice: "Náklad. cena",
        invoiceDate: "Dátum fakturácie",
        margin: "Marža",
        priceList: "Cenník",
        summary: "Sumár",
        subtotal: "Medzisúčet",
        summaryDiscount: "Zľavy/Prirážky spolu",
        totalPriceNoVatSum: "Celková cena bez DPH spolu",
        totalDiscount: "Zľava",
        vat: "DPH",
        deleteOrderItemConfirmTitle: "Zmazanie položky",
        deleteOrderItemConfirm: "Skutočne chcete zmazať položku?",
        summaryChangedToast: "Sumár bol uložený",
        itemChangeToast: "Položka bola uložená",
        itemAddedToast: "Položka bola pridaná",
        itemDeletedToast: "Položka bola odstranená",
        splitItemTitle: "Rozdelenie položky",
        allItemsDateChange: "Nastaviť všetkým položkám",
        splitItem: "Rozdeliť položku",
        remainingItemSum: "Zostatok",
        newItemSum: "Suma nových položiek",
        daysFromEnd: "Počet od konca",
        splitErrorToast: "Vznikla chyba pri rozdelení položky",
        splitWarningMessage: "POZOR! Rozdelenie je nevratnou zmenou!",
        changePricelistWarningMessage: "POZOR! Sumy všetkých položiek sa prepočítajú na základe vybraného cenníka!"
    },
    "cs-CZ": {
        itemName: "Jméno položky",
        count: "Počet",
        addItem: "Přidat položku",
        priceNoVat: "Jednotková cena bez DPH",
        itemType: "Typ položky",
        price: "Jednotková cena",
        totalPrice: "Celková cena s DPH",
        totalPriceNoVat: "Celková cena bez DPH",
        discount: "Percentuální sleva",
        absDiscount: "Absolutní sleva",
        costPrice: "Náklad. cena",
        invoiceDate: "Datum fakturace",
        margin: "Marže",
        priceList: "Cenník",
        summary: "Sumár",
        subtotal: "Mezisoučet",
        summaryDiscount: "Slevy/Přirážky spolu",
        totalPriceNoVatSum: "Celková cena bez DPH spolu",
        totalDiscount: "Sleva",
        vat: "DPH",
        deleteOrderItemConfirmTitle: "Smazání položky",
        deleteOrderItemConfirm: "Skutečně chcete smazat položku?",
        summaryChangedToast: "Sumár byl uložen",
        itemChangeToast: "Položka byla uložena",
        itemAddedToast: "Položka byla přidaná",
        itemDeletedToast: "Položka byla odstraněna",
        splitItemTitle: "Rozdelení položky",
        allItemsDateChange: "Nastavit všem položkám",
        splitItem: "Rozdelit položku",
        remainingItemSum: "Zůstatek",
        newItemSum: "Suma nových položek",
        daysFromEnd: "Počet od konce",
        splitWarningMessage: "POZOR! Rozdělení je nevratnou změnou!",
        changePricelistWarningMessage: "POZOR! Částky všech položek se přepočítají na základě vybraného ceníku!"
    },
    "en-US": {
        itemName: "Item name",
        count: "Count",
        addItem: "Add item",
        priceNoVat: "Price no VAT",
        itemType: "Item type",
        price: "Price",
        totalPrice: "Total price with VAT",
        totalPriceNoVat: "Total price no VAT",
        discount: "Percentage discount",
        absDiscount: "Absolute discount",
        costPrice: "Cost price",
        invoiceDate: "Invoicing date",
        margin: "Margin",
        priceList: "Price list",
        summary: "Summary",
        subtotal: "Subtotal",
        summaryDiscount: "Discounts/charge total",
        totalPriceNoVatSum: "Total price no VAT",
        totalDiscount: "Discount",
        vat: "VAT",
        deleteOrderItemConfirmTitle: "Delete item",
        deleteOrderItemConfirm: "Are you sure to delete the item?",
        summaryChangedToast: "Summary saved",
        itemChangeToast: "Item saved",
        itemAddedToast: "Item added",
        itemDeletedToast: "Item deleted",
        splitItemTitle: "Split item",
        allItemsDateChange: "Set to all items",
        splitItem: "Split item",
        remainingItemSum: "Remaining",
        newItemSum: "Sum of new items",
        daysFromEnd: "Days from end",
        splitWarningMessage: "ATTENTION! Spliting is irreversible change!",
        changePricelistWarningMessage: "WARNING! The amounts of all items will be recalculated based on the selected price list!"
    }
};

class AsolSummaryItemComponent {
    constructor(trans) {
        this.trans = trans;
        /** Label translation key */
        this.labelKey = '';
        /** Data to show */
        this.data = null;
        /** TranslationKey */
        this.transKey = ITEMS_LIST_CONSTANT.TRANS;
    }
}
AsolSummaryItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSummaryItemComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolSummaryItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSummaryItemComponent, selector: "asol-summary-item", inputs: { labelKey: "labelKey", data: "data", transKey: "transKey" }, ngImport: i0, template: "<div>\n  {{ trans.get(transKey, labelKey) }}:\n  <strong>\n    {{ data | valueCurrency }}\n  </strong>\n</div>\n", pipes: { "valueCurrency": i1.ValueCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSummaryItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-summary-item', template: "<div>\n  {{ trans.get(transKey, labelKey) }}:\n  <strong>\n    {{ data | valueCurrency }}\n  </strong>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { labelKey: [{
                type: Input
            }], data: [{
                type: Input
            }], transKey: [{
                type: Input
            }] } });

class AsolSplitDialogComponent {
    constructor(trans, cdr) {
        this.trans = trans;
        this.cdr = cdr;
        /** Splits collection where new splits are stored */
        this.splits = [];
        /** Stored item for later use (calculations, new splits, etc.) */
        this.item = null;
        /** Date from which ends of days will be calculated */
        this.date = null;
        this.ITEMS_LIST_CONSTANT = ITEMS_LIST_CONSTANT;
        this.ICONS = ICONS;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Confirm',
            },
            {
                textType: 'Cancel',
                type: 'flat',
            },
        ];
        /** Emits when dialog closes */
        this.hide = new EventEmitter();
        this.sub = new Subscription();
        this.initializeDefaultValues();
    }
    /**
     * Initializes default values
     */
    initializeDefaultValues() {
        this.data = {
            count: 0,
            result: [],
        };
        this.remainingItem = {
            count: 0,
            name: '',
            totalPrice: {
                currency: '',
                value: null,
            },
        };
        this.sumItem = {
            count: 0,
            name: '',
            totalPrice: {
                currency: '',
                value: null,
            },
        };
    }
    /**
     * Shows dialog
     * @param item Stored item @see {@link ItemList}
     * @param date Date from wich days to end will be calculated
     */
    showDialog(item, date) {
        this.initializeDefaultValues();
        this.splits.splice(0, this.splits.length);
        this.data = {
            count: 1,
            result: [item],
        };
        this.remainingItem = {
            count: item.count,
            name: item.name,
            totalPrice: item.totalPrice,
        };
        this.item = item;
        this.date = date;
        this.dialog.show();
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        var _a;
        if (type === 'Confirm') {
            this.hide.emit({
                id: 0,
                itemId: this.item.id,
                splits: this.splits,
                remaining: this.remainingItem,
            });
        }
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.dialog.hide();
    }
    /**
     * Adds new split to collection
     */
    onSplit() {
        if (!this.item) {
            return;
        }
        const split = {
            name: this.item.name,
            count: 1,
            totalPrice: {
                value: this.item.count !== 0
                    ? this.item.totalPrice.value / this.item.count
                    : 0,
                currency: this.item.totalPrice.currency,
            },
            invoiceDate: this.item.invoiceDate,
            daysToEnd: getDateDifference(this.trans, this.item.invoiceDate, this.date),
        };
        this.splits.push(split);
        this.recalculate();
    }
    /**
     * Removes aggregate form from aggregates
     * @param index Index of form to remove
     */
    onDelete(index) {
        this.splits.splice(index, 1);
        this.recalculate();
    }
    /**
     * Recalculates sum and remaining items
     */
    recalculate() {
        let count = 0;
        let totalPrice = 0;
        this.splits.forEach((item) => {
            count += item.count;
            totalPrice += item.totalPrice.value;
        });
        this.sumItem = {
            count,
            totalPrice: {
                value: totalPrice,
                currency: this.item.totalPrice.currency,
            },
            name: this.item.name,
        };
        this.remainingItem = {
            count: this.item.count - count,
            totalPrice: {
                value: this.item.totalPrice.value - totalPrice,
                currency: this.item.totalPrice.currency,
            },
            name: this.item.name,
        };
        this.cdr.markForCheck();
    }
    /**
     * Event handler when user changes split fields
     * @param index Index of changed items in collection
     * @param field Field name that was changed
     * @param value Value that was changed to
     */
    onItemChange(index, field, value) {
        const splitItem = this.splits[index];
        switch (field) {
            case 'count':
                splitItem.totalPrice = {
                    value: (this.item.totalPrice.value / this.item.count) * value,
                    currency: this.item.totalPrice.currency,
                };
                break;
            case 'invoiceDate':
                splitItem.daysToEnd = getDateDifference(this.trans, value, this.date);
                break;
        }
        this.recalculate();
    }
}
AsolSplitDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSplitDialogComponent, deps: [{ token: i1.TranslationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolSplitDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSplitDialogComponent, selector: "asol-split-dialog", outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }, { propertyName: "grid", first: true, predicate: ["grid"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"850px\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitItemTitle') }}\"\n  buttonPosition=\"start\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <asol-grid\n    id=\"splitGrid\"\n    [data]=\"data\"\n    [initialDataLoad]=\"false\"\n    [allowFiltering]=\"false\"\n    [allowGrouping]=\"false\"\n    [allowResizing]=\"false\"\n    [allowSorting]=\"false\"\n    [showPaging]=\"false\"\n    [enablePersistance]=\"false\"\n    #grid>\n    <asol-column\n      field=\"name\"\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemName')\">\n    </asol-column>\n    <asol-column\n      [visible]=\"false\"\n      [useInAggregate]=\"false\"\n      [isPrimaryKey]=\"true\"\n      field=\"id\">\n    </asol-column>\n    <asol-column\n      field=\"count\"\n      [width]=\"150\"\n      type=\"number\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'count')\">\n    </asol-column>\n    <asol-column\n      field=\"totalPrice\"\n      [width]=\"150\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.totalPrice\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"invoiceDate\"\n      [width]=\"150\"\n      type=\"date\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate')\">\n    </asol-column>\n    <asol-column\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'daysFromEnd')\">\n      <ng-template #gridTemplate let-data>\n        {{\n          data.invoiceDate && date ? (data.invoiceDate | dateDiff : date) : '0'\n        }}\n      </ng-template>\n    </asol-column>\n  </asol-grid>\n\n  <div class=\"summary mt-0 mb-3\">\n    <table>\n      <tbody>\n        <tr\n          class=\"remaining\"\n          [ngClass]=\"{\n            'remaining-error':\n              sumItem?.count > item?.count ||\n              sumItem?.totalPrice.value > item?.totalPrice.value\n          }\">\n          <td>\n            {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'remainingItemSum') }}\n          </td>\n          <td>{{ remainingItem.count }}</td>\n          <td>{{ remainingItem.totalPrice | valueCurrency }}</td>\n        </tr>\n        <tr class=\"newItems\">\n          <td>{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'newItemSum') }}</td>\n          <td>{{ sumItem.count }}</td>\n          <td>{{ sumItem.totalPrice | valueCurrency }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <asol-button type=\"outline\" (click)=\"onSplit()\">\n    {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitItem') }}\n  </asol-button>\n\n  <div class=\"splits mt-3\" *ngIf=\"splits.length\">\n    <ng-container *ngFor=\"let split of splits; let i = index\">\n      <div class=\"d-inline-flex split-container\">\n        <asol-label-field\n          [width]=\"135\"\n          [labelTextStyle]=\"{ padding: '1rem' }\"\n          [isDisabled]=\"true\"\n          [labelText]=\"split.name\">\n        </asol-label-field>\n        <asol-number-field\n          id=\"split-count-input-field\"\n          [width]=\"151\"\n          format=\"n0\"\n          [showError]=\"false\"\n          [debounceTime]=\"200\"\n          [min]=\"1\"\n          [(ngModel)]=\"split.count\"\n          (valueChanged)=\"onItemChange(i, 'count', $event)\">\n        </asol-number-field>\n        <asol-number-field\n          id=\"split-total-input-field\"\n          [width]=\"151\"\n          format=\"n2\"\n          [min]=\"0\"\n          [debounceTime]=\"200\"\n          [showError]=\"false\"\n          [(ngModel)]=\"split.totalPrice.value\"\n          (valueChanged)=\"onItemChange(i, 'totalPrice', $event)\">\n        </asol-number-field>\n        <asol-date-picker\n          id=\"split-date-input-field\"\n          [width]=\"151\"\n          [debounceTime]=\"200\"\n          [showError]=\"false\"\n          [(ngModel)]=\"split.invoiceDate\"\n          (valueChanged)=\"onItemChange(i, 'invoiceDate', $event)\">\n        </asol-date-picker>\n        <asol-input-field\n          [width]=\"87\"\n          [showError]=\"false\"\n          [isDisabled]=\"true\"\n          id=\"split-days-input-field\"\n          [(ngModel)]=\"split.daysToEnd\">\n        </asol-input-field>\n        <div class=\"center-item-v h-100 trash-button\">\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.TRASH\"\n            color=\"dark\"\n            type=\"flat\"\n            (click)=\"onDelete(i)\">\n          </asol-icon-button>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <div class=\"mt-6\">\n    <asol-info-panel\n      type=\"warning\"\n      [showAnymoreButton]=\"false\"\n      [showMoreButton]=\"false\"\n      [showCloseButton]=\"false\"\n      [text]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitWarningMessage')\">\n    </asol-info-panel>\n  </div>\n</asol-dialog>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.summary{border:1px solid #42526e;border-radius:4px;padding:.75rem .5rem;width:450px}.summary td{width:150px}.remaining td{color:#0065ff;font-size:1rem;font-weight:700}.remaining-error td{color:#de350b}.newItems td{font-size:.875rem}.splits{background-color:#f4f5f7;padding:1rem}.splits .split-container{background-color:#fff}.trash-button{line-height:40px}\n"], components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolGridComponent, selector: "asol-grid", inputs: ["syncId", "aggregateUri", "entityId", "additionalSearchParams", "cssClass", "data", "id", "checkboxDisableField", "datasource", "allowAggregates", "allowFiltering", "allowResizing", "allowGrouping", "allowReordering", "allowSorting", "allowExcelExport", "allowPdfExport", "showPaging", "allowTextWrap", "fixPagerAtBottom", "enablePersistance", "initialDataLoad", "height", "width", "filterOption", "groupSettings", "selectionSettings", "gridProperties", "columnTranslation", "useGlobalSpinner", "rowRenderingMode", "disableAdaptiveLayout", "exportParams", "selectedRowIndex", "singleSelection", "pagerData"], outputs: ["rowSelected", "rowDoubleClick", "dataStateChanged", "removeItems", "settingsParsed", "databound", "rowDatabound"] }, { type: AsolValueCurrencyComponent, selector: "asol-value-currency", inputs: ["data", "precision", "showSuccessColor"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: AsolNumberFieldComponent, selector: "asol-number-field", inputs: ["currency", "decimals", "format", "max", "min", "step", "showClearButton", "showSpinButton"] }, { type: AsolDatePickerComponent, selector: "asol-date-picker", inputs: ["max", "min", "openOnFocus", "showClearButton", "showTodayButton", "start", "weekNumber", "format"] }, { type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }, { type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolInfoPanelComponent, selector: "asol-info-panel", inputs: ["type", "text", "showMoreButton", "url", "showAnymoreButton", "showCloseButton", "cssClass", "showInfoPanel"] }], directives: [{ type: AsolDataColumnDirective, selector: "asol-column", inputs: ["allowResizing", "allowSorting", "allowFiltering", "allowReordering", "allowGrouping", "allowSearching", "isPrimaryKey", "autoFit", "clipMode", "field", "member", "format", "headerText", "headerKey", "transKey", "headerTextAlign", "templateType", "templateValueField", "color", "colorField", "minWidth", "maxWidth", "showInColumnChooser", "textAlign", "visible", "width", "type", "hideAtMedia", "columnChooserGroup", "category", "operators", "step", "validation", "value", "values", "showInMassEdit", "editType", "useInFilter", "useInAggregate", "dropDownService", "dropDownServiceName", "dropDownServiceFilter", "id", "columnChooserType", "columnChooserMultiselectService", "columnChooserMultiselectValue", "valueAccessor"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "dateDiff": i1.DateDiffPipe, "valueCurrency": i1.ValueCurrencyPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSplitDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-split-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<asol-dialog\n  #dialog\n  width=\"850px\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitItemTitle') }}\"\n  buttonPosition=\"start\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <asol-grid\n    id=\"splitGrid\"\n    [data]=\"data\"\n    [initialDataLoad]=\"false\"\n    [allowFiltering]=\"false\"\n    [allowGrouping]=\"false\"\n    [allowResizing]=\"false\"\n    [allowSorting]=\"false\"\n    [showPaging]=\"false\"\n    [enablePersistance]=\"false\"\n    #grid>\n    <asol-column\n      field=\"name\"\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemName')\">\n    </asol-column>\n    <asol-column\n      [visible]=\"false\"\n      [useInAggregate]=\"false\"\n      [isPrimaryKey]=\"true\"\n      field=\"id\">\n    </asol-column>\n    <asol-column\n      field=\"count\"\n      [width]=\"150\"\n      type=\"number\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'count')\">\n    </asol-column>\n    <asol-column\n      field=\"totalPrice\"\n      [width]=\"150\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.totalPrice\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"invoiceDate\"\n      [width]=\"150\"\n      type=\"date\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate')\">\n    </asol-column>\n    <asol-column\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'daysFromEnd')\">\n      <ng-template #gridTemplate let-data>\n        {{\n          data.invoiceDate && date ? (data.invoiceDate | dateDiff : date) : '0'\n        }}\n      </ng-template>\n    </asol-column>\n  </asol-grid>\n\n  <div class=\"summary mt-0 mb-3\">\n    <table>\n      <tbody>\n        <tr\n          class=\"remaining\"\n          [ngClass]=\"{\n            'remaining-error':\n              sumItem?.count > item?.count ||\n              sumItem?.totalPrice.value > item?.totalPrice.value\n          }\">\n          <td>\n            {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'remainingItemSum') }}\n          </td>\n          <td>{{ remainingItem.count }}</td>\n          <td>{{ remainingItem.totalPrice | valueCurrency }}</td>\n        </tr>\n        <tr class=\"newItems\">\n          <td>{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'newItemSum') }}</td>\n          <td>{{ sumItem.count }}</td>\n          <td>{{ sumItem.totalPrice | valueCurrency }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <asol-button type=\"outline\" (click)=\"onSplit()\">\n    {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitItem') }}\n  </asol-button>\n\n  <div class=\"splits mt-3\" *ngIf=\"splits.length\">\n    <ng-container *ngFor=\"let split of splits; let i = index\">\n      <div class=\"d-inline-flex split-container\">\n        <asol-label-field\n          [width]=\"135\"\n          [labelTextStyle]=\"{ padding: '1rem' }\"\n          [isDisabled]=\"true\"\n          [labelText]=\"split.name\">\n        </asol-label-field>\n        <asol-number-field\n          id=\"split-count-input-field\"\n          [width]=\"151\"\n          format=\"n0\"\n          [showError]=\"false\"\n          [debounceTime]=\"200\"\n          [min]=\"1\"\n          [(ngModel)]=\"split.count\"\n          (valueChanged)=\"onItemChange(i, 'count', $event)\">\n        </asol-number-field>\n        <asol-number-field\n          id=\"split-total-input-field\"\n          [width]=\"151\"\n          format=\"n2\"\n          [min]=\"0\"\n          [debounceTime]=\"200\"\n          [showError]=\"false\"\n          [(ngModel)]=\"split.totalPrice.value\"\n          (valueChanged)=\"onItemChange(i, 'totalPrice', $event)\">\n        </asol-number-field>\n        <asol-date-picker\n          id=\"split-date-input-field\"\n          [width]=\"151\"\n          [debounceTime]=\"200\"\n          [showError]=\"false\"\n          [(ngModel)]=\"split.invoiceDate\"\n          (valueChanged)=\"onItemChange(i, 'invoiceDate', $event)\">\n        </asol-date-picker>\n        <asol-input-field\n          [width]=\"87\"\n          [showError]=\"false\"\n          [isDisabled]=\"true\"\n          id=\"split-days-input-field\"\n          [(ngModel)]=\"split.daysToEnd\">\n        </asol-input-field>\n        <div class=\"center-item-v h-100 trash-button\">\n          <asol-icon-button\n            [iconSvgUrl]=\"ICONS.TRASH\"\n            color=\"dark\"\n            type=\"flat\"\n            (click)=\"onDelete(i)\">\n          </asol-icon-button>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <div class=\"mt-6\">\n    <asol-info-panel\n      type=\"warning\"\n      [showAnymoreButton]=\"false\"\n      [showMoreButton]=\"false\"\n      [showCloseButton]=\"false\"\n      [text]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitWarningMessage')\">\n    </asol-info-panel>\n  </div>\n</asol-dialog>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.summary{border:1px solid #42526e;border-radius:4px;padding:.75rem .5rem;width:450px}.summary td{width:150px}.remaining td{color:#0065ff;font-size:1rem;font-weight:700}.remaining-error td{color:#de350b}.newItems td{font-size:.875rem}.splits{background-color:#f4f5f7;padding:1rem}.splits .split-container{background-color:#fff}.trash-button{line-height:40px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }], grid: [{
                type: ViewChild,
                args: ['grid']
            }] } });

class AsolPriceListDialogComponent {
    constructor(trans, fb) {
        this.trans = trans;
        this.fb = fb;
        this.ITEMS_LIST_CONSTANT = ITEMS_LIST_CONSTANT;
        this.ICONS = ICONS;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Save',
            },
        ];
        /** Emits new invoicing date when dialog closes */
        this.hide = new EventEmitter();
        this.formGroup = this.fb.group({
            priceListId: [null],
        });
    }
    /**
     * Shows dialog
     */
    showDialog(id) {
        this.formGroup.patchValue({ priceListId: id });
        this.dialog.show();
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        if (type === 'Save') {
            this.hide.emit(this.formGroup.value.priceListId);
        }
        this.dialog.hide();
    }
}
AsolPriceListDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriceListDialogComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolPriceListDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolPriceListDialogComponent, selector: "asol-price-list-dialog", inputs: { dataProvider: "dataProvider", filterParams: "filterParams" }, outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"40.5rem\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceList') }}\"\n  buttonPosition=\"start\"\n  [defaultPaddings]=\"false\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\">\n    <asol-select-field\n      formControlName=\"priceListId\"\n      labelKey=\"priceList\"\n      [dataProvider]=\"dataProvider\"\n      [filterParams]=\"filterParams\"\n      [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\">\n    </asol-select-field>\n  </form>\n  <div class=\"mt-6 mb-3\">\n    <asol-info-panel\n      type=\"warning\"\n      [text]=\"\n        trans.get(ITEMS_LIST_CONSTANT.TRANS, 'changePricelistWarningMessage')\n      \">\n    </asol-info-panel>\n  </div>\n</asol-dialog>\n", components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolInfoPanelComponent, selector: "asol-info-panel", inputs: ["type", "text", "showMoreButton", "url", "showAnymoreButton", "showCloseButton", "cssClass", "showInfoPanel"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPriceListDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-price-list-dialog', template: "<asol-dialog\n  #dialog\n  width=\"40.5rem\"\n  headerText=\"{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceList') }}\"\n  buttonPosition=\"start\"\n  [defaultPaddings]=\"false\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <form [formGroup]=\"formGroup\" class=\"my-3\">\n    <asol-select-field\n      formControlName=\"priceListId\"\n      labelKey=\"priceList\"\n      [dataProvider]=\"dataProvider\"\n      [filterParams]=\"filterParams\"\n      [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\">\n    </asol-select-field>\n  </form>\n  <div class=\"mt-6 mb-3\">\n    <asol-info-panel\n      type=\"warning\"\n      [text]=\"\n        trans.get(ITEMS_LIST_CONSTANT.TRANS, 'changePricelistWarningMessage')\n      \">\n    </asol-info-panel>\n  </div>\n</asol-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }]; }, propDecorators: { dataProvider: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

class AsolItemsListComponent {
    constructor(trans, notificationService, formBuilder) {
        this.trans = trans;
        this.notificationService = notificationService;
        this.formBuilder = formBuilder;
        /** Sync identifier for filter */
        this.syncId = 'itemListToobarId';
        /** Data provider */
        this.provider = null;
        /**
         * Summary position
         * @default left
         */
        this.summaryPosition = 'left';
        /**
         * Flag if summary should be visible
         * @default true
         */
        this.showSummary = true;
        /**
         * Flag to allow grid grouping and aggregation
         * @default true
         */
        this.allowAggregate = true;
        /** Flag to show invoice date button
         * @default true
         */
        this.showInvoiceDate = true;
        /** Flag to show price list button
         * @default true
         */
        this.showPriceList = true;
        /**
         * Flag if column chooser should be shown
         * @default true
         */
        this.showColumnChooser = true;
        /** Flag to allow splitting
         * @default true
         */
        this.allowSplitting = true;
        /**
         * Invoicing date used to calculate days differences
         * @type {(Date | null)}
         */
        this.invoiceDate = null;
        /**
         * Selected Price list identifier
         */
        this.priceListId = null;
        /**
         * Column configuration
         * Provided values will be hidden from grid, but still visible via columnChooser
         */
        this.hideColumns = [];
        /**
         * Column configuration
         * Provided values will not be editable in grid
         */
        this.notEditableColumns = [];
        /**
         * Flag to allow emit on add button and hides item form group
         * When its true hides item form group and allows add button function
         * @default false
         */
        this.emitOnAdd = false;
        /**
         * Flag if add button should be disabled
         * @default false
         */
        this.addButtonDisabled = false;
        /**
         * Add button tooltip
         */
        this.addButtonTooltip = null;
        /**
         * Emits when add button is clicked
         */
        this.addClick = new EventEmitter();
        /** Summary model field */
        this.summary$ = of();
        /** Items to add reference */
        this.items$ = of([]);
        /** Confirmation dialog */
        this.confirmDialog = null;
        this.sub = new Subscription();
        this.items = [];
        this.ITEMS_LIST_CONSTANT = ITEMS_LIST_CONSTANT;
        this.ICONS = ICONS;
        this.trans.initialize(ITEMS_LIST_CONSTANT.TRANS, translation$a);
        this.itemsFormGroup = this.formBuilder.group({
            itemId: ['', Validators.required],
            count: [1, [Validators.required, Validators.min(1)]],
        });
        this.sub = this.trans.languageChanged$.subscribe(() => {
            this.translateItems();
        });
    }
    ngOnInit() {
        if (!this.id) {
            throw Error('Id is required');
        }
        this.getItemsToAdd();
        this.getSummary();
    }
    ngAfterViewInit() {
        this.translateItems();
        this.hideGridColumns();
        this.loadItems();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Deletes order item and reload order list
     * @param id Order item identifier
     */
    onItemDelete(id) {
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'deleteOrderItemConfirmTitle'),
            content: this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'deleteOrderItemConfirm'),
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.confirmClick.bind(this, id),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    /**
     * Reload items and get summary
     */
    reload() {
        this.loadItems();
        this.getSummary();
    }
    /**
     * Deletes item after confirmation dialog close
     * @param id Order Item identifier
     */
    confirmClick(id) {
        this.provider.deleteItem(id).subscribe(() => {
            this.reload();
            this.confirmDialog.hide();
            this.notificationService.success(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemDeletedToast'));
        });
    }
    /**
     * Loads order items and gets summary
     */
    loadItems() {
        var _a;
        (_a = this.grid) === null || _a === void 0 ? void 0 : _a.reload(undefined, this.id);
    }
    /**
     * Adds new item to order and reloads order list
     */
    onItemAdd() {
        if (this.emitOnAdd) {
            this.addClick.emit();
            return;
        }
        markForValidation(this.itemsFormGroup);
        if (this.itemsFormGroup.invalid) {
            return;
        }
        this.provider
            .addItem(Object.assign(Object.assign({}, this.itemsFormGroup.value), { id: this.id }))
            .subscribe(() => {
            this.reload();
            this.itemsFormGroup.reset({
                count: 1,
            });
            this.notificationService.success(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemAddedToast'));
        });
    }
    /**
     * Event handler after user changes discount, absDiscount or count.
     * @param item Order item that ewas changed
     * @param field which field was changed
     * @param value changed value
     */
    onItemChange(item, field, value) {
        const data = {
            id: item.id,
            fieldName: field,
            value: value,
        };
        this.provider.update(item.id, data).subscribe(() => {
            this.reload();
            this.notificationService.success(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemChangeToast'));
        });
    }
    /**
     * Shows invoice date dialog
     */
    onInvoiceDateClick() {
        this.invoicingDialog.showDialog();
    }
    /**
     * Event when user closes Invoice date dialog
     * @param invoicing Data from dialog @see {@link InvoiceDate}
     */
    onInvoiceDialogHide(invoicing) {
        this.provider
            .changeInvoicingDates(this.id, invoicing)
            .subscribe((result) => {
            if (result) {
                this.loadItems();
                this.notificationService.success(this.trans.get(GENERAL_TRANSLATION, 'saved'));
            }
            else {
                this.notificationService.danger(this.trans.get(GENERAL_TRANSLATION, 'error'));
            }
        });
    }
    /**
     * Shows invoice date dialog
     */
    onShowPriceListClick() {
        var _a;
        (_a = this.priceListDialog) === null || _a === void 0 ? void 0 : _a.showDialog(this.priceListId);
    }
    /**
     * Event when user closes Price list dialog
     * @param invoicing Price list id
     */
    onShowPriceListDialogHide(id) {
        this.provider.changePriceList(this.id, id).subscribe((result) => {
            if (result) {
                this.priceListId = id;
                this.getItemsToAdd();
                this.loadItems();
                this.notificationService.success(this.trans.get(GENERAL_TRANSLATION, 'saved'));
            }
            else {
                this.notificationService.danger(this.trans.get(GENERAL_TRANSLATION, 'error'));
            }
        });
    }
    /**
     * Loads order summary
     */
    getSummary() {
        this.summary$ = this.provider.getSummary(this.id);
    }
    /**
     * Loads items to add options
     */
    getItemsToAdd() {
        this.items$ = this.provider.getData(this.priceListId);
        /** resets selected item in item select field */
        this.itemsFormGroup.get('itemId').reset();
    }
    /**
     * Event handler for global discount or abs discount changes
     * @param field Field which was changed
     * @param value Changed value
     */
    onSummaryChange(field, value) {
        const data = {
            id: this.id,
            fieldName: field,
            value: value.toString(),
        };
        this.provider.updateSummary(this.id, data).subscribe(() => {
            this.getSummary();
            this.notificationService.success(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'summaryChangedToast'));
        });
    }
    /**
     * Event handler when user clicks on grid button from dropdown
     * @param args Menu event arg @see {@link MenuEventArgs}
     * @param item Row item which was clicked
     */
    onGridButtonSelect(args, item) {
        switch (args.item.id) {
            case ITEMS_LIST_CONSTANT.DUPLICATE:
                this.provider.duplicateItem(this.id, item.id).subscribe((result) => {
                    if (result) {
                        this.reload();
                        this.notificationService.success(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemAddedToast'));
                    }
                    else {
                        this.notificationService.danger(this.trans.get(GENERAL_TRANSLATION, 'error'));
                    }
                });
                break;
            case ITEMS_LIST_CONSTANT.SPLIT:
                this.splitDialog.showDialog(item, this.invoiceDate);
                break;
            case ITEMS_LIST_CONSTANT.DELETE:
                this.onItemDelete(item.id);
                break;
        }
    }
    /**
     * Event handler when user closes split dialog
     */
    onSplitDialogHide(splitResult) {
        this.provider
            .splitItems(this.id, Object.assign(Object.assign({}, splitResult), { id: this.id }))
            .subscribe((result) => {
            if (!result) {
                this.notificationService.danger(this.trans.get(ITEMS_LIST_CONSTANT.TRANS, 'splitErrorToast'));
            }
            this.reload();
            this.notificationService.success(this.trans.get(GENERAL_TRANSLATION, 'saved'));
        });
    }
    /**
     * Calculates correct position of pop up
     * @param args Pop up element arguments @see {@link OpenCloseMenuEventArgs}
     * @param id Button that was clicked
     */
    onGridButtonOpen(args, id) {
        const control = document.getElementById(`dropButton${id}`);
        args.element.parentElement.style.left =
            control.getBoundingClientRect().right -
                args.element.parentElement.offsetWidth +
                'px';
    }
    /**
     * Sets and translates the items
     */
    translateItems() {
        this.items.splice(0, this.items.length);
        this.items.push({
            id: ITEMS_LIST_CONSTANT.DUPLICATE,
            text: this.trans.get(GENERAL_TRANSLATION, 'duplicate'),
            iconCss: 'icon-duplicate',
        });
        if (this.allowSplitting) {
            this.items.push({
                id: ITEMS_LIST_CONSTANT.SPLIT,
                text: this.trans.get(GENERAL_TRANSLATION, 'split'),
                iconCss: 'icon-split',
            });
        }
        this.items.push({
            id: ITEMS_LIST_CONSTANT.DELETE,
            text: this.trans.get(GENERAL_TRANSLATION, 'reset'),
            iconCss: 'icon-trash',
        });
    }
    /**
     * Hides grid columns
     */
    hideGridColumns() {
        if (!this.hideColumns.length) {
            return;
        }
        this.grid.hasStoredData().subscribe((hasData) => {
            if (hasData) {
                return;
            }
            const cols = this.grid.columnModel
                .filter((p) => p.visible)
                .map((p) => {
                const hide = this.hideColumns.some((t) => t === p.field);
                return {
                    field: p.field,
                    visible: !hide,
                    headerText: p.headerText,
                };
            });
            const colChoose = [
                {
                    items: cols,
                },
            ];
            this.grid.changeColumnVisibility(colChoose, false, false);
        });
    }
    /**
     * Checks if column is editable
     * @param field the column item
     * @returns true/false if column is editable or not
     */
    checkEditable(field) {
        return !this.notEditableColumns.includes(field);
    }
}
AsolItemsListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListComponent, deps: [{ token: i1.TranslationService }, { token: NotificationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolItemsListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolItemsListComponent, selector: "asol-items-list", inputs: { id: "id", gridId: "gridId", syncId: "syncId", provider: "provider", summaryPosition: "summaryPosition", showSummary: "showSummary", allowAggregate: "allowAggregate", showInvoiceDate: "showInvoiceDate", showPriceList: "showPriceList", showColumnChooser: "showColumnChooser", allowSplitting: "allowSplitting", invoiceDate: "invoiceDate", priceListId: "priceListId", priceListDataProvider: "priceListDataProvider", priceListFilterParams: "priceListFilterParams", hideColumns: "hideColumns", notEditableColumns: "notEditableColumns", emitOnAdd: "emitOnAdd", addButtonDisabled: "addButtonDisabled", addButtonTooltip: "addButtonTooltip" }, outputs: { addClick: "addClick" }, viewQueries: [{ propertyName: "grid", first: true, predicate: ["grid"], descendants: true }, { propertyName: "invoicingDialog", first: true, predicate: ["invoicingDialog"], descendants: true }, { propertyName: "splitDialog", first: true, predicate: ["splitDialog"], descendants: true }, { propertyName: "priceListDialog", first: true, predicate: ["priceListDialog"], descendants: true }], ngImport: i0, template: "<div class=\"d-flex flex-wrap justify-content-between align-items-end\">\n  <form [formGroup]=\"itemsFormGroup\" class=\"d-inline-flex align-items-end\">\n    <ng-container *ngIf=\"!emitOnAdd\">\n      <asol-select-field\n        formControlName=\"itemId\"\n        #itemsCombo\n        class=\"me-5 mb-2 flex-shrink-0\"\n        [options]=\"items$ | async\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        labelKey=\"itemName\"\n        [showError]=\"false\">\n      </asol-select-field>\n      <asol-number-field\n        formControlName=\"count\"\n        class=\"me-5 mb-2\"\n        width=\"134\"\n        [min]=\"1\"\n        format=\"n0\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        (keyup.enter)=\"onItemAdd()\"\n        labelKey=\"count\"\n        [showError]=\"false\">\n      </asol-number-field>\n    </ng-container>\n\n    <ejs-tooltip\n      *ngIf=\"addButtonTooltip; else buttonTemplate\"\n      [content]=\"addButtonTooltip\"\n      position=\"TopCenter\">\n      <ng-container [ngTemplateOutlet]=\"buttonTemplate\"></ng-container>\n    </ejs-tooltip>\n\n    <ng-template #buttonTemplate>\n      <asol-button\n        [iconSvgUrl]=\"ICONS.PLUS\"\n        class=\"mb-2 d-block\"\n        (click)=\"onItemAdd()\"\n        (keyup.enter)=\"onItemAdd()\"\n        [disabled]=\"emitOnAdd ? addButtonDisabled : itemsFormGroup.invalid\">\n        {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'addItem') }}\n      </asol-button>\n    </ng-template>\n  </form>\n\n  <div class=\"d-flex align-items-end justify-content-end\">\n    <div class=\"mb-2\">\n      <asol-toolbar [syncId]=\"syncId\">\n        <asol-item position=\"right\" *ngIf=\"showPriceList\">\n          <ng-template #template>\n            <asol-button\n              type=\"flat\"\n              color=\"dark\"\n              [iconSvgUrl]=\"ICONS.COINS_STACKED_01\"\n              (click)=\"onShowPriceListClick()\">\n              {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceList') }}\n            </asol-button>\n          </ng-template>\n        </asol-item>\n        <asol-item *ngIf=\"allowAggregate\" type=\"aggregate\" position=\"right\">\n        </asol-item>\n        <asol-item position=\"right\" *ngIf=\"showInvoiceDate\">\n          <ng-template #template>\n            <asol-button\n              type=\"flat\"\n              color=\"dark\"\n              [iconSvgUrl]=\"ICONS.CALENDAR\"\n              (click)=\"onInvoiceDateClick()\">\n              {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate') }}\n            </asol-button>\n          </ng-template>\n        </asol-item>\n        <asol-item type=\"chooser\" position=\"right\" *ngIf=\"showColumnChooser\">\n        </asol-item>\n      </asol-toolbar>\n    </div>\n  </div>\n</div>\n\n<div>\n  <asol-grid\n    [id]=\"'gridItemsList' + gridId\"\n    [datasource]=\"provider\"\n    [initialDataLoad]=\"false\"\n    [syncId]=\"syncId\"\n    [entityId]=\"id\"\n    [allowSorting]=\"true\"\n    [allowGrouping]=\"allowAggregate\"\n    [allowFiltering]=\"false\"\n    #grid>\n    <asol-column\n      field=\"name\"\n      [useInAggregate]=\"true\"\n      [width]=\"250\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemName')\">\n    </asol-column>\n    <asol-column\n      [visible]=\"false\"\n      [useInAggregate]=\"false\"\n      [isPrimaryKey]=\"true\"\n      field=\"id\"></asol-column>\n    <asol-column\n      field=\"type\"\n      [width]=\"120\"\n      [useInAggregate]=\"true\"\n      textAlign=\"Center\"\n      [headerText]=\"\n        trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemType')\n      \"></asol-column>\n    <asol-column\n      field=\"priceNoVat\"\n      [width]=\"160\"\n      [useInAggregate]=\"true\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceNoVat')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('priceNoVat'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.priceNoVat.value\"\n          (valueChanged)=\"onItemChange(data, 'priceNoVat', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.priceNoVat\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"vat\"\n      [useInAggregate]=\"true\"\n      [width]=\"120\"\n      textAlign=\"Center\"\n      format=\"p2\"\n      [visible]=\"false\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'vat')\">\n    </asol-column>\n    <asol-column\n      field=\"price\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'price')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('price'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.price.value\"\n          (valueChanged)=\"onItemChange(data, 'price', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.price\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"costPrice\"\n      [useInAggregate]=\"true\"\n      [width]=\"190\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'costPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('costPrice'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.costPrice.value\"\n          (valueChanged)=\"onItemChange(data, 'costPrice', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.costPrice\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"count\"\n      [useInAggregate]=\"true\"\n      [width]=\"120\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'count')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          [min]=\"0\"\n          [min]=\"1\"\n          [showError]=\"false\"\n          format=\"n0\"\n          [(ngModel)]=\"data.count\"\n          (valueChanged)=\"onItemChange(data, 'count', $event)\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"discount\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'discount')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          [max]=\"1\"\n          [showError]=\"false\"\n          [step]=\"0.01\"\n          format=\"p2\"\n          (valueChanged)=\"onItemChange(data, 'discount', $event)\"\n          [(ngModel)]=\"data.discount\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"absDiscount\"\n      [useInAggregate]=\"true\"\n      [width]=\"190\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'absDiscount')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          format=\"n2\"\n          [showError]=\"false\"\n          [max]=\"data.price.value * data.count\"\n          [(ngModel)]=\"data.absDiscount.value\"\n          (valueChanged)=\"onItemChange(data, 'absDiscount', $event)\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"totalPriceNoVat\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPriceNoVat')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency\n          [data]=\"data.totalPriceNoVat\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"totalPrice\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.totalPrice\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"invoiceDate\"\n      [useInAggregate]=\"true\"\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate')\">\n      <ng-template #gridTemplate let-data>\n        <asol-date-picker\n          [showError]=\"false\"\n          [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n          [(ngModel)]=\"data.invoiceDate\"\n          (valueChanged)=\"onItemChange(data, 'invoiceDate', $event)\">\n        </asol-date-picker>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"margin\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'margin')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.margin\" [showSuccessColor]=\"true\">\n        </asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      [width]=\"75\"\n      textAlign=\"Center\"\n      [useInAggregate]=\"false\"\n      clipMode=\"Clip\">\n      <ng-template #gridTemplate let-data>\n        <asol-dropdown-button\n          [id]=\"'dropButton' + data.id\"\n          type=\"flat\"\n          color=\"dark\"\n          class=\"me-1\"\n          [items]=\"items\"\n          [iconChevronSvgUrl]=\"ICONS.MORE_VERTICAL\"\n          (open)=\"onGridButtonOpen($event, data.id)\"\n          (itemSelect)=\"onGridButtonSelect($event, data)\">\n        </asol-dropdown-button>\n      </ng-template>\n    </asol-column>\n  </asol-grid>\n</div>\n\n<div class=\"row mt-3\" *ngIf=\"showSummary && summary$ | async as summary\">\n  <div class=\"col-6\" [ngClass]=\"{ 'offset-6': summaryPosition === 'right' }\">\n    <div class=\"content-panel\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h2>{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'summary') }}</h2>\n          <asol-summary-item labelKey=\"subtotal\" [data]=\"summary?.subTotal\">\n          </asol-summary-item>\n          <asol-summary-item\n            labelKey=\"summaryDiscount\"\n            [data]=\"summary?.totalDiscount\">\n          </asol-summary-item>\n          <asol-summary-item\n            labelKey=\"totalPriceNoVatSum\"\n            [data]=\"summary?.totalPriceNoVat\">\n          </asol-summary-item>\n          <asol-summary-item labelKey=\"vat\" [data]=\"summary?.vat\">\n          </asol-summary-item>\n          <asol-summary-item labelKey=\"margin\" [data]=\"summary?.margin\">\n          </asol-summary-item>\n        </div>\n        <div class=\"col-6\">\n          <div class=\"d-inline-flex\" *ngIf=\"summary\">\n            <div class=\"row align-items-end mt-0\">\n              <div class=\"col-6\">\n                <asol-number-field\n                  [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n                  labelKey=\"totalDiscount\"\n                  [step]=\"1\"\n                  format=\"n2\"\n                  [(ngModel)]=\"summary.globalAbsDiscount\"\n                  (valueChanged)=\"onSummaryChange('absDiscount', $event)\">\n                </asol-number-field>\n              </div>\n              <div class=\"col-6\">\n                <asol-number-field\n                  [max]=\"1\"\n                  [step]=\"0.01\"\n                  format=\"p2\"\n                  [(ngModel)]=\"summary.globalDiscount\"\n                  (valueChanged)=\"onSummaryChange('discount', $event * 100)\">\n                </asol-number-field>\n              </div>\n            </div>\n          </div>\n          <div class=\"d-block w-100 mt-4 h3\">\n            <asol-summary-item\n              labelKey=\"totalPrice\"\n              [data]=\"summary?.totalPrice\">\n            </asol-summary-item>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<asol-invoicing-date-dialog\n  #invoicingDialog\n  (hide)=\"onInvoiceDialogHide($event)\">\n</asol-invoicing-date-dialog>\n<asol-split-dialog #splitDialog (hide)=\"onSplitDialogHide($event)\">\n</asol-split-dialog>\n\n<asol-price-list-dialog\n  #priceListDialog\n  [dataProvider]=\"priceListDataProvider\"\n  [filterParams]=\"priceListFilterParams\"\n  (hide)=\"onShowPriceListDialogHide($event)\">\n</asol-price-list-dialog>\n", components: [{ type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolNumberFieldComponent, selector: "asol-number-field", inputs: ["currency", "decimals", "format", "max", "min", "step", "showClearButton", "showSpinButton"] }, { type: i2$2.TooltipComponent, selector: "ejs-tooltip", inputs: ["animation", "closeDelay", "container", "content", "cssClass", "enableHtmlParse", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "height", "isSticky", "locale", "mouseTrail", "offsetX", "offsetY", "openDelay", "opensOn", "position", "showTipPointer", "target", "tipPointerPosition", "width", "windowCollision"], outputs: ["afterClose", "afterOpen", "beforeClose", "beforeCollision", "beforeOpen", "beforeRender", "created", "destroyed"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolToolbarComponent, selector: "asol-toolbar", inputs: ["syncId", "cssClass"], outputs: ["itemClick"] }, { type: AsolGridComponent, selector: "asol-grid", inputs: ["syncId", "aggregateUri", "entityId", "additionalSearchParams", "cssClass", "data", "id", "checkboxDisableField", "datasource", "allowAggregates", "allowFiltering", "allowResizing", "allowGrouping", "allowReordering", "allowSorting", "allowExcelExport", "allowPdfExport", "showPaging", "allowTextWrap", "fixPagerAtBottom", "enablePersistance", "initialDataLoad", "height", "width", "filterOption", "groupSettings", "selectionSettings", "gridProperties", "columnTranslation", "useGlobalSpinner", "rowRenderingMode", "disableAdaptiveLayout", "exportParams", "selectedRowIndex", "singleSelection", "pagerData"], outputs: ["rowSelected", "rowDoubleClick", "dataStateChanged", "removeItems", "settingsParsed", "databound", "rowDatabound"] }, { type: AsolValueCurrencyComponent, selector: "asol-value-currency", inputs: ["data", "precision", "showSuccessColor"] }, { type: AsolDatePickerComponent, selector: "asol-date-picker", inputs: ["max", "min", "openOnFocus", "showClearButton", "showTodayButton", "start", "weekNumber", "format"] }, { type: AsolDropDownButtonComponent, selector: "asol-dropdown-button", inputs: ["type", "textType", "color", "disabled", "iconSvgUrl", "iconChevronSvgUrl", "hideChevronIcon", "items", "active", "cssClass"], outputs: ["itemSelect", "open"] }, { type: AsolSummaryItemComponent, selector: "asol-summary-item", inputs: ["labelKey", "data", "transKey"] }, { type: AsolInvoicingDateDialogComponent, selector: "asol-invoicing-date-dialog", outputs: ["hide"] }, { type: AsolSplitDialogComponent, selector: "asol-split-dialog", outputs: ["hide"] }, { type: AsolPriceListDialogComponent, selector: "asol-price-list-dialog", inputs: ["dataProvider", "filterParams"], outputs: ["hide"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: ToolbarItemDirective, selector: "asol-toolbar>asol-item", inputs: ["id", "type", "position", "icon", "iconPosition", "color", "disabled", "text", "buttonType", "tooltip", "visible", "active", "canBeActive", "removeDefaultStyle", "group", "dataProvider", "data"] }, { type: AsolDataColumnDirective, selector: "asol-column", inputs: ["allowResizing", "allowSorting", "allowFiltering", "allowReordering", "allowGrouping", "allowSearching", "isPrimaryKey", "autoFit", "clipMode", "field", "member", "format", "headerText", "headerKey", "transKey", "headerTextAlign", "templateType", "templateValueField", "color", "colorField", "minWidth", "maxWidth", "showInColumnChooser", "textAlign", "visible", "width", "type", "hideAtMedia", "columnChooserGroup", "category", "operators", "step", "validation", "value", "values", "showInMassEdit", "editType", "useInFilter", "useInAggregate", "dropDownService", "dropDownServiceName", "dropDownServiceFilter", "id", "columnChooserType", "columnChooserMultiselectService", "columnChooserMultiselectValue", "valueAccessor"] }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i6.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-items-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex flex-wrap justify-content-between align-items-end\">\n  <form [formGroup]=\"itemsFormGroup\" class=\"d-inline-flex align-items-end\">\n    <ng-container *ngIf=\"!emitOnAdd\">\n      <asol-select-field\n        formControlName=\"itemId\"\n        #itemsCombo\n        class=\"me-5 mb-2 flex-shrink-0\"\n        [options]=\"items$ | async\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        labelKey=\"itemName\"\n        [showError]=\"false\">\n      </asol-select-field>\n      <asol-number-field\n        formControlName=\"count\"\n        class=\"me-5 mb-2\"\n        width=\"134\"\n        [min]=\"1\"\n        format=\"n0\"\n        [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n        (keyup.enter)=\"onItemAdd()\"\n        labelKey=\"count\"\n        [showError]=\"false\">\n      </asol-number-field>\n    </ng-container>\n\n    <ejs-tooltip\n      *ngIf=\"addButtonTooltip; else buttonTemplate\"\n      [content]=\"addButtonTooltip\"\n      position=\"TopCenter\">\n      <ng-container [ngTemplateOutlet]=\"buttonTemplate\"></ng-container>\n    </ejs-tooltip>\n\n    <ng-template #buttonTemplate>\n      <asol-button\n        [iconSvgUrl]=\"ICONS.PLUS\"\n        class=\"mb-2 d-block\"\n        (click)=\"onItemAdd()\"\n        (keyup.enter)=\"onItemAdd()\"\n        [disabled]=\"emitOnAdd ? addButtonDisabled : itemsFormGroup.invalid\">\n        {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'addItem') }}\n      </asol-button>\n    </ng-template>\n  </form>\n\n  <div class=\"d-flex align-items-end justify-content-end\">\n    <div class=\"mb-2\">\n      <asol-toolbar [syncId]=\"syncId\">\n        <asol-item position=\"right\" *ngIf=\"showPriceList\">\n          <ng-template #template>\n            <asol-button\n              type=\"flat\"\n              color=\"dark\"\n              [iconSvgUrl]=\"ICONS.COINS_STACKED_01\"\n              (click)=\"onShowPriceListClick()\">\n              {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceList') }}\n            </asol-button>\n          </ng-template>\n        </asol-item>\n        <asol-item *ngIf=\"allowAggregate\" type=\"aggregate\" position=\"right\">\n        </asol-item>\n        <asol-item position=\"right\" *ngIf=\"showInvoiceDate\">\n          <ng-template #template>\n            <asol-button\n              type=\"flat\"\n              color=\"dark\"\n              [iconSvgUrl]=\"ICONS.CALENDAR\"\n              (click)=\"onInvoiceDateClick()\">\n              {{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate') }}\n            </asol-button>\n          </ng-template>\n        </asol-item>\n        <asol-item type=\"chooser\" position=\"right\" *ngIf=\"showColumnChooser\">\n        </asol-item>\n      </asol-toolbar>\n    </div>\n  </div>\n</div>\n\n<div>\n  <asol-grid\n    [id]=\"'gridItemsList' + gridId\"\n    [datasource]=\"provider\"\n    [initialDataLoad]=\"false\"\n    [syncId]=\"syncId\"\n    [entityId]=\"id\"\n    [allowSorting]=\"true\"\n    [allowGrouping]=\"allowAggregate\"\n    [allowFiltering]=\"false\"\n    #grid>\n    <asol-column\n      field=\"name\"\n      [useInAggregate]=\"true\"\n      [width]=\"250\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemName')\">\n    </asol-column>\n    <asol-column\n      [visible]=\"false\"\n      [useInAggregate]=\"false\"\n      [isPrimaryKey]=\"true\"\n      field=\"id\"></asol-column>\n    <asol-column\n      field=\"type\"\n      [width]=\"120\"\n      [useInAggregate]=\"true\"\n      textAlign=\"Center\"\n      [headerText]=\"\n        trans.get(ITEMS_LIST_CONSTANT.TRANS, 'itemType')\n      \"></asol-column>\n    <asol-column\n      field=\"priceNoVat\"\n      [width]=\"160\"\n      [useInAggregate]=\"true\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'priceNoVat')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('priceNoVat'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.priceNoVat.value\"\n          (valueChanged)=\"onItemChange(data, 'priceNoVat', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.priceNoVat\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"vat\"\n      [useInAggregate]=\"true\"\n      [width]=\"120\"\n      textAlign=\"Center\"\n      format=\"p2\"\n      [visible]=\"false\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'vat')\">\n    </asol-column>\n    <asol-column\n      field=\"price\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'price')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('price'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.price.value\"\n          (valueChanged)=\"onItemChange(data, 'price', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.price\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"costPrice\"\n      [useInAggregate]=\"true\"\n      [width]=\"190\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'costPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          *ngIf=\"checkEditable('costPrice'); else value\"\n          [min]=\"0\"\n          format=\"n2\"\n          [showError]=\"false\"\n          [(ngModel)]=\"data.costPrice.value\"\n          (valueChanged)=\"onItemChange(data, 'costPrice', $event)\">\n        </asol-number-field>\n        <ng-template #value>\n          <asol-value-currency [data]=\"data.costPrice\"></asol-value-currency>\n        </ng-template>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"count\"\n      [useInAggregate]=\"true\"\n      [width]=\"120\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'count')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          [min]=\"0\"\n          [min]=\"1\"\n          [showError]=\"false\"\n          format=\"n0\"\n          [(ngModel)]=\"data.count\"\n          (valueChanged)=\"onItemChange(data, 'count', $event)\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"discount\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'discount')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          [max]=\"1\"\n          [showError]=\"false\"\n          [step]=\"0.01\"\n          format=\"p2\"\n          (valueChanged)=\"onItemChange(data, 'discount', $event)\"\n          [(ngModel)]=\"data.discount\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"absDiscount\"\n      [useInAggregate]=\"true\"\n      [width]=\"190\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'absDiscount')\">\n      <ng-template #gridTemplate let-data>\n        <asol-number-field\n          format=\"n2\"\n          [showError]=\"false\"\n          [max]=\"data.price.value * data.count\"\n          [(ngModel)]=\"data.absDiscount.value\"\n          (valueChanged)=\"onItemChange(data, 'absDiscount', $event)\">\n        </asol-number-field>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"totalPriceNoVat\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPriceNoVat')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency\n          [data]=\"data.totalPriceNoVat\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"totalPrice\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'totalPrice')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.totalPrice\"></asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"invoiceDate\"\n      [useInAggregate]=\"true\"\n      [width]=\"150\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'invoiceDate')\">\n      <ng-template #gridTemplate let-data>\n        <asol-date-picker\n          [showError]=\"false\"\n          [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n          [(ngModel)]=\"data.invoiceDate\"\n          (valueChanged)=\"onItemChange(data, 'invoiceDate', $event)\">\n        </asol-date-picker>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      field=\"margin\"\n      [useInAggregate]=\"true\"\n      [width]=\"160\"\n      textAlign=\"Center\"\n      [headerText]=\"trans.get(ITEMS_LIST_CONSTANT.TRANS, 'margin')\">\n      <ng-template #gridTemplate let-data>\n        <asol-value-currency [data]=\"data.margin\" [showSuccessColor]=\"true\">\n        </asol-value-currency>\n      </ng-template>\n    </asol-column>\n    <asol-column\n      [width]=\"75\"\n      textAlign=\"Center\"\n      [useInAggregate]=\"false\"\n      clipMode=\"Clip\">\n      <ng-template #gridTemplate let-data>\n        <asol-dropdown-button\n          [id]=\"'dropButton' + data.id\"\n          type=\"flat\"\n          color=\"dark\"\n          class=\"me-1\"\n          [items]=\"items\"\n          [iconChevronSvgUrl]=\"ICONS.MORE_VERTICAL\"\n          (open)=\"onGridButtonOpen($event, data.id)\"\n          (itemSelect)=\"onGridButtonSelect($event, data)\">\n        </asol-dropdown-button>\n      </ng-template>\n    </asol-column>\n  </asol-grid>\n</div>\n\n<div class=\"row mt-3\" *ngIf=\"showSummary && summary$ | async as summary\">\n  <div class=\"col-6\" [ngClass]=\"{ 'offset-6': summaryPosition === 'right' }\">\n    <div class=\"content-panel\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h2>{{ trans.get(ITEMS_LIST_CONSTANT.TRANS, 'summary') }}</h2>\n          <asol-summary-item labelKey=\"subtotal\" [data]=\"summary?.subTotal\">\n          </asol-summary-item>\n          <asol-summary-item\n            labelKey=\"summaryDiscount\"\n            [data]=\"summary?.totalDiscount\">\n          </asol-summary-item>\n          <asol-summary-item\n            labelKey=\"totalPriceNoVatSum\"\n            [data]=\"summary?.totalPriceNoVat\">\n          </asol-summary-item>\n          <asol-summary-item labelKey=\"vat\" [data]=\"summary?.vat\">\n          </asol-summary-item>\n          <asol-summary-item labelKey=\"margin\" [data]=\"summary?.margin\">\n          </asol-summary-item>\n        </div>\n        <div class=\"col-6\">\n          <div class=\"d-inline-flex\" *ngIf=\"summary\">\n            <div class=\"row align-items-end mt-0\">\n              <div class=\"col-6\">\n                <asol-number-field\n                  [transKey]=\"ITEMS_LIST_CONSTANT.TRANS\"\n                  labelKey=\"totalDiscount\"\n                  [step]=\"1\"\n                  format=\"n2\"\n                  [(ngModel)]=\"summary.globalAbsDiscount\"\n                  (valueChanged)=\"onSummaryChange('absDiscount', $event)\">\n                </asol-number-field>\n              </div>\n              <div class=\"col-6\">\n                <asol-number-field\n                  [max]=\"1\"\n                  [step]=\"0.01\"\n                  format=\"p2\"\n                  [(ngModel)]=\"summary.globalDiscount\"\n                  (valueChanged)=\"onSummaryChange('discount', $event * 100)\">\n                </asol-number-field>\n              </div>\n            </div>\n          </div>\n          <div class=\"d-block w-100 mt-4 h3\">\n            <asol-summary-item\n              labelKey=\"totalPrice\"\n              [data]=\"summary?.totalPrice\">\n            </asol-summary-item>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<asol-invoicing-date-dialog\n  #invoicingDialog\n  (hide)=\"onInvoiceDialogHide($event)\">\n</asol-invoicing-date-dialog>\n<asol-split-dialog #splitDialog (hide)=\"onSplitDialogHide($event)\">\n</asol-split-dialog>\n\n<asol-price-list-dialog\n  #priceListDialog\n  [dataProvider]=\"priceListDataProvider\"\n  [filterParams]=\"priceListFilterParams\"\n  (hide)=\"onShowPriceListDialogHide($event)\">\n</asol-price-list-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: NotificationService }, { type: i2.FormBuilder }]; }, propDecorators: { id: [{
                type: Input
            }], gridId: [{
                type: Input
            }], syncId: [{
                type: Input
            }], provider: [{
                type: Input
            }], summaryPosition: [{
                type: Input
            }], showSummary: [{
                type: Input
            }], allowAggregate: [{
                type: Input
            }], showInvoiceDate: [{
                type: Input
            }], showPriceList: [{
                type: Input
            }], showColumnChooser: [{
                type: Input
            }], allowSplitting: [{
                type: Input
            }], invoiceDate: [{
                type: Input
            }], priceListId: [{
                type: Input
            }], priceListDataProvider: [{
                type: Input
            }], priceListFilterParams: [{
                type: Input
            }], hideColumns: [{
                type: Input
            }], notEditableColumns: [{
                type: Input
            }], emitOnAdd: [{
                type: Input
            }], addButtonDisabled: [{
                type: Input
            }], addButtonTooltip: [{
                type: Input
            }], addClick: [{
                type: Output
            }], grid: [{
                type: ViewChild,
                args: ['grid']
            }], invoicingDialog: [{
                type: ViewChild,
                args: ['invoicingDialog']
            }], splitDialog: [{
                type: ViewChild,
                args: ['splitDialog']
            }], priceListDialog: [{
                type: ViewChild,
                args: ['priceListDialog']
            }] } });

class AsolItemsListModule {
}
AsolItemsListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolItemsListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListModule, declarations: [AsolItemsListComponent,
        AsolSummaryItemComponent,
        AsolInvoicingDateDialogComponent,
        AsolSplitDialogComponent,
        AsolPriceListDialogComponent], imports: [SharedModule,
        AsolSelectFieldModule,
        AsolNumberFieldModule,
        AsolButtonModule,
        AsolGridModule,
        AsolDataColumnModule,
        AsolValueCurrencyModule,
        AsolDatePickerModule,
        PipesModule,
        AsolToolbarModule,
        AsolDialogModule,
        AsolDatePickerModule,
        AsolCheckboxModule,
        AsolInputFieldModule,
        AsolLabelFieldModule,
        AsolInfoPanelModule,
        TooltipModule], exports: [AsolItemsListComponent, AsolSummaryItemComponent] });
AsolItemsListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListModule, providers: [ToolbarService], imports: [[
            SharedModule,
            AsolSelectFieldModule,
            AsolNumberFieldModule,
            AsolButtonModule,
            AsolGridModule,
            AsolDataColumnModule,
            AsolValueCurrencyModule,
            AsolDatePickerModule,
            PipesModule,
            AsolToolbarModule,
            AsolDialogModule,
            AsolDatePickerModule,
            AsolCheckboxModule,
            AsolInputFieldModule,
            AsolLabelFieldModule,
            AsolInfoPanelModule,
            TooltipModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolItemsListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolItemsListComponent,
                        AsolSummaryItemComponent,
                        AsolInvoicingDateDialogComponent,
                        AsolSplitDialogComponent,
                        AsolPriceListDialogComponent,
                    ],
                    exports: [AsolItemsListComponent, AsolSummaryItemComponent],
                    imports: [
                        SharedModule,
                        AsolSelectFieldModule,
                        AsolNumberFieldModule,
                        AsolButtonModule,
                        AsolGridModule,
                        AsolDataColumnModule,
                        AsolValueCurrencyModule,
                        AsolDatePickerModule,
                        PipesModule,
                        AsolToolbarModule,
                        AsolDialogModule,
                        AsolDatePickerModule,
                        AsolCheckboxModule,
                        AsolInputFieldModule,
                        AsolLabelFieldModule,
                        AsolInfoPanelModule,
                        TooltipModule,
                    ],
                    providers: [ToolbarService],
                }]
        }] });

const BREADCRUMB_CONSTANTS = {
    ROUTE_DATA: 'breadcrumb',
};

const BREADCRUMB_TRANSLATION = new InjectionToken('AsolBreadcrumbTranslation');

class AsolBreadcrumbComponent {
    constructor(activatedRoute, platformLocation, defaultTranslationFile, trans) {
        this.activatedRoute = activatedRoute;
        this.platformLocation = platformLocation;
        this.defaultTranslationFile = defaultTranslationFile;
        this.trans = trans;
        this.shouldTranslate = true;
        this.translationFile = null;
        this.breadcrumb = null;
        this.items = [];
        this.ICONS = ICONS;
        this.transInitialized = false;
        this.sub = new Subscription();
        this.transKey = generateId();
        if (this.defaultTranslationFile) {
            this.trans.initialize(this.transKey, this.defaultTranslationFile);
            this.transInitialized = true;
        }
        this.sub = this.trans.languageChanged$.subscribe(() => {
            this.translateItems();
        });
    }
    ngOnInit() {
        this.processBreadcrumbItems();
    }
    ngOnDestroy() {
        this.trans.removeTranslation(this.transKey);
        this.sub.unsubscribe();
    }
    ngOnChanges(changes) {
        if (changes.translationFile && !this.defaultTranslationFile) {
            this.trans.initialize(this.transKey, this.translationFile);
            this.transInitialized = true;
        }
        if (changes.shouldTranslate &&
            this.shouldTranslate &&
            this.transInitialized) {
            this.translateItems();
        }
    }
    /**
     * Processes breadcrumb items after component was rendered
     */
    processBreadcrumbItems() {
        this.items.splice(0, this.items.length);
        this.items.push({
            iconCss: 'asol-breadcrumb-home',
            url: '/',
        });
        const baseUrl = this.platformLocation.href.includes('#') ? '#' : '';
        const data = this.createBreadcrumbs(this.activatedRoute.root, baseUrl);
        this.items.push(...data);
        if (this.transInitialized) {
            this.translateItems();
        }
    }
    /**
     * Translates breadcrumb items
     */
    translateItems() {
        this.items.forEach((item) => {
            if (!item.transKey) {
                return;
            }
            item.text = this.trans.get(this.transKey, item.transKey);
        });
        // refresh breadcrumb component with new data
        if (this.breadcrumb) {
            this.breadcrumb.items = this.items;
        }
    }
    /**
     * Creates breadcrumb from routing params
     * @param route Activated route
     * @param url Url of item to navigate
     * @param breadcrumbs Collection of breadcrumbs parents
     * @returns Collection of breadcrumbs @see {@link AsolBreadcrumbItem}
     */
    createBreadcrumbs(route, url = '', breadcrumbs = []) {
        const children = route.children;
        if (children.length === 0) {
            return breadcrumbs;
        }
        for (const child of children) {
            const routeURL = child.snapshot.url
                .map((segment) => segment.path)
                .join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }
            const label = child.snapshot.data[BREADCRUMB_CONSTANTS.ROUTE_DATA];
            if (label) {
                breadcrumbs.push({
                    text: label,
                    transKey: label,
                    url,
                });
            }
            return this.createBreadcrumbs(child, url, breadcrumbs);
        }
        return breadcrumbs;
    }
}
AsolBreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbComponent, deps: [{ token: i1$3.ActivatedRoute }, { token: i6.PlatformLocation }, { token: BREADCRUMB_TRANSLATION, optional: true }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolBreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolBreadcrumbComponent, selector: "asol-breadcrumb", inputs: { shouldTranslate: "shouldTranslate", translationFile: "translationFile" }, viewQueries: [{ propertyName: "breadcrumb", first: true, predicate: ["breadcrumb"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ejs-breadcrumb\n  #breadcrumb\n  [enableNavigation]=\"true\"\n  overflowMode=\"Menu\"\n  [items]=\"items\">\n  <ng-template #separatorTemplate>\n    <svg-icon\n      [src]=\"ICONS.CHEVRON_RIGHT\"\n      class=\"asol-breadcrumb-separator\"></svg-icon>\n  </ng-template>\n</ejs-breadcrumb>\n", components: [{ type: i2$3.BreadcrumbComponent, selector: "ejs-breadcrumb", inputs: ["activeItem", "cssClass", "disabled", "enableActiveItemNavigation", "enableNavigation", "enablePersistence", "enableRtl", "itemTemplate", "items", "locale", "maxItems", "overflowMode", "separatorTemplate", "url"], outputs: ["beforeItemRender", "created", "itemClick", "activeItemChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-breadcrumb', template: "<ejs-breadcrumb\n  #breadcrumb\n  [enableNavigation]=\"true\"\n  overflowMode=\"Menu\"\n  [items]=\"items\">\n  <ng-template #separatorTemplate>\n    <svg-icon\n      [src]=\"ICONS.CHEVRON_RIGHT\"\n      class=\"asol-breadcrumb-separator\"></svg-icon>\n  </ng-template>\n</ejs-breadcrumb>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1$3.ActivatedRoute }, { type: i6.PlatformLocation }, { type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [BREADCRUMB_TRANSLATION]
                    }] }, { type: i1.TranslationService }];
    }, propDecorators: { shouldTranslate: [{
                type: Input
            }], translationFile: [{
                type: Input
            }], breadcrumb: [{
                type: ViewChild,
                args: ['breadcrumb']
            }] } });

class AsolBreadcrumbModule {
}
AsolBreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolBreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbModule, declarations: [AsolBreadcrumbComponent], imports: [SharedModule, BreadcrumbModule], exports: [AsolBreadcrumbComponent] });
AsolBreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbModule, imports: [[SharedModule, BreadcrumbModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolBreadcrumbComponent],
                    exports: [AsolBreadcrumbComponent],
                    imports: [SharedModule, BreadcrumbModule],
                }]
        }] });

var querybuilderTranslation = {
    "sk-SK": {
        querybuilder: {
            AddGroup: "Pridať skupinu",
            AddCondition: "Pridať podmienku",
            AddButton: "Pridať tlačidlo",
            DeleteRule: "Odstrániť pravidlo",
            DeleteGroup: "Odstrániť skupinu",
            Edit: "Upraviť",
            SelectField: "Vyberte pole",
            SelectOperator: "Vyberte operátor",
            Remove: "Odstrániť",
            ValidationMessage: "Toto pole je povinné",
            SummaryViewTitle: "Súhrnné zobrazenie",
            OtherFields: "Iné polia",
            AND: "ZÁROVEŇ",
            OR: "ALEBO",
            SelectValue: "Zadajte hodnotu"
        }
    },
    "cs-CZ": {
        querybuilder: {
            AddGroup: "Přidat skupinu",
            AddCondition: "Přidat podmínku",
            AddButton: "Přidat tlačítko",
            DeleteRule: "Odstranit pravidlo",
            DeleteGroup: "Odstranit skupinu",
            Edit: "Upravit",
            SelectField: "Vyberte pole",
            SelectOperator: "Vyberte operátor",
            Remove: "Odstranit",
            ValidationMessage: "Toto pole je povinné",
            SummaryViewTitle: "Shrnutí zobrazení",
            OtherFields: "Další pole",
            AND: "ZAČLEŇ",
            OR: "NEBO",
            SelectValue: "Zadejte hodnotu"
        }
    }
};

var translation$9 = {
    "sk-SK": {
        AddFilter: "Pridať filter",
        EditFilter: "Zmeniť filter",
        Name: "Názov filtra",
        NamePlaceholder: "Názov filtra",
        ActiveFilter: "Aktívny filter",
        InactiveFilter: "Neaktívny filter",
        NewFilter: "Nový filter",
        FilterName: "Názov filtra",
        AND: "AND",
        OR: "OR",
        DeleteConfirmTitle: "Zmazanie filtra",
        DeleteConfirm: "Skutočne chcete zmazať filter {0}?",
        SaveErrorMessage: "Filter musí obsahovať aspoň jedno pravidlo.",
        ValidationGroupErrorMessage: "Skupina musí obsahovať aspoň jedno pravidlo."
    },
    "cs-CZ": {
        AddFilter: "Přidat filter",
        EditFilter: "Změnit filter",
        Name: "Název filtra",
        NamePlaceholder: "Název filtra",
        ActiveFilter: "Aktívny filtr",
        InactiveFilter: "Neaktívny filtr",
        NewFilter: "Nový filtr",
        FilterName: "Název filtra",
        AND: "AND",
        OR: "OR",
        DeleteConfirmTitle: "Smazání filtra",
        DeleteConfirm: "Skutečně chcete smazat filtr {0}?",
        SaveErrorMessage: "Filtr musí obsahovat alespoň jedno pravidlo.",
        ValidationGroupErrorMessage: "Skupina musí obsahovať aspoň jedno pravidlo."
    },
    "en-US": {
        AddFilter: "Add filter",
        EditFilter: "Edit filter",
        Name: "Filter name",
        NamePlaceholder: "Filter name",
        ActiveFilter: "Active filter",
        InactiveFilter: "Inactive filter",
        NewFilter: "New filter",
        FilterName: "Filtra name",
        AND: "AND",
        OR: "OR",
        DeleteConfirmTitle: "Filter removal",
        DeleteConfirm: "Are you sure you want to remove filter {0}?",
        SaveErrorMessage: "The filter must contain at least one rule.",
        ValidationGroupErrorMessage: "The group must contain at least one rule."
    }
};

var FilterMenu;
(function (FilterMenu) {
    FilterMenu["edit"] = "edit";
    FilterMenu["duplicate"] = "duplicate";
    FilterMenu["delete"] = "delete";
})(FilterMenu || (FilterMenu = {}));

const FILTER_CONSTANT = {
    TRANS: 'ASOL-FILTER-TRANS',
    GENERAL_TRANS: GENERAL_TRANSLATION,
};

/* eslint-disable @typescript-eslint/ban-types */
/**
 * Creates date component for Query builder component
 * @param changeCallback Callback function when user selects date
 * @returns Dropdown component
 */
function createQueryBuilderDate(changeCallback) {
    const callback = changeCallback;
    return {
        create: () => {
            return createElement('input', { attrs: { type: 'Date' } });
        },
        destroy: (args) => {
            const datePicker = getComponent(document.getElementById(args.elementId), 'datepicker');
            if (datePicker) {
                datePicker.destroy();
            }
        },
        write: (args) => {
            const datePicker = new DatePicker({
                allowEdit: false,
                enabled: true,
                showClearButton: true,
                change: (data) => {
                    callback(data);
                },
                floatLabelType: 'Never',
                value: args.values ? new Date(args.values) : args.values,
            });
            datePicker.appendTo(`#${args.elements.id}`);
        },
    };
}

/**
 * Creates dropdown component for Query builder component
 * @param changeCallback Callback function when user selects item from dropdown
 * @param values Optional values for the dropdown
 * @param service Optional service to load values for the dropdown
 * @returns Dropdown component
 */
function createQueryBuilderDropdown(changeCallback, values, service) {
    const callback = changeCallback;
    return {
        create: () => {
            return createElement('input', { attrs: { type: 'text' } });
        },
        destroy: (args) => {
            const dropdown = getComponent(document.getElementById(args.elementId), 'dropdownlist');
            if (dropdown) {
                dropdown.destroy();
            }
        },
        write: (args) => {
            let dropDown = null;
            dropDown = new DropDownList({
                dataSource: values,
                fields: { value: 'value', text: 'text' },
                enabled: true,
                showClearButton: true,
                allowFiltering: true,
                change: (data) => {
                    callback(data);
                },
                floatLabelType: 'Never',
                value: args.values,
            });
            dropDown.appendTo(`#${args.elements.id}`);
            if (service) {
                // call the service and setup the component
                lastValueFrom(service).then((items) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    dropDown.dataSource = items;
                });
            }
            else {
                dropDown.dataSource = values;
            }
        },
    };
}

const QUERY_BUILDER_OPERATORS = {
    DATE_OPERATORS: [
        'greaterthan',
        'greaterthanorequal',
        'lessthan',
        'lessthanorequal',
        'equal',
        'notequal',
    ],
    NUMBER_OPERATORS: [
        'in',
        'notin',
        'isnull',
        'isnotnull',
        'greaterthan',
        'greaterthanorequal',
        'lessthan',
        'lessthanorequal',
        'between',
        'notbetween',
        'equal',
        'notequal',
    ],
    DEFAULT_OPERATORS: ['equal', 'notequal'],
    STRING_OPERATORS: [
        'in',
        'notin',
        'isnull',
        'isnotnull',
        'startswith',
        'endswith',
        'contains',
        'isempty',
        'isnotempty',
        'equal',
        'notequal',
    ],
};

/**
 * This function create query builder type operators based on input type.
 *
 * @export
 * @param {string} type - Type of query builder operation
 * @param {TranslationService} translation - Translation service from asol/core
 * @param {string} transConst - Translation init constant where is stored translation for operators
 * @returns {{ value: string; key: string }[]}
 */
function createQueryBuilderTypeOperators(type, translation, transConst) {
    switch (type) {
        case 'date': {
            return QUERY_BUILDER_OPERATORS.DATE_OPERATORS.map((item) => ({
                value: item,
                key: translation.get(transConst, item),
            }));
        }
        case 'number':
            return QUERY_BUILDER_OPERATORS.NUMBER_OPERATORS.map((item) => ({
                value: item,
                key: translation.get(transConst, item),
            }));
        case 'string': {
            return QUERY_BUILDER_OPERATORS.STRING_OPERATORS.map((item) => ({
                value: item,
                key: translation.get(transConst, item),
            }));
        }
        default:
            return QUERY_BUILDER_OPERATORS.DEFAULT_OPERATORS.map((item) => ({
                value: item,
                key: translation.get(transConst, item),
            }));
    }
}

/**
 * Builds Predicate object from json representation of Predicate @see {@link Predicate}
 * @param jsonPredicate source json representation of Predicate
 * @returns Predicate object or undefined
 */
function parsePredicateFromJson(jsonPredicate) {
    try {
        return JSON.parse(jsonPredicate);
    }
    catch (_a) {
        throw new Error('Given predicate is not valid');
    }
}

/**
 * Removes empty entries from filter model
 * @param rule Source filter tree model @see {@link RuleModel}
 * @returns Filter model without empty entries
 */
function removeEmptyFilterEntries(rule) {
    // Remove empty entries in child rules
    if (rule.rules) {
        rule.rules = rule.rules
            .map((childRule) => removeEmptyFilterEntries(childRule))
            .filter(Boolean);
    }
    // If both value and rules are empty, return null
    if ((rule.value === null || rule.value === undefined) &&
        (!rule.rules || rule.rules.length === 0)) {
        return null;
    }
    return rule;
}

class AsolFilterComponent {
    constructor(trans, cdr, filterService, dataPageService, formBuilder, notificationService) {
        this.trans = trans;
        this.cdr = cdr;
        this.filterService = filterService;
        this.dataPageService = dataPageService;
        this.formBuilder = formBuilder;
        this.notificationService = notificationService;
        /** Datasource that manages CRUD operations on filter */
        this.datasource = null;
        /** Shows outline to filter button */
        this.showFilterButtonOutline = false;
        /** Emit when user click on filter, if null active filter was deselected
         * @deprecated
         * */
        this.activeFilterClick = new EventEmitter();
        /** Emits when filter datasource is loaded and there is active filter */
        this.activeItemLoaded = new EventEmitter();
        /** Emits when user removes active item */
        this.activeItemRemoved = new EventEmitter();
        this.ICONS = ICONS;
        this.FILTER_CONSTANT = FILTER_CONSTANT;
        /** Filter items new or stored */
        this.filterItems = [];
        /** Items for each filter item */
        this.items = [];
        /** Dialog title changes according to add/edit */
        this.dialogTitle = '';
        this.confirmDialog = null;
        this.sub = new Subscription();
        /** Dialog button definition */
        this.dialogButtonDefinition = [
            {
                type: 'default',
                textType: 'Save',
                color: 'primary',
            },
            {
                type: 'outline',
                color: 'danger',
                textType: 'Cancel',
            },
        ];
        /** Column definition used directly on filter component (when not used with data page component)  */
        this.childColumns = null;
        /** Column definition used to fill the query builder */
        this.columnModel = [];
        this.trans.initialize(FILTER_CONSTANT.TRANS, translation$9);
        L10n.load(querybuilderTranslation);
        this.items = [
            {
                id: 'edit',
                text: this.trans.get(GENERAL_TRANSLATION, 'Edit'),
            },
            {
                id: 'duplicate',
                text: this.trans.get(GENERAL_TRANSLATION, 'Duplicate'),
            },
            {
                id: 'delete',
                text: this.trans.get(GENERAL_TRANSLATION, 'Delete'),
            },
        ];
        this.formGroup = this.formBuilder.group({
            id: [null],
            name: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.datasource.loadData(this.filter).subscribe((data) => {
            this.filterItems.splice(0, this.filterItems.length);
            this.filterItems = data !== null && data !== void 0 ? data : [];
            const item = this.filterItems.find((p) => p.active);
            if (item) {
                this.changeFilter(item, false);
                this.activeItemLoaded.emit(item);
            }
            this.cdr.detectChanges();
        });
        this.sub.add(this.filterService.filterChanged$.subscribe((data) => {
            var _a;
            if (data.id !== this.syncId) {
                return;
            }
            if (!((_a = data === null || data === void 0 ? void 0 : data.filter) === null || _a === void 0 ? void 0 : _a.filter)) {
                const active = this.filterItems.find((p) => p.active);
                if (!active) {
                    return;
                }
                this.datasource.changeActive(active).subscribe(() => {
                    this.filterItems.forEach((filter) => {
                        filter.active = false;
                    });
                    this.cdr.detectChanges();
                });
            }
        }));
        this.sub.add(this.dataPageService.columnsChanged$.subscribe((syncId) => {
            if (syncId !== this.syncId) {
                return;
            }
            const columns = this.dataPageService.getColumns(this.syncId);
            if (columns) {
                this.parseColumns(columns);
            }
        }));
    }
    ngAfterViewInit() {
        if (this.childColumns.length > 0) {
            this.childColumns.forEach((item) => {
                this.parseColumnItem(item);
            });
        }
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Parses column definition from input
     */
    parseColumns(columns) {
        this.columnModel.splice(0, this.columnModel.length);
        columns
            .filter((p) => p.useInFilter === true)
            .forEach((item) => {
            this.parseColumnItem(item);
        });
        this.cdr.detectChanges();
    }
    /**
     * Fills primary column definition model
     * @param item Item to parse @see {@link FilterColumnDirective}
     */
    parseColumnItem(item) {
        const type = item.type === 'select' ? 'string' : item.type;
        const header = item.headerKey
            ? item.transKey
                ? this.trans.get(item.transKey, item.headerKey)
                : translateProperty(this.columnTranslation, item.headerKey, this.trans.getFullLocale)
            : item.headerText;
        this.columnModel.push({
            type: type,
            field: item.field,
            format: item.format,
            label: header,
            operators: item.operators
                ? item.operators
                : this.getCustomOperatorsByType(item.type),
            step: item.step,
            validation: item.validation ? item.validation : { isRequired: true },
            value: item.value,
            values: item.values,
            template: this.createCustomQueryBuilderComponent(item.type, item.visible, item.values, item.dropDownService),
            category: item.category,
        });
    }
    /**
     * Creates custom components for grids filter bar
     * @param type Type of component to create
     * @param visible Flag if column is visible
     * @returns Returns component or undefined if component is not needed
     */
    createCustomQueryBuilderComponent(type, visible, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    values, service) {
        if (!type) {
            return undefined;
        }
        switch (type) {
            case 'select':
                return createQueryBuilderDropdown((data) => {
                    this.qryBldrObj.notifyChange(data.itemData.value, data.element);
                }, values, service);
            case 'date':
                return createQueryBuilderDate((data) => {
                    this.qryBldrObj.notifyChange(data.value, data.element);
                });
        }
        return undefined;
    }
    /**
     * Gets custom operators for query builder
     * @param type type of item
     * @param operators default operators
     * @returns Custom operator
     */
    getCustomOperatorsByType(type) {
        return createQueryBuilderTypeOperators(type, this.trans, FILTER_CONSTANT.GENERAL_TRANS);
    }
    /**
     * Toggles active and inactive filter
     * @param item Filter item
     */
    onToggleActive(item) {
        if (item.active) {
            item.active = false;
            this.activeFilterClick.emit(null);
            this.changeFilter(null);
        }
        else {
            this.filterItems.forEach((filter) => {
                filter.active = false;
            });
            item.active = true;
            this.activeFilterClick.emit(item);
            this.changeFilter(item);
        }
        this.datasource.changeActive(item).subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    /**
     * Gets parsed predicate and changes filter
     * @param item Filter item
     */
    changeFilter(item, store = true) {
        const predicate = item ? parsePredicateFromJson(item.predicate) : null;
        if (this.syncId) {
            this.filterService.changeFilter(this.syncId, 'filter', predicate, store);
        }
    }
    /**
     * Event handler for dropdown items click
     * @param event Button that was clicked
     * @param item Filter item
     */
    onSelect(event, item) {
        switch (event.item.id) {
            case FilterMenu.edit:
                this.edit(item);
                break;
            case FilterMenu.duplicate:
                this.duplicate(item);
                break;
            case FilterMenu.delete:
                this.delete(item);
                break;
        }
    }
    /**
     * Deletes filter
     * @param item Item to remove
     */
    delete(item) {
        const text = stringFormat(this.trans.get(FILTER_CONSTANT.TRANS, 'DeleteConfirm'), [item.name]);
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(FILTER_CONSTANT.TRANS, 'DeleteConfirmTitle'),
            content: text,
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.confirmClick.bind(this, item.id),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    confirmClick(id) {
        var _a;
        this.confirmDialog.hide();
        const item = this.filterItems.find((p) => p.id === id);
        if (!item) {
            return;
        }
        if (item.active && this.syncId) {
            (_a = this.filterService) === null || _a === void 0 ? void 0 : _a.changeFilter(this.syncId, 'filter', null);
        }
        this.datasource.delete(item).subscribe((removed) => {
            if (!removed) {
                return;
            }
            if (item.active) {
                this.activeItemRemoved.emit();
            }
            const index = this.filterItems.findIndex((p) => p.id === id);
            this.filterItems.splice(index, 1);
            this.cdr.detectChanges();
        });
    }
    /**
     * Creates new filter based on clicked filter
     * @param item Clicked filter item
     */
    duplicate(item) {
        this.dialogTitle = this.trans.get(FILTER_CONSTANT.TRANS, 'AddFilter');
        this.formGroup.patchValue({
            name: item.name,
        });
        this.changeButtonDefinition('Create');
        if (item.rules) {
            this.qryBldrObj.setRules(JSON.parse(item.rules));
        }
        this.filterDialog.show();
    }
    /**
     * Edits clicked filter
     * @param item Clicked filter item
     */
    edit(item) {
        this.dialogTitle = this.trans.get(FILTER_CONSTANT.TRANS, 'EditFilter');
        this.formGroup.patchValue({
            name: item.name,
            id: item.id,
        });
        if (item.rules) {
            const rules = removeEmptyFilterEntries(JSON.parse(item.rules));
            this.qryBldrObj.setRules(rules);
        }
        this.changeButtonDefinition('Save');
        if (!this.columnModel.length) {
            this.dataPageService.getColumns(this.syncId);
        }
        this.filterDialog.show();
    }
    /**
     * Opens dialog to add new filter
     */
    onAdd() {
        this.dialogTitle = this.trans.get(FILTER_CONSTANT.TRANS, 'AddFilter');
        this.formGroup.reset();
        this.changeButtonDefinition('Create');
        this.qryBldrObj.reset();
        this.filterDialog.show();
    }
    /**
     * Event when user clicks button in create dialog
     * @param button Button which was clicked
     */
    onDialogClose(button) {
        var _a;
        if (button === 'Close' || button === 'Cancel') {
            this.resetAndHide();
            return;
        }
        markForValidation(this.formGroup);
        if (this.formGroup.invalid) {
            return;
        }
        if (((_a = this.qryBldrObj.getRules()) === null || _a === void 0 ? void 0 : _a.rules.length) === 0) {
            this.notificationService.danger(this.trans.get(FILTER_CONSTANT.TRANS, 'SaveErrorMessage'));
            return;
        }
        if (!this.qryBldrObj.validateFields()) {
            return;
        }
        const rules = removeEmptyFilterEntries(this.qryBldrObj.getRules());
        if (!rules) {
            this.notificationService.danger(this.trans.get(FILTER_CONSTANT.TRANS, 'ValidationGroupErrorMessage'));
            return;
        }
        const predicate = JSON.stringify(this.qryBldrObj.getPredicate(rules));
        if (!predicate) {
            this.notificationService.danger(this.trans.get(FILTER_CONSTANT.TRANS, 'ValidationGroupErrorMessage'));
            return;
        }
        const ruleString = JSON.stringify(rules);
        switch (button) {
            case 'Save':
                {
                    const id = this.formGroup.controls['id'].value;
                    const item = this.filterItems.find((p) => p.id === id);
                    item.name = this.formGroup.controls['name'].value;
                    item.rules = ruleString;
                    item.predicate = predicate;
                    this.datasource.update(item, this.filter).subscribe(() => {
                        if (item.active) {
                            this.changeFilter(item);
                        }
                        this.resetAndHide();
                    });
                }
                return;
            case 'Create':
                {
                    this.datasource
                        .create({
                        active: false,
                        name: this.formGroup.controls['name'].value,
                        rules: ruleString,
                        predicate: predicate,
                    }, this.filter)
                        .subscribe((data) => {
                        this.filterItems.push(data);
                        this.resetAndHide();
                    });
                }
                return;
        }
    }
    /**
     * Reset the filter dialog
     */
    resetAndHide() {
        this.cdr.detectChanges();
        this.filterDialog.hide();
        this.formGroup.reset();
    }
    /**
     * Changes first button according to usage new/edit
     * @param type Button type
     */
    changeButtonDefinition(type) {
        this.dialogButtonDefinition.splice(0, 1);
        this.dialogButtonDefinition.unshift({
            type: 'default',
            textType: type,
            color: 'primary',
        });
    }
}
AsolFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterComponent, deps: [{ token: i1.TranslationService }, { token: i0.ChangeDetectorRef }, { token: FilterSyncService }, { token: PageColumnsService }, { token: i2.FormBuilder }, { token: NotificationService }], target: i0.ɵɵFactoryTarget.Component });
AsolFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolFilterComponent, selector: "asol-filter", inputs: { datasource: "datasource", filter: "filter", showFilterButtonOutline: "showFilterButtonOutline", columnTranslation: "columnTranslation", syncId: "syncId" }, outputs: { activeFilterClick: "activeFilterClick", activeItemLoaded: "activeItemLoaded", activeItemRemoved: "activeItemRemoved" }, providers: [DatePipe], queries: [{ propertyName: "childColumns", predicate: AsolDataColumnDirective }], viewQueries: [{ propertyName: "filterDialog", first: true, predicate: ["filterDialog"], descendants: true }, { propertyName: "qryBldrObj", first: true, predicate: ["querybuilder"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #filterDialog\n  width=\"900px\"\n  [headerText]=\"dialogTitle\"\n  [buttonDefinition]=\"dialogButtonDefinition\"\n  [buttonPosition]=\"'start'\"\n  [closeOnOverlayClick]=\"false\"\n  (buttonClicked)=\"onDialogClose($event)\">\n  <form [formGroup]=\"formGroup\">\n    <div class=\"row\">\n      <div class=\"col-6\">\n        <asol-input-field\n          id=\"new-filter-name\"\n          formControlName=\"name\"\n          [transKey]=\"FILTER_CONSTANT.TRANS\"\n          labelKey=\"Name\"\n          placeholderKey=\"NamePlaceholder\">\n        </asol-input-field>\n      </div>\n    </div>\n  </form>\n  <ejs-querybuilder\n    id=\"filter-querybuilder\"\n    [locale]=\"this.trans.getFullLocale\"\n    #querybuilder\n    width=\"100%\"\n    [allowValidation]=\"true\"\n    [columns]=\"columnModel\">\n  </ejs-querybuilder>\n</asol-dialog>\n\n<div class=\"d-flex flex-wrap align-items-center\">\n  <asol-button\n    id=\"filter-add-button\"\n    type=\"flat\"\n    color=\"dark\"\n    iconPosition=\"left\"\n    class=\"me-5 mb-2 add-button\"\n    cssClass=\"btn-small\"\n    (click)=\"onAdd()\"\n    [iconSvgUrl]=\"ICONS.FILTER\">\n    {{ trans.get(FILTER_CONSTANT.TRANS, 'AddFilter') }}\n  </asol-button>\n  <div class=\"me-3 mb-2\" *ngFor=\"let filter of filterItems\">\n    <asol-split-button\n      [id]=\"filter.id\"\n      [items]=\"items\"\n      [showOutline]=\"showFilterButtonOutline\"\n      [cssClass]=\"\n        !filter.active ? 'asol-split-filter' : 'asol-split-filter active-filter'\n      \"\n      chevronSvgUrl=\"assets/icons/popular/vertical-dots.svg\"\n      (primaryClick)=\"onToggleActive(filter)\"\n      (select)=\"onSelect($event, filter)\">\n      {{ filter.name }}\n    </asol-split-button>\n  </div>\n</div>\n", styles: [".e-btn.e-flat:focus ::ng-deep{box-shadow:none}\n"], components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }, { type: i8$1.QueryBuilderComponent, selector: "ejs-querybuilder", inputs: ["allowValidation", "columns", "cssClass", "dataSource", "displayMode", "enableNotCondition", "enablePersistence", "enableRtl", "fieldMode", "fieldModel", "headerTemplate", "height", "immediateModeDelay", "locale", "matchCase", "maxGroupCount", "operatorModel", "readonly", "rule", "separator", "showButtons", "sortDirection", "summaryView", "valueModel", "width"], outputs: ["actionBegin", "beforeChange", "change", "created", "dataBound", "ruleChange"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolSplitButtonComponent, selector: "asol-split-button", inputs: ["type", "textType", "color", "disabled", "iconSvgUrl", "chevronSvgUrl", "items", "showOutline", "cssClass"], outputs: ["primaryClick", "select"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-filter', providers: [DatePipe], changeDetection: ChangeDetectionStrategy.OnPush, template: "<asol-dialog\n  #filterDialog\n  width=\"900px\"\n  [headerText]=\"dialogTitle\"\n  [buttonDefinition]=\"dialogButtonDefinition\"\n  [buttonPosition]=\"'start'\"\n  [closeOnOverlayClick]=\"false\"\n  (buttonClicked)=\"onDialogClose($event)\">\n  <form [formGroup]=\"formGroup\">\n    <div class=\"row\">\n      <div class=\"col-6\">\n        <asol-input-field\n          id=\"new-filter-name\"\n          formControlName=\"name\"\n          [transKey]=\"FILTER_CONSTANT.TRANS\"\n          labelKey=\"Name\"\n          placeholderKey=\"NamePlaceholder\">\n        </asol-input-field>\n      </div>\n    </div>\n  </form>\n  <ejs-querybuilder\n    id=\"filter-querybuilder\"\n    [locale]=\"this.trans.getFullLocale\"\n    #querybuilder\n    width=\"100%\"\n    [allowValidation]=\"true\"\n    [columns]=\"columnModel\">\n  </ejs-querybuilder>\n</asol-dialog>\n\n<div class=\"d-flex flex-wrap align-items-center\">\n  <asol-button\n    id=\"filter-add-button\"\n    type=\"flat\"\n    color=\"dark\"\n    iconPosition=\"left\"\n    class=\"me-5 mb-2 add-button\"\n    cssClass=\"btn-small\"\n    (click)=\"onAdd()\"\n    [iconSvgUrl]=\"ICONS.FILTER\">\n    {{ trans.get(FILTER_CONSTANT.TRANS, 'AddFilter') }}\n  </asol-button>\n  <div class=\"me-3 mb-2\" *ngFor=\"let filter of filterItems\">\n    <asol-split-button\n      [id]=\"filter.id\"\n      [items]=\"items\"\n      [showOutline]=\"showFilterButtonOutline\"\n      [cssClass]=\"\n        !filter.active ? 'asol-split-filter' : 'asol-split-filter active-filter'\n      \"\n      chevronSvgUrl=\"assets/icons/popular/vertical-dots.svg\"\n      (primaryClick)=\"onToggleActive(filter)\"\n      (select)=\"onSelect($event, filter)\">\n      {{ filter.name }}\n    </asol-split-button>\n  </div>\n</div>\n", styles: [".e-btn.e-flat:focus ::ng-deep{box-shadow:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i0.ChangeDetectorRef }, { type: FilterSyncService }, { type: PageColumnsService }, { type: i2.FormBuilder }, { type: NotificationService }]; }, propDecorators: { datasource: [{
                type: Input
            }], filter: [{
                type: Input
            }], showFilterButtonOutline: [{
                type: Input
            }], columnTranslation: [{
                type: Input
            }], syncId: [{
                type: Input
            }], activeFilterClick: [{
                type: Output
            }], activeItemLoaded: [{
                type: Output
            }], activeItemRemoved: [{
                type: Output
            }], filterDialog: [{
                type: ViewChild,
                args: ['filterDialog']
            }], qryBldrObj: [{
                type: ViewChild,
                args: ['querybuilder']
            }], childColumns: [{
                type: ContentChildren,
                args: [AsolDataColumnDirective]
            }] } });

class AsolFilterModule {
}
AsolFilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolFilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterModule, declarations: [AsolFilterComponent], imports: [SharedModule,
        AsolButtonModule,
        SplitButtonModule,
        AsolDialogModule,
        AsolInputFieldModule,
        QueryBuilderModule,
        AsolDataColumnModule], exports: [AsolFilterComponent] });
AsolFilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterModule, imports: [[
            SharedModule,
            AsolButtonModule,
            SplitButtonModule,
            AsolDialogModule,
            AsolInputFieldModule,
            QueryBuilderModule,
            AsolDataColumnModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolFilterComponent],
                    exports: [AsolFilterComponent],
                    imports: [
                        SharedModule,
                        AsolButtonModule,
                        SplitButtonModule,
                        AsolDialogModule,
                        AsolInputFieldModule,
                        QueryBuilderModule,
                        AsolDataColumnModule,
                    ],
                }]
        }] });

/**
 * Adds custom predicates to grid filter predicate
 * @param args grid filter predicate @see {@link DataState}
 * @param customPredicates array of custom predicates @see {@link Predicate}
 */
function addCustomPredicates(args, customPredicates) {
    var _a;
    /** if there are no custom predicates */
    if (!(customPredicates === null || customPredicates === void 0 ? void 0 : customPredicates.length)) {
        return;
    }
    /** parent predicate to handle complex predicates */
    const parentPredicate = new Predicate(null, 'and', null);
    parentPredicate.isComplex = true;
    parentPredicate.condition = 'and';
    parentPredicate.predicates = [];
    /** if there are more custom predicates, add to parent predicate */
    if (customPredicates.length > 1) {
        parentPredicate.predicates = [...customPredicates];
    }
    /** if there are not any filters from grid, assign custom predicates */
    if (!((_a = args === null || args === void 0 ? void 0 : args.where) === null || _a === void 0 ? void 0 : _a.length)) {
        args.where = [];
        parentPredicate.predicates.length
            ? args.where.push(parentPredicate)
            : args.where.push(customPredicates[0]);
        return;
    }
    /** replace predicates in args */
    customPredicates.forEach((item) => {
        const targetArray = args.where[0].isComplex
            ? args.where[0].predicates
            : args.where;
        const index = targetArray.findIndex((predicate) => predicate.field === item.field);
        if (index >= 0) {
            targetArray[index] = item;
        }
        else {
            targetArray.push(item);
        }
    });
}

/**
 * Removes custom predicate from grid filter predicate
 * @param args grid filter predicate @see {@link DataState}
 * @param customPredicateName the custom predicate
 */
function removeCustomPredicate(args, customPredicateName) {
    var _a;
    /** if there is no predicate */
    if (!args || !customPredicateName || !((_a = args.where) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    /** remove predicate from args */
    const targetArray = args.where[0].isComplex
        ? args.where[0].predicates
        : args.where;
    const index = targetArray.findIndex((predicate) => predicate.field === customPredicateName);
    /** remove only if predicate was found */
    if (index >= 0) {
        targetArray.splice(index, 1);
    }
}

const ICON_FORMATS = {
    PNG: '.png',
    SVG: '.svg',
};

class AsolLanguageSelectComponent {
    constructor(translationService) {
        this.translationService = translationService;
        /** custom css class for dropdown button
         * @default ''
         */
        this.cssClass = '';
        /**
         * DEVCLOUD-6793 temporary fix for language select
         * Emits language when new language is selected.
         *
         * @type {string}
         */
        this.onLanguageChange = new EventEmitter();
        this.ASSETS_BASE = ASSETS_BASE;
        this.ICON_FORMATS = ICON_FORMATS;
    }
    /**
     * This method sets selected language from dropdown list in translation service
     * @param language Event from dropdownlist. SelectEventArgs contains selected language short code in itemData
     *
     */
    onFlagSelect(language) {
        this.onLanguageChange.emit(language.itemData['short']);
        this.translationService.setLocale(language.itemData['short'], true);
    }
}
AsolLanguageSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolLanguageSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolLanguageSelectComponent, selector: "asol-language-select", inputs: { cssClass: "cssClass" }, outputs: { onLanguageChange: "onLanguageChange" }, ngImport: i0, template: "<ejs-dropdownlist\n  [dataSource]=\"translationService.getSupportedLanguages\"\n  [cssClass]=\"'center-item dropdown-default' + ' ' + cssClass\"\n  [fields]=\"{ text: 'short', value: 'short' }\"\n  (select)=\"onFlagSelect($event)\"\n  [value]=\"translationService.currentLocale\">\n  <ng-template #itemTemplate #valueTemplate let-data>\n    <img\n      [src]=\"ASSETS_BASE.FLAGS + '/' + data.short + ICON_FORMATS.SVG\"\n      alt=\"flag\" />\n  </ng-template>\n</ejs-dropdownlist>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.custom-language-input.e-input-group{background-color:transparent;border:transparent}.custom-language-input .e-input-group-icon{color:#fff!important}\n"], components: [{ type: i4$1.DropDownListComponent, selector: "ejs-dropdownlist", inputs: ["actionFailureTemplate", "allowFiltering", "cssClass", "dataSource", "enablePersistence", "enableRtl", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "groupTemplate", "headerTemplate", "htmlAttributes", "ignoreAccent", "ignoreCase", "index", "itemTemplate", "locale", "noRecordsTemplate", "placeholder", "popupHeight", "popupWidth", "query", "readonly", "showClearButton", "sortOrder", "text", "value", "valueTemplate", "width", "zIndex"], outputs: ["actionBegin", "actionComplete", "actionFailure", "beforeOpen", "blur", "change", "close", "created", "dataBound", "destroyed", "filtering", "focus", "open", "select", "valueChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-language-select', template: "<ejs-dropdownlist\n  [dataSource]=\"translationService.getSupportedLanguages\"\n  [cssClass]=\"'center-item dropdown-default' + ' ' + cssClass\"\n  [fields]=\"{ text: 'short', value: 'short' }\"\n  (select)=\"onFlagSelect($event)\"\n  [value]=\"translationService.currentLocale\">\n  <ng-template #itemTemplate #valueTemplate let-data>\n    <img\n      [src]=\"ASSETS_BASE.FLAGS + '/' + data.short + ICON_FORMATS.SVG\"\n      alt=\"flag\" />\n  </ng-template>\n</ejs-dropdownlist>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.custom-language-input.e-input-group{background-color:transparent;border:transparent}.custom-language-input .e-input-group-icon{color:#fff!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { cssClass: [{
                type: Input
            }], onLanguageChange: [{
                type: Output
            }] } });

class AsolLanguageSelectModule {
}
AsolLanguageSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolLanguageSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectModule, declarations: [AsolLanguageSelectComponent], imports: [DropDownListModule], exports: [AsolLanguageSelectComponent] });
AsolLanguageSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectModule, imports: [[DropDownListModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLanguageSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolLanguageSelectComponent],
                    exports: [AsolLanguageSelectComponent],
                    imports: [DropDownListModule],
                }]
        }] });

class AsolCheckboxGroupComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        this.options = [];
        this.valueProperty = 'value';
        this.displayProperty = 'text';
        this.horizontalAlignment = false;
        this.labelPosition = 'After';
        this.indeterminate = false;
        this.checkboxButtons = null;
        this.groupId = generateId();
    }
    ngOnInit() {
        super.ngOnInit();
        this.loadOptions();
    }
    loadOptions() {
        if (!this.dataProvider) {
            return;
        }
        this.dataProvider
            .getData(this.optionsProviderParam)
            .subscribe((response) => {
            this.options = response;
        });
    }
    getControlValue() {
        if (!this.checkboxButtons) {
            return null;
        }
        return this.checkboxButtons.filter((p) => p.checked).map((x) => x.value);
    }
    setControlValue(val) {
        // not needed
    }
    setControlDisabled(isDisable) {
        // Not needed
    }
    callOnChange(event) {
        this.onChange(event.checked);
        this.valueChangedDebouncer.next(this.checkboxButtons.filter((p) => p.checked).map((x) => x.value));
    }
}
AsolCheckboxGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolCheckboxGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolCheckboxGroupComponent, selector: "asol-checkbox-group", inputs: { options: "options", valueProperty: "valueProperty", displayProperty: "displayProperty", dataProvider: "dataProvider", optionsProviderParam: "optionsProviderParam", horizontalAlignment: "horizontalAlignment", labelPosition: "labelPosition", indeterminate: "indeterminate" }, viewQueries: [{ propertyName: "checkboxButtons", predicate: CheckBoxComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div\n    class=\"asol-error d-inline-flex align-items-center mb-2 mt-0\"\n    *ngFor=\"let msg of getErrorMessages()\">\n    <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n    {{ msg }}\n  </div>\n  <div\n    class=\"d-flex\"\n    [ngClass]=\"horizontalAlignment ? 'flex-row' : 'flex-column'\">\n    <ejs-checkbox\n      [id]=\"id ?? 'radioelement'\"\n      cssClass=\"mb-2 me-3\"\n      *ngFor=\"let item of options; let i = index\"\n      id=\"checkbox{{ formControlName }}{{ i }}\"\n      [ngClass]=\"{\n        'e-error': ngControl.control.errors && ngControl.control.touched\n      }\"\n      [disabled]=\"isDisabled\"\n      [indeterminate]=\"indeterminate\"\n      [checked]=\"ngControl?.control?.value?.includes(item[valueProperty])\"\n      [labelPosition]=\"labelPosition\"\n      [label]=\"item[displayProperty]\"\n      [value]=\"item[valueProperty]\"\n      (change)=\"callOnChange($event)\"\n      [name]=\"groupId\">\n    </ejs-checkbox>\n  </div>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: i5.CheckBoxComponent, selector: "ejs-checkbox", inputs: ["checked", "cssClass", "disabled", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "htmlAttributes", "indeterminate", "label", "labelPosition", "locale", "name", "value"], outputs: ["focus", "blur", "change", "created", "checkedChange", "indeterminateChange"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-checkbox-group', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div\n    class=\"asol-error d-inline-flex align-items-center mb-2 mt-0\"\n    *ngFor=\"let msg of getErrorMessages()\">\n    <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n    {{ msg }}\n  </div>\n  <div\n    class=\"d-flex\"\n    [ngClass]=\"horizontalAlignment ? 'flex-row' : 'flex-column'\">\n    <ejs-checkbox\n      [id]=\"id ?? 'radioelement'\"\n      cssClass=\"mb-2 me-3\"\n      *ngFor=\"let item of options; let i = index\"\n      id=\"checkbox{{ formControlName }}{{ i }}\"\n      [ngClass]=\"{\n        'e-error': ngControl.control.errors && ngControl.control.touched\n      }\"\n      [disabled]=\"isDisabled\"\n      [indeterminate]=\"indeterminate\"\n      [checked]=\"ngControl?.control?.value?.includes(item[valueProperty])\"\n      [labelPosition]=\"labelPosition\"\n      [label]=\"item[displayProperty]\"\n      [value]=\"item[valueProperty]\"\n      (change)=\"callOnChange($event)\"\n      [name]=\"groupId\">\n    </ejs-checkbox>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { options: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], optionsProviderParam: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], checkboxButtons: [{
                type: ViewChildren,
                args: [CheckBoxComponent]
            }] } });

class AsolCheckboxGroupModule {
}
AsolCheckboxGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolCheckboxGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupModule, declarations: [AsolCheckboxGroupComponent], imports: [SharedModule, AsolLabelFieldModule, CheckBoxModule], exports: [AsolCheckboxGroupComponent] });
AsolCheckboxGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupModule, imports: [[SharedModule, AsolLabelFieldModule, CheckBoxModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolCheckboxGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolCheckboxGroupComponent],
                    exports: [AsolCheckboxGroupComponent],
                    imports: [SharedModule, AsolLabelFieldModule, CheckBoxModule],
                }]
        }] });

class AsolRadioGroupComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        this.options = [];
        this.valueProperty = 'value';
        this.displayProperty = 'text';
        this.horizontalAlignment = false;
        this.labelPosition = 'After';
        /** Label vertical alignment */
        this.labelVerticalAlignment = false;
        this.radioButtons = null;
        this.groupId = generateId();
    }
    ngOnInit() {
        super.ngOnInit();
        this.loadOptions();
    }
    loadOptions() {
        if (!this.dataProvider) {
            return;
        }
        this.displayProperty = 'text';
        this.valueProperty = 'value';
        this.dataProvider
            .getData(this.optionsProviderParam)
            .subscribe((response) => {
            this.options = response;
        });
    }
    getControlValue() {
        var _a;
        if (!this.radioButtons) {
            return null;
        }
        const checked = this.radioButtons.find((p) => p.checked);
        return (_a = checked === null || checked === void 0 ? void 0 : checked.value) !== null && _a !== void 0 ? _a : null;
    }
    setControlValue(val) {
        // not needed
    }
    setControlDisabled(isDisable) {
        // Not needed
    }
    callOnChange(event) {
        this.onChange(event.value);
        this.valueChangedDebouncer.next(event.value);
    }
}
AsolRadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolRadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolRadioGroupComponent, selector: "asol-radio-group", inputs: { options: "options", valueProperty: "valueProperty", displayProperty: "displayProperty", dataProvider: "dataProvider", optionsProviderParam: "optionsProviderParam", horizontalAlignment: "horizontalAlignment", labelPosition: "labelPosition", labelVerticalAlignment: "labelVerticalAlignment" }, viewQueries: [{ propertyName: "radioButtons", predicate: RadioButtonComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div\n    class=\"asol-error d-inline-flex align-items-center mb-2 mt-0\"\n    *ngFor=\"let msg of getErrorMessages()\">\n    <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n    {{ msg }}\n  </div>\n  <div\n    class=\"d-flex\"\n    [ngClass]=\"{\n      'flex-row': horizontalAlignment,\n      'flex-column': !horizontalAlignment,\n      'label-vertical-alignment': labelVerticalAlignment\n    }\">\n    <ejs-radiobutton\n      [id]=\"id ?? 'radioelement'\"\n      cssClass=\"mb-2 me-3\"\n      *ngFor=\"let item of options; let i = index\"\n      id=\"radio{{ formControlName }}{{ i }}\"\n      [ngClass]=\"{\n        'e-error': ngControl.control.errors && ngControl.control.touched\n      }\"\n      [disabled]=\"isDisabled\"\n      [checked]=\"item[valueProperty] === ngControl?.control?.value\"\n      [labelPosition]=\"labelPosition\"\n      [label]=\"item[displayProperty]\"\n      [value]=\"item[valueProperty]\"\n      (change)=\"callOnChange($event)\"\n      [name]=\"groupId\">\n    </ejs-radiobutton>\n  </div>\n</div>\n", styles: [""], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: i5.RadioButtonComponent, selector: "ejs-radiobutton", inputs: ["checked", "cssClass", "disabled", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "htmlAttributes", "label", "labelPosition", "locale", "name", "value"], outputs: ["focus", "blur", "change", "created", "valueChange"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-radio-group', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div\n    class=\"asol-error d-inline-flex align-items-center mb-2 mt-0\"\n    *ngFor=\"let msg of getErrorMessages()\">\n    <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n    {{ msg }}\n  </div>\n  <div\n    class=\"d-flex\"\n    [ngClass]=\"{\n      'flex-row': horizontalAlignment,\n      'flex-column': !horizontalAlignment,\n      'label-vertical-alignment': labelVerticalAlignment\n    }\">\n    <ejs-radiobutton\n      [id]=\"id ?? 'radioelement'\"\n      cssClass=\"mb-2 me-3\"\n      *ngFor=\"let item of options; let i = index\"\n      id=\"radio{{ formControlName }}{{ i }}\"\n      [ngClass]=\"{\n        'e-error': ngControl.control.errors && ngControl.control.touched\n      }\"\n      [disabled]=\"isDisabled\"\n      [checked]=\"item[valueProperty] === ngControl?.control?.value\"\n      [labelPosition]=\"labelPosition\"\n      [label]=\"item[displayProperty]\"\n      [value]=\"item[valueProperty]\"\n      (change)=\"callOnChange($event)\"\n      [name]=\"groupId\">\n    </ejs-radiobutton>\n  </div>\n</div>\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { options: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], optionsProviderParam: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], labelVerticalAlignment: [{
                type: Input
            }], radioButtons: [{
                type: ViewChildren,
                args: [RadioButtonComponent]
            }] } });

class AsolRadioGroupModule {
}
AsolRadioGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolRadioGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupModule, declarations: [AsolRadioGroupComponent], imports: [SharedModule, AsolLabelFieldModule, RadioButtonModule], exports: [AsolRadioGroupComponent] });
AsolRadioGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupModule, imports: [[SharedModule, AsolLabelFieldModule, RadioButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolRadioGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolRadioGroupComponent],
                    exports: [AsolRadioGroupComponent],
                    imports: [SharedModule, AsolLabelFieldModule, RadioButtonModule],
                }]
        }] });

class AsolSwitchComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.ngControl = ngControl;
        this.large = false;
        /** Adjustment for asol-switch on white background */
        this.isWhiteBackground = false;
        this.input = null;
        this.largeCss = '';
        this.checked = false;
        this.innerIconSrc = '';
    }
    ngOnChanges(changes) {
        if (changes.large && this.large) {
            this.largeCss = 'e-large';
        }
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.checked;
    }
    setControlValue(val) {
        if (!this.input || val === null) {
            return;
        }
        if (this.input) {
            this.input.checked = val;
            this.checked = val;
            this.handleInnerIconOnChange();
        }
    }
    setControlDisabled(isDisable) {
        // throw new Error('Method not implemented.');
    }
    callOnChange(event) {
        this.checked = event.checked;
        this.onChange(event.checked);
        this.valueChangedDebouncer.next(event.checked);
        this.handleInnerIconOnChange();
    }
    /**
     * Handles inner icon change on value changed
     */
    handleInnerIconOnChange() {
        this.innerIconSrc = this.checked
            ? this.ICONS.CHECK
            : this.ICONS.CLOSE_SMALL;
    }
}
AsolSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSwitchComponent, selector: "asol-switch", inputs: { large: "large", isWhiteBackground: "isWhiteBackground" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["switch"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div\n  [ngClass]=\"{ 'mb-2': showError, white: isWhiteBackground }\"\n  [class]=\"cssClass\">\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div class=\"d-flex flex-column\">\n    <div class=\"d-flex align-items-center\">\n      <ejs-switch\n        #switch\n        [id]=\"id ?? 'switchelement'\"\n        [disabled]=\"isDisabled\"\n        [cssClass]=\"largeCss\"\n        (change)=\"callOnChange($event)\"\n        [ngClass]=\"{\n          'e-error': ngControl.control.errors && ngControl.control.touched\n        }\">\n      </ejs-switch>\n      <svg-icon\n        [ngClass]=\"checked ? 'icon-on' : 'icon-off'\"\n        [class.disabled]=\"isDisabled\"\n        [class.large]=\"large\"\n        [src]=\"innerIconSrc\"></svg-icon>\n    </div>\n\n    <ng-container *ngIf=\"showError\">\n      <div\n        class=\"asol-error d-inline-flex align-items-center\"\n        *ngFor=\"let msg of getErrorMessages()\">\n        <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n        {{ msg }}\n      </div>\n    </ng-container>\n  </div>\n</div>\n", styles: [".icon-off{position:relative;bottom:2px;left:-14px}.icon-off.large{bottom:2px;left:-17px}.icon-off.large svg{width:10px;height:10px}.icon-on{position:relative;bottom:1px;left:-27px}.icon-on.large{bottom:2px;left:-34px}.icon-on.large svg{width:10px;height:10px}\n"], components: [{ type: i5.SwitchComponent, selector: "ejs-switch", inputs: ["checked", "cssClass", "disabled", "enablePersistence", "enableRtl", "locale", "name", "offLabel", "onLabel", "value"], outputs: ["focus", "blur", "change", "created", "checkedChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-switch', template: "<div\n  [ngClass]=\"{ 'mb-2': showError, white: isWhiteBackground }\"\n  [class]=\"cssClass\">\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n  <div class=\"d-flex flex-column\">\n    <div class=\"d-flex align-items-center\">\n      <ejs-switch\n        #switch\n        [id]=\"id ?? 'switchelement'\"\n        [disabled]=\"isDisabled\"\n        [cssClass]=\"largeCss\"\n        (change)=\"callOnChange($event)\"\n        [ngClass]=\"{\n          'e-error': ngControl.control.errors && ngControl.control.touched\n        }\">\n      </ejs-switch>\n      <svg-icon\n        [ngClass]=\"checked ? 'icon-on' : 'icon-off'\"\n        [class.disabled]=\"isDisabled\"\n        [class.large]=\"large\"\n        [src]=\"innerIconSrc\"></svg-icon>\n    </div>\n\n    <ng-container *ngIf=\"showError\">\n      <div\n        class=\"asol-error d-inline-flex align-items-center\"\n        *ngFor=\"let msg of getErrorMessages()\">\n        <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n        {{ msg }}\n      </div>\n    </ng-container>\n  </div>\n</div>\n", styles: [".icon-off{position:relative;bottom:2px;left:-14px}.icon-off.large{bottom:2px;left:-17px}.icon-off.large svg{width:10px;height:10px}.icon-on{position:relative;bottom:1px;left:-27px}.icon-on.large{bottom:2px;left:-34px}.icon-on.large svg{width:10px;height:10px}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { large: [{
                type: Input
            }], isWhiteBackground: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['switch', { static: false }]
            }] } });

class AsolSwitchModule {
}
AsolSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchModule, declarations: [AsolSwitchComponent], imports: [SharedModule, SwitchModule], exports: [AsolSwitchComponent] });
AsolSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchModule, imports: [[SharedModule, SwitchModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolSwitchComponent],
                    exports: [AsolSwitchComponent],
                    imports: [SharedModule, SwitchModule],
                }]
        }] });

class AsolTextAreaComponent extends NativeControlBase {
    constructor(renderer, trans, ngControl) {
        super(renderer, trans, ngControl);
        this.ngControl = ngControl;
        this.rows = 3;
    }
    focusIn(target) {
        target.parentElement.classList.add('e-input-focus');
    }
    focusOut(target) {
        target.parentElement.classList.remove('e-input-focus');
    }
    callOnChange() {
        this.onChange(this.value);
        this.valueChangedDebouncer.next(this.value);
    }
}
AsolTextAreaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaComponent, deps: [{ token: i0.Renderer2 }, { token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolTextAreaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolTextAreaComponent, selector: "asol-text-area", inputs: { rows: "rows" }, usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <div\n    class=\"e-input-group asol-input\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched,\n      'e-disabled': ngControl.control?.disabled\n    }\">\n    <textarea\n      #inputField\n      [id]=\"id ?? 'textareaelement'\"\n      class=\"e-input\"\n      [rows]=\"rows\"\n      [placeholder]=\"placeholderText\"\n      [disabled]=\"ngControl.control?.disabled\"\n      [readonly]=\"isReadonly\"\n      (change)=\"callOnChange()\"\n      (focus)=\"focusIn($event.target)\"\n      (blur)=\"focusOut($event.target)\">\n    </textarea>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [""], components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-text-area', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <div\n    class=\"e-input-group asol-input\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched,\n      'e-disabled': ngControl.control?.disabled\n    }\">\n    <textarea\n      #inputField\n      [id]=\"id ?? 'textareaelement'\"\n      class=\"e-input\"\n      [rows]=\"rows\"\n      [placeholder]=\"placeholderText\"\n      [disabled]=\"ngControl.control?.disabled\"\n      [readonly]=\"isReadonly\"\n      (change)=\"callOnChange()\"\n      (focus)=\"focusIn($event.target)\"\n      (blur)=\"focusOut($event.target)\">\n    </textarea>\n  </div>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { rows: [{
                type: Input
            }] } });

class AsolTextAreaModule {
}
AsolTextAreaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolTextAreaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaModule, declarations: [AsolTextAreaComponent], imports: [SharedModule, AsolLabelFieldModule], exports: [AsolTextAreaComponent] });
AsolTextAreaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaModule, imports: [[SharedModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTextAreaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolTextAreaComponent],
                    exports: [AsolTextAreaComponent],
                    imports: [SharedModule, AsolLabelFieldModule],
                }]
        }] });

class AsolTimePickerComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        /** Gets or sets the maximum time value that can be allowed to select in TimePicker. */
        this.max = null;
        /** Gets or sets the minimum time value that can be allowed to select in TimePicker. */
        this.min = null;
        /**
         * By default, the popup opens while clicking on the timepicker icon.
         * @default true
         */
        this.openOnFocus = true;
        /**
         * Specifies whether to show or hide the clear icon.
         * @default true
         */
        this.showClearButton = true;
        /**
         * Specifies the time interval between the two adjacent time values in the popup list.
         * @default 30
         *
         */
        this.step = 30;
        /** Specifies the component to act as strict so that, it allows to enter only a valid time value within a specified range or else
         * resets to previous value.
         * @default false
         * */
        this.strictMode = false;
        this.input = null;
        this.format = this.trans.getTimeFormatForLocale();
    }
    /**
     * Override for base lcoalize after language change
     */
    localizeTexts() {
        super.localizeTexts();
        this.format = this.trans.getTimeFormatForLocale();
    }
    getControlValue() {
        if (!this.input) {
            return null;
        }
        return this.input.value;
    }
    setControlValue(val) {
        if (!this.input) {
            return;
        }
        this.input.value = val;
    }
    setControlDisabled(isDisable) {
        // not needed
    }
    callOnChange(event) {
        if (event.isInteracted) {
            this.onChange(event.value);
            this.valueChangedDebouncer.next(event.value);
        }
    }
}
AsolTimePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolTimePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolTimePickerComponent, selector: "asol-time-picker", inputs: { format: "format", max: "max", min: "min", openOnFocus: "openOnFocus", showClearButton: "showClearButton", step: "step", strictMode: "strictMode" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["timePicker"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-timepicker\n    #timePicker\n    [id]=\"id ?? 'timepickerelement'\"\n    [enabled]=\"!isDisabled\"\n    class=\"asol-timepicker\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [openOnFocus]=\"openOnFocus\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [format]=\"format\"\n    [step]=\"step\"\n    [strictMode]=\"strictMode\"\n    [showClearButton]=\"showClearButton\"\n    [width]=\"width\"\n    (change)=\"callOnChange($event)\">\n  </ejs-timepicker>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$4.TimePickerComponent, selector: "ejs-timepicker", inputs: ["allowEdit", "cssClass", "enableMask", "enablePersistence", "enableRtl", "enabled", "floatLabelType", "format", "htmlAttributes", "keyConfigs", "locale", "maskPlaceholder", "max", "min", "openOnFocus", "placeholder", "readonly", "scrollTo", "showClearButton", "step", "strictMode", "value", "width", "zIndex"], outputs: ["blur", "change", "cleared", "close", "created", "destroyed", "focus", "itemRender", "open", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-time-picker', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-timepicker\n    #timePicker\n    [id]=\"id ?? 'timepickerelement'\"\n    [enabled]=\"!isDisabled\"\n    class=\"asol-timepicker\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [openOnFocus]=\"openOnFocus\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [format]=\"format\"\n    [step]=\"step\"\n    [strictMode]=\"strictMode\"\n    [showClearButton]=\"showClearButton\"\n    [width]=\"width\"\n    (change)=\"callOnChange($event)\">\n  </ejs-timepicker>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { format: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], openOnFocus: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], step: [{
                type: Input
            }], strictMode: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['timePicker']
            }] } });

class AsolTimePickerModule {
}
AsolTimePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolTimePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerModule, declarations: [AsolTimePickerComponent], imports: [SharedModule, AsolLabelFieldModule, TimePickerModule], exports: [AsolTimePickerComponent] });
AsolTimePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerModule, providers: [], imports: [[SharedModule, AsolLabelFieldModule, TimePickerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolTimePickerComponent],
                    exports: [AsolTimePickerComponent],
                    imports: [SharedModule, AsolLabelFieldModule, TimePickerModule],
                    providers: [],
                }]
        }] });

var translation$8 = {
    "sk-SK": {
        unknownControl: "Neznámy typ komponenty. Prosím kontaktujte administrátora!"
    },
    "cs-CZ": {
        unknownControl: "Neznámy typ komponenty. Prosím kontaktujte administrátora!"
    },
    "en-US": {
        unknownControl: "Unknown component type. Please contact administrator!"
    }
};

const DYNAMIC_CONTROL_CONST = {
    TRANS: 'asol-dynamic-control',
};

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Renders component based on type, if no control was found error message will be shown
 */
class AsolDynamicControlComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        /**
         * Defines type of the component to render @see {@link DynamicComponentType}
         * @default null
         */
        this.type = null;
        /**
         * Defines step used in numberic field
         * @default 1
         */
        this.steps = 1;
        /** Label text shown above component */
        this.labelText = '';
        /** Placeholder text shown in component */
        this.placeholderText = '';
        /** Dynamic control options */
        this.options = [];
        /** Emits when type component is not known, true if error */
        this.errorInRender = new EventEmitter();
        /** Value that user entered */
        this.value = null;
        this.DYNAMIC_CONTROL_CONST = DYNAMIC_CONTROL_CONST;
        /** initializes translation service */
        this.trans.initialize(DYNAMIC_CONTROL_CONST.TRANS, translation$8);
    }
    set content(content) {
        this.errorInRender.emit(!!content);
    }
    ngOnInit() {
        this.loadOptions();
    }
    /**
     * Loads data for options if provided
     */
    loadOptions() {
        var _a;
        if (!this.dropDownService || !((_a = this.options) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        this.dropDownService.subscribe((items) => {
            this.options = items;
        });
    }
    getControlValue() {
        if (!this.formGroup) {
            return null;
        }
        return this.formGroup.controls[this.formControlName].value;
    }
    setControlValue(val) {
        if (val === undefined || val === null) {
            return;
        }
        this.value = val;
    }
    setControlDisabled(isDisable) {
        // empty
    }
}
AsolDynamicControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolDynamicControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolDynamicControlComponent, selector: "asol-dynamic-control", inputs: { id: "id", type: "type", dropDownService: "dropDownService", steps: "steps", labelText: "labelText", placeholderText: "placeholderText", formGroup: "formGroup", options: "options" }, outputs: { errorInRender: "errorInRender" }, viewQueries: [{ propertyName: "content", first: true, predicate: ["errorTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"type\" [ngSwitch]=\"type\" [formGroup]=\"formGroup\">\n  <asol-input-field\n    *ngSwitchCase=\"'string'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-input-field>\n  <asol-text-area\n    *ngSwitchCase=\"'text'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-text-area>\n  <asol-editor\n    *ngSwitchCase=\"'editor'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-editor>\n  <asol-checkbox\n    *ngSwitchCase=\"'checkbox'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-checkbox>\n  <asol-checkbox-group\n    *ngSwitchCase=\"'checkboxgroup'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\">\n  </asol-checkbox-group>\n  <asol-radio-group\n    *ngSwitchCase=\"'radio'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\">\n  </asol-radio-group>\n  <asol-date-picker\n    *ngSwitchCase=\"'date'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-date-picker>\n  <asol-number-field\n    *ngSwitchCase=\"'number'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [step]=\"steps\">\n  </asol-number-field>\n  <asol-select-field\n    *ngSwitchCase=\"'select'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\"\n    displayProperty=\"text\"\n    valueProperty=\"value\">\n  </asol-select-field>\n  <asol-switch\n    *ngSwitchCase=\"'switch'\"\n    [formControlName]=\"formControlName\"\n    labelKey=\"EmptyLabel\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-switch>\n  <asol-time-picker\n    *ngSwitchCase=\"'time'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-time-picker>\n  <asol-multiselect\n    *ngSwitchCase=\"'multiselect'\"\n    [formControlName]=\"formControlName\"\n    [options]=\"options\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-multiselect>\n  <asol-upload *ngSwitchCase=\"'file'\" [formControlName]=\"formControlName\">\n  </asol-upload>\n  <div class=\"row\" *ngSwitchCase=\"'datetime'\">\n    <asol-date-picker\n      class=\"col-12 col-sm-6\"\n      [formControlName]=\"formControlName\"\n      [labelText]=\"labelText\"\n      [placeholderText]=\"placeholderText\">\n    </asol-date-picker>\n    <asol-time-picker\n      class=\"col-12 col-sm-6\"\n      [formControlName]=\"formControlName\"\n      [labelText]=\"labelText\"\n      [placeholderText]=\"placeholderText\">\n    </asol-time-picker>\n  </div>\n\n  <asol-info-panel\n    #errorTemplate\n    *ngSwitchDefault\n    type=\"danger\"\n    [showAnymoreButton]=\"false\"\n    [showMoreButton]=\"false\"\n    [showCloseButton]=\"false\"\n    text=\"{{ trans.get(DYNAMIC_CONTROL_CONST.TRANS, 'unknownControl') }}\">\n  </asol-info-panel>\n</div>\n", components: [{ type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }, { type: AsolTextAreaComponent, selector: "asol-text-area", inputs: ["rows"] }, { type: AsolEditorComponent, selector: "asol-editor", inputs: ["enableResize", "showCharCount", "height", "maxLength", "toolbarItems", "backgroundColor", "fontColor"] }, { type: AsolCheckboxComponent, selector: "asol-checkbox", inputs: ["indeterminate", "labelPosition"] }, { type: AsolCheckboxGroupComponent, selector: "asol-checkbox-group", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "optionsProviderParam", "horizontalAlignment", "labelPosition", "indeterminate"] }, { type: AsolRadioGroupComponent, selector: "asol-radio-group", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "optionsProviderParam", "horizontalAlignment", "labelPosition", "labelVerticalAlignment"] }, { type: AsolDatePickerComponent, selector: "asol-date-picker", inputs: ["max", "min", "openOnFocus", "showClearButton", "showTodayButton", "start", "weekNumber", "format"] }, { type: AsolNumberFieldComponent, selector: "asol-number-field", inputs: ["currency", "decimals", "format", "max", "min", "step", "showClearButton", "showSpinButton"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolSwitchComponent, selector: "asol-switch", inputs: ["large", "isWhiteBackground"] }, { type: AsolTimePickerComponent, selector: "asol-time-picker", inputs: ["format", "max", "min", "openOnFocus", "showClearButton", "step", "strictMode"] }, { type: AsolMultiselectComponent, selector: "asol-multiselect", inputs: ["allowFiltering", "changeOnBlur", "options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "filterOperator", "showClearButton", "allowCustomValue", "mode"] }, { type: AsolUploadComponent, selector: "asol-upload", inputs: ["buttonDefinition", "allowedExtensions", "uploadedFileIcon", "errorFileIcon", "uploadedFileError", "multipleFiles"], outputs: ["fileUploaded"] }, { type: AsolInfoPanelComponent, selector: "asol-info-panel", inputs: ["type", "text", "showMoreButton", "url", "showAnymoreButton", "showCloseButton", "cssClass", "showInfoPanel"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgSwitchDefault, selector: "[ngSwitchDefault]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-dynamic-control', template: "<div *ngIf=\"type\" [ngSwitch]=\"type\" [formGroup]=\"formGroup\">\n  <asol-input-field\n    *ngSwitchCase=\"'string'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-input-field>\n  <asol-text-area\n    *ngSwitchCase=\"'text'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-text-area>\n  <asol-editor\n    *ngSwitchCase=\"'editor'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-editor>\n  <asol-checkbox\n    *ngSwitchCase=\"'checkbox'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-checkbox>\n  <asol-checkbox-group\n    *ngSwitchCase=\"'checkboxgroup'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\">\n  </asol-checkbox-group>\n  <asol-radio-group\n    *ngSwitchCase=\"'radio'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\">\n  </asol-radio-group>\n  <asol-date-picker\n    *ngSwitchCase=\"'date'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-date-picker>\n  <asol-number-field\n    *ngSwitchCase=\"'number'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [step]=\"steps\">\n  </asol-number-field>\n  <asol-select-field\n    *ngSwitchCase=\"'select'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\"\n    [options]=\"options\"\n    displayProperty=\"text\"\n    valueProperty=\"value\">\n  </asol-select-field>\n  <asol-switch\n    *ngSwitchCase=\"'switch'\"\n    [formControlName]=\"formControlName\"\n    labelKey=\"EmptyLabel\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-switch>\n  <asol-time-picker\n    *ngSwitchCase=\"'time'\"\n    [formControlName]=\"formControlName\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-time-picker>\n  <asol-multiselect\n    *ngSwitchCase=\"'multiselect'\"\n    [formControlName]=\"formControlName\"\n    [options]=\"options\"\n    [labelText]=\"labelText\"\n    [placeholderText]=\"placeholderText\">\n  </asol-multiselect>\n  <asol-upload *ngSwitchCase=\"'file'\" [formControlName]=\"formControlName\">\n  </asol-upload>\n  <div class=\"row\" *ngSwitchCase=\"'datetime'\">\n    <asol-date-picker\n      class=\"col-12 col-sm-6\"\n      [formControlName]=\"formControlName\"\n      [labelText]=\"labelText\"\n      [placeholderText]=\"placeholderText\">\n    </asol-date-picker>\n    <asol-time-picker\n      class=\"col-12 col-sm-6\"\n      [formControlName]=\"formControlName\"\n      [labelText]=\"labelText\"\n      [placeholderText]=\"placeholderText\">\n    </asol-time-picker>\n  </div>\n\n  <asol-info-panel\n    #errorTemplate\n    *ngSwitchDefault\n    type=\"danger\"\n    [showAnymoreButton]=\"false\"\n    [showMoreButton]=\"false\"\n    [showCloseButton]=\"false\"\n    text=\"{{ trans.get(DYNAMIC_CONTROL_CONST.TRANS, 'unknownControl') }}\">\n  </asol-info-panel>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { id: [{
                type: Input
            }], type: [{
                type: Input
            }], dropDownService: [{
                type: Input
            }], steps: [{
                type: Input
            }], labelText: [{
                type: Input
            }], placeholderText: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], options: [{
                type: Input
            }], errorInRender: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: ['errorTemplate']
            }] } });

class AsolDynamicControlModule {
}
AsolDynamicControlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolDynamicControlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlModule, declarations: [AsolDynamicControlComponent], imports: [SharedModule,
        AsolTextAreaModule,
        AsolCheckboxModule,
        AsolDatePickerModule,
        AsolInputFieldModule,
        AsolNumberFieldModule,
        AsolRadioGroupModule,
        AsolSwitchModule,
        AsolSelectFieldModule,
        AsolInfoPanelModule,
        AsolEditorModule,
        AsolTimePickerModule,
        AsolMultiselectModule,
        AsolRadioGroupModule,
        AsolUploadModule,
        AsolCheckboxGroupModule,
        AsolTextAreaModule], exports: [AsolDynamicControlComponent] });
AsolDynamicControlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlModule, imports: [[
            SharedModule,
            AsolTextAreaModule,
            AsolCheckboxModule,
            AsolDatePickerModule,
            AsolInputFieldModule,
            AsolNumberFieldModule,
            AsolRadioGroupModule,
            AsolSwitchModule,
            AsolSelectFieldModule,
            AsolInfoPanelModule,
            AsolEditorModule,
            AsolTimePickerModule,
            AsolMultiselectModule,
            AsolRadioGroupModule,
            AsolUploadModule,
            AsolCheckboxGroupModule,
            AsolTextAreaModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolDynamicControlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolDynamicControlComponent],
                    exports: [AsolDynamicControlComponent],
                    imports: [
                        SharedModule,
                        AsolTextAreaModule,
                        AsolCheckboxModule,
                        AsolDatePickerModule,
                        AsolInputFieldModule,
                        AsolNumberFieldModule,
                        AsolRadioGroupModule,
                        AsolSwitchModule,
                        AsolSelectFieldModule,
                        AsolInfoPanelModule,
                        AsolEditorModule,
                        AsolTimePickerModule,
                        AsolMultiselectModule,
                        AsolRadioGroupModule,
                        AsolUploadModule,
                        AsolCheckboxGroupModule,
                        AsolTextAreaModule,
                    ],
                }]
        }] });

var translation$7 = {
    "sk-SK": {
        headerTitle: "Hromadná úprava",
        recordCountText: "Chystáte sa zmeniť údaje:",
        fieldChooser: "Zmeniť údaj",
        fieldChooserPlaceholder: "Vyberte stľpec",
        dynamicTitle: "Hodnota",
        dynamicPlaceholder: "Zadajte hondnotu",
        noControlDefined: "Žiadna komponenta nebola definovaná!"
    },
    "cs-CZ": {
        headerTitle: "Hromadná úprava",
        recordCountText: "Chystáte se změnit údaje:",
        fieldChooser: "Změnit údaj",
        fieldChooserPlaceholder: "Vyberte sloupec",
        dynamicTitle: "Hodnota",
        dynamicPlaceholder: "Zadejte hondnotu",
        noControlDefined: "Žádná komponenta nebyla definována!"
    },
    "en-US": {
        headerTitle: "Mass edit",
        recordCountText: "You are about to change:",
        fieldChooser: "Change record",
        fieldChooserPlaceholder: "Choose column",
        dynamicTitle: "Value",
        dynamicPlaceholder: "Enter value",
        noControlDefined: "No control defined for the type!"
    }
};

const MASS_EDIT_CONST = {
    TRANS: 'asol-mass-edit-trans',
};

class AsolMassEditDialogComponent {
    constructor(trans, formBuilder, dataPageService, cdr) {
        this.trans = trans;
        this.formBuilder = formBuilder;
        this.dataPageService = dataPageService;
        this.cdr = cdr;
        /** Defines columns text that will be shown */
        this.columns = [];
        /** Count with text shown in dialog */
        this.countText = null;
        /** Selected field from select box */
        this.selectedField = null;
        /** Selected type based on selected field */
        this.selectedItem = null;
        /** Original column list parsed from parent control */
        this.originalColumns = null;
        /** Emits new column value when dialog closes @see {@link ColumnEditResponse} */
        this.hide = new EventEmitter();
        this.MASS_EDIT_CONST = MASS_EDIT_CONST;
        /** Button definition for dialog */
        this.buttonDefinition = [
            {
                textType: 'Save',
                disabled: true,
            },
            {
                textType: 'Cancel',
            },
        ];
        this.sub = new Subscription();
        this.trans.initialize(MASS_EDIT_CONST.TRANS, translation$7);
        this.formGroup = this.formBuilder.group({ value: null });
    }
    ngOnInit() {
        this.sub.add(this.dataPageService.columnsChanged$.subscribe((syncId) => {
            if (syncId === this.syncId) {
                this.originalColumns = this.dataPageService.getColumns(syncId);
                this.parseColumns(this.originalColumns);
            }
        }));
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    /**
     * Shows dialog with columns
     * @param countText Text with count show in selected section
     */
    showDialog(countText) {
        this.countText = countText;
        this.dialog.show();
    }
    /**
     * Dialog close
     * @param type Button type that was clicked
     */
    dialogClose(type) {
        var _a;
        if (type === 'Save') {
            const field = this.selectedItem.member
                ? this.selectedItem.member
                : this.selectedItem.field;
            this.hide.emit({
                field: field,
                value: (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get('value').value,
            });
        }
        this.selectedField = null;
        this.clearData();
        this.dialog.hide();
    }
    /**
     * Parse columns from
     * @param columns
     */
    parseColumns(columns) {
        columns
            .filter((p) => p.showInMassEdit && p.headerText && (p.editType || p.type))
            .forEach((column) => {
            this.columns.push({
                text: column.headerText,
                value: column.field,
            });
        });
    }
    /**
     * Event handler after field was changed
     */
    onFieldChange() {
        if (!this.selectedField) {
            this.clearData();
            return;
        }
        const selectedColumnData = this.originalColumns.find((p) => p.field === this.selectedField);
        if (!selectedColumnData) {
            return;
        }
        this.selectedItem = selectedColumnData;
        this.cdr.detectChanges();
    }
    /**
     * Event fired when dynamic controls is in error
     */
    onDynamicError(error) {
        const button = this.buttonDefinition.find((p) => p.textType === 'Save');
        button.disabled = error || !this.selectedField;
    }
    /**
     * Clears dyamic value and type
     */
    clearData() {
        var _a;
        this.selectedItem = null;
        (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.reset();
        this.cdr.detectChanges();
    }
}
AsolMassEditDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }, { token: PageColumnsService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolMassEditDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolMassEditDialogComponent, selector: "asol-mass-edit-dialog", inputs: { syncId: "syncId" }, outputs: { hide: "hide" }, viewQueries: [{ propertyName: "dialog", first: true, predicate: ["dialog"], descendants: true }], ngImport: i0, template: "<asol-dialog\n  #dialog\n  width=\"500px\"\n  headerText=\"{{ trans.get(MASS_EDIT_CONST.TRANS, 'headerTitle') }}\"\n  buttonPosition=\"center\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <div>\n    <div *ngIf=\"countText\" class=\"countDiv mb-3\">\n      {{ trans.get(MASS_EDIT_CONST.TRANS, 'recordCountText') }} <br />\n      <div class=\"countText\">{{ countText }}</div>\n    </div>\n    <asol-select-field\n      id=\"mass-edit-select-field\"\n      [(ngModel)]=\"selectedField\"\n      (ngModelChange)=\"onFieldChange()\"\n      [options]=\"columns\"\n      displayProperty=\"text\"\n      valueProperty=\"value\"\n      [transKey]=\"MASS_EDIT_CONST.TRANS\"\n      labelKey=\"fieldChooser\"\n      placeholderKey=\"fieldChooserPlaceholder\">\n    </asol-select-field>\n\n    <form [formGroup]=\"formGroup\" *ngIf=\"formGroup\">\n      <asol-dynamic-control\n        [formGroup]=\"formGroup\"\n        formControlName=\"value\"\n        *ngIf=\"\n          (!!selectedItem && !!selectedField) || !selectedField;\n          else noType\n        \"\n        id=\"mass-edit-dynamic-control\"\n        [type]=\"selectedItem?.editType ?? selectedItem?.type\"\n        [steps]=\"selectedItem?.step\"\n        [options]=\"selectedItem?.values\"\n        [dropDownService]=\"selectedItem?.dropDownService\"\n        (errorInRender)=\"onDynamicError($event)\"\n        labelText=\"{{ trans.get(MASS_EDIT_CONST.TRANS, 'dynamicTitle') }}\"\n        placeholderText=\"{{\n          trans.get(MASS_EDIT_CONST.TRANS, 'dynamicPlaceholder')\n        }}\">\n      </asol-dynamic-control>\n    </form>\n  </div>\n</asol-dialog>\n\n<ng-template #noType>\n  <div class=\"info\">\n    {{ trans.get(MASS_EDIT_CONST.TRANS, 'noControlDefined') }}\n  </div>\n</ng-template>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.info{height:50px;background-color:#ffebe6;width:100%;align-items:center;display:flex;padding-left:19px}.countText{color:#36b37e;font-weight:700}.countDiv{font-size:1rem}\n"], components: [{ type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }, { type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolDynamicControlComponent, selector: "asol-dynamic-control", inputs: ["id", "type", "dropDownService", "steps", "labelText", "placeholderText", "formGroup", "options"], outputs: ["errorInRender"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-mass-edit-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<asol-dialog\n  #dialog\n  width=\"500px\"\n  headerText=\"{{ trans.get(MASS_EDIT_CONST.TRANS, 'headerTitle') }}\"\n  buttonPosition=\"center\"\n  [buttonDefinition]=\"buttonDefinition\"\n  (buttonClicked)=\"dialogClose($event)\">\n  <div>\n    <div *ngIf=\"countText\" class=\"countDiv mb-3\">\n      {{ trans.get(MASS_EDIT_CONST.TRANS, 'recordCountText') }} <br />\n      <div class=\"countText\">{{ countText }}</div>\n    </div>\n    <asol-select-field\n      id=\"mass-edit-select-field\"\n      [(ngModel)]=\"selectedField\"\n      (ngModelChange)=\"onFieldChange()\"\n      [options]=\"columns\"\n      displayProperty=\"text\"\n      valueProperty=\"value\"\n      [transKey]=\"MASS_EDIT_CONST.TRANS\"\n      labelKey=\"fieldChooser\"\n      placeholderKey=\"fieldChooserPlaceholder\">\n    </asol-select-field>\n\n    <form [formGroup]=\"formGroup\" *ngIf=\"formGroup\">\n      <asol-dynamic-control\n        [formGroup]=\"formGroup\"\n        formControlName=\"value\"\n        *ngIf=\"\n          (!!selectedItem && !!selectedField) || !selectedField;\n          else noType\n        \"\n        id=\"mass-edit-dynamic-control\"\n        [type]=\"selectedItem?.editType ?? selectedItem?.type\"\n        [steps]=\"selectedItem?.step\"\n        [options]=\"selectedItem?.values\"\n        [dropDownService]=\"selectedItem?.dropDownService\"\n        (errorInRender)=\"onDynamicError($event)\"\n        labelText=\"{{ trans.get(MASS_EDIT_CONST.TRANS, 'dynamicTitle') }}\"\n        placeholderText=\"{{\n          trans.get(MASS_EDIT_CONST.TRANS, 'dynamicPlaceholder')\n        }}\">\n      </asol-dynamic-control>\n    </form>\n  </div>\n</asol-dialog>\n\n<ng-template #noType>\n  <div class=\"info\">\n    {{ trans.get(MASS_EDIT_CONST.TRANS, 'noControlDefined') }}\n  </div>\n</ng-template>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.info{height:50px;background-color:#ffebe6;width:100%;align-items:center;display:flex;padding-left:19px}.countText{color:#36b37e;font-weight:700}.countDiv{font-size:1rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }, { type: PageColumnsService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { syncId: [{
                type: Input
            }], hide: [{
                type: Output
            }], dialog: [{
                type: ViewChild,
                args: ['dialog']
            }] } });

class AsolMassEditDialogModule {
}
AsolMassEditDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolMassEditDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogModule, declarations: [AsolMassEditDialogComponent], imports: [SharedModule,
        AsolDataColumnModule,
        AsolDialogModule,
        AsolDynamicControlModule,
        AsolSelectFieldModule], exports: [AsolMassEditDialogComponent] });
AsolMassEditDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogModule, imports: [[
            SharedModule,
            AsolDataColumnModule,
            AsolDialogModule,
            AsolDynamicControlModule,
            AsolSelectFieldModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMassEditDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolMassEditDialogComponent],
                    exports: [AsolMassEditDialogComponent],
                    imports: [
                        SharedModule,
                        AsolDataColumnModule,
                        AsolDialogModule,
                        AsolDynamicControlModule,
                        AsolSelectFieldModule,
                    ],
                }]
        }] });

const MESSAGE_PANEL_CONSTANT = {
    TRANS: 'ASOL-MESSAGE-PANEL-TRANS',
};

var translation$6 = {
    "sk-SK": {
        ShowMore: "Zobraziť viac",
        DisableShow: "Už nezobrazovať"
    },
    "cs-CZ": {
        ShowMore: "Zobrazit více",
        DisableShow: "Již nezobrazovat"
    },
    "en-US": {
        ShowMore: "Show more",
        DisableShow: "Don't show anymore"
    }
};

var MessagePanelType;
(function (MessagePanelType) {
    MessagePanelType["success"] = "success";
    MessagePanelType["warning"] = "warning";
    MessagePanelType["danger"] = "danger";
    MessagePanelType["info"] = "info";
})(MessagePanelType || (MessagePanelType = {}));

class MessagePanelService {
    constructor() {
        this.messageObservables = new Subject();
        /**
         * Subject when a new message panel is created and when it is removed
         */
        this.message$ = this.messageObservables.asObservable();
        this.buttonClickObservable = new Subject();
        /**
         * Subject when button is clicked
         */
        this.buttonClick$ = this.buttonClickObservable.asObservable();
        this.removeAllObservables = new Subject();
        /**
         * Subject when a remove all panels action is triggered
         */
        this.removeAll$ = this.removeAllObservables.asObservable();
    }
    /**
     * The remove() is used to delete message panels that have the same ID
     * @param properties Properties of message that should be removed
     */
    remove(properties) {
        this.messageObservables.next({
            show: false,
            properties: properties,
        });
    }
    /**
     * Removes all panels from the message panel list
     */
    removeAll() {
        this.removeAllObservables.next();
    }
    /**
     * Set button name and message panel id to be returned to another component
     */
    buttonClick(button) {
        this.buttonClickObservable.next(button);
    }
    /**
     * Shows info message panel
     * @param type set the message panel type
     * @param severity severity of the message panel
     * @param show show message panel
     * @param properties message panel custom properties
     */
    info(properties) {
        return this.messageObservables.next({
            type: MessagePanelType.info,
            severity: 0,
            show: true,
            properties,
        });
    }
    /**
     * Shows success message panel
     * @param type set the message panel type
     * @param severity severity of the message panel
     * @param show show message panel
     * @param properties message panel custom properties
     */
    success(properties) {
        return this.messageObservables.next({
            type: MessagePanelType.success,
            severity: 1,
            show: true,
            properties,
        });
    }
    /**
     * Shows warning message panel
     * @param type set the message panel type
     * @param severity severity of the message panel
     * @param show show message panel
     * @param properties message panel custom properties
     */
    warning(properties) {
        return this.messageObservables.next({
            type: MessagePanelType.warning,
            severity: 2,
            show: true,
            properties,
        });
    }
    /**
     * Shows danger message panel
     * @param type set the message panel type
     * @param severity severity of the message panel
     * @param show show message panel
     * @param properties message panel custom properties
     */
    danger(properties) {
        return this.messageObservables.next({
            type: MessagePanelType.danger,
            severity: 3,
            show: true,
            properties,
        });
    }
}
MessagePanelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MessagePanelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MessagePanelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MessagePanelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MessagePanelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AsolMessagePanelComponent {
    constructor(trans, messagePanelService, cdf) {
        this.trans = trans;
        this.messagePanelService = messagePanelService;
        this.cdf = cdf;
        /** Active message panel list */
        this.messagePanelList = [];
        /** Currently visible message panel */
        this.currentPanel = null;
        this.ICONS = ICONS;
        this.MESSAGE_PANEL_CONSTANT = MESSAGE_PANEL_CONSTANT;
        /**
         * Map types and assign icons to them
         */
        this.map = new Map([
            ['danger', ICONS.DANGER],
            ['success', ICONS.SUCCESS],
            ['warning', ICONS.WARNING],
            ['info', ICONS.INFO],
        ]);
        this.trans.initialize(MESSAGE_PANEL_CONSTANT.TRANS, translation$6);
    }
    ngOnInit() {
        this.subscription = this.messagePanelService.message$.subscribe((messagePanel) => {
            messagePanel.show
                ? this.addMessage(messagePanel)
                : this.removeMessage(messagePanel.properties.id);
        });
        /** remove all subscription initialization */
        this.removeAllSub = this.messagePanelService.removeAll$.subscribe(() => {
            /** remove all message panels */
            this.messagePanelList.splice(0, this.messagePanelList.length);
            this.currentPanel = null;
        });
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.removeAllSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    /** Display another message panel from list when click on button left  */
    moveLeft() {
        this.currentIndexPanel--;
        if (this.currentIndexPanel === -1) {
            this.currentIndexPanel = this.messagePanelList.length - 1;
        }
        this.currentPanel = this.messagePanelList[this.currentIndexPanel];
    }
    /** Display another message panel from list when click on button right */
    moveRight() {
        this.currentIndexPanel++;
        if (this.currentIndexPanel === this.messagePanelList.length) {
            this.currentIndexPanel = 0;
        }
        this.currentPanel = this.messagePanelList[this.currentIndexPanel];
    }
    /**
     * Find object by id and remove it
     * @param id message panel id
     */
    removeMessage(id) {
        if (!id) {
            return;
        }
        const index = this.messagePanelList.findIndex((p) => p.properties.id === id);
        /** in case message panel exists and was found */
        if (index >= 0) {
            this.messagePanelList.splice(index, 1);
            this.currentPanel = null;
            this.sortPanels();
        }
    }
    /**
     * Add new message panel
     * @param messagePanel new created message panel
     */
    addMessage(messagePanel) {
        /** Return when message panel is the same as the last message Panel */
        if (this.messagePanelList.some((p) => p.properties.id === messagePanel.properties.id)) {
            this.sortPanels();
            return;
        }
        /** Create new message panel */
        this.messagePanelList.push(messagePanel);
        this.sortPanels();
        this.cdf.detectChanges();
    }
    /**
     * Event handler when user clicks on button in panel
     */
    onButtonClick(id, buttonText) {
        this.messagePanelService.buttonClick({ id: id, textKey: buttonText });
    }
    /**
     * Sort panel based on severity
     */
    sortPanels() {
        if (!this.messagePanelList.length) {
            return;
        }
        this.messagePanelList = this.messagePanelList.sort((a, b) => b.severity - a.severity);
        this.currentIndexPanel = 0;
        this.currentPanel = this.messagePanelList[0];
    }
}
AsolMessagePanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelComponent, deps: [{ token: i1.TranslationService }, { token: MessagePanelService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AsolMessagePanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolMessagePanelComponent, selector: "asol-message-panel", ngImport: i0, template: "<div class=\"message-panel-area\">\n  <div\n    *ngIf=\"currentPanel\"\n    class=\"message-panel d-flex align-items-center justify-content-between w-100 px-6 py-3\"\n    ngClass=\"message-panel-{{ currentPanel.type }}\">\n    <div\n      class=\"d-flex align-items-center user-select-none fw-medium\"\n      *ngIf=\"messagePanelList.length >= 2\">\n      <asol-icon-button\n        type=\"flat\"\n        color=\"dark\"\n        [iconSvgUrl]=\"ICONS.CHEVRON_LEFT\"\n        (click)=\"moveLeft()\"></asol-icon-button>\n      {{ currentIndexPanel + 1 }}/{{ messagePanelList.length }}\n      <asol-icon-button\n        type=\"flat\"\n        color=\"dark\"\n        [iconSvgUrl]=\"ICONS.CHEVRON_RIGHT\"\n        (click)=\"moveRight()\"></asol-icon-button>\n    </div>\n    <div class=\"d-flex align-items-center flex-grow-1\">\n      <svg-icon\n        class=\"d-flex align-items-start me-2\"\n        [src]=\"map.get(currentPanel.type)\"></svg-icon>\n      <div>\n        {{\n          trans.get(\n            currentPanel.properties.transKey,\n            currentPanel.properties.textKey\n          )\n        }}\n      </div>\n    </div>\n\n    <div class=\"d-flex align-items-center\">\n      <div *ngFor=\"let button of currentPanel.properties.buttons\">\n        <asol-button\n          type=\"flat\"\n          color=\"dark\"\n          (click)=\"onButtonClick(currentPanel.properties.id, button.textKey)\">\n          {{ trans.get(button.transKey, button.textKey) }}\n        </asol-button>\n      </div>\n\n      <svg-icon\n        *ngIf=\"currentPanel.properties.showCloseButton\"\n        (click)=\"removeMessage(currentPanel.properties.id)\"\n        class=\"close d-flex align-items-center\"\n        [src]=\"ICONS.CLOSE\"></svg-icon>\n    </div>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.message-panel-area:empty{height:0!important}.message-panel-area .message-panel{color:#091e42}.message-panel-area .message-panel .close svg path{fill:#091e42!important}.message-panel-area .message-panel.message-panel-success{background:#e3fcef}.message-panel-area .message-panel.message-panel-danger{background:#ffebe6}.message-panel-area .message-panel.message-panel-warning{background:#fffae6}.message-panel-area .message-panel.message-panel-info{background:#deebff}\n"], components: [{ type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-message-panel', template: "<div class=\"message-panel-area\">\n  <div\n    *ngIf=\"currentPanel\"\n    class=\"message-panel d-flex align-items-center justify-content-between w-100 px-6 py-3\"\n    ngClass=\"message-panel-{{ currentPanel.type }}\">\n    <div\n      class=\"d-flex align-items-center user-select-none fw-medium\"\n      *ngIf=\"messagePanelList.length >= 2\">\n      <asol-icon-button\n        type=\"flat\"\n        color=\"dark\"\n        [iconSvgUrl]=\"ICONS.CHEVRON_LEFT\"\n        (click)=\"moveLeft()\"></asol-icon-button>\n      {{ currentIndexPanel + 1 }}/{{ messagePanelList.length }}\n      <asol-icon-button\n        type=\"flat\"\n        color=\"dark\"\n        [iconSvgUrl]=\"ICONS.CHEVRON_RIGHT\"\n        (click)=\"moveRight()\"></asol-icon-button>\n    </div>\n    <div class=\"d-flex align-items-center flex-grow-1\">\n      <svg-icon\n        class=\"d-flex align-items-start me-2\"\n        [src]=\"map.get(currentPanel.type)\"></svg-icon>\n      <div>\n        {{\n          trans.get(\n            currentPanel.properties.transKey,\n            currentPanel.properties.textKey\n          )\n        }}\n      </div>\n    </div>\n\n    <div class=\"d-flex align-items-center\">\n      <div *ngFor=\"let button of currentPanel.properties.buttons\">\n        <asol-button\n          type=\"flat\"\n          color=\"dark\"\n          (click)=\"onButtonClick(currentPanel.properties.id, button.textKey)\">\n          {{ trans.get(button.transKey, button.textKey) }}\n        </asol-button>\n      </div>\n\n      <svg-icon\n        *ngIf=\"currentPanel.properties.showCloseButton\"\n        (click)=\"removeMessage(currentPanel.properties.id)\"\n        class=\"close d-flex align-items-center\"\n        [src]=\"ICONS.CLOSE\"></svg-icon>\n    </div>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.message-panel-area:empty{height:0!important}.message-panel-area .message-panel{color:#091e42}.message-panel-area .message-panel .close svg path{fill:#091e42!important}.message-panel-area .message-panel.message-panel-success{background:#e3fcef}.message-panel-area .message-panel.message-panel-danger{background:#ffebe6}.message-panel-area .message-panel.message-panel-warning{background:#fffae6}.message-panel-area .message-panel.message-panel-info{background:#deebff}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: MessagePanelService }, { type: i0.ChangeDetectorRef }]; } });

class AsolMessagePanelModule {
}
AsolMessagePanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolMessagePanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelModule, declarations: [AsolMessagePanelComponent], imports: [SharedModule, AsolButtonModule], exports: [AsolMessagePanelComponent] });
AsolMessagePanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelModule, providers: [], imports: [[SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMessagePanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolMessagePanelComponent],
                    exports: [AsolMessagePanelComponent],
                    imports: [SharedModule, AsolButtonModule],
                    providers: [],
                }]
        }] });

var translation$5 = {
    "sk-SK": {
        searchPlaceholder: "Vyhľadať..."
    },
    "cs-CZ": {
        searchPlaceholder: "Vyhledat..."
    },
    "en-US": {
        searchPlaceholder: "Search..."
    }
};

const SEARCH_CONSTANT = {
    TRANS: 'asol-search-trans',
};

class AsolSearchPanelComponent {
    constructor(formBuilder, filterService, trans) {
        this.formBuilder = formBuilder;
        this.filterService = filterService;
        this.trans = trans;
        /** Button text to show */
        this.buttonText = '';
        /**
         * Debounce time for text changes in text field
         * @default 1000
         * */
        this.debounceTime = 1000;
        /**
         * Flag if button is visible
         * @default true
         */
        this.buttonVisible = true;
        /**
         * Flag if text field is visible
         * @default true
         */
        this.textFieldVisible = true;
        /** Synchronization identifier */
        this.syncId = null;
        /**
         * Emits when text in text field changes
         */
        this.textChanged = new EventEmitter();
        /**
         * Emits when button is clicked
         */
        this.buttonClicked = new EventEmitter();
        this.SEARCH_CONSTANT = SEARCH_CONSTANT;
        this.ICONS = ICONS;
        this.sub = new Subscription();
        this.trans.initialize(SEARCH_CONSTANT.TRANS, translation$5);
        this.formGroup = this.formBuilder.group({
            text: '',
        });
    }
    ngOnInit() {
        this.sub.add(this.formGroup.controls['text'].valueChanges
            .pipe(debounceTime$1(this.debounceTime))
            .subscribe((text) => {
            if (this.syncId) {
                const predicate = !text
                    ? null
                    : new Predicate('NotUsed', FilterOperator.CONTAINS, text);
                this.filterService.changeFilter(this.syncId, 'search', predicate);
            }
            this.textChanged.emit(text);
        }));
        this.sub.add(this.filterService.filterChanged$.subscribe((data) => {
            var _a;
            if (data.id !== this.syncId) {
                return;
            }
            if (!((_a = data === null || data === void 0 ? void 0 : data.filter) === null || _a === void 0 ? void 0 : _a.search)) {
                this.formGroup.reset({ text: '' }, { emitEvent: false });
            }
        }));
        this.loadData();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Loads stored filter data
     */
    loadData() {
        if (!this.syncId) {
            return;
        }
        this.filterService.get(this.syncId).subscribe((filter) => {
            if (!filter || !filter.search) {
                return;
            }
            this.formGroup.controls['text'].setValue(filter.search.value, {
                emitEvent: false,
            });
        });
    }
    /**
     * Event when button is clicked
     */
    onClick() {
        this.buttonClicked.emit();
    }
}
AsolSearchPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelComponent, deps: [{ token: i2.FormBuilder }, { token: FilterSyncService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolSearchPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSearchPanelComponent, selector: "asol-search-panel", inputs: { buttonText: "buttonText", debounceTime: "debounceTime", buttonVisible: "buttonVisible", textFieldVisible: "textFieldVisible", syncId: "syncId" }, outputs: { textChanged: "textChanged", buttonClicked: "buttonClicked" }, ngImport: i0, template: "<form [formGroup]=\"formGroup\">\n  <div\n    class=\"d-flex justify-content-between gap-0 gap-md-3 flex-column flex-md-row\">\n    <asol-input-field\n      [ngStyle]=\"!textFieldVisible && { visibility: 'hidden' }\"\n      formControlName=\"text\"\n      class=\"w-100\"\n      [transKey]=\"SEARCH_CONSTANT.TRANS\"\n      placeholderKey=\"searchPlaceholder\"\n      [prefixIcon]=\"ICONS.SEARCH\">\n    </asol-input-field>\n    <asol-button\n      *ngIf=\"buttonVisible\"\n      [iconSvgUrl]=\"ICONS.PLUS\"\n      (click)=\"onClick()\">\n      {{ buttonText }}\n    </asol-button>\n  </div>\n</form>\n", components: [{ type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-search-panel', template: "<form [formGroup]=\"formGroup\">\n  <div\n    class=\"d-flex justify-content-between gap-0 gap-md-3 flex-column flex-md-row\">\n    <asol-input-field\n      [ngStyle]=\"!textFieldVisible && { visibility: 'hidden' }\"\n      formControlName=\"text\"\n      class=\"w-100\"\n      [transKey]=\"SEARCH_CONSTANT.TRANS\"\n      placeholderKey=\"searchPlaceholder\"\n      [prefixIcon]=\"ICONS.SEARCH\">\n    </asol-input-field>\n    <asol-button\n      *ngIf=\"buttonVisible\"\n      [iconSvgUrl]=\"ICONS.PLUS\"\n      (click)=\"onClick()\">\n      {{ buttonText }}\n    </asol-button>\n  </div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: i2.FormBuilder }, { type: FilterSyncService }, { type: i1.TranslationService }]; }, propDecorators: { buttonText: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], buttonVisible: [{
                type: Input
            }], textFieldVisible: [{
                type: Input
            }], syncId: [{
                type: Input
            }], textChanged: [{
                type: Output
            }], buttonClicked: [{
                type: Output
            }] } });

class AsolSearchPanelModule {
}
AsolSearchPanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolSearchPanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelModule, declarations: [AsolSearchPanelComponent], imports: [SharedModule, AsolInputFieldModule, AsolButtonModule], exports: [AsolSearchPanelComponent] });
AsolSearchPanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelModule, imports: [[SharedModule, AsolInputFieldModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSearchPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolSearchPanelComponent],
                    exports: [AsolSearchPanelComponent],
                    imports: [SharedModule, AsolInputFieldModule, AsolButtonModule],
                }]
        }] });

class AsolStepperHeaderComponent {
    constructor() {
        this.label = '';
        this.order = 0;
        this.invalid = false;
        this.numberOfSteps = 0;
        this.selectedTabIndex = 0;
    }
}
AsolStepperHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolStepperHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolStepperHeaderComponent, selector: "asol-stepper-header", inputs: { label: "label", order: "order", invalid: "invalid", numberOfSteps: "numberOfSteps", selectedTabIndex: "selectedTabIndex" }, ngImport: i0, template: "<div\n  class=\"d-flex flex-column step c-pointer\"\n  [ngClass]=\"{ invalid: invalid, active: selectedTabIndex === order }\">\n  <svg\n    width=\"100%\"\n    height=\"38\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\">\n    <line\n      *ngIf=\"order !== 0\"\n      x1=\"0%\"\n      x2=\"25%\"\n      y1=\"50%\"\n      y2=\"50%\"\n      stroke=\"#A3AAB8\"\n      stroke-width=\"2\" />\n    <line\n      *ngIf=\"order + 1 !== numberOfSteps\"\n      x1=\"100%\"\n      x2=\"75%\"\n      y1=\"50%\"\n      y2=\"50%\"\n      stroke=\"#A3AAB8\"\n      stroke-width=\"2\" />\n    <circle\n      *ngIf=\"selectedTabIndex === order\"\n      cx=\"50%\"\n      cy=\"50%\"\n      r=\"16\"\n      stroke=\"var(--stepper-color, #2684ff)\"\n      fill=\"#091E42\"\n      stroke-width=\"5\" />\n    <circle\n      *ngIf=\"selectedTabIndex !== order\"\n      cx=\"50%\"\n      cy=\"50%\"\n      r=\"16\"\n      fill=\"#7A869A\" />\n    <text\n      x=\"50%\"\n      y=\"50%\"\n      text-anchor=\"middle\"\n      fill=\"white\"\n      font-size=\"0.875rem\"\n      dy=\".35em\">\n      {{ order + 1 }}\n    </text>\n  </svg>\n  <div\n    class=\"w-100 mt-1 text-center tab-title\"\n    [ngClass]=\"{ active: selectedTabIndex === order }\">\n    {{ label }}\n  </div>\n</div>\n", styles: [".step{width:7.5rem}.invalid:not(.active) svg circle{stroke-width:2px}\n"], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-stepper-header', template: "<div\n  class=\"d-flex flex-column step c-pointer\"\n  [ngClass]=\"{ invalid: invalid, active: selectedTabIndex === order }\">\n  <svg\n    width=\"100%\"\n    height=\"38\"\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\">\n    <line\n      *ngIf=\"order !== 0\"\n      x1=\"0%\"\n      x2=\"25%\"\n      y1=\"50%\"\n      y2=\"50%\"\n      stroke=\"#A3AAB8\"\n      stroke-width=\"2\" />\n    <line\n      *ngIf=\"order + 1 !== numberOfSteps\"\n      x1=\"100%\"\n      x2=\"75%\"\n      y1=\"50%\"\n      y2=\"50%\"\n      stroke=\"#A3AAB8\"\n      stroke-width=\"2\" />\n    <circle\n      *ngIf=\"selectedTabIndex === order\"\n      cx=\"50%\"\n      cy=\"50%\"\n      r=\"16\"\n      stroke=\"var(--stepper-color, #2684ff)\"\n      fill=\"#091E42\"\n      stroke-width=\"5\" />\n    <circle\n      *ngIf=\"selectedTabIndex !== order\"\n      cx=\"50%\"\n      cy=\"50%\"\n      r=\"16\"\n      fill=\"#7A869A\" />\n    <text\n      x=\"50%\"\n      y=\"50%\"\n      text-anchor=\"middle\"\n      fill=\"white\"\n      font-size=\"0.875rem\"\n      dy=\".35em\">\n      {{ order + 1 }}\n    </text>\n  </svg>\n  <div\n    class=\"w-100 mt-1 text-center tab-title\"\n    [ngClass]=\"{ active: selectedTabIndex === order }\">\n    {{ label }}\n  </div>\n</div>\n", styles: [".step{width:7.5rem}.invalid:not(.active) svg circle{stroke-width:2px}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], order: [{
                type: Input
            }], invalid: [{
                type: Input
            }], numberOfSteps: [{
                type: Input
            }], selectedTabIndex: [{
                type: Input
            }] } });

class AsolStepComponent {
    constructor() {
        this.headerText = '';
        this.stepControl = null;
        this.invalid = false;
        this.submitClick = new EventEmitter();
        this.content = null;
    }
}
AsolStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AsolStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolStepComponent, selector: "asol-stepper>asol-step", inputs: { headerText: "headerText", stepControl: "stepControl", invalid: "invalid" }, outputs: { submitClick: "submitClick" }, viewQueries: [{ propertyName: "content", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-stepper>asol-step', template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n" }]
        }], propDecorators: { headerText: [{
                type: Input
            }], stepControl: [{
                type: Input
            }], invalid: [{
                type: Input
            }], submitClick: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: [TemplateRef]
            }] } });

class AsolStepperComponent {
    constructor(cdf, trans) {
        this.cdf = cdf;
        this.trans = trans;
        /** Selected step index */
        this.selectedTabIndex = 0;
        /** Steps definition */
        this.steps = null;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        /** Flag if all forms are valid */
        this.validToSubmit = false;
        /** Subscription holder */
        this.subs = new Subscription();
        // Disabling tab animation
        this.animation = {
            previous: { effect: '', duration: 0, easing: '' },
            next: { effect: '', duration: 0, easing: '' },
        };
        this.submitLabel = trans.get(GENERAL_TRANSLATION, 'submit');
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    ngAfterViewInit() {
        this.stepper.selectedItem = this.selectedTabIndex;
        this.steps
            .filter((p) => !!p.stepControl)
            .forEach((step) => {
            this.subs.add(step.stepControl.statusChanges
                .pipe(debounceTime(500))
                .subscribe((data) => {
                if (data === 'VALID') {
                    this.revalidateForms();
                }
            }));
        });
    }
    ngOnChanges(changes) {
        if (changes.selectedTabIndex && this.stepper && this.stepper.selectedItem) {
            this.stepper.selectedItem = this.selectedTabIndex;
            this.cdf.detectChanges();
        }
    }
    /**
     * Event handler when user clicks on Next
     */
    onClickNext() {
        if (this.stepper.selectedItem < this.steps.length) {
            this.validateStep(this.stepper.selectedItem);
            this.stepper.selectedItem++;
            this.cdf.detectChanges();
        }
    }
    /**
     * Event handler when user clicks on back button
     */
    onClickBack() {
        if (this.stepper.selectedItem > 0) {
            this.validateStep(this.stepper.selectedItem);
            this.stepper.selectedItem--;
            this.cdf.detectChanges();
        }
    }
    /**
     * Event handler when user clicks on submit button
     * @param event Passing event emitter
     */
    onClickSubmit(event) {
        if (event !== null) {
            event.emit();
        }
    }
    /**
     * For-of trackby
     */
    trackStep(step) {
        return step ? step.content : undefined;
    }
    /**
     * Event hanlder when user clicks on stop number
     * @param actualStep Step clicked
     */
    onStepClick(actualStep) {
        const previousStep = this.stepper.selectedItem;
        for (let i = previousStep; i <= actualStep; i++) {
            this.validateStep(i);
        }
        this.stepper.selectedItem = actualStep;
        this.cdf.detectChanges();
    }
    /**
     * Runs validation of step change
     * @param stepId Old step iorder
     */
    validateStep(stepId) {
        const step = this.steps.filter((el, index) => index === stepId);
        if (!step.length || !step[0].stepControl) {
            return;
        }
        markForValidation(step[0].stepControl);
        step[0].invalid = step[0].stepControl.invalid;
    }
    /**
     * Revalidates form after data where changed
     */
    revalidateForms() {
        this.validToSubmit =
            this.steps.filter((p) => p.stepControl.invalid).length === 0;
        this.steps
            .filter((p) => !!p.stepControl)
            .forEach((step) => {
            step.invalid = step.stepControl.invalid;
        });
        this.cdf.detectChanges();
    }
}
AsolStepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolStepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolStepperComponent, selector: "asol-stepper", inputs: { selectedTabIndex: "selectedTabIndex", submitLabel: "submitLabel" }, queries: [{ propertyName: "steps", predicate: AsolStepComponent }], viewQueries: [{ propertyName: "stepper", first: true, predicate: ["stepper"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ejs-tab #stepper class=\"stepper\" [animation]=\"animation\">\n  <e-tabitems>\n    <e-tabitem *ngFor=\"let step of steps; let i = index; trackStep\">\n      <ng-template #headerText>\n        <asol-stepper-header\n          [label]=\"step.headerText\"\n          [order]=\"i\"\n          [invalid]=\"step.invalid\"\n          [numberOfSteps]=\"steps.length\"\n          (click)=\"onStepClick(i)\"\n          [selectedTabIndex]=\"stepper.selectedItem\">\n        </asol-stepper-header>\n      </ng-template>\n      <ng-template #content>\n        <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n        <div class=\"d-flex flex-row mt-5 justify-content-end\">\n          <asol-button\n            *ngIf=\"stepper.selectedItem !== 0\"\n            type=\"flat\"\n            class=\"me-5\"\n            (click)=\"onClickBack()\">\n            {{ trans.get(GENERAL_TRANSLATION, 'back') }}\n          </asol-button>\n          <asol-button\n            *ngIf=\"stepper.selectedItem !== steps.length - 1; else confirm\"\n            (click)=\"onClickNext()\">\n            {{ trans.get(GENERAL_TRANSLATION, 'next') }}\n          </asol-button>\n          <ng-template #confirm>\n            <asol-button\n              (click)=\"onClickSubmit(step.submitClick)\"\n              [ngClass]=\"{ 'pe-none': !validToSubmit }\"\n              [disabled]=\"!validToSubmit\">\n              {{ submitLabel }}\n            </asol-button>\n          </ng-template>\n        </div>\n      </ng-template>\n    </e-tabitem>\n  </e-tabitems>\n</ejs-tab>\n", components: [{ type: i2$3.TabComponent, selector: "ejs-tab", inputs: ["allowDragAndDrop", "animation", "cssClass", "dragArea", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "headerPlacement", "height", "heightAdjustMode", "items", "loadOn", "locale", "overflowMode", "reorderActiveTab", "scrollStep", "selectedItem", "showCloseButton", "width"], outputs: ["added", "adding", "created", "destroyed", "dragged", "dragging", "onDragStart", "removed", "removing", "selected", "selecting"] }, { type: AsolStepperHeaderComponent, selector: "asol-stepper-header", inputs: ["label", "order", "invalid", "numberOfSteps", "selectedTabIndex"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i2$3.TabItemsDirective, selector: "ejs-tab>e-tabitems" }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$3.TabItemDirective, selector: "e-tabitems>e-tabitem", inputs: ["content", "cssClass", "disabled", "header", "headerTemplate", "id", "visible"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-stepper', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ejs-tab #stepper class=\"stepper\" [animation]=\"animation\">\n  <e-tabitems>\n    <e-tabitem *ngFor=\"let step of steps; let i = index; trackStep\">\n      <ng-template #headerText>\n        <asol-stepper-header\n          [label]=\"step.headerText\"\n          [order]=\"i\"\n          [invalid]=\"step.invalid\"\n          [numberOfSteps]=\"steps.length\"\n          (click)=\"onStepClick(i)\"\n          [selectedTabIndex]=\"stepper.selectedItem\">\n        </asol-stepper-header>\n      </ng-template>\n      <ng-template #content>\n        <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n        <div class=\"d-flex flex-row mt-5 justify-content-end\">\n          <asol-button\n            *ngIf=\"stepper.selectedItem !== 0\"\n            type=\"flat\"\n            class=\"me-5\"\n            (click)=\"onClickBack()\">\n            {{ trans.get(GENERAL_TRANSLATION, 'back') }}\n          </asol-button>\n          <asol-button\n            *ngIf=\"stepper.selectedItem !== steps.length - 1; else confirm\"\n            (click)=\"onClickNext()\">\n            {{ trans.get(GENERAL_TRANSLATION, 'next') }}\n          </asol-button>\n          <ng-template #confirm>\n            <asol-button\n              (click)=\"onClickSubmit(step.submitClick)\"\n              [ngClass]=\"{ 'pe-none': !validToSubmit }\"\n              [disabled]=\"!validToSubmit\">\n              {{ submitLabel }}\n            </asol-button>\n          </ng-template>\n        </div>\n      </ng-template>\n    </e-tabitem>\n  </e-tabitems>\n</ejs-tab>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.TranslationService }]; }, propDecorators: { selectedTabIndex: [{
                type: Input
            }], submitLabel: [{
                type: Input
            }], stepper: [{
                type: ViewChild,
                args: ['stepper']
            }], steps: [{
                type: ContentChildren,
                args: [AsolStepComponent]
            }] } });

class AsolStepperModule {
}
AsolStepperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolStepperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperModule, declarations: [AsolStepperComponent,
        AsolStepperHeaderComponent,
        AsolStepComponent], imports: [TabModule, SharedModule, AsolButtonModule], exports: [AsolStepperComponent, AsolStepComponent] });
AsolStepperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperModule, imports: [[TabModule, SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolStepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolStepperComponent,
                        AsolStepperHeaderComponent,
                        AsolStepComponent,
                    ],
                    imports: [TabModule, SharedModule, AsolButtonModule],
                    exports: [AsolStepperComponent, AsolStepComponent],
                }]
        }] });

/**
 * Service that checks if all required fields are filled
 */
class RequiredCheckService {
    constructor(messageService) {
        this.messageService = messageService;
        /** Observable that check is required, mostly used in components */
        this.requireObservable = new Subject();
        this.requireCheck$ = this.requireObservable.asObservable();
        /** Observable that emits result of check in one component */
        this.responseObservable = new Subject();
        this.response$ = this.responseObservable.asObservable();
        /** Observable that emits result of check in components */
        this.resultObservable = new Subject();
        this.result$ = this.resultObservable.asObservable();
        /** Unique sesstion identifier */
        this.sessionId = null;
        /** Collection of all registered components */
        this.registeredComponents = [];
        /** Collection of all components that are valid */
        this.validComponents = [];
        /**
         * Flag if result should be sent,
         * used when recheck is needed without sending result to listeners
         * @default true
         */
        this.shouldSendResult = true;
        /**
         * Flag if at least once was check requested
         * @default false
         */
        this.checkRequested = false;
    }
    /**
     * Initializes service with translation keys for message panel text
     * @param transKey Module translation key
     * @param textKey Text translation key
     */
    initialize(transKey, textKey) {
        this.transKey = transKey;
        this.textKey = textKey;
    }
    /**
     * Emits to all registered components to check if all required fields are filled
     */
    check(sendResult = true) {
        if (sendResult && !this.checkRequested) {
            // if sendResult is true, then check was requested
            this.checkRequested = true;
        }
        // If no component requested for check, then no action is needed
        // this prevents from checking when form is not dirty
        if (!this.checkRequested) {
            return;
        }
        this.sessionId = new Date().getTime().toString();
        this.shouldSendResult = sendResult;
        this.validComponents = [];
        this.requireObservable.next(this.sessionId);
    }
    /**
     * Response from component if all required fields are filled
     * If all components have all required fields filled in emits true
     * If any component does not have all required fields filled in emits false
     * @param sessionId Session identifier
     * @param componentId Component identifier
     * @param response Response from component, true if all required fields are filled in
     */
    response(sessionId, componentId, response) {
        this.responseObservable.next({
            componentId,
            response,
        });
        if (sessionId !== this.sessionId) {
            return;
        }
        // If any component does not have all required fields, then no action allowed
        if (!response) {
            this.resultObservable.next(false);
            if (this.transKey && this.textKey) {
                this.messageService.danger({
                    id: 'required-fields',
                    transKey: this.transKey,
                    textKey: this.textKey,
                    showCloseButton: true,
                });
            }
            this.sessionId = null;
        }
        else {
            this.validComponents.push(componentId);
        }
        // all component where checked and are valid
        if (this.registeredComponents.length === this.validComponents.length) {
            this.clearMessage();
            if (this.shouldSendResult) {
                this.resultObservable.next(true);
            }
        }
    }
    /**
     * Register component to service
     * @param componentId Component identifier
     */
    register(componentId) {
        if (this.registeredComponents.includes(componentId)) {
            return;
        }
        this.registeredComponents.push(componentId);
    }
    /**
     * Unregister component from service
     * @param componentId Component identifier
     */
    unregister(componentId) {
        const index = this.registeredComponents.indexOf(componentId);
        if (index > -1) {
            this.registeredComponents.splice(index, 1);
        }
    }
    /**
     * Clear all components
     */
    clear() {
        this.registeredComponents = [];
        this.validComponents = [];
        this.sessionId = null;
        this.clearMessage();
    }
    /**
     * Clear message from message panel
     */
    clearMessage() {
        this.messageService.remove({
            id: 'required-fields',
        });
    }
}
RequiredCheckService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredCheckService, deps: [{ token: MessagePanelService }], target: i0.ɵɵFactoryTarget.Injectable });
RequiredCheckService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredCheckService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: RequiredCheckService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: MessagePanelService }]; } });

class AsolTabComponent {
    constructor(requiredService) {
        this.requiredService = requiredService;
        /** Header text for the tab */
        this.headerText = '';
        /** Collection of components */
        this.components = [];
        /**
         * Response from components after check
         */
        this.componentResponse = [];
        /**
         * Flag if tab content is valid
         * @default null
         */
        this.isValid = null;
        /** Template content */
        this.content = null;
        this.sub = new Subscription();
    }
    ngOnInit() {
        if (this.components.length > 0) {
            this.sub = this.requiredService.response$.subscribe((response) => {
                if (!this.components.some((x) => x === response.componentId)) {
                    return;
                }
                if (!this.componentResponse.some((x) => x.componentId === response.componentId)) {
                    this.componentResponse.push(response);
                }
                else {
                    this.componentResponse = this.componentResponse.map((x) => x.componentId === response.componentId ? response : x);
                }
                this.isValid = this.componentResponse.every((x) => x.response);
            });
        }
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
AsolTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabComponent, deps: [{ token: RequiredCheckService }], target: i0.ɵɵFactoryTarget.Component });
AsolTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolTabComponent, selector: "asol-tabs>asol-tab", inputs: { headerText: "headerText", components: "components" }, viewQueries: [{ propertyName: "content", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-tabs>asol-tab', template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: RequiredCheckService }]; }, propDecorators: { headerText: [{
                type: Input
            }], components: [{
                type: Input
            }], content: [{
                type: ViewChild,
                args: [TemplateRef]
            }] } });

class AsolTabsService {
    constructor() {
        /** Subject used to move to the tab */
        this.selectTab = new Subject();
        /** Observable that emits when moved to tab */
        this.selectTab$ = this.selectTab.asObservable();
    }
    /** Selects the tab by emitting an event */
    select(id, selectedTabIndex) {
        this.selectTab.next({
            id: id,
            selectedTabIndex: selectedTabIndex,
        });
    }
}
AsolTabsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AsolTabsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsService, decorators: [{
            type: Injectable
        }] });

class AsolTabsComponent {
    constructor(asolTabsService, requiredService) {
        this.asolTabsService = asolTabsService;
        this.requiredService = requiredService;
        this.selectedTabIndex = 0;
        /** Tabs id */
        this.tabsId = null;
        this.created = new EventEmitter();
        this.selected = new EventEmitter();
        this.tabs = null;
        this.initializeTabSubscription();
    }
    ngOnInit() {
        this.requiredSub = this.requiredService.result$.subscribe((result) => {
            if (result) {
                return;
            }
            const inValidTab = this.tabs
                .filter((p) => p.isValid !== null)
                .find((p) => p.isValid === false);
            if (inValidTab) {
                this.tab.selectedItem = this.tabs.toArray().indexOf(inValidTab);
            }
        });
    }
    ngAfterViewInit() {
        this.tab.selectedItem = this.selectedTabIndex;
    }
    ngOnChanges(changes) {
        if (changes.selectedTabIndex && this.tab) {
            this.tab.selectedItem = this.selectedTabIndex;
        }
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.requiredSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    trackTab(tab) {
        return tab ? tab.content : undefined;
    }
    /**
     * Emits event when tab is rendered
     */
    onCreated() {
        this.created.emit();
    }
    /**
     * Emits event when tab is changed
     * @param event Event fired @see {@link SelectEventArgs}
     */
    onSelected(event) {
        this.selected.emit(event);
    }
    /**
     * Disabling swipe change
     * @param e Event @see {@link SelectEventArgs}
     */
    onSelecting(e) {
        if (e.isSwiped) {
            e.cancel = true;
        }
    }
    /**
     * Initialize tab subscription to listen for tab changes.
     */
    initializeTabSubscription() {
        if (!this.asolTabsService) {
            return;
        }
        this.sub = this.asolTabsService.selectTab$.subscribe((data) => {
            if (data.id !== this.tabsId) {
                return;
            }
            this.tab.selectedItem = data.selectedTabIndex;
        });
    }
}
AsolTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsComponent, deps: [{ token: AsolTabsService, optional: true }, { token: RequiredCheckService }], target: i0.ɵɵFactoryTarget.Component });
AsolTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolTabsComponent, selector: "asol-tabs", inputs: { selectedTabIndex: "selectedTabIndex", tabsId: "tabsId" }, outputs: { created: "created", selected: "selected" }, queries: [{ propertyName: "tabs", predicate: AsolTabComponent }], viewQueries: [{ propertyName: "tab", first: true, predicate: ["asolTab"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ejs-tab\n  #asolTab\n  class=\"asol-tab\"\n  (created)=\"onCreated()\"\n  (selecting)=\"onSelecting($event)\"\n  (selected)=\"onSelected($event)\">\n  <e-tabitems>\n    <e-tabitem *ngFor=\"let tab of tabs\">\n      >\n      <ng-template #headerText>\n        <div\n          [ngClass]=\"{ 'invalid-tab': tab.isValid !== null && !tab.isValid }\">\n          {{ tab.headerText }}\n        </div>\n      </ng-template>\n      <ng-template #content>\n        <ng-container *ngTemplateOutlet=\"tab.content\"></ng-container>\n      </ng-template>\n    </e-tabitem>\n  </e-tabitems>\n</ejs-tab>\n", components: [{ type: i2$3.TabComponent, selector: "ejs-tab", inputs: ["allowDragAndDrop", "animation", "cssClass", "dragArea", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "headerPlacement", "height", "heightAdjustMode", "items", "loadOn", "locale", "overflowMode", "reorderActiveTab", "scrollStep", "selectedItem", "showCloseButton", "width"], outputs: ["added", "adding", "created", "destroyed", "dragged", "dragging", "onDragStart", "removed", "removing", "selected", "selecting"] }], directives: [{ type: i2$3.TabItemsDirective, selector: "ejs-tab>e-tabitems" }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$3.TabItemDirective, selector: "e-tabitems>e-tabitem", inputs: ["content", "cssClass", "disabled", "header", "headerTemplate", "id", "visible"] }, { type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-tabs', template: "<ejs-tab\n  #asolTab\n  class=\"asol-tab\"\n  (created)=\"onCreated()\"\n  (selecting)=\"onSelecting($event)\"\n  (selected)=\"onSelected($event)\">\n  <e-tabitems>\n    <e-tabitem *ngFor=\"let tab of tabs\">\n      >\n      <ng-template #headerText>\n        <div\n          [ngClass]=\"{ 'invalid-tab': tab.isValid !== null && !tab.isValid }\">\n          {{ tab.headerText }}\n        </div>\n      </ng-template>\n      <ng-template #content>\n        <ng-container *ngTemplateOutlet=\"tab.content\"></ng-container>\n      </ng-template>\n    </e-tabitem>\n  </e-tabitems>\n</ejs-tab>\n" }]
        }], ctorParameters: function () {
        return [{ type: AsolTabsService, decorators: [{
                        type: Optional
                    }] }, { type: RequiredCheckService }];
    }, propDecorators: { selectedTabIndex: [{
                type: Input
            }], tabsId: [{
                type: Input
            }], created: [{
                type: Output
            }], selected: [{
                type: Output
            }], tab: [{
                type: ViewChild,
                args: ['asolTab']
            }], tabs: [{
                type: ContentChildren,
                args: [AsolTabComponent]
            }] } });

class AsolTabsModule {
}
AsolTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsModule, declarations: [AsolTabsComponent, AsolTabComponent], imports: [SharedModule, TabModule], exports: [AsolTabsComponent, AsolTabComponent] });
AsolTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsModule, imports: [[SharedModule, TabModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolTabsComponent, AsolTabComponent],
                    exports: [AsolTabsComponent, AsolTabComponent],
                    imports: [SharedModule, TabModule],
                }]
        }] });

class ToolbarMessage {
}

const WORKFLOW_CONSTANT = {
    DEFAULT_HOVER_STROKE: '#b3bac5',
    DEFAULT_STROKE: '#fff',
    DEFAULT_FILL: '#fff',
    DEFAULT_TEXT_FILL: '#000',
    DEFAULT_ACTIVE_STROKE: '#0065FF',
    DEFAULT_ACTIVE_FILL: '#0065FF',
    DEFAULT_ACTIVE_TEXT_FILL: '#fff',
    TRANS: 'ASOL-WORKFLOW-TRANS',
};

var WorkflowState;
(function (WorkflowState) {
    //aktualny
    WorkflowState["CURRENT"] = "Current";
    //stav je nastaveny ako nasledujuci, ale uzivatel nema opravnenie
    WorkflowState["UNAUTHORIZED"] = "Unauthorized";
    //stav je nastaveny ako nasledujuci a uzivatel ma opravnenie
    WorkflowState["ALLOWED"] = "Allowed";
    //stav nie je nastaveny ako nasledujuci
    WorkflowState["FORBIDDEN"] = "Forbidden";
    //nekompatibilny mod zmeny wf (v ramci formulara sa meni iba na jednom zazname, ale je v stave ze ma zmenit hromadne alebo naopak)
    WorkflowState["INCOMPATIBLE_WORKFLOW"] = "IncompatibleWorkflow";
    //v pripade ze chceme hromadne posuvat wf ale nie je kazdy stav v rovnakom stave takze posuvat nemozeme
    WorkflowState["STATES_NOT_SAME"] = "StatesNotSame";
})(WorkflowState || (WorkflowState = {}));

var translation$4 = {
    "sk-SK": {
        Allowed: "Povolený stav",
        Current: "Aktuálny stav",
        Forbidden: "Stav nie je povolený pre aktuálny stav",
        Unauthorized: "Užívateľ nemá právo meniť stav workflowu na tento stav",
        IncompatibleWorkflow: "Stav workflow nie je nastavený na hromadnú zmenu",
        StatesNotSame: "Hromadný posun stavu workflowu nie je povolený lebo záznamy sa nenachádzajú v tom istom stave workflowu",
        ChangeWorkflowControlQuestion: "Naozaj si želáte zmeniť stav workflowu?"
    },
    "cs-CZ": {
        Allowed: "Povolený stav",
        Current: "Aktuální stav",
        Forbidden: "Stav není povolen pro aktuální stav",
        Unauthorized: "Uživatel nemá právo měnit stav workflowu na tenhle stav",
        IncompatibleWorkflow: "Stav workflow není nastaven na hromadnou změnu",
        StatesNotSame: "Hromadný posun stavu workflowu není povolen, neboť záznamy se nenacházejí ve stejném stavu workflowu",
        ChangeWorkflowControlQuestion: "Opravdu si přejete změnit stav workflowu?"
    },
    "en-US": {
        Allowed: "Allowed state",
        Current: "Current state",
        Forbidden: "State is not allowed for current state",
        Unauthorized: "User is not allowed to change workflow state to this state",
        IncompatibleWorkflow: "Workflow state is not set to bulk change",
        StatesNotSame: "Bulk chanage of workflow state is not allowed because records are not in the same state of workflow",
        ChangeWorkflowControlQuestion: "Are you sure you want to change workflow state?"
    }
};

class AsolWorkflowItemComponent {
    constructor(trans) {
        this.trans = trans;
        this.isFirst = false;
        this.isLast = false;
        this.item = null;
        this.isActive = false;
        this.defaultFill = WORKFLOW_CONSTANT.DEFAULT_FILL;
        this.defaultStroke = WORKFLOW_CONSTANT.DEFAULT_STROKE;
        this.defaultTextFill = WORKFLOW_CONSTANT.DEFAULT_TEXT_FILL;
        this.itemClick = new EventEmitter();
        this.WORKFLOW_CONSTANT = WORKFLOW_CONSTANT;
        this.fill = WORKFLOW_CONSTANT.DEFAULT_FILL;
        this.textFill = WORKFLOW_CONSTANT.DEFAULT_TEXT_FILL;
        this.stroke = WORKFLOW_CONSTANT.DEFAULT_STROKE;
        this.text = [];
        this.trans.initialize(WORKFLOW_CONSTANT.TRANS, translation$4);
    }
    ngOnChanges(changes) {
        if (changes.item || changes.isActive) {
            this.changeColors();
            this.changeState();
        }
        if (changes.item) {
            this.text.splice(0, this.text.length);
            this.parseText();
        }
    }
    changeState() {
        this.item.disabled = !((this.item.state === WorkflowState.ALLOWED ||
            this.item.state === WorkflowState.CURRENT) &&
            !this.item.disabled);
    }
    /**
     * Parses input text according these rules:
     * - if text is longer that 28 chars and does not contain any space it inserts ...
     * - if text is longer that 28 chars it splits the words into two lines
     * - if text is longer that 56 chars it splits the words into two lines and adds ...
     */
    parseText() {
        if (!this.item.text) {
            return;
        }
        if (this.item.text.length > 28) {
            const split = this.item.text.split(' ');
            // no space in text
            if (split.length === 1) {
                this.text.push(this.subStringEllipsis(split[0]));
                return;
            }
            let i = 0;
            for (let index = 0; index < 2; index++) {
                if (split.length <= i) {
                    break;
                }
                let text = split[i];
                i++;
                do {
                    if (split.length <= i) {
                        break;
                    }
                    const element = split[i];
                    if (text.length + element.length > 27) {
                        break;
                    }
                    text = `${text} ${element}`;
                    i++;
                } while (split.length > i);
                if (split.length > i && index === 1) {
                    text = `${text}...`;
                }
                this.text.push(text);
            }
        }
        else
            this.text.push(this.item.text);
    }
    /**
     * Inserts ... at the end of the string
     * @param text Text where ... are added
     * @returns text with ...
     */
    subStringEllipsis(text) {
        const item = text.substring(0, 27);
        return `${item}...`;
    }
    /**
     * Changes color according to state
     */
    changeColors() {
        if (!this.isActive) {
            this.fill = this.defaultFill;
            this.stroke = this.defaultStroke;
            this.textFill = this.defaultTextFill;
            return;
        }
        this.fill = this.item.color
            ? this.item.color
            : WORKFLOW_CONSTANT.DEFAULT_ACTIVE_FILL;
        this.stroke = this.item.color
            ? this.item.color
            : WORKFLOW_CONSTANT.DEFAULT_ACTIVE_STROKE;
        this.textFill = this.item.textColor
            ? this.item.textColor
            : WORKFLOW_CONSTANT.DEFAULT_ACTIVE_TEXT_FILL;
    }
    /**
     * Change hover state of the button
     * @param state True if mouse enters
     */
    changeHover(state) {
        if (!this.item || this.isActive) {
            return;
        }
        if (state) {
            this.stroke = this.item.color
                ? this.item.color
                : WORKFLOW_CONSTANT.DEFAULT_HOVER_STROKE;
        }
        else {
            this.stroke = WORKFLOW_CONSTANT.DEFAULT_STROKE;
        }
    }
    onClick() {
        if (this.item.disabled || this.item.active) {
            return;
        }
        this.itemClick.emit(this.item);
    }
    onBeforeOpen(e, text) {
        if (!text) {
            e.cancel = true;
        }
    }
}
AsolWorkflowItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowItemComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
AsolWorkflowItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolWorkflowItemComponent, selector: "asol-workflow-item", inputs: { isFirst: "isFirst", isLast: "isLast", item: "item", isActive: "isActive", defaultFill: "defaultFill", defaultStroke: "defaultStroke", defaultTextFill: "defaultTextFill" }, outputs: { itemClick: "itemClick" }, usesOnChanges: true, ngImport: i0, template: "<ejs-tooltip\n  (beforeRender)=\"onBeforeOpen($event, item.state)\"\n  content=\"{{\n    item?.state ? trans.get(WORKFLOW_CONSTANT.TRANS, item.state) : ''\n  }} \">\n  <svg\n    width=\"220\"\n    height=\"48\"\n    viewBox=\"0 0 260 56\"\n    fill=\"none\"\n    class=\"workflow-step\"\n    (mouseenter)=\"changeHover(true)\"\n    (mouseleave)=\"changeHover(false)\"\n    [ngClass]=\"{ disabled: item.disabled }\"\n    (click)=\"onClick()\"\n    xmlns=\"http://www.w3.org/2000/svg\">\n    <g *ngIf=\"isFirst\">\n      <path\n        d=\"M4 1H241.679C242.755 1 243.749 1.57686 244.283 2.51158L257.998 26.5116C258.525 27.4339 258.525 28.5661 257.998 29.4884L244.283 53.4884C243.749 54.4231 242.755 55 241.679 55H4C2.34314 55 1 53.6569 1 52V4C1 2.34315 2.34315 1 4 1Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <g *ngIf=\"!isFirst && !isLast\">\n      <path\n        d=\"M239.679 1C240.755 1 241.749 1.57686 242.283 2.51158L255.998 26.5116C256.525 27.4339 256.525 28.5661 255.998 29.4884L242.283 53.4884C241.749 54.4231 240.755 55 239.679 55H4.89272C2.58925 55 1.14515 52.5116 2.28799 50.5116L13.7342 30.4807C14.6126 28.9435 14.6126 27.0565 13.7342 25.5193L2.28799 5.48842C1.14515 3.48845 2.58925 1 4.89272 1H239.679Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <g *ngIf=\"isLast\">\n      <path\n        d=\"M2.28799 5.48842C1.14515 3.48844 2.58924 1 4.89271 1H254C255.657 1 257 2.34315 257 4V52C257 53.6569 255.657 55 254 55H4.89272C2.58925 55 1.14515 52.5116 2.28799 50.5116L13.7342 30.4807C14.6126 28.9435 14.6126 27.0565 13.7342 25.5193L2.28799 5.48842Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <text\n      x=\"50%\"\n      y=\"50%\"\n      [style.fill]=\"textFill\"\n      font-size=\"0.875rem\"\n      font-weight=\"500\"\n      dominant-baseline=\"middle\"\n      text-anchor=\"middle\">\n      <tspan *ngIf=\"text.length > 1\" x=\"50%\" y=\"20\">{{ text[0] }}</tspan>\n      <tspan *ngIf=\"text.length > 1\" x=\"50%\" y=\"35\">{{ text[1] }}</tspan>\n      <tspan *ngIf=\"text.length === 1\" x=\"50%\" y=\"50%\">{{ text[0] }}</tspan>\n    </text>\n  </svg>\n</ejs-tooltip>\n", styles: [""], components: [{ type: i2$2.TooltipComponent, selector: "ejs-tooltip", inputs: ["animation", "closeDelay", "container", "content", "cssClass", "enableHtmlParse", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "height", "isSticky", "locale", "mouseTrail", "offsetX", "offsetY", "openDelay", "opensOn", "position", "showTipPointer", "target", "tipPointerPosition", "width", "windowCollision"], outputs: ["afterClose", "afterOpen", "beforeClose", "beforeCollision", "beforeOpen", "beforeRender", "created", "destroyed"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-workflow-item', template: "<ejs-tooltip\n  (beforeRender)=\"onBeforeOpen($event, item.state)\"\n  content=\"{{\n    item?.state ? trans.get(WORKFLOW_CONSTANT.TRANS, item.state) : ''\n  }} \">\n  <svg\n    width=\"220\"\n    height=\"48\"\n    viewBox=\"0 0 260 56\"\n    fill=\"none\"\n    class=\"workflow-step\"\n    (mouseenter)=\"changeHover(true)\"\n    (mouseleave)=\"changeHover(false)\"\n    [ngClass]=\"{ disabled: item.disabled }\"\n    (click)=\"onClick()\"\n    xmlns=\"http://www.w3.org/2000/svg\">\n    <g *ngIf=\"isFirst\">\n      <path\n        d=\"M4 1H241.679C242.755 1 243.749 1.57686 244.283 2.51158L257.998 26.5116C258.525 27.4339 258.525 28.5661 257.998 29.4884L244.283 53.4884C243.749 54.4231 242.755 55 241.679 55H4C2.34314 55 1 53.6569 1 52V4C1 2.34315 2.34315 1 4 1Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <g *ngIf=\"!isFirst && !isLast\">\n      <path\n        d=\"M239.679 1C240.755 1 241.749 1.57686 242.283 2.51158L255.998 26.5116C256.525 27.4339 256.525 28.5661 255.998 29.4884L242.283 53.4884C241.749 54.4231 240.755 55 239.679 55H4.89272C2.58925 55 1.14515 52.5116 2.28799 50.5116L13.7342 30.4807C14.6126 28.9435 14.6126 27.0565 13.7342 25.5193L2.28799 5.48842C1.14515 3.48845 2.58925 1 4.89272 1H239.679Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <g *ngIf=\"isLast\">\n      <path\n        d=\"M2.28799 5.48842C1.14515 3.48844 2.58924 1 4.89271 1H254C255.657 1 257 2.34315 257 4V52C257 53.6569 255.657 55 254 55H4.89272C2.58925 55 1.14515 52.5116 2.28799 50.5116L13.7342 30.4807C14.6126 28.9435 14.6126 27.0565 13.7342 25.5193L2.28799 5.48842Z\"\n        [style.fill]=\"fill\"\n        [style.stroke]=\"stroke\"\n        stroke-width=\"2\" />\n    </g>\n    <text\n      x=\"50%\"\n      y=\"50%\"\n      [style.fill]=\"textFill\"\n      font-size=\"0.875rem\"\n      font-weight=\"500\"\n      dominant-baseline=\"middle\"\n      text-anchor=\"middle\">\n      <tspan *ngIf=\"text.length > 1\" x=\"50%\" y=\"20\">{{ text[0] }}</tspan>\n      <tspan *ngIf=\"text.length > 1\" x=\"50%\" y=\"35\">{{ text[1] }}</tspan>\n      <tspan *ngIf=\"text.length === 1\" x=\"50%\" y=\"50%\">{{ text[0] }}</tspan>\n    </text>\n  </svg>\n</ejs-tooltip>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; }, propDecorators: { isFirst: [{
                type: Input
            }], isLast: [{
                type: Input
            }], item: [{
                type: Input
            }], isActive: [{
                type: Input
            }], defaultFill: [{
                type: Input
            }], defaultStroke: [{
                type: Input
            }], defaultTextFill: [{
                type: Input
            }], itemClick: [{
                type: Output
            }] } });

class AsolWorkflowComponent {
    constructor(trans, requiredService) {
        this.trans = trans;
        this.requiredService = requiredService;
        /**
         * Items for workflow
         */
        this.items = [];
        /**
         * Flag if user can select multiple items
         * @default false
         */
        this.multiSelect = false;
        /**
         * Active Id, it will be selected from items if provided
         */
        this.activeId = '';
        /**
         * Flag if step changing requires check for all required fields
         * @default false
         */
        this.checkRequired = false;
        /**
         * Event emmiter after user changes the state
         */
        this.itemClick = new EventEmitter();
        this.ICONS = ICONS;
        /**
         * WorkflowItem to emit upon confirming {@link controlQuestionDialog}
         */
        this.selectedWorkflowItem = null;
        this.WORKFLOW_CONSTANT = WORKFLOW_CONSTANT;
        this.sub = new Subscription();
        this.trans.initialize(WORKFLOW_CONSTANT.TRANS, translation$4);
    }
    ngOnInit() {
        this.sub = this.requiredService.result$.subscribe((res) => {
            if (!res) {
                return;
            }
            this.changeState(this.selectedWorkflowItem);
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.requiredService.clear();
    }
    ngOnChanges(changes) {
        if (changes.activeId) {
            this.setActive();
        }
        if (changes.items && this.items.length && this.activeId) {
            this.setActive();
        }
    }
    /**
     * Sets active workflow item
     */
    setActive() {
        const workflow = this.items.find((p) => p.id === this.activeId);
        if (workflow) {
            workflow.active = true;
        }
    }
    /**
     * Click event after user changes the state.
     * If neccessary shows {@link controlQuestionDialog}, otherwise moves workflow
     * @param item Changed item @see {@link WorkflowItem}
     */
    onClick(item) {
        this.selectedWorkflowItem = item;
        if (this.checkRequired) {
            this.requiredService.check();
        }
        else {
            this.changeState(item);
        }
    }
    /**
     * Changes state of workflow item
     * @param item Changed item @see {@link WorkflowItem}
     */
    changeState(item) {
        if (item.controlQuestionOnChange) {
            this.controlQuestionDialog.show();
        }
        else {
            this.moveWorkflow(item);
        }
    }
    /**
     * Emits information about selected workflow state to move to
     * @param item
     */
    moveWorkflow(item) {
        if (!this.multiSelect) {
            this.items
                .filter((p) => p.id !== item.id)
                .forEach((p) => {
                p.active = false;
            });
        }
        const workflow = this.items.find((p) => p.id === item.id);
        workflow.active = !workflow.active;
        this.itemClick.emit(item);
    }
    moveLeft() {
        //
    }
    moveRight() {
        //
    }
    /**
     * Evaluates user's action on {@link controlQuestionDialog}
     */
    onDialogButton(e) {
        if (e === 'Confirm') {
            this.moveWorkflow(this.selectedWorkflowItem);
        }
        this.controlQuestionDialog.hide();
        this.selectedWorkflowItem = null;
    }
}
AsolWorkflowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowComponent, deps: [{ token: i1.TranslationService }, { token: RequiredCheckService }], target: i0.ɵɵFactoryTarget.Component });
AsolWorkflowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolWorkflowComponent, selector: "asol-workflow", inputs: { items: "items", multiSelect: "multiSelect", activeId: "activeId", checkRequired: "checkRequired" }, outputs: { itemClick: "itemClick" }, viewQueries: [{ propertyName: "workflowDiv", first: true, predicate: ["workflowDiv"], descendants: true }, { propertyName: "controlQuestionDialog", first: true, predicate: ["controlQuestionDialog"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"d-inline-flex w-100 flex-wrap\" #workflowDiv>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_LEFT\"\n    class=\"mb-2 d-flex align-items-center c-pointer\"\n    (click)=\"moveLeft()\">\n  </svg-icon> -->\n  <asol-workflow-item\n    class=\"mb-2\"\n    *ngFor=\"let item of items; let first = first; let last = last\"\n    [item]=\"item\"\n    [isFirst]=\"first\"\n    [isLast]=\"last && items.length > 1\"\n    [isActive]=\"item.active\"\n    (itemClick)=\"onClick($event)\">\n  </asol-workflow-item>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_RIGHT\"\n    class=\"mb-2 d-flex align-items-center\"\n    (click)=\"moveRight()\"></svg-icon> -->\n</div>\n\n<asol-dialog\n  #controlQuestionDialog\n  headerText=\"{{\n    trans.get(WORKFLOW_CONSTANT.TRANS, 'ChangeWorkflowControlQuestion')\n  }}\"\n  [buttonDefinition]=\"[\n    {\n      type: 'default',\n      color: 'primary',\n      textType: 'Confirm'\n    },\n    {\n      type: 'outline',\n      color: 'primary',\n      textType: 'Cancel'\n    }\n  ]\"\n  (buttonClicked)=\"onDialogButton($event)\"\n  [showCloseIcon]=\"false\"\n  [closeOnOverlayClick]=\"false\"\n  [buttonPosition]=\"'start'\">\n</asol-dialog>\n", styles: ["<div class=\"d-inline-flex w-100 flex-wrap\" #workflowDiv>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_LEFT\"\n    class=\"mb-2 d-flex align-items-center c-pointer\"\n    (click)=\"moveLeft()\">\n  </svg-icon> -->\n  <asol-workflow-item\n    class=\"mb-2\"\n    *ngFor=\"let item of items; let first = first; let last = last\"\n    [item]=\"item\"\n    [isFirst]=\"first\"\n    [isLast]=\"last && items.length > 1\"\n    [isActive]=\"item.active\"\n    (itemClick)=\"onClick($event)\">\n  </asol-workflow-item>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_RIGHT\"\n    class=\"mb-2 d-flex align-items-center\"\n    (click)=\"moveRight()\"></svg-icon> -->\n</div>\n\n<asol-dialog\n  #controlQuestionDialog\n  headerText=\"{{\n    trans.get(WORKFLOW_CONSTANT.TRANS, 'ChangeWorkflowControlQuestion')\n  }}\"\n  [buttonDefinition]=\"[\n    {\n      type: 'default',\n      color: 'primary',\n      textType: 'Confirm'\n    },\n    {\n      type: 'outline',\n      color: 'primary',\n      textType: 'Cancel'\n    }\n  ]\"\n  (buttonClicked)=\"onDialogButton($event)\"\n  [showCloseIcon]=\"false\"\n  [closeOnOverlayClick]=\"false\"\n  [buttonPosition]=\"'start'\">\n</asol-dialog>\n"], components: [{ type: AsolWorkflowItemComponent, selector: "asol-workflow-item", inputs: ["isFirst", "isLast", "item", "isActive", "defaultFill", "defaultStroke", "defaultTextFill"], outputs: ["itemClick"] }, { type: AsolDialogComponent, selector: "asol-dialog", inputs: ["headerText", "width", "minHeight", "height", "isModal", "buttonDefinition", "showCloseIcon", "closeOnOverlayClick", "buttonPosition", "defaultPaddings", "buttonCssClass"], outputs: ["buttonClicked"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-workflow', template: "<div class=\"d-inline-flex w-100 flex-wrap\" #workflowDiv>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_LEFT\"\n    class=\"mb-2 d-flex align-items-center c-pointer\"\n    (click)=\"moveLeft()\">\n  </svg-icon> -->\n  <asol-workflow-item\n    class=\"mb-2\"\n    *ngFor=\"let item of items; let first = first; let last = last\"\n    [item]=\"item\"\n    [isFirst]=\"first\"\n    [isLast]=\"last && items.length > 1\"\n    [isActive]=\"item.active\"\n    (itemClick)=\"onClick($event)\">\n  </asol-workflow-item>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_RIGHT\"\n    class=\"mb-2 d-flex align-items-center\"\n    (click)=\"moveRight()\"></svg-icon> -->\n</div>\n\n<asol-dialog\n  #controlQuestionDialog\n  headerText=\"{{\n    trans.get(WORKFLOW_CONSTANT.TRANS, 'ChangeWorkflowControlQuestion')\n  }}\"\n  [buttonDefinition]=\"[\n    {\n      type: 'default',\n      color: 'primary',\n      textType: 'Confirm'\n    },\n    {\n      type: 'outline',\n      color: 'primary',\n      textType: 'Cancel'\n    }\n  ]\"\n  (buttonClicked)=\"onDialogButton($event)\"\n  [showCloseIcon]=\"false\"\n  [closeOnOverlayClick]=\"false\"\n  [buttonPosition]=\"'start'\">\n</asol-dialog>\n", styles: ["<div class=\"d-inline-flex w-100 flex-wrap\" #workflowDiv>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_LEFT\"\n    class=\"mb-2 d-flex align-items-center c-pointer\"\n    (click)=\"moveLeft()\">\n  </svg-icon> -->\n  <asol-workflow-item\n    class=\"mb-2\"\n    *ngFor=\"let item of items; let first = first; let last = last\"\n    [item]=\"item\"\n    [isFirst]=\"first\"\n    [isLast]=\"last && items.length > 1\"\n    [isActive]=\"item.active\"\n    (itemClick)=\"onClick($event)\">\n  </asol-workflow-item>\n  <!-- <svg-icon\n    [src]=\"ICONS.CHEVRON_RIGHT\"\n    class=\"mb-2 d-flex align-items-center\"\n    (click)=\"moveRight()\"></svg-icon> -->\n</div>\n\n<asol-dialog\n  #controlQuestionDialog\n  headerText=\"{{\n    trans.get(WORKFLOW_CONSTANT.TRANS, 'ChangeWorkflowControlQuestion')\n  }}\"\n  [buttonDefinition]=\"[\n    {\n      type: 'default',\n      color: 'primary',\n      textType: 'Confirm'\n    },\n    {\n      type: 'outline',\n      color: 'primary',\n      textType: 'Cancel'\n    }\n  ]\"\n  (buttonClicked)=\"onDialogButton($event)\"\n  [showCloseIcon]=\"false\"\n  [closeOnOverlayClick]=\"false\"\n  [buttonPosition]=\"'start'\">\n</asol-dialog>\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: RequiredCheckService }]; }, propDecorators: { items: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], activeId: [{
                type: Input
            }], checkRequired: [{
                type: Input
            }], itemClick: [{
                type: Output
            }], workflowDiv: [{
                type: ViewChild,
                args: ['workflowDiv']
            }], controlQuestionDialog: [{
                type: ViewChild,
                args: ['controlQuestionDialog']
            }] } });

class AsolWorkflowModule {
}
AsolWorkflowModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolWorkflowModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowModule, declarations: [AsolWorkflowComponent, AsolWorkflowItemComponent], imports: [SharedModule, TooltipModule, AsolDialogModule], exports: [AsolWorkflowComponent, AsolWorkflowItemComponent] });
AsolWorkflowModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowModule, imports: [[SharedModule, TooltipModule, AsolDialogModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolWorkflowModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolWorkflowComponent, AsolWorkflowItemComponent],
                    exports: [AsolWorkflowComponent, AsolWorkflowItemComponent],
                    imports: [SharedModule, TooltipModule, AsolDialogModule],
                }]
        }] });

/**
 * Class for checking if item is duplicated
 */
class CheckFieldProvider {
}
CheckFieldProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckFieldProvider, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CheckFieldProvider.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: CheckFieldProvider, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CheckFieldProvider, decorators: [{
            type: Directive
        }] });

/**
 * The AsolSelectTreeComponent contains a hierarchical structure list of pre-defined values
 * from that the user can choose a single value.
 *
 * IMPORTANT: - valueProperty, displayProperty, parentProperty must correctly set accroding to the type SelectedTreeItem
 *            - there is no need to define valueProperty, displayProperty or parentProperty
 *              if DataTreeProvider is used or data is of type SelectedTreeItem
 *
 * @export
 * @class AsolSelectTreeComponent
 * @typedef {AsolSelectTreeComponent}
 * @extends {ControlBase<string[]>}
 * @implements {OnInit, OnChanges}
 */
class AsolSelectTreeComponent extends ControlBase {
    constructor(trans, ngControl) {
        super(trans, ngControl);
        this.trans = trans;
        this.ngControl = ngControl;
        /**
         * Data source that provides data without DataTreeProvider.
         * Key structure of this data source is defined by
         * valueProperty, displayProperty, parentProperty.
         *
         * @default []
         */
        this.options = [];
        /**
         * Data source that provides data by DataTreeProvider.
         * Returned data must be of type SelectedTreeItem[]
         */
        this.dataProvider = null;
        /**
         *  Is used for field model to map value of data.
         *
         * @default 'value'
         */
        this.valueProperty = 'value';
        /**
         * Is used for field model to map data that are displayed in tree.
         *
         * @default 'text'
         */
        this.displayProperty = 'text';
        /**
         * Is used for field model to map child and parent data.
         *
         * @default 'parentId'
         */
        this.parentProperty = 'parentId';
        /**
         * Hide or show clear button in input.
         *
         * @default false
         */
        this.showClearButton = false;
        /**
         * Hide or show checkbox in tree.
         *
         * @default false
         */
        this.showCheckBox = false;
        /**
         * Allow to select multiple items in tree.
         *
         * @default false
         */
        this.allowMultiSelection = false;
        /**
         * Optional filtering parameter for data provider.
         *
         * @default null
         */
        this.filterParams = null;
        this.locale = '';
        /**
         * Specifies the data source and mapping fields to render Dropdown Tree items.
         *
         * @public
         * @type {FieldsModel}
         */
        this.fieldsModel = {};
        this.ICONS = ICONS;
        this.locale = this.trans.currentLocale;
    }
    ngOnInit() {
        super.ngOnInit();
        this.setFieldsModel();
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        if (((_a = changes.valueProperty) === null || _a === void 0 ? void 0 : _a.currentValue) ||
            ((_b = changes.displayProperty) === null || _b === void 0 ? void 0 : _b.currentValue) ||
            ((_c = changes.parentProperty) === null || _c === void 0 ? void 0 : _c.currentValue)) {
            this.setFieldsModel();
        }
        if (changes.filterParams && !changes.filterParams.firstChange) {
            this.loadDataProvider();
        }
        if (changes.options) {
            this.parseOptions();
        }
        if (changes.dataProvider) {
            this.loadDataProvider();
        }
    }
    /**
     * This method creates a tree-data mapping model.
     *
     * @private
     */
    setFieldsModel() {
        this.fieldsModel.value = this.valueProperty;
        this.fieldsModel.text = this.displayProperty;
        this.fieldsModel.parentValue = this.parentProperty;
        this.fieldsModel.hasChildren = 'hasChild';
    }
    /**
     * This method loads the data by the data provider.
     *
     * @private
     */
    loadDataProvider() {
        if (!this.dataProvider) {
            return;
        }
        this.dataProvider.getTreeData(this.filterParams).subscribe((options) => {
            if (!options) {
                return;
            }
            this.treeParsing(options);
            this.setData(options);
        });
    }
    /**
     * This method parse data in options.
     */
    parseOptions() {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        this.treeParsing(this.options);
        this.setData(this.options);
    }
    getControlValue() {
        if (!this.selectInput) {
            return null;
        }
        return this.selectInput.value;
    }
    setControlValue(val) {
        if (!this.selectInput) {
            return;
        }
        if (val && (val === null || val === void 0 ? void 0 : val.length)) {
            // Unfortunately
            setTimeout(() => {
                this.selectInput.value = val;
            });
        }
        else {
            this.selectInput.value = [];
        }
    }
    setControlDisabled(isDisable) {
        // empty
    }
    /**
     * This method emit value after new item is selected in select tree box.
     * @param {SelectEventArgs} event
     */
    callOnChange(event) {
        this.onChange(event.itemData['id']);
        this.valueChangedDebouncer.next(event.itemData['id']);
    }
    /**
     * This method open popup and roll out tree items that are selected.
     *
     * @param {PopupEventArgs} event
     */
    callOnOpen(event) {
        var _a;
        if (this.selectInput.value && ((_a = this.selectInput.value) === null || _a === void 0 ? void 0 : _a.length)) {
            this.selectInput.ensureVisible(this.getControlValue()[0]);
        }
    }
    /**
     * The method return full selected entity and is casted a T.
     */
    getSelectedEntity() {
        if (!this.selectInput) {
            return null;
        }
        return this.selectInput.value;
    }
    /**
     * This method parse data for tree model.
     * Example:  main parent -> parent -> child
     */
    treeParsing(options) {
        options.forEach((item) => {
            if (!(item instanceof SelectedTreeItem)) {
                if ((!item[this.fieldsModel.parentValue] &&
                    item[this.fieldsModel.parentValue] !== 0) ||
                    item[this.fieldsModel.parentValue] === item[this.fieldsModel.value]) {
                    item[this.fieldsModel.hasChildren] = true;
                    item[this.fieldsModel.parentValue] = null;
                }
            }
            if (item[this.fieldsModel.parentValue] ||
                item[this.fieldsModel.parentValue] === 0) {
                const option = options.find((option) => option[this.fieldsModel.value] ===
                    item[this.fieldsModel.parentValue]);
                if (option) {
                    option[this.fieldsModel.hasChildren] = true;
                }
            }
        });
    }
    /**
     * This method set parsed data to model.
     *
     * @param {(unknown[] | SelectedTreeItem[])} options
     */
    setData(options) {
        this.fieldsModel.dataSource = new DataManager(options);
        if (this.selectInput) {
            this.selectInput.fields = this.fieldsModel;
        }
        this.setControlValue(this.value);
    }
}
AsolSelectTreeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeComponent, deps: [{ token: i1.TranslationService }, { token: i2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AsolSelectTreeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSelectTreeComponent, selector: "asol-select-tree", inputs: { options: "options", dataProvider: "dataProvider", valueProperty: "valueProperty", displayProperty: "displayProperty", parentProperty: "parentProperty", showClearButton: "showClearButton", showCheckBox: "showCheckBox", allowMultiSelection: "allowMultiSelection", filterParams: "filterParams" }, viewQueries: [{ propertyName: "selectInput", first: true, predicate: ["dropdowntree"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-dropdowntree\n    [id]=\"id ?? 'dropdowntreeElement'\"\n    class=\"asol-select\"\n    cssClass=\"asol-tree\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    #dropdowntree\n    [fields]=\"fieldsModel\"\n    (select)=\"callOnChange($event)\"\n    (open)=\"callOnOpen($event)\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [showClearButton]=\"showClearButton\"\n    [allowMultiSelection]=\"allowMultiSelection\"\n    [showCheckBox]=\"showCheckBox\"\n    [width]=\"width\"\n    [locale]=\"locale\">\n  </ejs-dropdowntree>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n", components: [{ type: AsolLabelFieldComponent, selector: "asol-label-field", inputs: ["text", "textStyle", "textClass", "labelText", "labelTextStyle", "labelTextClass", "labelKey", "transKey", "useTemplate", "useDefaultText", "control", "isDisabled", "isRequired", "width", "icon", "editable"], outputs: ["edit"] }, { type: i4$1.DropDownTreeComponent, selector: "ejs-dropdowntree", inputs: ["actionFailureTemplate", "allowFiltering", "allowMultiSelection", "changeOnBlur", "cssClass", "customTemplate", "delimiterChar", "enablePersistence", "enableRtl", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "headerTemplate", "htmlAttributes", "ignoreAccent", "ignoreCase", "itemTemplate", "locale", "mode", "noRecordsTemplate", "placeholder", "popupHeight", "popupWidth", "readonly", "selectAllText", "showCheckBox", "showClearButton", "showDropDownIcon", "showSelectAll", "sortOrder", "text", "treeSettings", "unSelectAllText", "value", "width", "wrapText", "zIndex"], outputs: ["actionFailure", "beforeOpen", "blur", "change", "close", "created", "dataBound", "destroyed", "filtering", "focus", "keyPress", "open", "select", "valueChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-select-tree', template: "<div [ngClass]=\"{ 'mb-2': showError }\" [class]=\"cssClass\">\n  <asol-label-field\n    *ngIf=\"labelText\"\n    [labelTextStyle]=\"labelTextStyle\"\n    labelTextClass=\"mb-0\"\n    [labelText]=\"labelText\"\n    [control]=\"ngControl.control\"\n    [isDisabled]=\"ngControl.control?.disabled\"\n    [isRequired]=\"isRequired\"></asol-label-field>\n\n  <div class=\"asol-hint mb-0\" *ngIf=\"hintText\">\n    {{ hintText }}\n  </div>\n\n  <ejs-dropdowntree\n    [id]=\"id ?? 'dropdowntreeElement'\"\n    class=\"asol-select\"\n    cssClass=\"asol-tree\"\n    [ngClass]=\"{\n      'e-error': ngControl.control.errors && ngControl.control.touched\n    }\"\n    #dropdowntree\n    [fields]=\"fieldsModel\"\n    (select)=\"callOnChange($event)\"\n    (open)=\"callOnOpen($event)\"\n    [placeholder]=\"placeholderText\"\n    [readonly]=\"isReadonly\"\n    [enabled]=\"!isDisabled\"\n    [showClearButton]=\"showClearButton\"\n    [allowMultiSelection]=\"allowMultiSelection\"\n    [showCheckBox]=\"showCheckBox\"\n    [width]=\"width\"\n    [locale]=\"locale\">\n  </ejs-dropdowntree>\n\n  <ng-container *ngIf=\"showError\">\n    <div\n      class=\"asol-error d-inline-flex align-items-center\"\n      *ngFor=\"let msg of getErrorMessages()\">\n      <svg-icon [src]=\"ICONS.ERROR\"></svg-icon>\n      {{ msg }}\n    </div>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: i2.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { options: [{
                type: Input
            }], dataProvider: [{
                type: Input
            }], valueProperty: [{
                type: Input
            }], displayProperty: [{
                type: Input
            }], parentProperty: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], showCheckBox: [{
                type: Input
            }], allowMultiSelection: [{
                type: Input
            }], filterParams: [{
                type: Input
            }], selectInput: [{
                type: ViewChild,
                args: ['dropdowntree']
            }] } });

class AsolSelectTreeModule {
}
AsolSelectTreeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolSelectTreeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeModule, declarations: [AsolSelectTreeComponent], imports: [DropDownTreeModule, SharedModule, AsolLabelFieldModule], exports: [AsolSelectTreeComponent] });
AsolSelectTreeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeModule, imports: [[DropDownTreeModule, SharedModule, AsolLabelFieldModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSelectTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolSelectTreeComponent],
                    imports: [DropDownTreeModule, SharedModule, AsolLabelFieldModule],
                    exports: [AsolSelectTreeComponent],
                }]
        }] });

class ContentSummaryItemDirective {
    constructor() {
        /** Summary title */
        this.title = '';
        /** Flag if title should be visible */
        this.showTitle = true;
        /** Translation key */
        this.transKey = '';
        /** Displays translated title based on key */
        this.titleKey = '';
        /** Summary data value */
        this.value = CORE_CONSTANTS.DEFAULT_RETURN_VALUE;
        /** Summary items that will be displayed on separated lines */
        this.values = [];
        /** Optional template definition */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.template = null;
    }
}
ContentSummaryItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ContentSummaryItemDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ContentSummaryItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ContentSummaryItemDirective, selector: "content-summary>content-summary-item", inputs: { title: "title", showTitle: "showTitle", transKey: "transKey", titleKey: "titleKey", value: "value", values: "values" }, queries: [{ propertyName: "template", first: true, predicate: ["template"], descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ContentSummaryItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'content-summary>content-summary-item',
                }]
        }], propDecorators: { title: [{
                type: Input
            }], showTitle: [{
                type: Input
            }], transKey: [{
                type: Input
            }], titleKey: [{
                type: Input
            }], value: [{
                type: Input
            }], values: [{
                type: Input
            }],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        template: [{
                type: ContentChild,
                args: ['template']
            }] } });

class ContentSummaryLinkDirective {
    constructor() {
        /** Link title */
        this.title = '';
        /** Flag if title should be visible */
        this.showTitle = true;
        /** Translation key */
        this.transKey = '';
        /** Displays translated title based on key */
        this.titleKey = '';
        /**
         * Link icon url
         * @default LINK_04
         * */
        this.iconUrl = ICONS.LINK_04;
        /**
         * Link module base uri
         * e.g. /firms/detail
         */
        this.uri = '';
        /** Content summary links */
        this.links = [];
    }
}
ContentSummaryLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ContentSummaryLinkDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ContentSummaryLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ContentSummaryLinkDirective, selector: "content-summary>content-summary-link", inputs: { title: "title", showTitle: "showTitle", transKey: "transKey", titleKey: "titleKey", iconUrl: "iconUrl", uri: "uri", links: "links" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ContentSummaryLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'content-summary>content-summary-link',
                }]
        }], propDecorators: { title: [{
                type: Input
            }], showTitle: [{
                type: Input
            }], transKey: [{
                type: Input
            }], titleKey: [{
                type: Input
            }], iconUrl: [{
                type: Input
            }], uri: [{
                type: Input
            }], links: [{
                type: Input
            }] } });

class AsolContentSummaryComponent {
    constructor(trans, router) {
        this.trans = trans;
        this.router = router;
        this.ICONS = ICONS;
        this.CORE_CONSTANTS = CORE_CONSTANTS;
    }
    /**
     * Method that navigates or opens new window provided uri
     * @param link Link URI object @see {@link ContentSummaryLinkDirective}
     * @param item Item with data @see {@link ContentSummaryLink}
     */
    onLinkClick(link, item) {
        if (link.uri.startsWith('http')) {
            window.open(link.uri, '_blank');
            return;
        }
        this.router.navigate([`/${link.uri}/${item.id}`]);
    }
}
AsolContentSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryComponent, deps: [{ token: i1.TranslationService }, { token: i1$3.Router }], target: i0.ɵɵFactoryTarget.Component });
AsolContentSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolContentSummaryComponent, selector: "asol-content-summary", queries: [{ propertyName: "items", predicate: ContentSummaryItemDirective }, { propertyName: "links", predicate: ContentSummaryLinkDirective }], ngImport: i0, template: "<div class=\"summary-content h-100 content-panel\">\n  <!-- Data -->\n  <div *ngFor=\"let item of items\" class=\"mb-3\">\n    <div class=\"title\" *ngIf=\"item.showTitle\">\n      {{ item.title ? item.title : trans.get(item.transKey, item.titleKey) }}\n    </div>\n    <div class=\"value\">\n      <ng-container *ngIf=\"!item.values.length; else multiValues\">\n        <ng-container *ngIf=\"!item.template\">\n          {{ item.value ?? CORE_CONSTANTS.DEFAULT_RETURN_VALUE }}\n        </ng-container>\n      </ng-container>\n      <ng-container\n        *ngIf=\"item.template\"\n        [ngTemplateOutlet]=\"item.template\"\n        [ngTemplateOutletContext]=\"{ $implicit: item }\">\n      </ng-container>\n    </div>\n    <ng-template #multiValues>\n      <div class=\"row flex-column\">\n        <div class=\"col\" *ngFor=\"let data of item.values\">\n          {{ data }}\n        </div>\n      </div>\n    </ng-template>\n  </div>\n\n  <!-- Links -->\n  <div *ngFor=\"let link of links\" class=\"mb-3\">\n    <div class=\"title\" *ngIf=\"link.showTitle\">\n      {{ link.title ? link.title : trans.get(link.transKey, link.titleKey) }}\n    </div>\n    <ejs-tooltip\n      *ngFor=\"let item of link.links\"\n      class=\"d-flex\"\n      content=\"{{ item.name }}\"\n      position=\"LeftCenter\">\n      <a\n        class=\"d-inline-flex align-items-center c-pointer overflow-hidden\"\n        (click)=\"onLinkClick(link, item)\">\n        <svg-icon [src]=\"link.iconUrl\" class=\"me-0\"></svg-icon>\n        <div class=\"text-truncate\">\n          {{ item.name ?? CORE_CONSTANTS.DEFAULT_RETURN_VALUE }}\n        </div>\n      </a>\n    </ejs-tooltip>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.summary-content{width:251px;font-size:.875rem;font-weight:500}.summary-content .title{font-weight:400;color:#42526e}.summary-content .value{font-weight:700}.summary-content a{color:#0065ff;text-decoration:none;line-height:2.5rem;font-size:.875rem;font-weight:500}.summary-content a svg path{stroke:#0065ff}\n"], components: [{ type: i2$2.TooltipComponent, selector: "ejs-tooltip", inputs: ["animation", "closeDelay", "container", "content", "cssClass", "enableHtmlParse", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "height", "isSticky", "locale", "mouseTrail", "offsetX", "offsetY", "openDelay", "opensOn", "position", "showTipPointer", "target", "tipPointerPosition", "width", "windowCollision"], outputs: ["afterClose", "afterOpen", "beforeClose", "beforeCollision", "beforeOpen", "beforeRender", "created", "destroyed"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-content-summary', template: "<div class=\"summary-content h-100 content-panel\">\n  <!-- Data -->\n  <div *ngFor=\"let item of items\" class=\"mb-3\">\n    <div class=\"title\" *ngIf=\"item.showTitle\">\n      {{ item.title ? item.title : trans.get(item.transKey, item.titleKey) }}\n    </div>\n    <div class=\"value\">\n      <ng-container *ngIf=\"!item.values.length; else multiValues\">\n        <ng-container *ngIf=\"!item.template\">\n          {{ item.value ?? CORE_CONSTANTS.DEFAULT_RETURN_VALUE }}\n        </ng-container>\n      </ng-container>\n      <ng-container\n        *ngIf=\"item.template\"\n        [ngTemplateOutlet]=\"item.template\"\n        [ngTemplateOutletContext]=\"{ $implicit: item }\">\n      </ng-container>\n    </div>\n    <ng-template #multiValues>\n      <div class=\"row flex-column\">\n        <div class=\"col\" *ngFor=\"let data of item.values\">\n          {{ data }}\n        </div>\n      </div>\n    </ng-template>\n  </div>\n\n  <!-- Links -->\n  <div *ngFor=\"let link of links\" class=\"mb-3\">\n    <div class=\"title\" *ngIf=\"link.showTitle\">\n      {{ link.title ? link.title : trans.get(link.transKey, link.titleKey) }}\n    </div>\n    <ejs-tooltip\n      *ngFor=\"let item of link.links\"\n      class=\"d-flex\"\n      content=\"{{ item.name }}\"\n      position=\"LeftCenter\">\n      <a\n        class=\"d-inline-flex align-items-center c-pointer overflow-hidden\"\n        (click)=\"onLinkClick(link, item)\">\n        <svg-icon [src]=\"link.iconUrl\" class=\"me-0\"></svg-icon>\n        <div class=\"text-truncate\">\n          {{ item.name ?? CORE_CONSTANTS.DEFAULT_RETURN_VALUE }}\n        </div>\n      </a>\n    </ejs-tooltip>\n  </div>\n</div>\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.summary-content{width:251px;font-size:.875rem;font-weight:500}.summary-content .title{font-weight:400;color:#42526e}.summary-content .value{font-weight:700}.summary-content a{color:#0065ff;text-decoration:none;line-height:2.5rem;font-size:.875rem;font-weight:500}.summary-content a svg path{stroke:#0065ff}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i1$3.Router }]; }, propDecorators: { items: [{
                type: ContentChildren,
                args: [ContentSummaryItemDirective]
            }], links: [{
                type: ContentChildren,
                args: [ContentSummaryLinkDirective]
            }] } });

class AsolContentSummaryModule {
}
AsolContentSummaryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolContentSummaryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryModule, declarations: [AsolContentSummaryComponent,
        ContentSummaryLinkDirective,
        ContentSummaryItemDirective], imports: [SharedModule, RouterModule, TooltipModule], exports: [AsolContentSummaryComponent,
        ContentSummaryLinkDirective,
        ContentSummaryItemDirective] });
AsolContentSummaryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryModule, imports: [[SharedModule, RouterModule, TooltipModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentSummaryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AsolContentSummaryComponent,
                        ContentSummaryLinkDirective,
                        ContentSummaryItemDirective,
                    ],
                    exports: [
                        AsolContentSummaryComponent,
                        ContentSummaryLinkDirective,
                        ContentSummaryItemDirective,
                    ],
                    imports: [SharedModule, RouterModule, TooltipModule],
                }]
        }] });

var translation$3 = {
    "sk-SK": {
        confirmDiscardTitle: "Zahodiť zmeny",
        confirmDiscardContent: "Skutočne chcete zahodiť zmeny?"
    },
    "cs-CZ": {
        confirmDiscardTitle: "Zahodit změny",
        confirmDiscardContent: "Skutečně chcete zahodit změny?"
    },
    "en-US": {
        confirmDiscardTitle: "Discard changes",
        confirmDiscardContent: "Are you sure you want to discard the changes?"
    }
};

const CONTENT_WRAPPER_CONSTANT = {
    TRANS: 'asol-content-wrapper-trans',
};

class AsolContentWrapperComponent {
    constructor(trans, requiredService) {
        this.trans = trans;
        this.requiredService = requiredService;
        /** Content title */
        this.title = null;
        /** Data that will be used as default after discard changes */
        this.data = null;
        /** Formgoup where changes will be checked */
        this.formGroup = null;
        /**
         * Debounce time used in formgroup changes delay in ms
         * @default 200
         */
        this.debounceTime = 200;
        /** Emits when user clicks on Save button */
        this.saveChanges = new EventEmitter();
        /** Emits when form was reseted by user */
        this.formReset = new EventEmitter();
        /** Flag if form group contains changes */
        this.isDirty = false;
        /** Gets all data components where columns will be injected */
        this.contentForms = null;
        this.confirmDialog = null;
        this.sub = new Subscription();
        this.requiredSub = new Subscription();
        this.contentSub = new Subscription();
        this.trans.initialize(CONTENT_WRAPPER_CONSTANT.TRANS, translation$3);
    }
    ngOnInit() {
        if (this.componentId) {
            this.requiredService.register(this.componentId);
            this.requiredSub = this.requiredService.requireCheck$.subscribe((sessionId) => {
                const formValid = this.checkValidity() && !this.isDirty;
                this.requiredService.response(sessionId, this.componentId, formValid);
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.data && !changes.data.firstChange) {
            this.resetForm();
        }
    }
    ngAfterContentInit() {
        this.contentForms.changes.subscribe(() => {
            this.prepareContentForms();
        });
        this.prepareContentForms();
        this.listenToFormChanges();
    }
    ngOnDestroy() {
        var _a, _b, _c;
        if (this.componentId) {
            this.requiredService.unregister(this.componentId);
        }
        (_a = this.requiredSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.sub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.contentSub) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    }
    /**
     * Starts listen to form value changes and emits state of form
     */
    listenToFormChanges() {
        var _a;
        // listens for value changes and marks form group as changed
        this.sub = (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(() => {
            // check if any inner form is dirty
            const formDirty = this.contentForms.some((p) => p.isDirty);
            if (formDirty) {
                return;
            }
            // no inner form is dirty, set the flag
            this.isDirty = this.formGroup.dirty;
            if (!this.isDirty) {
                this.recheckValidity();
            }
        });
    }
    /**
     * Event handler to emit storing
     */
    onSave() {
        var _a;
        if (this.formGroup) {
            const isValid = this.checkValidity();
            if (!isValid) {
                return;
            }
        }
        (_a = this.contentForms) === null || _a === void 0 ? void 0 : _a.forEach((form) => {
            if (form.isDirty) {
                form.saveData();
            }
        });
        this.saveMainForm();
    }
    /**
     * Save main form only when is dirty
     * or any child form is dirty and marked that it should be saved via parent
     */
    saveMainForm() {
        const childDirty = this.contentForms.some((p) => p.isDirty && p.includeInParentSave);
        if ((this.formGroup && this.formGroup.dirty) || childDirty) {
            this.saveChanges.emit();
        }
    }
    /**
     * Sends valid message to everyone who is listening to this component
     * @returns
     */
    recheckValidity() {
        if (!this.componentId) {
            return;
        }
        this.requiredService.check(false);
    }
    /**
     * Checks validity of main form and content forms
     * @returns True if all valid
     */
    checkValidity() {
        if (this.formGroup) {
            markForValidation(this.formGroup);
            if (!this.formGroup.valid) {
                return false;
            }
        }
        let valid = true;
        this.contentForms.forEach((formDirective) => {
            valid = formDirective.validate();
        });
        return valid;
    }
    /**
     * Event handler for discarding changes of form group via confirm dialog
     */
    onDiscard() {
        this.confirmDialog = DialogUtility.confirm({
            title: this.trans.get(CONTENT_WRAPPER_CONSTANT.TRANS, 'confirmDiscardTitle'),
            content: this.trans.get(CONTENT_WRAPPER_CONSTANT.TRANS, 'confirmDiscardContent'),
            okButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'Yes'),
                click: this.resetForm.bind(this),
            },
            cancelButton: {
                text: this.trans.get(GENERAL_TRANSLATION, 'No'),
            },
        });
    }
    /**
     * Prepares forms
     */
    prepareContentForms() {
        var _a;
        (_a = this.contentSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        if (!this.contentForms || !this.contentForms.length) {
            return;
        }
        this.contentSub = new Subscription();
        this.contentForms.forEach((form) => {
            var _a;
            (_a = this.contentSub) === null || _a === void 0 ? void 0 : _a.add(form.isDirty$.subscribe((isDirty) => {
                this.calculateDirty(isDirty, form.formId);
                if (!this.isDirty) {
                    this.recheckValidity();
                }
            }));
        });
    }
    /**
     * Reset form
     */
    resetForm() {
        var _a;
        this.resetAllForms();
        this.resetMainForm();
        this.formReset.emit();
        this.isDirty = false;
        (_a = this.confirmDialog) === null || _a === void 0 ? void 0 : _a.hide();
    }
    /**
     * Recalculates the dirty flag
     * @param isDirty dirty value
     */
    calculateDirty(isDirty, id) {
        var _a;
        // if inner form is dirty mark as dirty
        if (isDirty) {
            this.isDirty = true;
            return;
        }
        const formDirty = this.contentForms
            .filter((p) => p.formId !== id)
            .some((p) => p.isDirty);
        // if any other inner form is dirty return
        if (formDirty) {
            return;
        }
        // none of inner form is dirty, so check this one
        if ((_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.dirty) {
            return;
        }
        // if no form is dirty
        this.isDirty = false;
    }
    /**
     * Resets main form
     */
    resetMainForm() {
        var _a, _b, _c;
        if (!((_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.dirty)) {
            return;
        }
        const defaultData = this.data;
        (_b = this.formGroup) === null || _b === void 0 ? void 0 : _b.reset(Object.assign({}, defaultData), {
            emitEvent: false,
            onlySelf: true,
        });
        (_c = this.formGroup) === null || _c === void 0 ? void 0 : _c.updateValueAndValidity();
    }
    /**
     * Resets all forms in wrapper
     */
    resetAllForms() {
        var _a;
        (_a = this.contentForms) === null || _a === void 0 ? void 0 : _a.forEach((form) => {
            form.resetForm();
        });
    }
}
AsolContentWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperComponent, deps: [{ token: i1.TranslationService }, { token: RequiredCheckService }], target: i0.ɵɵFactoryTarget.Component });
AsolContentWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolContentWrapperComponent, selector: "asol-content-wrapper", inputs: { title: "title", data: "data", formGroup: "formGroup", componentId: "componentId", debounceTime: "debounceTime" }, outputs: { saveChanges: "saveChanges", formReset: "formReset" }, queries: [{ propertyName: "contentForms", predicate: ["contentForm"] }], usesOnChanges: true, ngImport: i0, template: "<div class=\"w-100 h-100 content-panel\">\n  <h3 class=\"mb-3\">{{ title }}</h3>\n  <ng-content></ng-content>\n  <div *ngIf=\"isDirty\" class=\"mt-4\">\n    <asol-button\n      class=\"me-2\"\n      color=\"success\"\n      textType=\"Save\"\n      (click)=\"onSave()\"></asol-button>\n    <asol-button\n      color=\"light\"\n      textType=\"Discard\"\n      (click)=\"onDiscard()\"></asol-button>\n  </div>\n</div>\n", components: [{ type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-content-wrapper', template: "<div class=\"w-100 h-100 content-panel\">\n  <h3 class=\"mb-3\">{{ title }}</h3>\n  <ng-content></ng-content>\n  <div *ngIf=\"isDirty\" class=\"mt-4\">\n    <asol-button\n      class=\"me-2\"\n      color=\"success\"\n      textType=\"Save\"\n      (click)=\"onSave()\"></asol-button>\n    <asol-button\n      color=\"light\"\n      textType=\"Discard\"\n      (click)=\"onDiscard()\"></asol-button>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: RequiredCheckService }]; }, propDecorators: { title: [{
                type: Input
            }], data: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], componentId: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], saveChanges: [{
                type: Output
            }], formReset: [{
                type: Output
            }], contentForms: [{
                type: ContentChildren,
                args: ['contentForm']
            }] } });

class AsolContentWrapperModule {
}
AsolContentWrapperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolContentWrapperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperModule, declarations: [AsolContentWrapperComponent], imports: [SharedModule, AsolButtonModule], exports: [AsolContentWrapperComponent] });
AsolContentWrapperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperModule, imports: [[SharedModule, AsolButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolContentWrapperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolContentWrapperComponent],
                    exports: [AsolContentWrapperComponent],
                    imports: [SharedModule, AsolButtonModule],
                }]
        }] });

class AsolPageColumnsComponent {
    constructor(dataPageService) {
        this.dataPageService = dataPageService;
        /** Synchronization identifier */
        this.syncId = null;
        /** Column data definition */
        this.childColumns = null;
    }
    ngAfterViewInit() {
        this.childColumns.changes.subscribe(() => {
            this.parseColumns();
        });
        this.parseColumns();
    }
    /**
     * Stores new columns definition in service
     */
    parseColumns() {
        if (!this.childColumns) {
            return;
        }
        this.dataPageService.setColumns(this.syncId, this.childColumns.toArray());
    }
}
AsolPageColumnsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsComponent, deps: [{ token: PageColumnsService }], target: i0.ɵɵFactoryTarget.Component });
AsolPageColumnsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolPageColumnsComponent, selector: "asol-page-columns", inputs: { syncId: "syncId" }, queries: [{ propertyName: "childColumns", predicate: AsolDataColumnDirective }], ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-page-columns', template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: PageColumnsService }]; }, propDecorators: { syncId: [{
                type: Input
            }], childColumns: [{
                type: ContentChildren,
                args: [AsolDataColumnDirective]
            }] } });

class AsolPageColumnsModule {
}
AsolPageColumnsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolPageColumnsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsModule, declarations: [AsolPageColumnsComponent], imports: [SharedModule,
        AsolGridModule,
        AsolFilterModule,
        AsolToolbarModule,
        AsolDataColumnModule], exports: [AsolPageColumnsComponent] });
AsolPageColumnsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsModule, imports: [[
            SharedModule,
            AsolGridModule,
            AsolFilterModule,
            AsolToolbarModule,
            AsolDataColumnModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolPageColumnsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolPageColumnsComponent],
                    exports: [AsolPageColumnsComponent],
                    imports: [
                        SharedModule,
                        AsolGridModule,
                        AsolFilterModule,
                        AsolToolbarModule,
                        AsolDataColumnModule,
                    ],
                }]
        }] });

class HeaderPanelComponent {
    constructor() {
        /**
         * Specifies text of the header
         */
        this.title = '';
        /**
         * Specifies the path for the icon.
         *
         * You can use ICONS constant to specify the icon URL
         */
        this.iconUrl = '';
    }
}
HeaderPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HeaderPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeaderPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: HeaderPanelComponent, selector: "asol-header-panel", inputs: { title: "title", iconUrl: "iconUrl" }, ngImport: i0, template: "<div class=\"my-3\">\n  <div class=\"d-flex\">\n    <svg-icon *ngIf=\"iconUrl\" [src]=\"iconUrl\" class=\"m-2\"> </svg-icon>\n    <h2 class=\"center-item mb-0\">{{ title }}</h2>\n  </div>\n</div>\n", components: [{ type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: HeaderPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-header-panel', template: "<div class=\"my-3\">\n  <div class=\"d-flex\">\n    <svg-icon *ngIf=\"iconUrl\" [src]=\"iconUrl\" class=\"m-2\"> </svg-icon>\n    <h2 class=\"center-item mb-0\">{{ title }}</h2>\n  </div>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], iconUrl: [{
                type: Input
            }] } });

class AsolHeaderModule {
}
AsolHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolHeaderModule, declarations: [HeaderPanelComponent], imports: [SharedModule], exports: [HeaderPanelComponent] });
AsolHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolHeaderModule, imports: [[SharedModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HeaderPanelComponent],
                    exports: [HeaderPanelComponent],
                    imports: [SharedModule],
                }]
        }] });

const LANDING_PAGE_CONST = {
    TRANS: 'asol-library-landing-page',
};

var translation$2 = {
    "sk-SK": {
        copyright: "© Copyright {0} Asseco Solutions, a. s. — Všetky práva vyhradené",
        welcome: "Vitajte!",
        logToAccount: "Prihláste sa do svojho účtu.",
        logButton: "Prihlásiť sa do {0}",
        tryDemo: "Vyskúšať DEMO verziu",
        registerMessage: "Nemáte Asseco účet?",
        register: "Registrovať"
    },
    "cs-CZ": {
        copyright: "© Copyright {0} Asseco Solutions, a. s. — Všechny práva vyhrazena",
        welcome: "Vítejte!",
        logToAccount: "Přihlaste se do svého účtu.",
        logButton: "Přihlásit se do {0}",
        tryDemo: "Vyzkoušet DEMO verzi",
        registerMessage: "Nemáte Asseco účet?",
        register: "Registrovat"
    },
    "en-US": {
        copyright: "© Copyright {0} Asseco Solutions, a. s. — All rights reserved",
        welcome: "Welcome!",
        logToAccount: "Log into your account.",
        logButton: "Log into {0}",
        tryDemo: "Try DEMO version",
        registerMessage: "Don't have an Asseco account?",
        register: "Register"
    }
};

class AppService {
    constructor(http) {
        this.http = http;
    }
    /**
     * Returns max. 4 apps
     * @returns Collection of landing apps @see {@link LandingApp}
     */
    getApps(slice = true) {
        return this.http
            .get('assets/landing/apps.json', {
            responseType: 'json',
        })
            .pipe(map((result) => {
            return slice ? result.slice(0, 5) : result;
        }));
    }
    /**
     * Gets main app based on provided token
     * @returns Landing app @see {@link LandingApp}
     */
    getMainApp(appCode) {
        return this.getApps(false).pipe(map((apps) => {
            return apps.find((app) => app.code === appCode) || null;
        }));
    }
}
AppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AppService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AppService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AppService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

const USER_REGISTRATION_LINK = new InjectionToken('UserRegistrationLink');

class AppBackgroundComponent {
    constructor() {
        /** Color of the gradient */
        this.color = null;
        /** Unique id of the component for the fill ID */
        this.id = '';
        this.id = Math.round(Math.random() * 100).toString();
    }
}
AppBackgroundComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AppBackgroundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AppBackgroundComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AppBackgroundComponent, selector: "asol-app-background", inputs: { color: "color" }, ngImport: i0, template: "<svg\n  *ngIf=\"color\"\n  width=\"100%\"\n  height=\"100%\"\n  viewBox=\"0 0 330 100\"\n  preserveAspectRatio=\"none\"\n  fill=\"none\"\n  xmlns=\"http://www.w3.org/2000/svg\">\n  <rect width=\"330\" height=\"100\" fill=\"#0E2642\" />\n  <path\n    d=\"M0 100H330V0H0V100Z\"\n    [attr.fill]=\"'url(#paint0_linear_4268_148139' + id + ')'\" />\n  <defs>\n    <linearGradient\n      id=\"{{ 'paint0_linear_4268_148139' + id }}\"\n      x1=\"51.1227\"\n      y1=\"134.855\"\n      x2=\"147.124\"\n      y2=\"6.02002\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop [attr.stop-color]=\"color\" />\n      <stop stop-color=\"#F8BF27\" />\n      <stop offset=\"0.0001\" [attr.stop-color]=\"color\" />\n      <stop offset=\"0.04\" [attr.stop-color]=\"color\" stop-opacity=\"0.84\" />\n      <stop offset=\"0.09\" [attr.stop-color]=\"color\" stop-opacity=\"0.67\" />\n      <stop offset=\"0.15\" [attr.stop-color]=\"color\" stop-opacity=\"0.51\" />\n      <stop offset=\"0.21\" [attr.stop-color]=\"color\" stop-opacity=\"0.37\" />\n      <stop offset=\"0.28\" [attr.stop-color]=\"color\" stop-opacity=\"0.25\" />\n      <stop offset=\"0.35\" [attr.stop-color]=\"color\" stop-opacity=\"0.16\" />\n      <stop offset=\"0.44\" [attr.stop-color]=\"color\" stop-opacity=\"0.09\" />\n      <stop offset=\"0.54\" [attr.stop-color]=\"color\" stop-opacity=\"0.04\" />\n      <stop offset=\"0.68\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n      <stop offset=\"0.744792\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n      <stop offset=\"1\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n    </linearGradient>\n  </defs>\n</svg>\n", directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AppBackgroundComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-app-background', template: "<svg\n  *ngIf=\"color\"\n  width=\"100%\"\n  height=\"100%\"\n  viewBox=\"0 0 330 100\"\n  preserveAspectRatio=\"none\"\n  fill=\"none\"\n  xmlns=\"http://www.w3.org/2000/svg\">\n  <rect width=\"330\" height=\"100\" fill=\"#0E2642\" />\n  <path\n    d=\"M0 100H330V0H0V100Z\"\n    [attr.fill]=\"'url(#paint0_linear_4268_148139' + id + ')'\" />\n  <defs>\n    <linearGradient\n      id=\"{{ 'paint0_linear_4268_148139' + id }}\"\n      x1=\"51.1227\"\n      y1=\"134.855\"\n      x2=\"147.124\"\n      y2=\"6.02002\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop [attr.stop-color]=\"color\" />\n      <stop stop-color=\"#F8BF27\" />\n      <stop offset=\"0.0001\" [attr.stop-color]=\"color\" />\n      <stop offset=\"0.04\" [attr.stop-color]=\"color\" stop-opacity=\"0.84\" />\n      <stop offset=\"0.09\" [attr.stop-color]=\"color\" stop-opacity=\"0.67\" />\n      <stop offset=\"0.15\" [attr.stop-color]=\"color\" stop-opacity=\"0.51\" />\n      <stop offset=\"0.21\" [attr.stop-color]=\"color\" stop-opacity=\"0.37\" />\n      <stop offset=\"0.28\" [attr.stop-color]=\"color\" stop-opacity=\"0.25\" />\n      <stop offset=\"0.35\" [attr.stop-color]=\"color\" stop-opacity=\"0.16\" />\n      <stop offset=\"0.44\" [attr.stop-color]=\"color\" stop-opacity=\"0.09\" />\n      <stop offset=\"0.54\" [attr.stop-color]=\"color\" stop-opacity=\"0.04\" />\n      <stop offset=\"0.68\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n      <stop offset=\"0.744792\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n      <stop offset=\"1\" [attr.stop-color]=\"color\" stop-opacity=\"0\" />\n    </linearGradient>\n  </defs>\n</svg>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: {
        /** Color of the gradient */
        color: [{
                type: Input
            }]
    } });

class AsolLandingPageComponent {
    constructor(trans, service, authService, registerLink, appCode, mediaService) {
        this.trans = trans;
        this.service = service;
        this.authService = authService;
        this.registerLink = registerLink;
        this.appCode = appCode;
        this.mediaService = mediaService;
        /** Observable containing all apps (max. 4) */
        this.apps$ = of([]);
        /** Observable containing main app */
        this.mainApp$ = of();
        /** Main app, used when switching locale */
        this.mainApp = null;
        /** Main app data based on current locale */
        this.mainAppData = null;
        /**
         * Emits when user clicks on login button
         */
        this.loginTriggered = new EventEmitter();
        /**
         * Flag to show/hide app selector.
         * @type {boolean}
         * @default true
         */
        this.displayApps = true;
        /** Current year shown in footer */
        this.year = new Date().getFullYear().toString();
        /** Flag if screen is mobile or not */
        this.showMobile = false;
        this.LANDING_PAGE_CONST = LANDING_PAGE_CONST;
        this.sub = new Subscription();
        this.trans.initialize(LANDING_PAGE_CONST.TRANS, translation$2);
        this.apps$ = this.service.getApps();
        this.mainApp$ = this.service.getMainApp(this.appCode).pipe(tap((app) => {
            this.mainApp = app;
            this.loadData();
        }));
        this.sub.add(this.mediaService.viewportChanged$.subscribe((state) => {
            if (state.breakpoints[MEDIA_QUERY.XL] === false &&
                state.breakpoints[MEDIA_QUERY.XXL] === false) {
                this.showMobile = true;
            }
            else {
                this.showMobile = false;
            }
        }));
    }
    ngOnInit() {
        this.sub.add(this.trans.languageChanged$.subscribe(() => {
            this.loadData();
        }));
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Loads data for the main app based on locale
     */
    loadData() {
        if (!this.mainApp) {
            return;
        }
        const data = this.mainApp.data.find((p) => p.locale === this.trans.getFullLocale);
        if (!data) {
            return;
        }
        this.mainAppData = data;
    }
    /**
     * Login user
     */
    onLogin() {
        this.authService.login();
        this.loginTriggered.emit();
    }
}
AsolLandingPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageComponent, deps: [{ token: i1.TranslationService }, { token: AppService }, { token: i1.AuthenticationServiceBase }, { token: USER_REGISTRATION_LINK, optional: true }, { token: MAIN_APP }, { token: i1.AsolMediaQueryService }], target: i0.ɵɵFactoryTarget.Component });
AsolLandingPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolLandingPageComponent, selector: "asol-landing-page", inputs: { displayApps: "displayApps" }, outputs: { loginTriggered: "loginTriggered" }, providers: [AppService], ngImport: i0, template: "<ng-container *ngIf=\"mainApp$ | async as mainApp\">\r\n  <div class=\"d-flex vh-100 row g-none overflow-hidden\">\r\n    <div class=\"content-image col-12 col-lg-8 d-flex flex-column\">\r\n      <div\r\n        class=\"h-100 back\"\r\n        [ngStyle]=\"{\r\n          'background-image': 'url(\\'' + mainApp.background + '\\')'\r\n        }\">\r\n        <asol-app-background\r\n          class=\"back-overlay\"\r\n          [color]=\"mainApp.color\"></asol-app-background>\r\n        <div class=\"back-heading w-100\">\r\n          <div class=\"d-flex justify-content-between\">\r\n            <svg-icon class=\"me-6\" [src]=\"mainApp.logo\"></svg-icon>\r\n            <asol-language-select cssClass=\"d-lg-none\"> </asol-language-select>\r\n          </div>\r\n          <div class=\"title h-100\">\r\n            <div class=\"d-flex flex-column\">\r\n              <h1>{{ mainAppData.title }}</h1>\r\n\r\n              <div class=\"mt-5\">\r\n                {{ mainAppData.description }}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"d-lg-none mt-8 login\">\r\n            <ng-container *ngTemplateOutlet=\"login\"></ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"apps\" *ngIf=\"displayApps && apps$ | async as apps\">\r\n        <a class=\"app\" *ngFor=\"let app of apps\" [href]=\"app.url\">\r\n          <asol-app-background [color]=\"app.color\"></asol-app-background>\r\n          <svg-icon class=\"app-logo\" [src]=\"app.logo\" [applyClass]=\"true\">\r\n          </svg-icon>\r\n        </a>\r\n      </div>\r\n    </div>\r\n    <div class=\"content-login col-4\">\r\n      <div class=\"d-flex justify-content-end\">\r\n        <asol-language-select cssClass=\"landing-language-input\">\r\n        </asol-language-select>\r\n      </div>\r\n      <div class=\"center-item\">\r\n        <ng-container *ngTemplateOutlet=\"login\"></ng-container>\r\n      </div>\r\n      <div class=\"text-center\">\r\n        {{\r\n          trans.get(LANDING_PAGE_CONST.TRANS, 'copyright')\r\n            | stringFormat : [year]\r\n        }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #login>\r\n  <div class=\"flex-column text-start\">\r\n    <h1 class=\"display\">\r\n      {{ trans.get(LANDING_PAGE_CONST.TRANS, 'welcome') }}\r\n    </h1>\r\n    <div class=\"description mb-6\">\r\n      {{ trans.get(LANDING_PAGE_CONST.TRANS, 'logToAccount') }}\r\n    </div>\r\n    <asol-button [color]=\"showMobile ? 'light' : 'dark'\" (click)=\"onLogin()\">\r\n      {{\r\n        trans.get(LANDING_PAGE_CONST.TRANS, 'logButton')\r\n          | stringFormat : [mainAppData.name]\r\n      }}\r\n    </asol-button>\r\n\r\n    <!-- Registration message -->\r\n    <div\r\n      *ngIf=\"registerLink\"\r\n      class=\"register-message d-flex align-items-center\">\r\n      <div>\r\n        {{ trans.get(LANDING_PAGE_CONST.TRANS, 'registerMessage') }}\r\n      </div>\r\n      <asol-button type=\"flat\" color=\"primary\" [routerLink]=\"registerLink\">{{\r\n        trans.get(LANDING_PAGE_CONST.TRANS, 'register')\r\n      }}</asol-button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.content-image .back{padding:5rem;display:flex;flex-direction:column;align-items:flex-start;opacity:.8;background-color:#0d2443;position:relative;background-repeat:no-repeat;background-size:cover}.content-image .back .back-overlay{position:absolute;inset:0;opacity:.8;z-index:400}.content-image .back .back-heading{z-index:500;height:100%}.content-image .back .title{width:36rem;display:flex;align-items:center;color:#fff}.content-image .back .title h1,.content-image .back .title .h1{color:#fff}.content-image .back svg{width:355px;height:100px}.content-image .apps{height:100px;display:flex}.content-image .apps .app{width:100%;height:100px;text-align:center;background-color:#0d2443;position:relative}.content-image .apps .app svg-icon{position:absolute;left:0;right:0;bottom:0}.content-image .apps .app svg-icon svg{width:100%;height:100%}.content-image .apps .app svg-icon.app-logo{padding:1.5rem 0}.content-image .apps .app svg-icon.app-logo svg{max-width:183px}.content-login{background-color:#fff;display:flex;justify-content:space-between;flex-direction:column;padding:1.5rem}.display{font-size:6.25rem;line-height:120%}.register-message{font-size:.875rem}@media (max-width: 1500px){.content-image .back{padding:2.5rem}.content-image .back .title{width:33rem}.content-image .apps .app svg-icon.app-logo svg{max-width:162px}.content-login{padding:1rem}.display{font-size:3.75rem}}@media (max-width: 1100px){.content-image .apps .app svg-icon.app-logo svg{max-width:122px}}@media (max-width: 992px){.content-image .back{padding:2.5rem}.content-image .back .title{display:none}.content-image .back .login{z-index:500;color:#fff}.content-image .back .login .register-message{justify-content:center}.content-image .back .login div{text-align:center!important}.content-image .back .login .h1,.content-image .back .login h1{color:#fff}.content-image .apps{display:none}.content-login{display:none!important}}@media (max-width: 576px){.content-image .back .back-heading svg{width:100%}.display{font-size:2.5rem}}@media (max-width: 500px){.content-image .back .back-heading svg{height:100%}}\n"], components: [{ type: AppBackgroundComponent, selector: "asol-app-background", inputs: ["color"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolLanguageSelectComponent, selector: "asol-language-select", inputs: ["cssClass"], outputs: ["onLanguageChange"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i6.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$3.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }], pipes: { "async": i6.AsyncPipe, "stringFormat": i1.StringFormatPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-landing-page', providers: [AppService], template: "<ng-container *ngIf=\"mainApp$ | async as mainApp\">\r\n  <div class=\"d-flex vh-100 row g-none overflow-hidden\">\r\n    <div class=\"content-image col-12 col-lg-8 d-flex flex-column\">\r\n      <div\r\n        class=\"h-100 back\"\r\n        [ngStyle]=\"{\r\n          'background-image': 'url(\\'' + mainApp.background + '\\')'\r\n        }\">\r\n        <asol-app-background\r\n          class=\"back-overlay\"\r\n          [color]=\"mainApp.color\"></asol-app-background>\r\n        <div class=\"back-heading w-100\">\r\n          <div class=\"d-flex justify-content-between\">\r\n            <svg-icon class=\"me-6\" [src]=\"mainApp.logo\"></svg-icon>\r\n            <asol-language-select cssClass=\"d-lg-none\"> </asol-language-select>\r\n          </div>\r\n          <div class=\"title h-100\">\r\n            <div class=\"d-flex flex-column\">\r\n              <h1>{{ mainAppData.title }}</h1>\r\n\r\n              <div class=\"mt-5\">\r\n                {{ mainAppData.description }}\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"d-lg-none mt-8 login\">\r\n            <ng-container *ngTemplateOutlet=\"login\"></ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"apps\" *ngIf=\"displayApps && apps$ | async as apps\">\r\n        <a class=\"app\" *ngFor=\"let app of apps\" [href]=\"app.url\">\r\n          <asol-app-background [color]=\"app.color\"></asol-app-background>\r\n          <svg-icon class=\"app-logo\" [src]=\"app.logo\" [applyClass]=\"true\">\r\n          </svg-icon>\r\n        </a>\r\n      </div>\r\n    </div>\r\n    <div class=\"content-login col-4\">\r\n      <div class=\"d-flex justify-content-end\">\r\n        <asol-language-select cssClass=\"landing-language-input\">\r\n        </asol-language-select>\r\n      </div>\r\n      <div class=\"center-item\">\r\n        <ng-container *ngTemplateOutlet=\"login\"></ng-container>\r\n      </div>\r\n      <div class=\"text-center\">\r\n        {{\r\n          trans.get(LANDING_PAGE_CONST.TRANS, 'copyright')\r\n            | stringFormat : [year]\r\n        }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #login>\r\n  <div class=\"flex-column text-start\">\r\n    <h1 class=\"display\">\r\n      {{ trans.get(LANDING_PAGE_CONST.TRANS, 'welcome') }}\r\n    </h1>\r\n    <div class=\"description mb-6\">\r\n      {{ trans.get(LANDING_PAGE_CONST.TRANS, 'logToAccount') }}\r\n    </div>\r\n    <asol-button [color]=\"showMobile ? 'light' : 'dark'\" (click)=\"onLogin()\">\r\n      {{\r\n        trans.get(LANDING_PAGE_CONST.TRANS, 'logButton')\r\n          | stringFormat : [mainAppData.name]\r\n      }}\r\n    </asol-button>\r\n\r\n    <!-- Registration message -->\r\n    <div\r\n      *ngIf=\"registerLink\"\r\n      class=\"register-message d-flex align-items-center\">\r\n      <div>\r\n        {{ trans.get(LANDING_PAGE_CONST.TRANS, 'registerMessage') }}\r\n      </div>\r\n      <asol-button type=\"flat\" color=\"primary\" [routerLink]=\"registerLink\">{{\r\n        trans.get(LANDING_PAGE_CONST.TRANS, 'register')\r\n      }}</asol-button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [":root{--logo-primary: #fff;--stepper-color: #2684ff}.content-image .back{padding:5rem;display:flex;flex-direction:column;align-items:flex-start;opacity:.8;background-color:#0d2443;position:relative;background-repeat:no-repeat;background-size:cover}.content-image .back .back-overlay{position:absolute;inset:0;opacity:.8;z-index:400}.content-image .back .back-heading{z-index:500;height:100%}.content-image .back .title{width:36rem;display:flex;align-items:center;color:#fff}.content-image .back .title h1,.content-image .back .title .h1{color:#fff}.content-image .back svg{width:355px;height:100px}.content-image .apps{height:100px;display:flex}.content-image .apps .app{width:100%;height:100px;text-align:center;background-color:#0d2443;position:relative}.content-image .apps .app svg-icon{position:absolute;left:0;right:0;bottom:0}.content-image .apps .app svg-icon svg{width:100%;height:100%}.content-image .apps .app svg-icon.app-logo{padding:1.5rem 0}.content-image .apps .app svg-icon.app-logo svg{max-width:183px}.content-login{background-color:#fff;display:flex;justify-content:space-between;flex-direction:column;padding:1.5rem}.display{font-size:6.25rem;line-height:120%}.register-message{font-size:.875rem}@media (max-width: 1500px){.content-image .back{padding:2.5rem}.content-image .back .title{width:33rem}.content-image .apps .app svg-icon.app-logo svg{max-width:162px}.content-login{padding:1rem}.display{font-size:3.75rem}}@media (max-width: 1100px){.content-image .apps .app svg-icon.app-logo svg{max-width:122px}}@media (max-width: 992px){.content-image .back{padding:2.5rem}.content-image .back .title{display:none}.content-image .back .login{z-index:500;color:#fff}.content-image .back .login .register-message{justify-content:center}.content-image .back .login div{text-align:center!important}.content-image .back .login .h1,.content-image .back .login h1{color:#fff}.content-image .apps{display:none}.content-login{display:none!important}}@media (max-width: 576px){.content-image .back .back-heading svg{width:100%}.display{font-size:2.5rem}}@media (max-width: 500px){.content-image .back .back-heading svg{height:100%}}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1.TranslationService }, { type: AppService }, { type: i1.AuthenticationServiceBase }, { type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [USER_REGISTRATION_LINK]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAIN_APP]
                    }] }, { type: i1.AsolMediaQueryService }];
    }, propDecorators: { loginTriggered: [{
                type: Output
            }], displayApps: [{
                type: Input
            }] } });

class AsolLandingPageModule {
}
AsolLandingPageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolLandingPageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageModule, declarations: [AsolLandingPageComponent, AppBackgroundComponent], imports: [SharedModule,
        AsolLanguageSelectModule,
        AsolButtonModule,
        PipesModule], exports: [AsolLandingPageComponent] });
AsolLandingPageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageModule, imports: [[
            SharedModule,
            AsolLanguageSelectModule,
            AsolButtonModule,
            PipesModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolLandingPageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolLandingPageComponent, AppBackgroundComponent],
                    exports: [AsolLandingPageComponent],
                    imports: [
                        SharedModule,
                        AsolLanguageSelectModule,
                        AsolButtonModule,
                        PipesModule,
                    ],
                }]
        }] });

const PACKAGE_CONFIG = new InjectionToken('PackageConfig');

class AsolAboutComponent {
    constructor(config) {
        this.config = config;
        this.info = [];
        this.name = this.config.name;
        this.version = this.config.version;
        this.info = Object.entries(this.config.dependencies).map(([name, version]) => ({ name, version }));
    }
}
AsolAboutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAboutComponent, deps: [{ token: PACKAGE_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
AsolAboutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolAboutComponent, selector: "asol-about", ngImport: i0, template: "<div class=\"ms-5\">\n  <h1>{{ name }}</h1>\n  <h2 class=\"mt-3 mb-5\">Version: {{ version }}</h2>\n\n  <section>\n    <h2>Dependencies:</h2>\n    <ul>\n      <li *ngFor=\"let item of info\">{{ item.name }}: {{ item.version }}</li>\n    </ul>\n  </section>\n</div>\n", directives: [{ type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolAboutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-about', template: "<div class=\"ms-5\">\n  <h1>{{ name }}</h1>\n  <h2 class=\"mt-3 mb-5\">Version: {{ version }}</h2>\n\n  <section>\n    <h2>Dependencies:</h2>\n    <ul>\n      <li *ngFor=\"let item of info\">{{ item.name }}: {{ item.version }}</li>\n    </ul>\n  </section>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [PACKAGE_CONFIG]
                    }] }];
    } });

const NAVIGATION = {
    BASE: '/',
    LOGOUT: '/',
    ABOUT: '/about',
};

const LAYOUT = {
    LOGOUT: 'logout',
    ABOUT: 'about',
    TOP_MENU_HEIGHT: 50,
};

/**
 * Searches the tree structure and finds item with id
 * @param items Items collection to search
 * @param id Id to find
 * @returns Found node or null
 */
function searchTree(items, id) {
    var _a;
    let foundItem = null;
    for (const item of items) {
        if (item.id === id) {
            foundItem = item;
        }
        if (((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) && !foundItem) {
            foundItem = searchTree(item.items, id);
        }
    }
    // not found
    return foundItem;
}

var translation$1 = {
    "sk-SK": {
        success: "Zmena tenanta bola úspešná",
        fail: "Nepodarilo sa zmeniť tenanta"
    },
    "cs-CZ": {
        success: "Změna tenanta byla úspěšná",
        fail: "Nepodařilo se změnit tenanta"
    },
    "en-US": {
        success: "Change of tenant was successful",
        fail: "Failed to change tenant"
    }
};

const TENANT_SELECT_CONSTANT = {
    TRANS: 'asol-tenant-select-trans',
};

class AsolTenantSelectComponent {
    constructor(authService, trans, router, spinner, notificationService) {
        this.authService = authService;
        this.trans = trans;
        this.router = router;
        this.spinner = spinner;
        this.notificationService = notificationService;
        /** Selected or stored tenant identifier */
        this.tenantValue = null;
        /** List of all available tenants */
        this.tenants$ = of([]);
        /** initializes translation service */
        this.trans.initialize(TENANT_SELECT_CONSTANT.TRANS, translation$1);
        this.authService.loginChanged$.subscribe((logged) => {
            if (logged) {
                this.loadTenants();
            }
        });
    }
    ngOnInit() {
        this.authService.isLoggedIn().then((logged) => {
            if (logged) {
                this.loadTenants();
            }
        });
    }
    /**
     * Stores selected tenant to session storage and API
     * @param tenant Selected tenant
     */
    onTenantSelect(tenant) {
        sessionStorage.setItem(CORE_CONSTANTS.TENANT_STORAGE, tenant.itemData['id']);
        /** sends new tenant id to API */
        this.spinner.show();
        this.authService
            .updateTenant(tenant.itemData['id'])
            .then((success) => {
            if (success) {
                /** shows success message */
                this.notificationService.success(this.trans.get(TENANT_SELECT_CONSTANT.TRANS, 'success'));
                /** if tenant select change was successful, reload application */
                this.router.navigate(['/']).then(() => window.location.reload());
            }
            else {
                /** if tenant select change failed, throw toast exception */
                this.notificationService.danger(this.trans.get(TENANT_SELECT_CONSTANT.TRANS, 'fail'));
            }
            /** hides the spinner */
            this.spinner.hide();
        });
    }
    /**
     * Gets tenant from session storage
     */
    getTenant() {
        this.tenantValue = sessionStorage.getItem(CORE_CONSTANTS.TENANT_STORAGE);
    }
    /**
     * Loads tenant from auth service
     */
    loadTenants() {
        this.tenants$ = from(this.authService.getTenants()).pipe(tap((data) => {
            if (!(data === null || data === void 0 ? void 0 : data.length)) {
                throw new Error('No tenants for user');
            }
            this.getTenant();
        }));
    }
}
AsolTenantSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectComponent, deps: [{ token: i1.AuthenticationServiceBase }, { token: i1.TranslationService }, { token: i1$3.Router }, { token: SpinnerService }, { token: NotificationService }], target: i0.ɵɵFactoryTarget.Component });
AsolTenantSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolTenantSelectComponent, selector: "asol-tenant-select", ngImport: i0, template: "<ejs-dropdownlist\n  [dataSource]=\"tenants$ | async\"\n  cssClass=\"center-item dropdown-default\"\n  [fields]=\"{ text: 'name', value: 'id' }\"\n  (select)=\"onTenantSelect($event)\"\n  [value]=\"tenantValue\">\n</ejs-dropdownlist>\n", components: [{ type: i4$1.DropDownListComponent, selector: "ejs-dropdownlist", inputs: ["actionFailureTemplate", "allowFiltering", "cssClass", "dataSource", "enablePersistence", "enableRtl", "enabled", "fields", "filterBarPlaceholder", "filterType", "floatLabelType", "footerTemplate", "groupTemplate", "headerTemplate", "htmlAttributes", "ignoreAccent", "ignoreCase", "index", "itemTemplate", "locale", "noRecordsTemplate", "placeholder", "popupHeight", "popupWidth", "query", "readonly", "showClearButton", "sortOrder", "text", "value", "valueTemplate", "width", "zIndex"], outputs: ["actionBegin", "actionComplete", "actionFailure", "beforeOpen", "blur", "change", "close", "created", "dataBound", "destroyed", "filtering", "focus", "open", "select", "valueChange"] }], pipes: { "async": i6.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-tenant-select', template: "<ejs-dropdownlist\n  [dataSource]=\"tenants$ | async\"\n  cssClass=\"center-item dropdown-default\"\n  [fields]=\"{ text: 'name', value: 'id' }\"\n  (select)=\"onTenantSelect($event)\"\n  [value]=\"tenantValue\">\n</ejs-dropdownlist>\n" }]
        }], ctorParameters: function () { return [{ type: i1.AuthenticationServiceBase }, { type: i1.TranslationService }, { type: i1$3.Router }, { type: SpinnerService }, { type: NotificationService }]; } });

class AsolMainLayoutComponent {
    constructor(router, translation, mediaService, spinner, messagePanelService, authService) {
        this.router = router;
        this.translation = translation;
        this.mediaService = mediaService;
        this.spinner = spinner;
        this.messagePanelService = messagePanelService;
        this.authService = authService;
        /** Translation key */
        this.transKey = '';
        /** Provider to load the side menu content */
        this.menuProvider = null;
        /** Logo URL shown in upper left corner */
        this.logoUrl = `/assets/icons/qasida-logo2.svg`;
        /** Allow tenant picker */
        this.allowTenants = true;
        /** Profile menu items */
        this.profileMenuItems = [];
        /** Menu data items */
        this.menuData = [];
        /**
         * Flag if main layout should be shown
         * Only authenticated user can access main layout
         * @default false
         */
        this.showMainLayout = false;
        this.ICONS = ICONS;
        this.MEDIA_QUERY = MEDIA_QUERY;
        this.menuTree = null;
        this.sidebarInstance = null;
        /** Message panel div reference */
        this.messagePanelRef = null;
        /** Message panel height for total height calculation */
        this.messagePanelHeight = LAYOUT.TOP_MENU_HEIGHT;
        /**
         * Default animation setup
         */
        this.animation = {
            collapse: { effect: 'SlideUp', duration: 0, easing: '' },
            expand: { effect: 'SlideDown', duration: 0, easing: '' },
        };
        /**
         * Default field setup
         */
        this.field = {
            id: 'id',
            text: 'text',
            iconCss: '',
            child: 'items',
            expanded: 'isExpanded',
        };
        /** Flag if menu was loaded */
        this.menuLoaded = false;
        this.spinner.show();
        // handle login changes
        this.authService.loginChanged$.subscribe((isLogged) => {
            var _a, _b;
            this.showMainLayout = isLogged;
            if (!isLogged) {
                this.spinner.hide();
                (_a = this.sidebarInstance) === null || _a === void 0 ? void 0 : _a.hide();
                return;
            }
            this.loadMenu();
            this.prepareProfileMenu();
            this.spinner.hide();
            if (!this.mediaService.isMobile() && this.showMainLayout) {
                (_b = this.sidebarInstance) === null || _b === void 0 ? void 0 : _b.show();
            }
        });
        // Listes to storage for token changes
        window.addEventListener('storage', (event) => {
            // The `key` is `null` if the event was caused by `.clear()`
            if (event.key !== 'access_token' && event.key !== null) {
                return;
            }
            this.authService.isLoggedIn().then(() => {
                this.router.navigate(['']);
            });
        });
    }
    ngOnInit() {
        this.translation.languageChanged$.subscribe(() => {
            this.loadMenu(true);
            this.prepareProfileMenu();
        });
        // Hide sidebar on mobile
        this.mediaService.mobileViewportChanged$.subscribe((state) => {
            var _a;
            if (!state.matches && this.showMainLayout) {
                (_a = this.sidebarInstance) === null || _a === void 0 ? void 0 : _a.show();
            }
        });
    }
    ngAfterViewInit() {
        var _a;
        // checks if user is not already logged in
        this.checkAuth();
        if (!this.mediaService.isMobile() && this.showMainLayout) {
            (_a = this.sidebarInstance) === null || _a === void 0 ? void 0 : _a.show();
        }
        /** Calculate total height with message panel height with responsivity */
        this.mediaService.viewportChanged$.subscribe(() => {
            this.recalculateMainLayoutHeight();
        });
        /** Calculate total height with message panel height when message panel is added or removed */
        this.messagePanelService.message$.subscribe(() => {
            this.recalculateMainLayoutHeight();
        });
    }
    /**
     * Method checks if user is authenticated and shows main layout
     */
    checkAuth() {
        this.authService.isLoggedIn().then((isLogged) => {
            this.showMainLayout = isLogged;
            this.spinner.hide();
            if (!isLogged) {
                return;
            }
            this.prepareProfileMenu();
            this.loadMenu();
        });
    }
    /**
     * Loads side menu items
     */
    loadMenu(refresh = false) {
        var _a;
        if (this.menuLoaded && !refresh) {
            return;
        }
        (_a = this.menuProvider) === null || _a === void 0 ? void 0 : _a.getMenuItems().subscribe((data) => {
            if (!this.menuTree) {
                return;
            }
            this.menuData = data;
            this.menuTree.fields = {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                dataSource: this.menuData,
                id: 'id',
                text: 'text',
                child: 'items',
                expanded: 'isExpanded',
            };
            this.menuLoaded = true;
            if (refresh) {
                this.menuTree.refresh();
            }
        });
    }
    /**
     * Creates profile menu items
     */
    prepareProfileMenu(name) {
        var _a;
        if (!this.authService.userData && !name) {
            return;
        }
        const loggedUserName = name
            ? name
            : `${this.authService.userData.firstname} ${this.authService.userData.lastname}`;
        this.profileMenuItems.splice(0, this.profileMenuItems.length);
        this.profileMenuItems = [
            {
                text: loggedUserName,
                ignoreTranslate: true,
                items: [
                    {
                        text: 'logout',
                        id: LAYOUT.LOGOUT,
                        url: NAVIGATION.LOGOUT,
                    },
                    {
                        text: 'about',
                        id: LAYOUT.ABOUT,
                        url: NAVIGATION.ABOUT,
                    },
                ],
            },
        ];
        (_a = this.menuProvider) === null || _a === void 0 ? void 0 : _a.getProfileMenuItems().subscribe((data) => {
            var _a;
            if (!data) {
                return;
            }
            (_a = this.profileMenuItems[0].items) === null || _a === void 0 ? void 0 : _a.splice(0, 0, ...data);
        });
    }
    /**
     * Event handler when user selects a profile menu item
     * @param e Menu event args
     */
    selectPersonalMenuItem(e) {
        if (e.item.items.length > 0) {
            return;
        }
        switch (e.item.id) {
            case LAYOUT.LOGOUT:
                this.spinner.show();
                this.authService.logout();
                break;
            default:
                if (e.item.url) {
                    this.router.navigate([e.item.url]);
                }
                break;
        }
    }
    /**
     * Toggles sidebar
     */
    onToggleSidebar() {
        var _a;
        (_a = this.sidebarInstance) === null || _a === void 0 ? void 0 : _a.toggle();
    }
    /**
     * Event handler when user selects a menu item, it will navigate to page only if it is not collapsed
     * @param args Selected node args
     */
    navigateToPage(args) {
        var _a;
        const data = (_a = this.menuTree) === null || _a === void 0 ? void 0 : _a.getTreeData(args.node);
        if (!data || !data.length || !data[0].url) {
            return;
        }
        this.router.navigate([data[0].url]);
    }
    /**
     * Event handler when user expands/collapses a menu item
     * @param args Expanded node args
     * @param expand Flag if node should be expanded or collapsed
     */
    onNodeExpanded(args, expand = true) {
        var _a;
        const menuItem = searchTree(this.menuData, args.nodeData.id);
        if (!menuItem || !((_a = menuItem.items) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        this.menuTree.refreshNode(args.node, [{ isExpanded: expand }]);
    }
    /**
     * Recalculates the main layout if there is message panel instance
     */
    recalculateMainLayoutHeight() {
        var _a;
        if (!this.messagePanelRef) {
            return;
        }
        /** calculated height with message panel */
        this.messagePanelHeight =
            ((_a = this.messagePanelRef) === null || _a === void 0 ? void 0 : _a.nativeElement.offsetHeight) + LAYOUT.TOP_MENU_HEIGHT;
    }
}
AsolMainLayoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMainLayoutComponent, deps: [{ token: i1$3.Router }, { token: i1.TranslationService }, { token: i1.AsolMediaQueryService }, { token: SpinnerService }, { token: MessagePanelService }, { token: i1.AuthenticationServiceBase }], target: i0.ɵɵFactoryTarget.Component });
AsolMainLayoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolMainLayoutComponent, selector: "asol-main-layout", inputs: { transKey: "transKey", menuProvider: "menuProvider", logoUrl: "logoUrl", allowTenants: "allowTenants" }, viewQueries: [{ propertyName: "menuTree", first: true, predicate: ["menuTree"], descendants: true }, { propertyName: "sidebarInstance", first: true, predicate: ["dockBar"], descendants: true }, { propertyName: "messagePanelRef", first: true, predicate: ["messagePanel"], descendants: true }], ngImport: i0, template: "<ejs-sidebar\n  #dockBar\n  id=\"dockSidebar\"\n  [enableDock]=\"false\"\n  class=\"sidebar\"\n  [ngClass]=\"{ invisible: !showMainLayout }\"\n  width=\"240px\"\n  [type]=\"mediaService.isMobile() ? 'Over' : 'Push'\"\n  [closeOnDocumentClick]=\"mediaService.isMobile()\"\n  [enableGestures]=\"false\"\n  dockSize=\"0px\">\n  <div class=\"logo center-item\">\n    <svg-icon [src]=\"logoUrl\"></svg-icon>\n  </div>\n  <div class=\"overflow-auto mb-7\">\n    <ejs-treeview\n      class=\"menu-tree mt-4\"\n      id=\"menu-tree\"\n      #menuTree\n      [fields]=\"field\"\n      [animation]=\"animation\"\n      (nodeExpanded)=\"onNodeExpanded($event)\"\n      (nodeCollapsed)=\"onNodeExpanded($event, false)\"\n      (nodeSelected)=\"navigateToPage($event)\"\n      expandOn=\"Click\">\n      <ng-template #nodeTemplate let-data>\n        <div\n          class=\"sub-item w-100 d-flex justify-content-between\"\n          [routerLink]=\"data.url ? data.url : null\"\n          [routerLinkActive]=\"[data.url ? 'e-url-active' : '']\">\n          <div class=\"d-inline-flex\">\n            <svg-icon\n              *ngIf=\"data.iconUrl\"\n              class=\"menuIcon me-2\"\n              [src]=\"data.iconUrl\"></svg-icon>\n            <div class=\"w-100 text-wrap\">\n              <a>{{ translation.get(transKey, data.text) }}</a>\n            </div>\n          </div>\n          <svg-icon\n            *ngIf=\"data.items && data.items.length\"\n            [src]=\"\n              !data.isExpanded ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_UP\n            \"></svg-icon>\n        </div>\n      </ng-template>\n    </ejs-treeview>\n  </div>\n  <!-- <div class=\"sidebar-settings center-item\">\n    <a href=\"#\" class=\"center-item-v\">\n      <svg-icon class=\"me-2 pb-0\" src=\"/assets/icons/settings.svg\"></svg-icon>\n      {{ translation.get(transKey, 'menuSettings') }}\n    </a>\n  </div> -->\n  <!-- <div class=\"sidebar-bottom\" (click)=\"toggleSidebar()\">Hide</div> -->\n</ejs-sidebar>\n\n<div class=\"main-page\">\n  <!--header-section  declaration -->\n  <nav class=\"navbar\" *ngIf=\"showMainLayout\">\n    <ul class=\"navbar-left\">\n      <li *ngIf=\"mediaService.isMobile()\">\n        <asol-icon-button\n          type=\"flat\"\n          color=\"light\"\n          cssClass=\"hamburger-button\"\n          [iconSvgUrl]=\"ICONS.MENU_01\"\n          (click)=\"onToggleSidebar()\">\n        </asol-icon-button>\n      </li>\n    </ul>\n    <ul>\n      <li>\n        <asol-tenant-select *ngIf=\"allowTenants\"></asol-tenant-select>\n      </li>\n    </ul>\n    <ul class=\"navbar-right pe-3\">\n      <li>\n        <asol-language-select\n          cssClass=\"custom-language-input\"></asol-language-select>\n      </li>\n      <li>\n        <div class=\"profile\" *ngIf=\"profileMenuItems.length\">\n          <ejs-menu\n            [items]=\"profileMenuItems\"\n            (select)=\"selectPersonalMenuItem($event)\">\n            <ng-template #template let-menuItems>\n              <div\n                *ngIf=\"menuItems.text\"\n                class=\"w-100 d-flex justify-content-between\">\n                <span class=\"{{ menuItems.iconCss }} center-item\"></span>\n                <span class=\"w-100\">\n                  <a>{{\n                    menuItems.ignoreTranslate\n                      ? menuItems.text\n                      : translation.get(transKey, menuItems.text)\n                  }}</a>\n                </span>\n              </div>\n            </ng-template>\n          </ejs-menu>\n        </div>\n      </li>\n    </ul>\n  </nav>\n\n  <div [ngClass]=\"{ 'main-content': showMainLayout }\">\n    <!--end of header-section  declaration -->\n    <div #messagePanel>\n      <asol-message-panel></asol-message-panel>\n    </div>\n    <div\n      class=\"inner\"\n      [ngStyle]=\"{\n        height: 'calc(100vh - ' + messagePanelHeight + 'px)'\n      }\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n", styles: [".navbar{height:50px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap}.navbar ul{margin-bottom:0}.navbar-right{display:flex;list-style:none;justify-content:flex-end;align-items:center}.navbar-left{display:flex;list-style:none;justify-content:flex-start;align-items:center}.sidebar{overflow-y:none;z-index:1050;min-height:100vh;display:flex;flex-direction:column}.profile{height:50px;display:flex;align-items:center}.profile .e-menu-wrapper .e-menu-item{font-size:1rem}.profile .e-menu-wrapper ul .e-menu-item{padding-right:40px}.profile .e-menu-wrapper ul .e-menu-item .e-caret:before{font-size:1rem}.main-content{margin-bottom:20px}.main-content .inner{overflow-y:auto;padding:16px 24px}.main-page{height:100vh}.logo{width:100%;height:100px;min-height:100px}.sidebar-settings{width:100%;height:50px;position:fixed;bottom:0}.sidebar-settings a{font-style:normal;font-weight:400;font-size:.75rem;text-decoration:none}.sidebar-settings img{margin-top:-2px;margin-right:12px}.sidebar-bottom{width:100%;margin-bottom:20px;margin-top:auto;text-align:center}.menuIcon{display:inline;margin-right:.4rem;vertical-align:middle;line-height:22px}.e-treeview .e-ul:first-child{padding:0}.e-treeview .e-text-content{padding:0 0 0 15px}.e-treeview .e-text-content.e-icon-wrapper{padding:0 0 0 15px;display:flex;align-items:center}.e-treeview .e-list-icon{width:24px;height:24px}.e-treeview .e-list-text{line-height:28px;min-height:24px;font-size:1rem}.e-treeview .e-fullrow{height:24px}.e-treeview .e-list-item .e-level-3{padding-bottom:0!important;padding-top:0!important;margin-bottom:-2px}.e-treeview>.e-ul{overflow:hidden}.e-treeview .e-list-item{line-height:24px;padding-bottom:7px;padding-top:7px;font-size:1rem;font-weight:500}.e-treeview .e-list-item:last-child{padding-bottom:0}.e-treeview .e-list-item .e-icon-expandable,.e-treeview .e-list-item .e-icon-collapsible{display:none}\n"], components: [{ type: i2$3.SidebarComponent, selector: "ejs-sidebar", inputs: ["animate", "closeOnDocumentClick", "dockSize", "enableDock", "enableGestures", "enablePersistence", "enableRtl", "height", "isOpen", "locale", "mediaQuery", "position", "showBackdrop", "target", "type", "width", "zIndex"], outputs: ["change", "close", "created", "destroyed", "open", "isOpenChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: i2$3.TreeViewComponent, selector: "ejs-treeview", inputs: ["allowDragAndDrop", "allowEditing", "allowMultiSelection", "allowTextWrap", "animation", "autoCheck", "checkedNodes", "cssClass", "disabled", "dragArea", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "expandOn", "expandedNodes", "fields", "fullRowNavigable", "fullRowSelect", "loadOnDemand", "locale", "nodeTemplate", "selectedNodes", "showCheckBox", "sortOrder"], outputs: ["actionFailure", "created", "dataBound", "dataSourceChanged", "destroyed", "drawNode", "keyPress", "nodeChecked", "nodeChecking", "nodeClicked", "nodeCollapsed", "nodeCollapsing", "nodeDragStart", "nodeDragStop", "nodeDragging", "nodeDropped", "nodeEdited", "nodeEditing", "nodeExpanded", "nodeExpanding", "nodeSelected", "nodeSelecting"] }, { type: AsolIconButtonComponent, selector: "asol-icon-button", inputs: ["type", "color", "iconSvgUrl", "disabled", "active", "cssClass"] }, { type: AsolTenantSelectComponent, selector: "asol-tenant-select" }, { type: AsolLanguageSelectComponent, selector: "asol-language-select", inputs: ["cssClass"], outputs: ["onLanguageChange"] }, { type: i2$3.MenuComponent, selector: "ejs-menu", inputs: ["animationSettings", "cssClass", "enableHtmlSanitizer", "enablePersistence", "enableRtl", "enableScrolling", "fields", "filter", "hamburgerMode", "hoverDelay", "items", "locale", "orientation", "showItemOnClick", "target", "template", "title"], outputs: ["beforeClose", "beforeItemRender", "beforeOpen", "created", "onClose", "onOpen", "select"] }, { type: AsolMessagePanelComponent, selector: "asol-message-panel" }], directives: [{ type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$3.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i1$3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i1$3.RouterOutlet, selector: "router-outlet", outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolMainLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-main-layout', template: "<ejs-sidebar\n  #dockBar\n  id=\"dockSidebar\"\n  [enableDock]=\"false\"\n  class=\"sidebar\"\n  [ngClass]=\"{ invisible: !showMainLayout }\"\n  width=\"240px\"\n  [type]=\"mediaService.isMobile() ? 'Over' : 'Push'\"\n  [closeOnDocumentClick]=\"mediaService.isMobile()\"\n  [enableGestures]=\"false\"\n  dockSize=\"0px\">\n  <div class=\"logo center-item\">\n    <svg-icon [src]=\"logoUrl\"></svg-icon>\n  </div>\n  <div class=\"overflow-auto mb-7\">\n    <ejs-treeview\n      class=\"menu-tree mt-4\"\n      id=\"menu-tree\"\n      #menuTree\n      [fields]=\"field\"\n      [animation]=\"animation\"\n      (nodeExpanded)=\"onNodeExpanded($event)\"\n      (nodeCollapsed)=\"onNodeExpanded($event, false)\"\n      (nodeSelected)=\"navigateToPage($event)\"\n      expandOn=\"Click\">\n      <ng-template #nodeTemplate let-data>\n        <div\n          class=\"sub-item w-100 d-flex justify-content-between\"\n          [routerLink]=\"data.url ? data.url : null\"\n          [routerLinkActive]=\"[data.url ? 'e-url-active' : '']\">\n          <div class=\"d-inline-flex\">\n            <svg-icon\n              *ngIf=\"data.iconUrl\"\n              class=\"menuIcon me-2\"\n              [src]=\"data.iconUrl\"></svg-icon>\n            <div class=\"w-100 text-wrap\">\n              <a>{{ translation.get(transKey, data.text) }}</a>\n            </div>\n          </div>\n          <svg-icon\n            *ngIf=\"data.items && data.items.length\"\n            [src]=\"\n              !data.isExpanded ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_UP\n            \"></svg-icon>\n        </div>\n      </ng-template>\n    </ejs-treeview>\n  </div>\n  <!-- <div class=\"sidebar-settings center-item\">\n    <a href=\"#\" class=\"center-item-v\">\n      <svg-icon class=\"me-2 pb-0\" src=\"/assets/icons/settings.svg\"></svg-icon>\n      {{ translation.get(transKey, 'menuSettings') }}\n    </a>\n  </div> -->\n  <!-- <div class=\"sidebar-bottom\" (click)=\"toggleSidebar()\">Hide</div> -->\n</ejs-sidebar>\n\n<div class=\"main-page\">\n  <!--header-section  declaration -->\n  <nav class=\"navbar\" *ngIf=\"showMainLayout\">\n    <ul class=\"navbar-left\">\n      <li *ngIf=\"mediaService.isMobile()\">\n        <asol-icon-button\n          type=\"flat\"\n          color=\"light\"\n          cssClass=\"hamburger-button\"\n          [iconSvgUrl]=\"ICONS.MENU_01\"\n          (click)=\"onToggleSidebar()\">\n        </asol-icon-button>\n      </li>\n    </ul>\n    <ul>\n      <li>\n        <asol-tenant-select *ngIf=\"allowTenants\"></asol-tenant-select>\n      </li>\n    </ul>\n    <ul class=\"navbar-right pe-3\">\n      <li>\n        <asol-language-select\n          cssClass=\"custom-language-input\"></asol-language-select>\n      </li>\n      <li>\n        <div class=\"profile\" *ngIf=\"profileMenuItems.length\">\n          <ejs-menu\n            [items]=\"profileMenuItems\"\n            (select)=\"selectPersonalMenuItem($event)\">\n            <ng-template #template let-menuItems>\n              <div\n                *ngIf=\"menuItems.text\"\n                class=\"w-100 d-flex justify-content-between\">\n                <span class=\"{{ menuItems.iconCss }} center-item\"></span>\n                <span class=\"w-100\">\n                  <a>{{\n                    menuItems.ignoreTranslate\n                      ? menuItems.text\n                      : translation.get(transKey, menuItems.text)\n                  }}</a>\n                </span>\n              </div>\n            </ng-template>\n          </ejs-menu>\n        </div>\n      </li>\n    </ul>\n  </nav>\n\n  <div [ngClass]=\"{ 'main-content': showMainLayout }\">\n    <!--end of header-section  declaration -->\n    <div #messagePanel>\n      <asol-message-panel></asol-message-panel>\n    </div>\n    <div\n      class=\"inner\"\n      [ngStyle]=\"{\n        height: 'calc(100vh - ' + messagePanelHeight + 'px)'\n      }\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n", styles: [".navbar{height:50px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap}.navbar ul{margin-bottom:0}.navbar-right{display:flex;list-style:none;justify-content:flex-end;align-items:center}.navbar-left{display:flex;list-style:none;justify-content:flex-start;align-items:center}.sidebar{overflow-y:none;z-index:1050;min-height:100vh;display:flex;flex-direction:column}.profile{height:50px;display:flex;align-items:center}.profile .e-menu-wrapper .e-menu-item{font-size:1rem}.profile .e-menu-wrapper ul .e-menu-item{padding-right:40px}.profile .e-menu-wrapper ul .e-menu-item .e-caret:before{font-size:1rem}.main-content{margin-bottom:20px}.main-content .inner{overflow-y:auto;padding:16px 24px}.main-page{height:100vh}.logo{width:100%;height:100px;min-height:100px}.sidebar-settings{width:100%;height:50px;position:fixed;bottom:0}.sidebar-settings a{font-style:normal;font-weight:400;font-size:.75rem;text-decoration:none}.sidebar-settings img{margin-top:-2px;margin-right:12px}.sidebar-bottom{width:100%;margin-bottom:20px;margin-top:auto;text-align:center}.menuIcon{display:inline;margin-right:.4rem;vertical-align:middle;line-height:22px}.e-treeview .e-ul:first-child{padding:0}.e-treeview .e-text-content{padding:0 0 0 15px}.e-treeview .e-text-content.e-icon-wrapper{padding:0 0 0 15px;display:flex;align-items:center}.e-treeview .e-list-icon{width:24px;height:24px}.e-treeview .e-list-text{line-height:28px;min-height:24px;font-size:1rem}.e-treeview .e-fullrow{height:24px}.e-treeview .e-list-item .e-level-3{padding-bottom:0!important;padding-top:0!important;margin-bottom:-2px}.e-treeview>.e-ul{overflow:hidden}.e-treeview .e-list-item{line-height:24px;padding-bottom:7px;padding-top:7px;font-size:1rem;font-weight:500}.e-treeview .e-list-item:last-child{padding-bottom:0}.e-treeview .e-list-item .e-icon-expandable,.e-treeview .e-list-item .e-icon-collapsible{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.Router }, { type: i1.TranslationService }, { type: i1.AsolMediaQueryService }, { type: SpinnerService }, { type: MessagePanelService }, { type: i1.AuthenticationServiceBase }]; }, propDecorators: { transKey: [{
                type: Input
            }], menuProvider: [{
                type: Input
            }], logoUrl: [{
                type: Input
            }], allowTenants: [{
                type: Input
            }], menuTree: [{
                type: ViewChild,
                args: ['menuTree']
            }], sidebarInstance: [{
                type: ViewChild,
                args: ['dockBar']
            }], messagePanelRef: [{
                type: ViewChild,
                args: ['messagePanel']
            }] } });

class AsolTenantSelectModule {
}
AsolTenantSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolTenantSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectModule, declarations: [AsolTenantSelectComponent], imports: [DropDownListModule, CommonModule], exports: [AsolTenantSelectComponent] });
AsolTenantSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectModule, imports: [[DropDownListModule, CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolTenantSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolTenantSelectComponent],
                    exports: [AsolTenantSelectComponent],
                    imports: [DropDownListModule, CommonModule],
                }]
        }] });

class MainLayoutModule {
}
MainLayoutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MainLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MainLayoutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MainLayoutModule, declarations: [AsolMainLayoutComponent, AsolAboutComponent], imports: [SidebarModule,
        MenuModule,
        TreeViewModule,
        SharedModule,
        AsolLanguageSelectModule,
        AsolMessagePanelModule,
        AsolButtonModule,
        AsolTenantSelectModule], exports: [AsolMainLayoutComponent, AsolAboutComponent] });
MainLayoutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MainLayoutModule, providers: [], imports: [[
            SidebarModule,
            MenuModule,
            TreeViewModule,
            SharedModule,
            AsolLanguageSelectModule,
            AsolMessagePanelModule,
            AsolButtonModule,
            AsolTenantSelectModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: MainLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolMainLayoutComponent, AsolAboutComponent],
                    exports: [AsolMainLayoutComponent, AsolAboutComponent],
                    providers: [],
                    imports: [
                        SidebarModule,
                        MenuModule,
                        TreeViewModule,
                        SharedModule,
                        AsolLanguageSelectModule,
                        AsolMessagePanelModule,
                        AsolButtonModule,
                        AsolTenantSelectModule,
                    ],
                }]
        }] });

class MenuProvider {
}

const ONBOARDING_CONST = {
    TRANS: 'asol-library-onboarding',
    ITEM: 'highlighted-item',
    ASSETS_PATH: '/assets/onboarding/',
    BACKGROUND: '/assets/images/qasida-onboarding-background.svg',
};

var translation = {
    "sk-SK": {
        "continue": "Pokračovať",
        onboarding: "Onboarding",
        language: "Jazyk",
        finish: "Ukončiť",
        noItems: "Onboarding nie je k dispozícii",
        title: "Názov",
        module: "Modul",
        highlitedText: "Zvýraznený text",
        text: "Text",
        image: "URL obrázku",
        extension: "Prípona obrázku",
        skip: "Preskočiť"
    },
    "cs-CZ": {
        "continue": "Pokračovat",
        onboarding: "Onboarding",
        language: "Jazyk",
        finish: "Ukončit",
        noItems: "Onboarding není k dispozici",
        title: "Název",
        module: "Modul",
        highlitedText: "Zvýrazněný text",
        text: "Text",
        image: "URL obrázku",
        extension: "Přípona obrázku",
        skip: "Přeskočit"
    },
    "en-US": {
        "continue": "Continue",
        onboarding: "Onboarding",
        language: "Language",
        finish: "Finish",
        noItems: "Onboarding not available",
        title: "Title",
        module: "Module",
        highlitedText: "Highlited text",
        text: "Text",
        image: "Image URL",
        extension: "Image extension",
        skip: "Skip"
    }
};

class AsolOnboardingCreateComponent {
    constructor(trans, fb) {
        this.trans = trans;
        this.fb = fb;
        this.ONBOARDING_CONST = ONBOARDING_CONST;
        this.GENERAL_TRANSLATION = GENERAL_TRANSLATION;
        this.save = new EventEmitter();
        this.trans.initialize(ONBOARDING_CONST.TRANS, translation);
        this.formGroup = this.fb.group({
            title: [null, Validators.required],
            module: [],
            highlitedText: [],
            text: [],
            image: [],
            extension: [],
            language: [null, Validators.required],
        });
    }
    /**
     * Event handler after user clicks on skip or next button
     * @param skip Flag if user clicked on skip button
     */
    onCreate() {
        markForValidation(this.formGroup);
        if (!this.formGroup.valid) {
            return;
        }
        this.save.emit(this.formGroup.value);
    }
}
AsolOnboardingCreateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingCreateComponent, deps: [{ token: i1.TranslationService }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component });
AsolOnboardingCreateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolOnboardingCreateComponent, selector: "asol-onboarding-create", outputs: { save: "save" }, ngImport: i0, template: "<div class=\"container\">\n  <h1>{{ trans.get(ONBOARDING_CONST.TRANS, 'onboarding') }}</h1>\n\n  <form [formGroup]=\"formGroup\">\n    <asol-select-field\n      formControlName=\"language\"\n      [options]=\"trans.getSupportedLanguages\"\n      valueProperty=\"locale\"\n      displayProperty=\"name\"\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"language\">\n    </asol-select-field>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"title\"\n          formControlName=\"title\">\n        </asol-input-field>\n      </div>\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"module\"\n          formControlName=\"module\">\n        </asol-input-field>\n      </div>\n    </div>\n\n    <asol-text-area\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"highlitedText\"\n      formControlName=\"highlitedText\">\n    </asol-text-area>\n\n    <asol-text-area\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"text\"\n      formControlName=\"text\">\n    </asol-text-area>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"image\"\n          formControlName=\"image\">\n        </asol-input-field>\n      </div>\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"extension\"\n          formControlName=\"extension\">\n        </asol-input-field>\n      </div>\n    </div>\n  </form>\n\n  <asol-button (click)=\"onCreate()\" type=\"outline\">\n    {{ trans.get(GENERAL_TRANSLATION, 'create') }}\n  </asol-button>\n</div>\n", components: [{ type: AsolSelectFieldComponent, selector: "asol-select-field", inputs: ["options", "valueProperty", "displayProperty", "dataProvider", "filterParams", "autofill", "showClearButton", "openOnFocus", "allowCustom", "popupWidth", "allowFiltering"] }, { type: AsolInputFieldComponent, selector: "asol-input-field", inputs: ["prefixIcon", "suffixIcon", "inputType", "provider", "providerUri", "checkTransKey", "checkErrorKey"] }, { type: AsolTextAreaComponent, selector: "asol-text-area", inputs: ["rows"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingCreateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-onboarding-create', template: "<div class=\"container\">\n  <h1>{{ trans.get(ONBOARDING_CONST.TRANS, 'onboarding') }}</h1>\n\n  <form [formGroup]=\"formGroup\">\n    <asol-select-field\n      formControlName=\"language\"\n      [options]=\"trans.getSupportedLanguages\"\n      valueProperty=\"locale\"\n      displayProperty=\"name\"\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"language\">\n    </asol-select-field>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"title\"\n          formControlName=\"title\">\n        </asol-input-field>\n      </div>\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"module\"\n          formControlName=\"module\">\n        </asol-input-field>\n      </div>\n    </div>\n\n    <asol-text-area\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"highlitedText\"\n      formControlName=\"highlitedText\">\n    </asol-text-area>\n\n    <asol-text-area\n      [transKey]=\"ONBOARDING_CONST.TRANS\"\n      labelKey=\"text\"\n      formControlName=\"text\">\n    </asol-text-area>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"image\"\n          formControlName=\"image\">\n        </asol-input-field>\n      </div>\n      <div class=\"col-12 col-lg-6\">\n        <asol-input-field\n          [transKey]=\"ONBOARDING_CONST.TRANS\"\n          labelKey=\"extension\"\n          formControlName=\"extension\">\n        </asol-input-field>\n      </div>\n    </div>\n  </form>\n\n  <asol-button (click)=\"onCreate()\" type=\"outline\">\n    {{ trans.get(GENERAL_TRANSLATION, 'create') }}\n  </asol-button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: i2.FormBuilder }]; }, propDecorators: { save: [{
                type: Output
            }] } });

/**
 * Data source for onboarding
 */
class OnboardingDataSource {
    constructor() {
        this.showOnboarding = new Subject();
        this.show$ = this.showOnboarding.asObservable();
    }
    /**
     * Show onboarding with given data
     * @param data Data to show
     */
    show(data) {
        this.showOnboarding.next(data);
    }
}
OnboardingDataSource.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OnboardingDataSource, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OnboardingDataSource.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OnboardingDataSource, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: OnboardingDataSource, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AsolOnboardingComponent {
    constructor(trans, provider, notificationService, mediaService) {
        this.trans = trans;
        this.provider = provider;
        this.notificationService = notificationService;
        this.mediaService = mediaService;
        /** Onboarding items collection */
        this.items = [];
        /** Current selected item index */
        this.selectedIndex = 0;
        /** Logo shown in the header of dialog */
        this.logo = null;
        /** Background image of dialog header */
        this.background = ONBOARDING_CONST.BACKGROUND;
        /** Image path of the onboarding image */
        this.imagePath = '';
        /** Resolution of image */
        this.resolution = '';
        /**
         * Flag if onboarding should be visible
         */
        this.showOnboarding = false;
        this.ONBOARDING_CONST = ONBOARDING_CONST;
        this.sub = new Subscription();
        this.trans.initialize(ONBOARDING_CONST.TRANS, translation);
        this.sub.add(this.mediaService.viewportChanged$.subscribe((state) => {
            if (state.breakpoints[MEDIA_QUERY.XXL] === true) {
                this.resolution = '1920px';
                this.refreshPosition();
                this.fillImage();
            }
            if (state.breakpoints[MEDIA_QUERY.LG] === true ||
                state.breakpoints[MEDIA_QUERY.XL] === true) {
                this.resolution = '1280px';
                this.refreshPosition();
                this.fillImage();
            }
            if (state.breakpoints[MEDIA_QUERY.MD] === true) {
                this.resolution = '800px';
                this.refreshPosition();
                this.fillImage();
            }
            if (state.breakpoints[MEDIA_QUERY.XS] === true ||
                state.breakpoints[MEDIA_QUERY.SM] === true) {
                this.hide();
            }
        }));
        this.sub.add(this.provider.show$.subscribe((data) => {
            var _a;
            if (!((_a = data.items) === null || _a === void 0 ? void 0 : _a.length)) {
                this.notificationService.warning(this.trans.get(ONBOARDING_CONST.TRANS, 'noItems'));
                return;
            }
            this.logo = data.logoUrl;
            this.items = data.items;
            this.show();
        }));
    }
    ngOnDestroy() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    /**
     * Event handler after user clicks on skip or next button
     * @param skip Flag if user clicked on skip button
     */
    onClick(skip) {
        if (skip) {
            this.hide();
            return;
        }
        if (this.selectedIndex + 1 === this.items.length) {
            this.hide();
            return;
        }
        this.selectedIndex = this.selectedIndex + 1;
        this.fillImage();
    }
    /**
     * Shows dialog window
     */
    show() {
        this.showOnboarding = true;
        this.fillImage();
        this.ejDialog.show();
        this.ejDialog.refreshPosition();
    }
    /**
     * Hides dialog window
     */
    hide() {
        var _a;
        this.selectedIndex = 0;
        this.showOnboarding = false;
        this.imagePath = '';
        (_a = this.ejDialog) === null || _a === void 0 ? void 0 : _a.hide();
    }
    /**
     * Fills image from selected item if there is one defined
     */
    fillImage() {
        const item = this.items[this.selectedIndex];
        if (!item || !item.image) {
            return;
        }
        if (item.image) {
            this.imagePath = `${this.ONBOARDING_CONST.ASSETS_PATH}${this.trans.getCurrentLanguage().short}/${item.image} ${this.resolution}.${item.extension}`;
        }
        else {
            this.imagePath = '';
        }
    }
    /**
     * Refresher position of dialog window
     */
    refreshPosition() {
        var _a;
        if (this.showOnboarding) {
            (_a = this.ejDialog) === null || _a === void 0 ? void 0 : _a.refreshPosition();
        }
    }
}
AsolOnboardingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingComponent, deps: [{ token: i1.TranslationService }, { token: OnboardingDataSource }, { token: NotificationService }, { token: i1.AsolMediaQueryService }], target: i0.ɵɵFactoryTarget.Component });
AsolOnboardingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolOnboardingComponent, selector: "asol-onboarding", viewQueries: [{ propertyName: "ejDialog", first: true, predicate: ["ejDialog"], descendants: true }], ngImport: i0, template: "<img\n  [src]=\"imagePath\"\n  class=\"onboarding-image\"\n  *ngIf=\"imagePath && showOnboarding\" />\n<ejs-dialog\n  id=\"onboardingDialog\"\n  #ejDialog\n  [isModal]=\"false\"\n  class=\"onboardingDialog\"\n  [zIndex]=\"1100\"\n  [visible]=\"false\">\n  <ng-template #content>\n    <div class=\"header\">\n      <svg-icon [stretch]=\"true\" class=\"back\" [src]=\"background\"></svg-icon>\n      <svg-icon [src]=\"logo\"></svg-icon>\n    </div>\n    <div class=\"body\" *ngIf=\"items.length\">\n      <div>\n        <h1 class=\"mt-4 text-center\">{{ items[selectedIndex].title }}</h1>\n        <h4 class=\"mt-4 mb-7\">{{ items[selectedIndex].highlitedText }}</h4>\n        <div class=\"mt-2\">{{ items[selectedIndex].text }}</div>\n      </div>\n    </div>\n    <div\n      class=\"overflow-hidden d-flex justify-content-between align-items-center\">\n      <div class=\"col-4\"></div>\n      <div class=\"col-4 text-center\">\n        {{ selectedIndex + 1 }}/{{ items.length }}\n      </div>\n      <div\n        class=\"col-4 d-flex align-items-end justify-content-end pt-3 pe-5 pb-5\">\n        <asol-button\n          color=\"light\"\n          id=\"onboarding-skip\"\n          cssClass=\"me-3\"\n          *ngIf=\"items.length !== selectedIndex + 1\"\n          (click)=\"onClick(true)\">\n          {{ trans.get(ONBOARDING_CONST.TRANS, 'skip') }}\n        </asol-button>\n        <asol-button\n          color=\"primary\"\n          id=\"onboarding-continue\"\n          (click)=\"onClick(false)\">\n          {{\n            items.length !== selectedIndex + 1\n              ? trans.get(ONBOARDING_CONST.TRANS, 'continue')\n              : trans.get(ONBOARDING_CONST.TRANS, 'finish')\n          }}\n        </asol-button>\n      </div>\n    </div>\n  </ng-template>\n</ejs-dialog>\n", styles: [".onboardingDialog.e-dialog{border:none;border-radius:8px;width:51rem}.onboardingDialog.e-dialog .e-dlg-content{padding:0;border-radius:8px}.onboardingDialog .header{height:80px;border-radius:0 0 8px 8px/0px 0px 8px 8px;width:100%;display:flex;align-items:center;justify-content:center;overflow:hidden}.onboardingDialog .header svg-icon.back{position:absolute}.onboardingDialog .header svg-icon.back svg{width:51rem;height:80px;border-radius:8px}.onboardingDialog .body{height:auto;display:flex;align-items:center;justify-content:center;overflow:hidden}.onboardingDialog .body div{width:570px}.onboarding-image{position:fixed;inset:0;height:100%;width:100vw;pointer-events:none;z-index:1005}@media (max-width: 993px){.onboardingDialog.e-dialog{width:37.5rem}.onboardingDialog .header svg-icon.back svg{width:37.5rem}.onboardingDialog .body div{width:25rem}}\n"], components: [{ type: i2$2.DialogComponent, selector: "ejs-dialog", inputs: ["allowDragging", "animationSettings", "buttons", "closeOnEscape", "content", "cssClass", "enableHtmlSanitizer", "enablePersistence", "enableResize", "enableRtl", "footerTemplate", "header", "height", "isModal", "locale", "minHeight", "position", "resizeHandles", "showCloseIcon", "target", "visible", "width", "zIndex"], outputs: ["beforeClose", "beforeOpen", "beforeSanitizeHtml", "close", "created", "destroyed", "drag", "dragStart", "dragStop", "open", "overlayClick", "resizeStart", "resizeStop", "resizing", "visibleChange"] }, { type: i4.SvgIconComponent, selector: "svg-icon", inputs: ["src", "name", "stretch", "applyClass", "applyCss", "svgClass", "class", "viewBox", "svgAriaLabel", "svgStyle"] }, { type: AsolButtonComponent, selector: "asol-button", inputs: ["type", "textType", "color", "iconPosition", "iconSvgUrl", "disabled", "active", "cssClass"] }], directives: [{ type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-onboarding', template: "<img\n  [src]=\"imagePath\"\n  class=\"onboarding-image\"\n  *ngIf=\"imagePath && showOnboarding\" />\n<ejs-dialog\n  id=\"onboardingDialog\"\n  #ejDialog\n  [isModal]=\"false\"\n  class=\"onboardingDialog\"\n  [zIndex]=\"1100\"\n  [visible]=\"false\">\n  <ng-template #content>\n    <div class=\"header\">\n      <svg-icon [stretch]=\"true\" class=\"back\" [src]=\"background\"></svg-icon>\n      <svg-icon [src]=\"logo\"></svg-icon>\n    </div>\n    <div class=\"body\" *ngIf=\"items.length\">\n      <div>\n        <h1 class=\"mt-4 text-center\">{{ items[selectedIndex].title }}</h1>\n        <h4 class=\"mt-4 mb-7\">{{ items[selectedIndex].highlitedText }}</h4>\n        <div class=\"mt-2\">{{ items[selectedIndex].text }}</div>\n      </div>\n    </div>\n    <div\n      class=\"overflow-hidden d-flex justify-content-between align-items-center\">\n      <div class=\"col-4\"></div>\n      <div class=\"col-4 text-center\">\n        {{ selectedIndex + 1 }}/{{ items.length }}\n      </div>\n      <div\n        class=\"col-4 d-flex align-items-end justify-content-end pt-3 pe-5 pb-5\">\n        <asol-button\n          color=\"light\"\n          id=\"onboarding-skip\"\n          cssClass=\"me-3\"\n          *ngIf=\"items.length !== selectedIndex + 1\"\n          (click)=\"onClick(true)\">\n          {{ trans.get(ONBOARDING_CONST.TRANS, 'skip') }}\n        </asol-button>\n        <asol-button\n          color=\"primary\"\n          id=\"onboarding-continue\"\n          (click)=\"onClick(false)\">\n          {{\n            items.length !== selectedIndex + 1\n              ? trans.get(ONBOARDING_CONST.TRANS, 'continue')\n              : trans.get(ONBOARDING_CONST.TRANS, 'finish')\n          }}\n        </asol-button>\n      </div>\n    </div>\n  </ng-template>\n</ejs-dialog>\n", styles: [".onboardingDialog.e-dialog{border:none;border-radius:8px;width:51rem}.onboardingDialog.e-dialog .e-dlg-content{padding:0;border-radius:8px}.onboardingDialog .header{height:80px;border-radius:0 0 8px 8px/0px 0px 8px 8px;width:100%;display:flex;align-items:center;justify-content:center;overflow:hidden}.onboardingDialog .header svg-icon.back{position:absolute}.onboardingDialog .header svg-icon.back svg{width:51rem;height:80px;border-radius:8px}.onboardingDialog .body{height:auto;display:flex;align-items:center;justify-content:center;overflow:hidden}.onboardingDialog .body div{width:570px}.onboarding-image{position:fixed;inset:0;height:100%;width:100vw;pointer-events:none;z-index:1005}@media (max-width: 993px){.onboardingDialog.e-dialog{width:37.5rem}.onboardingDialog .header svg-icon.back svg{width:37.5rem}.onboardingDialog .body div{width:25rem}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: OnboardingDataSource }, { type: NotificationService }, { type: i1.AsolMediaQueryService }]; }, propDecorators: { ejDialog: [{
                type: ViewChild,
                args: ['ejDialog']
            }] } });

class AsolOnboardingModule {
}
AsolOnboardingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolOnboardingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingModule, declarations: [AsolOnboardingComponent, AsolOnboardingCreateComponent], imports: [SharedModule,
        DialogModule,
        AsolContentWrapperModule,
        AsolInputFieldModule,
        AsolButtonModule,
        AsolTextAreaModule,
        AsolSelectFieldModule], exports: [AsolOnboardingComponent, AsolOnboardingCreateComponent] });
AsolOnboardingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingModule, imports: [[
            SharedModule,
            DialogModule,
            AsolContentWrapperModule,
            AsolInputFieldModule,
            AsolButtonModule,
            AsolTextAreaModule,
            AsolSelectFieldModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolOnboardingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AsolOnboardingComponent, AsolOnboardingCreateComponent],
                    exports: [AsolOnboardingComponent, AsolOnboardingCreateComponent],
                    imports: [
                        SharedModule,
                        DialogModule,
                        AsolContentWrapperModule,
                        AsolInputFieldModule,
                        AsolButtonModule,
                        AsolTextAreaModule,
                        AsolSelectFieldModule,
                    ],
                }]
        }] });

class AsolSpinnerComponent {
    constructor(spinner) {
        this.spinner = spinner;
        /**
         * Custom width of spinner
         *
         * @type {string}
         */
        this.width = null;
    }
    ngOnInit() {
        this.createSpinner(this.width);
        this.startSpinnerHandler();
    }
    /**
     * Subscribe to spinner service for watching and react to spinner events
     *
     * @private
     */
    startSpinnerHandler() {
        this.spinner.spin$.subscribe((spin) => {
            if (spin) {
                this.showSpinner();
            }
            else {
                this.hideSpinner();
            }
        });
    }
    /**
     * Create spinner DOM element with default width
     *
     * @private
     * @param {?string} [width] Optional width of spinner
     */
    createSpinner(width) {
        createSpinner({
            target: document.getElementById('global-progress-container'),
            width: width ? width : '',
        });
    }
    /**
     * Show spinner
     *
     * @private
     */
    showSpinner() {
        showSpinner(document.getElementById('global-progress-container'));
    }
    /**
     * Hide spinner
     *
     * @private
     */
    hideSpinner() {
        hideSpinner(document.getElementById('global-progress-container'));
    }
}
AsolSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerComponent, deps: [{ token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component });
AsolSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AsolSpinnerComponent, selector: "asol-spinner", inputs: { width: "width" }, ngImport: i0, template: "<div id=\"global-progress-container\"></div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'asol-spinner', template: "<div id=\"global-progress-container\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: SpinnerService }]; }, propDecorators: { width: [{
                type: Input
            }] } });

class AsolSpinnerModule {
}
AsolSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AsolSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerModule, declarations: [AsolSpinnerComponent], imports: [CommonModule], exports: [AsolSpinnerComponent] });
AsolSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AsolSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [AsolSpinnerComponent],
                    exports: [AsolSpinnerComponent],
                }]
        }] });

class GlobalErrorService {
    constructor(injector // @Inject(Router) private router: Router
    ) {
        this.injector = injector;
    }
    get trans() {
        return this.injector.get(TranslationService);
    }
    get notificationService() {
        return this.injector.get(NotificationService);
    }
    /**
     * This method inform user about some error that happens in back-end
     * and show error toast via notificationService. There is also condition for
     * license error, and if this error will happen, user will be redirected to
     * separate page
     * @param err Error
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(err) {
        var _a, _b, _c, _d;
        console.error(err);
        // ignore NG0100 error (Expression has changed after it was checked)
        if (err.message && err.message.includes('NG0100')) {
            return;
        }
        const error_message = 'Error';
        if ((err === null || err === void 0 ? void 0 : err.name) == error_message &&
            (err === null || err === void 0 ? void 0 : err.message) &&
            this.isValidJson(err === null || err === void 0 ? void 0 : err.message)) {
            err = JSON.parse(err === null || err === void 0 ? void 0 : err.message);
        }
        if (err instanceof HttpErrorResponse && err.error.length) {
            err = err.error[0].message;
        }
        if (err === null || err === void 0 ? void 0 : err.rejection) {
            const error = err.rejection;
            if ((_a = error.url) === null || _a === void 0 ? void 0 : _a.includes('openid-configuration')) {
                this.notificationService.danger(this.trans.get(ERROR_TRANSLATION, 'identityErrorHeader'));
            }
            else {
                this.notificationService.danger(this.trans.get(ERROR_TRANSLATION, 'unknownErrorText'));
            }
            return;
        }
        if (err === null || err === void 0 ? void 0 : err.error) {
            // check statuses
            if ((_b = err.error) === null || _b === void 0 ? void 0 : _b.status) {
                switch (err.error.status) {
                    case 403: {
                        this.notificationService.danger(this.trans.get(ERROR_TRANSLATION, 'unauthorizedErrorHeader'));
                        return;
                    }
                    case 409: {
                        this.notificationService.danger(err.error);
                        return;
                    }
                    case 503: {
                        this.notificationService.danger(this.trans.get(ERROR_TRANSLATION, 'identityErrorHeader'));
                        return;
                    }
                    case 401: {
                        this.notificationService.danger(err.error.title);
                        // this.router.navigate(['/']);
                    }
                }
            }
            const message = ((_c = err === null || err === void 0 ? void 0 : err.error) === null || _c === void 0 ? void 0 : _c.detail) ||
                ((_d = err === null || err === void 0 ? void 0 : err.error) === null || _d === void 0 ? void 0 : _d.title) ||
                this.trans.get(ERROR_TRANSLATION, 'genericErrorHeader');
            this.notificationService.danger(message);
        }
        else {
            if (err === null || err === void 0 ? void 0 : err.message) {
                this.notificationService.danger(err.message);
            }
            else {
                this.notificationService.danger(err);
            }
            console.error(err);
        }
    }
    /**
     * This method checks if error message is valid JSON or not
     * @param message error message
     * @returns TRUE if valid, otherwise FALSE
     */
    isValidJson(message) {
        try {
            JSON.parse(message);
        }
        catch (error) {
            return false;
        }
        return true;
    }
}
GlobalErrorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GlobalErrorService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
GlobalErrorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GlobalErrorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: GlobalErrorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/**
 * Method for formatting currency value in grid.
 * Used for valueAccessor property in column definition.
 *
 * @export
 * @param {string} field
 * @param {unknown} data
 * @param {Column} column
 * @returns {unknown}
 */
function valueAccessorCurrency(field, data, column) {
    var _a, _b, _c, _d;
    const value = (_b = (_a = data === null || data === void 0 ? void 0 : data[field]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    const currency = (_d = (_c = data === null || data === void 0 ? void 0 : data[field]) === null || _c === void 0 ? void 0 : _c.currency) !== null && _d !== void 0 ? _d : '';
    return `${value} ${currency}`;
}

/**
 * Method for formatting date value in grid.
 * Common use case is for exporting grid date to excel format.
 * Example 1685350800000 => 29.05.2023.
 * Used for valueAccessor property in column definition.
 *
 * @export
 * @param {string} field
 * @param {unknown} data
 * @param {Column} column
 * @returns {unknown}
 */
function valueAccessorDate(field, data, column) {
    return (data === null || data === void 0 ? void 0 : data[field]) ? new Date(data === null || data === void 0 ? void 0 : data[field]) : '';
}

class BooleanTypeService {
    constructor(trans) {
        this.trans = trans;
        /** Boolean types */
        this.booleanTypes = [true, false];
    }
    /**
     * Gets boolean type
     * @returns Observable selected item collection @see {@link SelectedItem}
     */
    getData() {
        const types = [];
        this.booleanTypes.forEach((item) => {
            types.push({
                value: `${item}`,
                text: this.trans.get(GENERAL_TRANSLATION, item ? 'yes' : 'no'),
            });
        });
        return of(types);
    }
}
BooleanTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: BooleanTypeService, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
BooleanTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: BooleanTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: BooleanTypeService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; } });

/**
 * Preparation for theme switching by user
 */
class ThemeService {
    constructor(document) {
        this.document = document;
    }
    loadTheme(themeName) {
        const head = this.document.getElementsByTagName('head')[0];
        const themeSrc = this.document.getElementById('client-theme');
        if (themeSrc) {
            themeSrc.href = `assets/themes/${themeName}.scss`;
        }
        else {
            const style = this.document.createElement('link');
            style.id = 'client-theme';
            style.rel = 'stylesheet';
            style.href = `assets/themes/${themeName}.scss`;
            head.appendChild(style);
        }
    }
}
ThemeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ThemeService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
ThemeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ThemeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: Document, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    } });

/**
 * Function searches through rules created by Querybuilder and
 * replaces the date type of the rule to string and formats the date into ISO string.
 * This is an fix for converting rules to predicates using querybuilder as he is trying to format the date and fails
 * @param rule Rules to search @see {@link RuleModel}
 */
function changeDateToString(rule) {
    if ((rule === null || rule === void 0 ? void 0 : rule.type) === 'date') {
        rule.type = 'string';
        if (rule.value) {
            rule.value = new Date(rule.value.toString()).toISOString();
        }
    }
    if (rule.rules) {
        rule.rules.forEach((item) => {
            changeDateToString(item);
        });
    }
}

/**
 * Builds predicate from filter rule model of existing filter
 * Not suitable to build predicate for null, not null, empty, is empty, in and not in operators!
 * @param ruleModel source ruleModel to build predicate @see {@link Predicate}
 */
function buildPredicate(ruleModel) {
    if (!ruleModel) {
        return undefined;
    }
    const qryBldrObj = new QueryBuilder();
    let predicate = undefined;
    try {
        const rules = JSON.parse(ruleModel);
        changeDateToString(rules);
        if (rules) {
            predicate = qryBldrObj.getPredicate(rules);
        }
    }
    catch (_a) {
        throw new Error('Given rule model is not valid');
    }
    return predicate;
}

/*
 * Public API Surface of asol-controls
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AggregateService, AggregationType, AggregationTypesService, AsolAboutComponent, AsolAddressComponent, AsolAddressModule, AsolAggregateDialogComponent, AsolAggregateItemComponent, AsolAggregateItemsComponent, AsolAggregateModule, AsolAutoCompleteComponent, AsolAutoCompleteModule, AsolBreadcrumbComponent, AsolBreadcrumbModule, AsolButtonComponent, AsolButtonModule, AsolCheckboxComponent, AsolCheckboxGroupComponent, AsolCheckboxGroupModule, AsolCheckboxModule, AsolColumnChooserDialogComponent, AsolColumnChooserDialogModule, AsolCommentComponent, AsolCommentsModule, AsolContentFormDirective, AsolContentSummaryComponent, AsolContentSummaryModule, AsolContentWrapperComponent, AsolContentWrapperModule, AsolControlModule, AsolDataColumnDirective, AsolDataColumnModule, AsolDatePickerComponent, AsolDatePickerModule, AsolDialogComponent, AsolDialogModule, AsolDropDownButtonComponent, AsolDynamicControlComponent, AsolDynamicControlModule, AsolEditorComponent, AsolEditorModule, AsolEntityLinkComponent, AsolEntityLinkModule, AsolFileUploadProgressComponent, AsolFilterComponent, AsolFilterModule, AsolGridComponent, AsolGridModule, AsolHeaderModule, AsolIconButtonComponent, AsolInfoPanelComponent, AsolInfoPanelModule, AsolInputFieldComponent, AsolInputFieldModule, AsolItemsListComponent, AsolItemsListModule, AsolLabelFieldComponent, AsolLabelFieldModule, AsolLandingPageComponent, AsolLandingPageModule, AsolLanguageSelectComponent, AsolLanguageSelectModule, AsolMainLayoutComponent, AsolMassEditDialogComponent, AsolMassEditDialogModule, AsolMessagePanelComponent, AsolMessagePanelModule, AsolMultiselectComponent, AsolMultiselectModule, AsolNumberFieldComponent, AsolNumberFieldModule, AsolOnboardingComponent, AsolOnboardingCreateComponent, AsolOnboardingModule, AsolPageColumnsComponent, AsolPageColumnsModule, AsolPagerComponent, AsolPagerModule, AsolPriorityComponent, AsolPriorityModule, AsolProgressBarComponent, AsolProgressBarModule, AsolRadioGroupComponent, AsolRadioGroupModule, AsolSearchPanelComponent, AsolSearchPanelModule, AsolSelectFieldComponent, AsolSelectFieldModule, AsolSelectTreeComponent, AsolSelectTreeModule, AsolSpinnerComponent, AsolSpinnerModule, AsolSplitButtonComponent, AsolStepComponent, AsolStepperComponent, AsolStepperModule, AsolSummaryItemComponent, AsolSwitchComponent, AsolSwitchModule, AsolTabComponent, AsolTabsComponent, AsolTabsModule, AsolTabsService, AsolTenantSelectComponent, AsolTenantSelectModule, AsolTextAreaComponent, AsolTextAreaModule, AsolTimePickerComponent, AsolTimePickerModule, AsolToolbarComponent, AsolToolbarModule, AsolUploadComponent, AsolUploadModule, AsolValueCurrencyComponent, AsolValueCurrencyModule, AsolWorkflowComponent, AsolWorkflowItemComponent, AsolWorkflowModule, BREADCRUMB_TRANSLATION, BooleanTypeService, CheckFieldProvider, ContentSummaryItemDirective, ContentSummaryLinkDirective, DialogContentDirective, EntityFilter, FilterOperator, FilterSyncService, FormValidatorService, GRID_CONSTANT, GlobalErrorService, HeaderPanelComponent, ICONS, ICON_FORMATS, MainLayoutModule, MenuProvider, MessagePanelService, NotificationService, OnboardingDataSource, PACKAGE_CONFIG, PageColumnsService, RequiredAsteriskDirective, RequiredAsteriskModule, RequiredCheckService, SettingsServiceBase, SpinnerService, ThemeService, ToolbarItemDirective, ToolbarMessage, ToolbarService, USER_REGISTRATION_LINK, UploadProgressModule, WorkflowState, addCustomPredicates, buildPredicate, changeDateToString, fillFilterToState, fillSearchToState, parsePredicateFromJson, removeCustomPredicate, valueAccessorCurrency, valueAccessorDate };
